(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.df.bF === region.d7.bF)
	{
		return 'on line ' + region.df.bF;
	}
	return 'on lines ' + region.df.bF + ' through ' + region.d7.bF;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hG,
		impl.jL,
		impl.jo,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		h1: func(record.h1),
		dg: record.dg,
		c6: record.c6
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.h1;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.dg;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.c6) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hG,
		impl.jL,
		impl.jo,
		function(sendToApp, initialModel) {
			var view = impl.jU;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hG,
		impl.jL,
		impl.jo,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.de && impl.de(sendToApp)
			var view = impl.jU;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.dG);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.r) && (_VirtualDom_doc.title = title = doc.r);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.iq;
	var onUrlRequest = impl.ir;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		de: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.ff === next.ff
							&& curr.et === next.et
							&& curr.e$.a === next.e$.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		hG: function(flags)
		{
			return A3(impl.hG, flags, _Browser_getUrl(), key);
		},
		jU: impl.jU,
		jL: impl.jL,
		jo: impl.jo
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hC: 'hidden', aU: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hC: 'mozHidden', aU: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hC: 'msHidden', aU: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hC: 'webkitHidden', aU: 'webkitvisibilitychange' }
		: { hC: 'hidden', aU: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		fu: _Browser_getScene(),
		f4: {
			ge: _Browser_window.pageXOffset,
			gf: _Browser_window.pageYOffset,
			gd: _Browser_doc.documentElement.clientWidth,
			hB: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		gd: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		hB: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			fu: {
				gd: node.scrollWidth,
				hB: node.scrollHeight
			},
			f4: {
				ge: node.scrollLeft,
				gf: node.scrollTop,
				gd: node.clientWidth,
				hB: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			fu: _Browser_getScene(),
			f4: {
				ge: x,
				gf: y,
				gd: _Browser_doc.documentElement.clientWidth,
				hB: _Browser_doc.documentElement.clientHeight
			},
			hh: {
				ge: x + rect.left,
				gf: y + rect.top,
				gd: rect.width,
				hB: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.eg.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.eg.b, xhr)); });
		$elm$core$Maybe$isJust(request.jH) && _Http_track(router, xhr, request.jH.a);

		try {
			xhr.open(request.eK, request.jM, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.jM));
		}

		_Http_configureRequest(xhr, request);

		request.dG.a && xhr.setRequestHeader('Content-Type', request.dG.a);
		xhr.send(request.dG.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.eq; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.jE.a || 0;
	xhr.responseType = request.eg.d;
	xhr.withCredentials = request.gs;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		jM: xhr.responseURL,
		jl: xhr.status,
		jm: xhr.statusText,
		eq: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			je: event.loaded,
			fK: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			iQ: event.loaded,
			fK: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = '';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $author$project$MainMsg$ChangedUrl = function (a) {
	return {$: 15, a: a};
};
var $author$project$MainMsg$ClickedLink = function (a) {
	return {$: 16, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.C) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.E),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.E);
		} else {
			var treeLen = builder.C * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.G) : builder.G;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.C);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.E) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.E);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{G: nodeList, C: (len / $elm$core$Array$branchFactor) | 0, E: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {em: fragment, et: host, iu: path, e$: port_, ff: protocol, fg: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$MainMsg$ToAudEndDatePicker = function (a) {
	return {$: 86, a: a};
};
var $author$project$MainMsg$ToAudStartDatePicker = function (a) {
	return {$: 85, a: a};
};
var $author$project$MainMsg$ToCallEndDatePicker = function (a) {
	return {$: 89, a: a};
};
var $author$project$MainMsg$ToCallStartDatePicker = function (a) {
	return {$: 88, a: a};
};
var $author$project$MainMsg$ToFittingDatePicker = function (a) {
	return {$: 91, a: a};
};
var $author$project$MainMsg$ToProjectEndDatePicker = function (a) {
	return {$: 90, a: a};
};
var $author$project$MainMsg$ToProjectStartDatePicker = function (a) {
	return {$: 87, a: a};
};
var $author$project$MainMsg$ToShootDatePicker = function (a) {
	return {$: 92, a: a};
};
var $author$project$MainMsg$ToSubDatePicker = function (a) {
	return {$: 84, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Route$PageNotFound = {$: 17};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {a_: frag, a2: params, aS: unvisited, ba: value, bb: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aS;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.ba);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.ba);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.iu),
					$elm$url$Url$Parser$prepareQuery(url.fg),
					url.em,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$Account = {$: 6};
var $author$project$Route$AccountSubPage = function (a) {
	return {$: 19, a: a};
};
var $author$project$Route$AccountVerification = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Route$AgencyProfile = {$: 15};
var $author$project$Route$AgencyRegistration = {$: 5};
var $author$project$Route$AgencyTalentSchedulePage = function (a) {
	return {$: 28, a: a};
};
var $author$project$Route$AgentProfile = {$: 16};
var $author$project$Route$AgentsSignupPage = function (a) {
	return {$: 27, a: a};
};
var $author$project$Route$CollaboratorsSignupPage = function (a) {
	return {$: 26, a: a};
};
var $author$project$Route$Dashboard = {$: 13};
var $author$project$Route$DayOfPage = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Route$DirectorRegistration = {$: 4};
var $author$project$Route$Inbox = {$: 10};
var $author$project$Route$Job = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$JobIndex = {$: 8};
var $author$project$Route$Login = {$: 0};
var $author$project$Route$MarketingDirectorRegistration = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$MarketingTalentRegistration = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$MyJobs = {$: 9};
var $author$project$Route$Project = function (a) {
	return {$: 21, a: a};
};
var $author$project$Route$Role = function (a) {
	return {$: 12, a: a};
};
var $author$project$Route$RoleIndex = {$: 11};
var $author$project$Route$ScheduleIndex = {$: 23};
var $author$project$Route$SchedulePage = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Route$TalentProfile = {$: 14};
var $author$project$Route$TalentRegistration = {$: 1};
var $author$project$Route$TalentSearch = {$: 20};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.bb;
		var unvisited = _v0.aS;
		var params = _v0.a2;
		var frag = _v0.a_;
		var value = _v0.ba;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.bb;
			var unvisited = _v1.aS;
			var params = _v1.a2;
			var frag = _v1.a_;
			var value = _v1.ba;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.bb;
		var unvisited = _v0.aS;
		var params = _v0.a2;
		var frag = _v0.a_;
		var value = _v0.ba;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.bb;
			var unvisited = _v0.aS;
			var params = _v0.a2;
			var frag = _v0.a_;
			var value = _v0.ba;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Data$RoleId$RoleId = $elm$core$Basics$identity;
var $author$project$Data$RoleId$urlParser = A2(
	$elm$url$Url$Parser$custom,
	'ROLEID',
	function (str) {
		return $elm$core$Maybe$Just(str);
	});
var $author$project$Route$routeParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Route$Login, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Login,
			$elm$url$Url$Parser$s('login')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$DirectorRegistration,
			$elm$url$Url$Parser$s('casting-signup')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$MarketingDirectorRegistration,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('casting-signup'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$MarketingTalentRegistration,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('talent-signup'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AgencyRegistration,
			$elm$url$Url$Parser$s('agency-signup')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TalentRegistration,
			$elm$url$Url$Parser$s('talent-signup')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RoleIndex,
			$elm$url$Url$Parser$s('roles')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Project,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('projects'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TalentSearch,
			$elm$url$Url$Parser$s('talent-search')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Account,
			$elm$url$Url$Parser$s('account/profile')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AccountSubPage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('account'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TalentProfile,
			$elm$url$Url$Parser$s('talent-profile')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AgencyProfile,
			$elm$url$Url$Parser$s('agency-profile')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AgentProfile,
			$elm$url$Url$Parser$s('agent-profile')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Inbox,
			$elm$url$Url$Parser$s('inbox')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Dashboard,
			$elm$url$Url$Parser$s('dashboard')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Job,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('discover-jobs'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$JobIndex,
			$elm$url$Url$Parser$s('discover-jobs')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$MyJobs,
			$elm$url$Url$Parser$s('jobs')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Role,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('role'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AccountVerification,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('account'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ScheduleIndex,
			$elm$url$Url$Parser$s('schedules')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$SchedulePage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('schedules'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$DayOfPage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('schedule'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$CollaboratorsSignupPage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('signup-collaborators'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AgentsSignupPage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('signup-agents'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AgencyTalentSchedulePage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('talent-schedule'),
				$author$project$Data$RoleId$urlParser))
		]));
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Route$fromUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Route$PageNotFound,
		A2($elm$url$Url$Parser$parse, $author$project$Route$routeParser, url));
};
var $CurrySoftware$elm_datepicker$DatePicker$CurrentDate = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $elm$time$Time$May = 4;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$initDate = A3($justinmimbs$date$Date$fromCalendarDate, 1992, 4, 31);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.df, posixMinutes) < 0) {
					return posixMinutes + era.io;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		ha: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		h9: month,
		jZ: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ha;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).h9;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).jZ;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $CurrySoftware$elm_datepicker$DatePicker$init = _Utils_Tuple2(
	{
		ad: $elm$core$Maybe$Just($CurrySoftware$elm_datepicker$DatePicker$Date$initDate),
		aL: false,
		an: $elm$core$Maybe$Nothing,
		c2: false,
		a9: $CurrySoftware$elm_datepicker$DatePicker$Date$initDate
	},
	A2($elm$core$Task$perform, $CurrySoftware$elm_datepicker$DatePicker$CurrentDate, $justinmimbs$date$Date$today));
var $author$project$Utils$Closed = {$: 1};
var $author$project$Project$ClosedForm = 4;
var $author$project$SharedProjectRoleSchedules$DashboardDataPending = {$: 0};
var $author$project$Model$EmptyRouteData = {$: 1};
var $author$project$Message$FetchingAllDataFromTwilio = 0;
var $author$project$SharedProjectRoleSchedules$Hidden = 0;
var $author$project$Utils$HiddenConf = {$: 5};
var $author$project$Project$HiddenForm = 1;
var $author$project$Model$Hiding = {$: 1};
var $author$project$SharedProjectRoleSchedules$Initial = 3;
var $author$project$User$Invalid = 5;
var $author$project$Message$LoadingMessages = {$: 0};
var $author$project$Model$LoggingIn = 1;
var $author$project$SharedProjectRoleSchedules$NoImageShowing = 0;
var $author$project$User$NoStage = 27;
var $author$project$Project$NotEditing = {$: 0};
var $author$project$MainMsg$NotFetched = {$: 1};
var $author$project$Schedule$PublishedModalClosed = 2;
var $author$project$SharedProjectRoleSchedules$ResumeWaiting = {$: 0};
var $author$project$Pipeline$StandardPipeline = {$: 0};
var $author$project$Pipeline$StandardView = 0;
var $author$project$Filter$TOff = 8;
var $author$project$SharedProjectRoleSchedules$Waiting = {$: 0};
var $author$project$User$emptyAddress = {bv: '', bw: '', dr: '', aV: '', e0: '', a7: '', cu: ''};
var $author$project$User$emptyAgency = {bv: '', bw: '', cz: '', gr: _List_Nil, aV: '', cF: '', bl: '', bm: '', V: '', bE: '', eW: '', a7: '', dn: ''};
var $author$project$User$emptySearchTalentProfile = {gk: 0, gl: $author$project$User$emptyAgency, gC: '', dK: false, aV: '', cE: '', g0: '', dY: 0, bl: '', ea: _List_Nil, ho: '', bm: '', hw: '', hz: '', hA: '', hB: 0, cU: '', hE: _List_Nil, ev: false, bE: '', eZ: '', iI: '', iU: $elm$core$Maybe$Nothing, iX: '', aQ: '', iY: '', fx: _List_Nil, cs: false, jj: 27, a7: '', jT: _List_Nil, jV: 0, jX: 0};
var $author$project$Job$emptyApplicant = {V: '', iW: '', jj: 27, f_: $author$project$User$emptySearchTalentProfile, jN: ''};
var $author$project$Job$emptyApplication = {iW: '', jj: 27, jN: ''};
var $author$project$Message$emptyChatFilterValues = {gw: false, iG: 'Project', iO: false, fo: 'Role', da: _List_Nil, fC: ''};
var $author$project$User$Applied = 0;
var $author$project$User$Dateasc = 0;
var $author$project$Pipeline$emptyColumn = {g6: '', hs: 0, V: '', hL: false, bH: '', iz: 0, ji: 0, jR: _List_Nil};
var $author$project$User$emptyCompanyProfile = {gR: '', gS: '', gT: '', gU: '', gV: ''};
var $author$project$Message$ProjectRoleChannel = 0;
var $author$project$Message$emptyConversation = {dz: false, b0: 0, g9: '', V: '', hO: '', eA: '', hQ: '', hU: '', h3: _List_Nil, iH: '', iI: '', iX: '', aQ: '', iY: '', js: '', jt: '', jv: '', bW: 0};
var $author$project$Message$emptyFromTwilioPayload = {g: _List_Nil, t: '', k: $author$project$Message$emptyConversation, h3: _List_Nil};
var $author$project$Data$Image$emptyImage = {V: '', jM: '/default_user.png'};
var $author$project$Job$Searching = 0;
var $author$project$Job$ViewingJobClosed = 1;
var $author$project$SharedProjectRoleSchedules$emptyBasicProjectData = {gm: '', dE: '', gS: '', hf: '', V: '', hY: '', bH: '', e1: '', e9: '', fc: '', iJ: '', fq: _List_Nil, jg: '', fH: '', jr: $author$project$User$emptySearchTalentProfile, jw: '', jI: false};
var $author$project$Job$emptyJobPageData = {eO: _List_Nil, fe: _List_Nil, fB: 0, fC: '', fD: $author$project$SharedProjectRoleSchedules$emptyBasicProjectData, f3: 1};
var $author$project$Job$emptyNotification = {dG: '', gY: '', hT: '', aQ: '', cu: ''};
var $author$project$User$AgentUser = 4;
var $author$project$User$PendingResponse = 2;
var $author$project$User$emptyAgent = {$7: false, dp: 2, cz: '', dA: '', aV: '', bl: '', bm: '', V: '', eu: '/default_user.png', hT: 4, bE: '', eZ: '', fU: ''};
var $author$project$Profile$emptyProfilePageData = {cx: _List_Nil, bY: false, bB: $author$project$User$emptyAgent, dZ: 0, c7: false, bN: $author$project$MainMsg$NotFetched, fI: false, z: $author$project$MainMsg$NotFetched};
var $author$project$SharedProjectRoleSchedules$emptyDeadline = {bv: '', bw: '', aV: '', d8: '', hV: '', bH: '', fO: '', a7: '', dn: ''};
var $author$project$SharedProjectRoleSchedules$emptyProject = {
	gm: '',
	dz: false,
	gZ: '',
	hb: _List_fromArray(
		[$author$project$SharedProjectRoleSchedules$emptyDeadline]),
	cU: '',
	hK: false,
	bH: '',
	v: _List_Nil,
	iE: '',
	iJ: '0',
	fq: _List_Nil,
	f: _List_Nil,
	jw: '',
	jI: false,
	jN: ''
};
var $author$project$User$emptyProxyImage = {V: '', jM: ''};
var $author$project$SharedProjectRoleSchedules$emptyRole = {gg: false, dz: false, hb: _List_Nil, ea: _List_Nil, hy: _List_Nil, cU: '', cX: 100, hZ: 0, eI: 500, cZ: 0, h4: 0, eN: 0, bH: '', iE: '', fb: '', iH: '', iI: '', iV: '', iZ: ''};
var $author$project$Project$emptyRoleChangeInfo = {ie: '', aQ: '', cu: ''};
var $author$project$User$Talent = 0;
var $author$project$User$emptyUserData = {cE: '', bl: '', bm: '', cU: '', bE: '', eR: '', eW: '', eX: '', P: 0, i8: ''};
var $author$project$User$emptyUserPasswords = {cF: '', eR: '', eW: ''};
var $author$project$User$emptyManualAgency = {cz: '', gn: '', go: '', gp: '', gq: ''};
var $author$project$User$emptyNotificationSettings = {gy: true, h3: true, iD: true, ae: true, jr: true};
var $author$project$User$emptyUserProfile = {gk: 0, gl: $author$project$User$emptyAgency, cy: $author$project$User$emptyManualAgency, gr: _List_Nil, gC: '', aV: '', cE: '', bz: $author$project$User$emptyCompanyProfile, ha: '', bl: '', ea: _List_Nil, ho: '', bm: '', hw: '', hB: 0, cU: '', hE: _List_Nil, bE: '', cX: 0, cZ: 0, h9: '', $9: $author$project$User$emptyNotificationSettings, bJ: _List_Nil, eZ: '', ck: _List_Nil, iU: $elm$core$Maybe$Nothing, P: 5, a7: '', u: '', f$: $author$project$User$emptyAddress, f0: $author$project$User$emptyAddress, jV: 0, jX: 0, jZ: ''};
var $author$project$Data$Video$emptyVideo = {d9: false, V: '', eE: '', bH: '', eY: false, e8: '0%', aQ: '', fZ: '', jM: '', f5: false};
var $author$project$InitData$initTalentFilterValues = {hp: _List_Nil, hx: _List_Nil, cX: '', h_: '', eI: '', h$: '', cZ: '', h5: '', eN: '', h6: '', io: 0, iM: _List_Nil, i6: ''};
var $author$project$Api$Utils$NotAsked = {$: 0};
var $author$project$TalentProfileModal$initialModel = {cb: $elm$core$Maybe$Nothing, cc: false, h1: '', dd: 0, jr: $author$project$Api$Utils$NotAsked};
var $author$project$User$initialProfileValidations = {gC: false, ea: false, ho: false, hw: false, hB: false, hE: false, jX: false};
var $author$project$Project$RoleMenuClosed = {$: 1};
var $author$project$Project$initialProjectMenuState = {ed: true, ee: true, ef: true, db: $author$project$Project$RoleMenuClosed};
var $author$project$Views$DatePicker$initialRawDates = {gz: $elm$core$Maybe$Nothing, gA: $elm$core$Maybe$Nothing, gI: $elm$core$Maybe$Nothing, gJ: $elm$core$Maybe$Nothing, hu: $elm$core$Maybe$Nothing, iF: $elm$core$Maybe$Nothing, iK: $elm$core$Maybe$Nothing, jg: $elm$core$Maybe$Nothing, jn: $elm$core$Maybe$Nothing};
var $author$project$SharedProjectRoleSchedules$DefaultSchedulePage = function (a) {
	return {$: 0, a: a};
};
var $author$project$SharedProjectRoleSchedules$NoScheduleForm = 0;
var $author$project$SharedProjectRoleSchedules$emptyCollaboratorForm = {gi: false, dO: _List_Nil, cE: '', bl: '', aZ: false, cS: false, bm: '', bE: '', c2: false, iv: '', cu: ''};
var $author$project$SharedProjectRoleSchedules$emptySchedule = {gE: '', gF: '', gK: 0, g_: '', hi: '', V: '', a3: false, da: _List_Nil, i_: '', fq: _List_Nil, fv: '', fy: '', jk: '', jC: 10, jD: _List_Nil};
var $author$project$SharedProjectRoleSchedules$emptyScheduleDeadline = {bv: '', bw: '', aV: '', d8: '', hV: '', bH: 'Audition', fO: '', a7: '', dn: ''};
var $author$project$SharedProjectRoleSchedules$emptyScheduleProject = {
	gm: '',
	dz: false,
	gZ: '',
	hb: _List_fromArray(
		[$author$project$SharedProjectRoleSchedules$emptyScheduleDeadline]),
	cU: '',
	hK: false,
	bH: 'Select Project',
	v: _List_Nil,
	iE: '',
	iJ: '0',
	fq: _List_Nil,
	f: _List_Nil,
	jw: '',
	jI: false,
	jN: ''
};
var $author$project$User$emptyRoleInfo = {dQ: '', V: '', bH: '', iH: ''};
var $author$project$User$emptyPipelineUser = {gk: 0, gl: $author$project$User$emptyAgency, dy: 27, gC: '', aV: '', cE: '', g0: '', bl: '', ea: _List_Nil, ho: '', bm: '', hw: '', hz: '', hA: '', hB: 0, cU: '', hE: _List_Nil, bE: '', eZ: '', iI: '', iU: $elm$core$Maybe$Nothing, P: $author$project$User$emptyRoleInfo, iX: '', aQ: '', iY: '', fx: _List_Nil, cs: false, jj: 27, a7: '', jT: _List_Nil, jV: 0, jX: 0};
var $author$project$SharedProjectRoleSchedules$emptyUserSwapData = {S: $author$project$User$emptyPipelineUser, bn: false, q: $author$project$User$emptyPipelineUser, i0: '', U: '', J: ''};
var $author$project$SharedProjectRoleSchedules$initialSchedulePageData = {
	gB: false,
	D: _List_Nil,
	by: $author$project$SharedProjectRoleSchedules$emptyCollaboratorForm,
	dP: false,
	b2: '',
	aX: $author$project$SharedProjectRoleSchedules$emptySchedule,
	b6: $author$project$SharedProjectRoleSchedules$emptySchedule,
	d8: '',
	ae: $author$project$SharedProjectRoleSchedules$emptyScheduleProject,
	a3: false,
	fw: false,
	bP: 0,
	aE: $author$project$SharedProjectRoleSchedules$DefaultSchedulePage(''),
	fy: 'Audition',
	i3: _List_Nil,
	f: _List_Nil,
	ja: false,
	fJ: false,
	fO: '',
	f2: $author$project$SharedProjectRoleSchedules$emptyUserSwapData
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$State$NoDropTarget = {$: 0};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$State = $elm$core$Basics$identity;
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState = {b7: $elm$core$Maybe$Nothing, bi: $arsduo$elm_dom_drag_drop$Dom$DragDrop$State$NoDropTarget};
var $author$project$Filter$initialTalentFilterExpands = {ds: true, eb: true, ei: true, en: true, er: true, eJ: true, fL: true, gc: true};
var $author$project$User$MenuClosed = 1;
var $author$project$User$ModalClosed = {$: 0};
var $author$project$User$initialTalentMenuOptions = {g2: '', g4: '', h8: '', bG: $author$project$User$ModalClosed, ae: '', iP: '', fp: '', fq: _List_Nil, jr: $author$project$User$emptySearchTalentProfile, dk: 1};
var $author$project$Project$resetProjectValidation = {bH: false, iE: false};
var $author$project$Role$resetRoleValidations = {ea: false, hw: false, cX: false, hZ: false, eI: false, cZ: false, h4: false, eN: false, bH: false, fb: false, iV: false, iZ: false};
var $author$project$Model$initialModel = function (key) {
	return function (url) {
		return function (flags) {
			return function (submissionDatePicker) {
				return function (audStartDatePicker) {
					return function (audEndDatePicker) {
						return function (projectStartDatePicker) {
							return function (callStartDatePicker) {
								return function (callEndDatePicker) {
									return function (projectEndDatePicker) {
										return function (fittingDatePicker) {
											return function (shootDatePicker) {
												return {
													av: false,
													gl: $author$project$User$emptyAgency,
													a: $author$project$Model$Hiding,
													du: _List_Nil,
													dv: _List_Nil,
													dw: _List_Nil,
													bZ: $author$project$Message$LoadingMessages,
													A: _List_Nil,
													aw: _List_Nil,
													cA: _List_Nil,
													cB: $author$project$Job$emptyApplicant,
													dx: $author$project$Job$emptyApplication,
													cC: false,
													L: 1,
													ax: $author$project$User$emptyAddress,
													bf: '',
													b1: $author$project$Message$emptyChatFilterValues,
													dN: _List_Nil,
													gQ: $author$project$Pipeline$emptyColumn,
													aK: '',
													bz: $author$project$User$emptyCompanyProfile,
													l: false,
													al: $author$project$Utils$HiddenConf,
													cH: _List_Nil,
													g0: '',
													bC: '',
													bh: $author$project$Data$Image$emptyImage,
													d_: '',
													g3: '',
													i: $author$project$Route$fromUrl(url),
													cJ: $author$project$Model$EmptyRouteData,
													b4: 1,
													g5: '',
													b5: 27,
													cK: $author$project$Data$Video$emptyVideo,
													g7: $author$project$SharedProjectRoleSchedules$DashboardDataPending,
													B: {dC: audEndDatePicker, dD: audStartDatePicker, dI: callEndDatePicker, dJ: callStartDatePicker, ej: fittingDatePicker, fa: projectEndDatePicker, fd: projectStartDatePicker, fG: shootDatePicker, fR: submissionDatePicker},
													am: '',
													d1: '',
													aY: $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState,
													bj: false,
													cP: $author$project$Project$NotEditing,
													bl: '',
													ea: _List_Nil,
													hs: '',
													ht: '',
													ay: flags,
													cT: false,
													aj: 4,
													ca: 0,
													hy: _List_Nil,
													az: $author$project$User$emptyProxyImage,
													W: $author$project$SharedProjectRoleSchedules$Waiting,
													hE: _List_Nil,
													M: $author$project$Job$emptyJobPageData,
													hR: '',
													eB: key,
													hW: false,
													eG: 0,
													eH: 0,
													bn: false,
													h3: _List_Nil,
													eL: 0,
													eM: 0,
													ap: $author$project$Utils$Closed,
													eO: _List_Nil,
													y: {dG: ''},
													id: _List_Nil,
													bI: $author$project$Job$emptyNotification,
													bJ: _List_Nil,
													bp: false,
													it: $author$project$Pipeline$StandardPipeline,
													eW: '',
													aB: $author$project$User$emptyAddress,
													v: _List_Nil,
													e2: _List_Nil,
													iB: '',
													e6: false,
													e7: '',
													c: $author$project$Profile$emptyProfilePageData,
													as: $author$project$User$initialProfileValidations,
													ae: $author$project$SharedProjectRoleSchedules$emptyProject,
													aN: 1,
													c8: '',
													bM: false,
													cl: false,
													aC: $author$project$Project$initialProjectMenuState,
													aO: '',
													aP: $author$project$Project$resetProjectValidation,
													cm: 2,
													aD: 3,
													at: $author$project$Views$DatePicker$initialRawDates,
													co: $author$project$SharedProjectRoleSchedules$ResumeWaiting,
													P: $author$project$SharedProjectRoleSchedules$emptyRole,
													a5: $author$project$Project$emptyRoleChangeInfo,
													ah: 1,
													bO: '',
													T: $author$project$Role$resetRoleValidations,
													a6: $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState,
													bQ: $author$project$SharedProjectRoleSchedules$initialSchedulePageData,
													i5: '',
													i7: '',
													Y: '',
													br: '',
													H: 0,
													w: _List_Nil,
													aF: false,
													Z: false,
													bR: '',
													aG: '',
													ji: 'asc',
													dj: false,
													F: 8,
													I: $author$project$Filter$initialTalentFilterExpands,
													m: $author$project$InitData$initTalentFilterValues,
													Q: $author$project$User$initialTalentMenuOptions,
													aR: $author$project$TalentProfileModal$initialModel,
													fW: false,
													aH: false,
													a8: $author$project$MainMsg$NotFetched,
													r: 'Slayt',
													j: $author$project$Message$emptyFromTwilioPayload,
													au: 0,
													aT: $author$project$User$emptyUserData,
													jP: $author$project$User$emptyUserPasswords,
													z: $author$project$User$emptyUserProfile,
													R: $author$project$MainMsg$NotFetched,
													f1: 5,
													jQ: 0,
													cv: $author$project$SharedProjectRoleSchedules$Waiting,
													h: $author$project$SharedProjectRoleSchedules$emptyProject,
													p: $author$project$User$emptySearchTalentProfile,
													bX: 0
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Main$getUserToken = _Platform_outgoingPort('getUserToken', $elm$json$Json$Encode$string);
var $author$project$Main$loadData = function (page) {
	return $author$project$Main$getUserToken('');
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Main$init = F3(
	function (key, url, flags) {
		var _v0 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var submissionDatePicker = _v0.a;
		var submissionDatePickerCmd = _v0.b;
		var _v1 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var shootDatePicker = _v1.a;
		var shootDatePickerCmd = _v1.b;
		var _v2 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var projectStartDatePicker = _v2.a;
		var projectStartDatePickerCmd = _v2.b;
		var _v3 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var projectEndDatePicker = _v3.a;
		var projectEndDatePickerCmd = _v3.b;
		var _v4 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var fittingDatePicker = _v4.a;
		var fittingDatePickerCmd = _v4.b;
		var _v5 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var callStartDatePicker = _v5.a;
		var callStartDatePickerCmd = _v5.b;
		var _v6 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var callEndDatePicker = _v6.a;
		var callEndDatePickerCmd = _v6.b;
		var _v7 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var audStartDatePicker = _v7.a;
		var audStartDatePickerCmd = _v7.b;
		var _v8 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var audEndDatePicker = _v8.a;
		var audEndDatePickerCmd = _v8.b;
		var model = $author$project$Model$initialModel(key)(url)(flags)(submissionDatePicker)(audStartDatePicker)(audEndDatePicker)(projectStartDatePicker)(callStartDatePicker)(callEndDatePicker)(projectEndDatePicker)(fittingDatePicker)(shootDatePicker);
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Main$loadData(
						$author$project$Route$fromUrl(url)),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToSubDatePicker, submissionDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToAudStartDatePicker, audStartDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToAudEndDatePicker, audEndDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToProjectStartDatePicker, projectStartDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToCallStartDatePicker, callStartDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToCallEndDatePicker, callEndDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToProjectEndDatePicker, projectEndDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToFittingDatePicker, fittingDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToShootDatePicker, shootDatePickerCmd)
					])));
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$MainMsg$DataReceivedFromTwilio = function (a) {
	return {$: 225, a: a};
};
var $author$project$MainMsg$ReceiveSignInTokens = function (a) {
	return {$: 76, a: a};
};
var $author$project$MainMsg$ReceiveSignUpTokens = function (a) {
	return {$: 77, a: a};
};
var $author$project$MainMsg$ReceiveToken = function (a) {
	return {$: 80, a: a};
};
var $author$project$MainMsg$RefreshProjectData = F2(
	function (a, b) {
		return {$: 282, a: a, b: b};
	});
var $author$project$MainMsg$RefreshViewingTalent = F2(
	function (a, b) {
		return {$: 293, a: a, b: b};
	});
var $author$project$MainMsg$SignInError = function (a) {
	return {$: 39, a: a};
};
var $author$project$MainMsg$SignUpError = function (a) {
	return {$: 79, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Main$dataFromTwilio = _Platform_incomingPort('dataFromTwilio', $elm$json$Json$Decode$value);
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {e5: processes, fT: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.e5;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.fT);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Main$toElmSignIn = _Platform_incomingPort('toElmSignIn', $elm$json$Json$Decode$string);
var $author$project$Main$toElmSignInError = _Platform_incomingPort('toElmSignInError', $elm$json$Json$Decode$string);
var $author$project$Main$toElmSignUp = _Platform_incomingPort('toElmSignUp', $elm$json$Json$Decode$string);
var $author$project$Main$toElmSignUpError = _Platform_incomingPort('toElmSignUpError', $elm$json$Json$Decode$string);
var $author$project$Main$toElmToken = _Platform_incomingPort('toElmToken', $elm$json$Json$Decode$string);
var $author$project$Main$loginMessages = _List_fromArray(
	[
		$author$project$Main$toElmSignIn($author$project$MainMsg$ReceiveSignInTokens),
		$author$project$Main$toElmSignUp($author$project$MainMsg$ReceiveSignUpTokens),
		$author$project$Main$toElmToken($author$project$MainMsg$ReceiveToken),
		$author$project$Main$toElmSignUpError($author$project$MainMsg$SignUpError),
		$author$project$Main$toElmSignInError($author$project$MainMsg$SignInError)
	]);
var $author$project$MainMsg$FetchRefreshToken = function (a) {
	return {$: 148, a: a};
};
var $author$project$MainMsg$GetDataUpdates = function (a) {
	return {$: 75, a: a};
};
var $author$project$MainMsg$GetNotificationUpdates = function (a) {
	return {$: 240, a: a};
};
var $author$project$MainMsg$GotProgress = function (a) {
	return {$: 125, a: a};
};
var $author$project$MainMsg$GotVideoProgress = function (a) {
	return {$: 126, a: a};
};
var $author$project$MainMsg$PasswordEmailSent = function (a) {
	return {$: 310, a: a};
};
var $author$project$MainMsg$ReceivedCroppedUrl = function (a) {
	return {$: 256, a: a};
};
var $author$project$Main$croppedUrl = _Platform_incomingPort('croppedUrl', $elm$json$Json$Decode$string);
var $author$project$Main$passwordEmailSent = _Platform_incomingPort('passwordEmailSent', $elm$json$Json$Decode$string);
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {fj: reqs, fS: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.jH;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.fj));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.fS)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					gs: r.gs,
					dG: r.dG,
					eg: A2(_Http_mapExpect, func, r.eg),
					eq: r.eq,
					eK: r.eK,
					jE: r.jE,
					jH: r.jH,
					jM: r.jM
				});
		}
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$track = F2(
	function (tracker, toMsg) {
		return $elm$http$Http$subscription(
			A2($elm$http$Http$MySub, tracker, toMsg));
	});
var $author$project$Main$subMessages = _List_fromArray(
	[
		A2($elm$time$Time$every, 300000000, $author$project$MainMsg$GetDataUpdates),
		A2($elm$time$Time$every, 330000000, $author$project$MainMsg$FetchRefreshToken),
		A2($elm$time$Time$every, 20000000, $author$project$MainMsg$GetNotificationUpdates),
		$author$project$Main$toElmSignIn($author$project$MainMsg$ReceiveSignInTokens),
		$author$project$Main$toElmSignUp($author$project$MainMsg$ReceiveSignUpTokens),
		$author$project$Main$toElmToken($author$project$MainMsg$ReceiveToken),
		$author$project$Main$toElmSignUpError($author$project$MainMsg$SignUpError),
		$author$project$Main$toElmSignInError($author$project$MainMsg$SignInError),
		A2($elm$http$Http$track, 'upload', $author$project$MainMsg$GotProgress),
		A2($elm$http$Http$track, 'uploadVideo', $author$project$MainMsg$GotVideoProgress),
		$author$project$Main$croppedUrl($author$project$MainMsg$ReceivedCroppedUrl),
		$author$project$Main$passwordEmailSent($author$project$MainMsg$PasswordEmailSent),
		$author$project$Main$dataFromTwilio($author$project$MainMsg$DataReceivedFromTwilio)
	]);
var $author$project$Main$subscriptions = function (model) {
	var _v0 = model.i;
	switch (_v0.$) {
		case 10:
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$author$project$Main$toElmSignIn($author$project$MainMsg$ReceiveSignInTokens),
						$author$project$Main$toElmSignUp($author$project$MainMsg$ReceiveSignUpTokens),
						$author$project$Main$toElmToken($author$project$MainMsg$ReceiveToken),
						$author$project$Main$toElmSignUpError($author$project$MainMsg$SignUpError),
						$author$project$Main$toElmSignInError($author$project$MainMsg$SignInError),
						$author$project$Main$dataFromTwilio($author$project$MainMsg$DataReceivedFromTwilio)
					]));
		case 25:
			var projectId = _v0.a;
			var scheduleId = _v0.b;
			return $elm$core$Platform$Sub$batch(
				_Utils_ap(
					$author$project$Main$subMessages,
					_List_fromArray(
						[
							A2(
							$elm$time$Time$every,
							10000000,
							function (time) {
								return A2($author$project$MainMsg$RefreshProjectData, time, projectId);
							}),
							A2(
							$elm$time$Time$every,
							10000,
							function (time) {
								return A2($author$project$MainMsg$RefreshViewingTalent, time, model.p.aQ);
							})
						])));
		case 0:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 1:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 2:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 3:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 4:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 5:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 26:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 27:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		default:
			return $elm$core$Platform$Sub$batch($author$project$Main$subMessages);
	}
};
var $author$project$User$AcceptedApplicationRequest = 3;
var $author$project$User$AcceptedAudition = 6;
var $author$project$User$AcceptedBooking = 18;
var $author$project$User$AcceptedCallBack = 12;
var $author$project$RoleForms$AddEthnicity = 2;
var $author$project$RoleForms$AddGender = 0;
var $author$project$Model$AgencyTalentScheduleRouteData = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$AppliedToRole = 0;
var $author$project$Model$AudEnd = 2;
var $author$project$Model$AudStart = 1;
var $author$project$SharedProjectRoleSchedules$Body = $elm$core$Basics$identity;
var $author$project$Model$CallEnd = 5;
var $author$project$Model$CallStart = 4;
var $author$project$User$CanceledAudition = 10;
var $author$project$User$CanceledCallBack = 16;
var $author$project$MainMsg$ChatFileToString = function (a) {
	return {$: 229, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollaboratorAdded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Project$CreateRoleForm = 2;
var $author$project$MainMsg$CreateUser = {$: 78};
var $author$project$SharedProjectRoleSchedules$DashboardDataDone = function (a) {
	return {$: 2, a: a};
};
var $author$project$Utils$DeleteProject = {$: 3};
var $author$project$Project$Edit = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$Failed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Fitting = 7;
var $author$project$Utils$ForbiddenBookingColumn = {$: 7};
var $author$project$Utils$ForbiddenScheduleColumn = function (a) {
	return {$: 6, a: a};
};
var $author$project$SharedProjectRoleSchedules$FullScreen = 2;
var $author$project$MainMsg$GoToPage = function (a) {
	return {$: 296, a: a};
};
var $author$project$MainMsg$GotAgencyTalentScheduleMsg = function (a) {
	return {$: 326, a: a};
};
var $author$project$MainMsg$GotFile = F2(
	function (a, b) {
		return {$: 118, a: a, b: b};
	});
var $author$project$MainMsg$GotResume = F2(
	function (a, b) {
		return {$: 119, a: a, b: b};
	});
var $author$project$User$GotTalentInfo = function (a) {
	return {$: 2, a: a};
};
var $author$project$MainMsg$GotVideoFile = F2(
	function (a, b) {
		return {$: 121, a: a, b: b};
	});
var $author$project$SharedProjectRoleSchedules$JobSearchAction = 0;
var $author$project$Job$LandedOnPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$MainMsg$LoadMore = {$: 250};
var $author$project$SharedProjectRoleSchedules$LoadingScheduleData = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$MainMsg$Loadings = {$: 2};
var $author$project$Model$LoggedIn = 2;
var $author$project$MainMsg$Logout = {$: 32};
var $author$project$User$MenuOpen = 0;
var $author$project$User$MessageReceived = 20;
var $author$project$Message$Messages = function (a) {
	return {$: 1, a: a};
};
var $andrewMacmurray$elm_delay$Delay$Millisecond = 0;
var $author$project$MainMsg$NewMessageMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$MainMsg$NoOp = {$: 0};
var $author$project$Model$NotLoggedIn = 0;
var $author$project$Project$Pending = 0;
var $author$project$User$PendingApplicationRequest = 2;
var $author$project$User$PendingAudition = 5;
var $author$project$User$PendingBooking = 17;
var $author$project$User$PendingCallBack = 11;
var $author$project$SharedProjectRoleSchedules$PipelineUpdate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$ProfileInfo = 0;
var $author$project$Route$ProfileSubPage = function (a) {
	return {$: 18, a: a};
};
var $author$project$Model$ProjectEnd = 6;
var $author$project$Model$ProjectStart = 3;
var $author$project$MainMsg$PublishProject = {$: 156};
var $author$project$MainMsg$PublishRole = {$: 245};
var $author$project$Schedule$PublishScheduleUpdate = function (a) {
	return {$: 11, a: a};
};
var $author$project$SharedProjectRoleSchedules$QuickMessage = 1;
var $author$project$MainMsg$RedirectRoute = function (a) {
	return {$: 136, a: a};
};
var $author$project$User$RejectedApplicationRequest = 4;
var $author$project$User$RejectedAudition = 7;
var $author$project$User$RejectedBooking = 19;
var $author$project$User$RejectedCallBack = 13;
var $author$project$RoleForms$RemoveEthnicity = 4;
var $author$project$RoleForms$RemoveGender = 1;
var $author$project$User$RescheduleAuditionRequest = 8;
var $author$project$User$RescheduleCallBackRequest = 14;
var $author$project$User$RescheduledAudition = 9;
var $author$project$User$RescheduledCallBack = 15;
var $author$project$Schedule$ResetSchedulePageData = {$: 6};
var $author$project$User$RoleCanceled = 21;
var $author$project$User$RoleChanged = 22;
var $author$project$Project$Saving = 2;
var $author$project$SharedProjectRoleSchedules$SavingSchedule = 3;
var $author$project$Schedule$ScheduleDataLoading = {$: 7};
var $author$project$Schedule$ScheduleDataUpdate = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$SharedProjectRoleSchedules$ScheduleDayOfPage = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Schedule$ScheduleFormViewUpdate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Schedule$ScheduleListUpdate = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Schedule$SchedulePageViewUpdate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Schedule$ScheduleProjectUpdate = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$MainMsg$SearchJobs = {$: 305};
var $author$project$Job$SearchResults = function (a) {
	return {$: 5, a: a};
};
var $author$project$MainMsg$SearchUsers = {$: 140};
var $author$project$Job$SearchingJobs = {$: 2};
var $author$project$MainMsg$SetToLoggedIn = {$: 137};
var $author$project$Model$Shoot = 8;
var $author$project$Model$Showing = function (a) {
	return {$: 0, a: a};
};
var $author$project$SharedProjectRoleSchedules$ShowingMini = 1;
var $author$project$Model$Submission = 0;
var $author$project$MainMsg$Successs = function (a) {
	return {$: 3, a: a};
};
var $author$project$Schedule$SwitchViewingSchedules = function (a) {
	return {$: 4, a: a};
};
var $author$project$SharedProjectRoleSchedules$TalentSearchAction = 1;
var $author$project$MainMsg$Timeout = F2(
	function (a, b) {
		return {$: 260, a: a, b: b};
	});
var $author$project$MainMsg$ToggleColumnMenu = function (a) {
	return {$: 159, a: a};
};
var $author$project$MainMsg$ToggleFormOpen = function (a) {
	return {$: 24, a: a};
};
var $author$project$User$ToggleMenuModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Project$ToggleRoleMenu = function (a) {
	return {$: 3, a: a};
};
var $author$project$MainMsg$TypingEnded = function (a) {
	return {$: 264, a: a};
};
var $author$project$MainMsg$UpdateCollaboratorData = function (a) {
	return {$: 266, a: a};
};
var $author$project$SharedProjectRoleSchedules$UpdateCollaborators = function (a) {
	return {$: 7, a: a};
};
var $author$project$Schedule$UpdateCollaboratorsModal = {$: 13};
var $author$project$MainMsg$UpdateCurrentProjectId = function (a) {
	return {$: 93, a: a};
};
var $author$project$Schedule$UpdateMyComment = function (a) {
	return {$: 14, a: a};
};
var $author$project$MainMsg$UpdateProfileHeightValue = {$: 82};
var $author$project$Project$UpdateProjectForm = 1;
var $author$project$MainMsg$UpdateProjectMenuState = function (a) {
	return {$: 243, a: a};
};
var $author$project$MainMsg$UpdateSearchingRole = function (a) {
	return {$: 314, a: a};
};
var $author$project$Schedule$UpdateTimeSlot = function (a) {
	return {$: 5, a: a};
};
var $author$project$MainMsg$UpdateVotingComment = function (a) {
	return {$: 281, a: a};
};
var $author$project$SharedProjectRoleSchedules$Uploading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Project$User = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Schedule$User = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$RoleForms$UserAddEthnicity = 3;
var $author$project$User$UserEmail = function (a) {
	return {$: 2, a: a};
};
var $author$project$RoleForms$UserRemoveEthnicity = 5;
var $author$project$SharedProjectRoleSchedules$UserSwapData = F6(
	function (menuOpen, movingUser, droppedOnUser, timeSlotDroppedOn, timeSlotMovedFrom, scheduleId) {
		return {S: droppedOnUser, bn: menuOpen, q: movingUser, i0: scheduleId, U: timeSlotDroppedOn, J: timeSlotMovedFrom};
	});
var $author$project$Schedule$UserSwapDataUpdate = function (a) {
	return {$: 9, a: a};
};
var $author$project$MainMsg$VerifyCollabForm = function (a) {
	return {$: 267, a: a};
};
var $author$project$SharedProjectRoleSchedules$VerifyForm = {$: 6};
var $author$project$SharedProjectRoleSchedules$VerifyInput = 2;
var $author$project$MainMsg$View = function (a) {
	return {$: 21, a: a};
};
var $author$project$MainMsg$ViewThenMarkAsRead = F2(
	function (a, b) {
		return {$: 239, a: a, b: b};
	});
var $author$project$SharedProjectRoleSchedules$Votes = 4;
var $author$project$SharedProjectRoleSchedules$VotesComments = 5;
var $author$project$MainMsg$AgentAdded = function (a) {
	return {$: 263, a: a};
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$Encoders$addAgentEncoder = F2(
	function (agentId, agencyId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'agent_id',
					$elm$json$Json$Encode$string(agentId)),
					_Utils_Tuple2(
					'agency_id',
					$elm$json$Json$Encode$string(agencyId))
				]));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Api$Request$authorizationHeader = function (token) {
	return A2($elm$http$Http$header, 'jwt', token);
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.jl));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{gs: false, dG: r.dG, eg: r.eg, eq: r.eq, eK: r.eK, jE: r.jE, jH: r.jH, jM: r.jM}));
};
var $author$project$Api$BaseUrl$talentSourceUrl = 'https://slayt-live-production.herokuapp.com/';
var $author$project$User$UserProfile = function (id_) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phone) {
					return function (eyeColor) {
						return function (birthDate) {
							return function (month) {
								return function (day) {
									return function (year) {
										return function (gender) {
											return function (ethnicities) {
												return function (height) {
													return function (weight) {
														return function (waistSize) {
															return function (city) {
																return function (state) {
																	return function (company) {
																		return function (role) {
																			return function (images) {
																				return function (minAge) {
																					return function (maxAge) {
																						return function (age) {
																							return function (companyProfile) {
																								return function (userBillingAddress) {
																									return function (userPhysicalAddress) {
																										return function (twilioToken) {
																											return function (notifications) {
																												return function (profilePages) {
																													return function (agency) {
																														return function (notificationSettings) {
																															return function (agents) {
																																return function (agencyForm) {
																																	return function (resume) {
																																		return {gk: age, gl: agency, cy: agencyForm, gr: agents, gC: birthDate, aV: city, cE: company, bz: companyProfile, ha: day, bl: email, ea: ethnicities, ho: eyeColor, bm: firstName, hw: gender, hB: height, cU: id_, hE: images, bE: lastName, cX: maxAge, cZ: minAge, h9: month, $9: notificationSettings, bJ: notifications, eZ: phone, ck: profilePages, iU: resume, P: role, a7: state, u: twilioToken, f$: userBillingAddress, f0: userPhysicalAddress, jV: waistSize, jX: weight, jZ: year};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$Address = F7(
	function (address1, address2, city, state, postalCode, addressType, userId) {
		return {bv: address1, bw: address2, dr: addressType, aV: city, e0: postalCode, a7: state, cu: userId};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Api$Decoders$addressDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'user_id',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'kind',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'postal_code',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'state',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'city',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'address2',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'address1',
							$elm$json$Json$Decode$string,
							'',
							$elm$json$Json$Decode$succeed($author$project$User$Address))))))));
var $author$project$User$Agency = function (id) {
	return function (agencyName) {
		return function (firstName) {
			return function (lastName) {
				return function (agents) {
					return function (address1) {
						return function (address2) {
							return function (city) {
								return function (state) {
									return function (zip) {
										return function (email) {
											return function (password) {
												return function (confirmPassword) {
													return {bv: address1, bw: address2, cz: agencyName, gr: agents, aV: city, cF: confirmPassword, bl: email, bm: firstName, V: id, bE: lastName, eW: password, a7: state, dn: zip};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$Agent = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phone) {
					return function (imageUrl) {
						return function (city) {
							return function (talentCount) {
								return function (acceptedInvitation) {
									return function (agencyName) {
										return function (associationId) {
											return function (acceptedTalent) {
												return function (kind) {
													return {$7: acceptedInvitation, dp: acceptedTalent, cz: agencyName, dA: associationId, aV: city, bl: email, bm: firstName, V: id, eu: imageUrl, hT: kind, bE: lastName, eZ: phone, fU: talentCount};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$User$AcceptedTalent = 0;
var $author$project$User$RejectedTalent = 1;
var $author$project$Api$Decoders$decodeAgentAcceptanceType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Accepted':
				return $elm$json$Json$Decode$succeed(0);
			case 'Rejected':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$succeed(2);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$User$AgencyUser = 3;
var $author$project$User$Collaborating = 2;
var $author$project$User$Director = 1;
var $author$project$Api$Decoders$decodeUserType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Talent':
				return $elm$json$Json$Decode$succeed(0);
			case 'Director':
				return $elm$json$Json$Decode$succeed(1);
			case 'Collaborator':
				return $elm$json$Json$Decode$succeed(2);
			case 'Agency':
				return $elm$json$Json$Decode$succeed(3);
			case 'Agent':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$agentDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'kind',
	$author$project$Api$Decoders$decodeUserType,
	4,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'accepted_talent',
		$author$project$Api$Decoders$decodeAgentAcceptanceType,
		2,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'association_id',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'agency_name',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'accepted_invitation',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'talent_count',
						$elm$json$Json$Decode$string,
						'0',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'city',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'image_url',
								$elm$json$Json$Decode$string,
								'./default_user.png',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'phone',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'email',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'last_name',
											$elm$json$Json$Decode$string,
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'first_name',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'id',
													$elm$json$Json$Decode$string,
													'',
													$elm$json$Json$Decode$succeed($author$project$User$Agent))))))))))))));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Api$Decoders$agentsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$agentDecoder);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Api$Decoders$agencyDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'password_confirmation',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'password',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'email',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'zip',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'state',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'city',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'address_2',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'address_1',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'agents',
									$author$project$Api$Decoders$agentsDecoder,
									_List_Nil,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'last_name',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'first_name',
											$elm$json$Json$Decode$string,
											'',
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'agency_name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$User$Agency))))))))))))));
var $author$project$User$ManualAgency = F5(
	function (agencyName, agentFirstName, agentLastName, agentEmail, agentPhone) {
		return {cz: agencyName, gn: agentEmail, go: agentFirstName, gp: agentLastName, gq: agentPhone};
	});
var $author$project$Api$Decoders$agencyFormDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'agent_phone',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'agent_email',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'agent_last_name',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'agent_first_name',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'agency_name',
					$elm$json$Json$Decode$string,
					'',
					$elm$json$Json$Decode$succeed($author$project$User$ManualAgency))))));
var $author$project$User$CompanyProfile = F5(
	function (companyName, companyType, companyWebAddress, companyPhone, companyId) {
		return {gR: companyId, gS: companyName, gT: companyPhone, gU: companyType, gV: companyWebAddress};
	});
var $author$project$Api$Decoders$companyDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'id',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'phone',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'web_address',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'kind',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'name',
					$elm$json$Json$Decode$string,
					'',
					$elm$json$Json$Decode$succeed($author$project$User$CompanyProfile))))));
var $author$project$User$Option = F2(
	function (name, id) {
		return {V: id, bH: name};
	});
var $author$project$Api$Decoders$optionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$User$Option)));
var $author$project$Api$Decoders$ethnicitiesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$optionDecoder);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Data$Image$Image = F2(
	function (id, url) {
		return {V: id, jM: url};
	});
var $author$project$Api$Decoders$imageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'image_url',
	$elm$json$Json$Decode$string,
	'./default_user.png',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'id',
		$elm$json$Json$Decode$string,
		'',
		$elm$json$Json$Decode$succeed($author$project$Data$Image$Image)));
var $author$project$Api$Decoders$imagesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$imageDecoder);
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$User$NotificationSettings = F5(
	function (project, talent, messages, audition, profileUpdate) {
		return {gy: audition, h3: messages, iD: profileUpdate, ae: project, jr: talent};
	});
var $author$project$Api$Decoders$notificationSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'profile_update',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'audition',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'messages',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'talent',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'project',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$User$NotificationSettings))))));
var $author$project$User$UserNotification = function (id) {
	return function (body) {
		return function (isRead) {
			return function (roleMemberId) {
				return function (jobPosterId) {
					return function (talentId) {
						return function (kind) {
							return function (updatedAt) {
								return function (count) {
									return function (projectId) {
										return function (conversationId) {
											return function (roleId) {
												return function (jobPosterAvatar) {
													return function (talentAvatar) {
														return function (talentName) {
															return function (jobPosterName) {
																return function (projectName) {
																	return function (roleName) {
																		return {dG: body, gY: conversationId, dU: count, V: id, hN: isRead, hO: jobPosterAvatar, eA: jobPosterId, hQ: jobPosterName, hT: kind, iH: projectId, iI: projectName, iX: roleId, aQ: roleMemberId, iY: roleName, js: talentAvatar, jt: talentId, jv: talentName, fY: updatedAt};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$AgentAddedToRole = 1;
var $author$project$User$AgentRemoved = 25;
var $author$project$User$DirectorRemoved = 24;
var $author$project$User$Scheduled = 26;
var $author$project$User$TalentRemoved = 23;
var $author$project$Api$Decoders$stageDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Applied':
				return $elm$json$Json$Decode$succeed(0);
			case 'Agent Added':
				return $elm$json$Json$Decode$succeed(1);
			case 'Requested to Apply':
				return $elm$json$Json$Decode$succeed(2);
			case 'Accepted Application':
				return $elm$json$Json$Decode$succeed(3);
			case 'Rejected Application':
				return $elm$json$Json$Decode$succeed(4);
			case 'Audition Requested':
				return $elm$json$Json$Decode$succeed(5);
			case 'Audition Accepted':
				return $elm$json$Json$Decode$succeed(6);
			case 'Audition Rejected':
				return $elm$json$Json$Decode$succeed(7);
			case 'Audition Reschedule Requested':
				return $elm$json$Json$Decode$succeed(8);
			case 'Audition Rescheduled':
				return $elm$json$Json$Decode$succeed(9);
			case 'Audition Canceled':
				return $elm$json$Json$Decode$succeed(10);
			case 'Callback Requested':
				return $elm$json$Json$Decode$succeed(11);
			case 'Callback Accepted':
				return $elm$json$Json$Decode$succeed(12);
			case 'Callback Rejected':
				return $elm$json$Json$Decode$succeed(13);
			case 'Callback Reschedule Requested':
				return $elm$json$Json$Decode$succeed(14);
			case 'Callback Rescheduled':
				return $elm$json$Json$Decode$succeed(15);
			case 'Callback Canceled':
				return $elm$json$Json$Decode$succeed(16);
			case 'Booking Request':
				return $elm$json$Json$Decode$succeed(17);
			case 'Booking Accepted':
				return $elm$json$Json$Decode$succeed(18);
			case 'Booking Rejected':
				return $elm$json$Json$Decode$succeed(19);
			case 'Role Canceled':
				return $elm$json$Json$Decode$succeed(21);
			case 'Role Changed':
				return $elm$json$Json$Decode$succeed(22);
			case 'message':
				return $elm$json$Json$Decode$succeed(20);
			case 'Scheduled':
				return $elm$json$Json$Decode$succeed(26);
			case 'Removed By Agent':
				return $elm$json$Json$Decode$succeed(25);
			case 'Removed By Talent':
				return $elm$json$Json$Decode$succeed(23);
			case 'Removed By Director':
				return $elm$json$Json$Decode$succeed(24);
			default:
				return $elm$json$Json$Decode$succeed(27);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$notificationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'role_name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'project_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'job_poster_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'talent_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'talent_avatar',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'job_poster_avatar',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'role_id',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'conversation_id',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'project_id',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'count',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'updated_at',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'kind',
												$author$project$Api$Decoders$stageDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'talent_id',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'job_poster_id',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'role_member_id',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'is_read',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'body',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'id',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$User$UserNotification)))))))))))))))))));
var $author$project$Api$Decoders$notificationsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$notificationDecoder);
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$User$ProfilePage = F2(
	function (id, title) {
		return {V: id, r: title};
	});
var $author$project$Api$Decoders$profilePageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'title',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$User$ProfilePage)));
var $author$project$Api$Decoders$profilePagesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$profilePageDecoder);
var $author$project$Api$Decoders$updateProfileDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'resume',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'agencyForm',
		$author$project$Api$Decoders$agencyFormDecoder,
		$author$project$User$emptyManualAgency,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'agents',
			$author$project$Api$Decoders$agentsDecoder,
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'notification_settings',
				$author$project$Api$Decoders$notificationSettingsDecoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'agency',
					$author$project$Api$Decoders$agencyDecoder,
					$author$project$User$emptyAgency,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'profile_pages',
						$author$project$Api$Decoders$profilePagesDecoder,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'notifications',
							$author$project$Api$Decoders$notificationsDecoder,
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'twilio_token',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'physicalAddress',
									$author$project$Api$Decoders$addressDecoder,
									$author$project$User$emptyAddress,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'billingAddress',
										$author$project$Api$Decoders$addressDecoder,
										$author$project$User$emptyAddress,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'companyInfo',
											$author$project$Api$Decoders$companyDecoder,
											$author$project$User$emptyCompanyProfile,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'age',
												$elm$json$Json$Decode$int,
												0,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'max_age',
													$elm$json$Json$Decode$int,
													100,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'min_age',
														$elm$json$Json$Decode$int,
														0,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'images',
															$author$project$Api$Decoders$imagesDecoder,
															_List_Nil,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'kind',
																$author$project$Api$Decoders$decodeUserType,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'company',
																	$elm$json$Json$Decode$string,
																	'',
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'state',
																		$elm$json$Json$Decode$string,
																		'',
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'city',
																			$elm$json$Json$Decode$string,
																			'',
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'waist_size',
																				$elm$json$Json$Decode$oneOf(
																					_List_fromArray(
																						[
																							$elm$json$Json$Decode$float,
																							$elm$json$Json$Decode$null(0)
																						])),
																				0,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'weight',
																					$elm$json$Json$Decode$int,
																					0,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'height',
																						$elm$json$Json$Decode$int,
																						0,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'ethnicities',
																							$author$project$Api$Decoders$ethnicitiesDecoder,
																							_List_Nil,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'gender',
																								$elm$json$Json$Decode$string,
																								'',
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'year',
																									$elm$json$Json$Decode$string,
																									'',
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'day',
																										$elm$json$Json$Decode$string,
																										'',
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'month',
																											$elm$json$Json$Decode$string,
																											'',
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'birth_date',
																												$elm$json$Json$Decode$string,
																												'',
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'eye_color',
																													$elm$json$Json$Decode$string,
																													'',
																													A4(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																														'phone',
																														$elm$json$Json$Decode$string,
																														'',
																														A4(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																															'email',
																															$elm$json$Json$Decode$string,
																															'',
																															A4(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																'last_name',
																																$elm$json$Json$Decode$string,
																																'',
																																A4(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																	'first_name',
																																	$elm$json$Json$Decode$string,
																																	'',
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'id',
																																		$elm$json$Json$Decode$string,
																																		$elm$json$Json$Decode$succeed($author$project$User$UserProfile)))))))))))))))))))))))))))))))))));
var $author$project$Api$Request$addAgentToUser = F3(
	function (agentId, agencyId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$addAgentEncoder, agentId, agencyId)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$AgentAdded, $author$project$Api$Decoders$updateProfileDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'users/add_agent'
			});
	});
var $author$project$MainMsg$AddedCollaborator = function (a) {
	return {$: 269, a: a};
};
var $author$project$Api$Encoders$collaboratorEncoder = F2(
	function (collaborator, projectId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'first_name',
					$elm$json$Json$Encode$string(collaborator.bm)),
					_Utils_Tuple2(
					'last_name',
					$elm$json$Json$Encode$string(collaborator.bE)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(collaborator.bl)),
					_Utils_Tuple2(
					'company',
					$elm$json$Json$Encode$string(collaborator.cE)),
					_Utils_Tuple2(
					'phone_number',
					$elm$json$Json$Encode$string(collaborator.iv)),
					_Utils_Tuple2(
					'user_id',
					$elm$json$Json$Encode$string(collaborator.cu)),
					_Utils_Tuple2(
					'project_id',
					$elm$json$Json$Encode$string(projectId))
				]));
	});
var $author$project$User$Collaborator = F8(
	function (id, email, firstName, lastName, phoneNumber, company, invitationId, accepted) {
		return {cw: accepted, cE: company, bl: email, bm: firstName, V: id, ey: invitationId, bE: lastName, iv: phoneNumber};
	});
var $author$project$Api$Decoders$collaboratorDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accepted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invitation_id',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'company',
			$elm$json$Json$Decode$string,
			'N/A',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'phone',
				$elm$json$Json$Decode$string,
				'N/A',
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'last_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'first_name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'email',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$User$Collaborator)))))))));
var $author$project$Api$Decoders$collaboratorsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$collaboratorDecoder);
var $author$project$Api$Request$addCollaborator = F3(
	function (collaboratorData, jwt, projectId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$collaboratorEncoder, collaboratorData, projectId)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$AddedCollaborator, $author$project$Api$Decoders$collaboratorsDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'collaborators/add'
			});
	});
var $author$project$Main$addMoreUsersToList = F2(
	function (newUsers, currentUsers) {
		var users = function () {
			if (currentUsers.$ === 3) {
				var u = currentUsers.a;
				return u;
			} else {
				return _List_Nil;
			}
		}();
		return A2($elm$core$List$append, users, newUsers);
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Main$addOrRemoveSelectedTalent = F2(
	function (talent, selectedTalent) {
		return A2(
			$elm$core$List$any,
			function (profile) {
				return _Utils_eq(profile.cU, talent.cU);
			},
			selectedTalent) ? A2(
			$elm$core$List$filter,
			function (profile) {
				return !_Utils_eq(profile.cU, talent.cU);
			},
			selectedTalent) : A2($elm$core$List$cons, talent, selectedTalent);
	});
var $author$project$Main$addPipelineToViewingProject = F2(
	function (project, columns) {
		return _Utils_update(
			project,
			{v: columns});
	});
var $author$project$Main$addSchedulesToViewingProject = F2(
	function (project, schedules) {
		return _Utils_update(
			project,
			{f: schedules});
	});
var $author$project$MainMsg$AddedUpdatedAgent = function (a) {
	return {$: 105, a: a};
};
var $author$project$Api$Encoders$agentEncoder = function (agent) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(agent.bm)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(agent.bE)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(agent.bl)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(agent.aV)),
				_Utils_Tuple2(
				'agent_id',
				$elm$json$Json$Encode$string(agent.V))
			]));
};
var $author$project$Api$Request$addUpdateAgent = F3(
	function (agent, agencyId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$agentEncoder(agent)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$AddedUpdatedAgent, $author$project$Api$Decoders$agentsDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('agencies/' + (agencyId + '/agents'))
			});
	});
var $author$project$MainMsg$TimeSlotUpdated = function (a) {
	return {$: 207, a: a};
};
var $author$project$SharedProjectRoleSchedules$TimeSlot = F8(
	function (id, eventTime, user, scheduleId, votes, comments, scheduleType, formattedTime) {
		return {dR: comments, hj: eventTime, el: formattedTime, V: id, i0: scheduleId, fy: scheduleType, f_: user, f7: votes};
	});
var $author$project$SharedProjectRoleSchedules$Comment = F6(
	function (id, body, creatorId, creatorName, creatorAvatar, updatedAt) {
		return {dG: body, dV: creatorAvatar, g_: creatorId, dW: creatorName, V: id, fY: updatedAt};
	});
var $author$project$Api$Decoders$commentDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'updated_at',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'creator_avatar',
		$elm$json$Json$Decode$string,
		$author$project$Data$Image$emptyImage.jM,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'creator_name',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'creator_id',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'body',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'id',
						$elm$json$Json$Decode$string,
						'',
						$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$Comment)))))));
var $author$project$Api$Decoders$commentsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$commentDecoder);
var $author$project$Api$Decoders$decodeTime = A2(
	$elm$json$Json$Decode$andThen,
	function (ms) {
		return $elm$json$Json$Decode$succeed(
			$elm$time$Time$millisToPosix(ms));
	},
	$elm$json$Json$Decode$int);
var $author$project$User$PipelineUser = function (id_) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phone) {
					return function (eyeColor) {
						return function (birthDate) {
							return function (gender) {
								return function (ethnicities) {
									return function (height) {
										return function (weight) {
											return function (waistSize) {
												return function (city) {
													return function (state) {
														return function (company) {
															return function (images) {
																return function (videos) {
																	return function (hairColor) {
																		return function (hairLength) {
																			return function (roleMemberId) {
																				return function (selected) {
																					return function (role) {
																						return function (currentColumn) {
																							return function (stage) {
																								return function (applicationStage) {
																									return function (age) {
																										return function (roleName) {
																											return function (projectName) {
																												return function (roleId) {
																													return function (scheduleMembers) {
																														return function (agency) {
																															return function (resume) {
																																return {gk: age, gl: agency, dy: applicationStage, gC: birthDate, aV: city, cE: company, g0: currentColumn, bl: email, ea: ethnicities, ho: eyeColor, bm: firstName, hw: gender, hz: hairColor, hA: hairLength, hB: height, cU: id_, hE: images, bE: lastName, eZ: phone, iI: projectName, iU: resume, P: role, iX: roleId, aQ: roleMemberId, iY: roleName, fx: scheduleMembers, cs: selected, jj: stage, a7: state, jT: videos, jV: waistSize, jX: weight};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$RoleInfo = F4(
	function (name, id, projectId, columnId) {
		return {dQ: columnId, V: id, bH: name, iH: projectId};
	});
var $author$project$Api$Decoders$roleInfoDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'column_id',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'project_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$User$RoleInfo)))));
var $author$project$User$ScheduleMember = F5(
	function (id, scheduleType, scheduleStatus, body, scheduledTime) {
		return {dG: body, V: id, dc: scheduleStatus, fy: scheduleType, fA: scheduledTime};
	});
var $author$project$Api$Decoders$scheduleMemberDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'scheduled_time',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'body',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'schedule_status',
			$author$project$Api$Decoders$stageDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'schedule_type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$User$ScheduleMember))))));
var $author$project$Data$Video$Video = function (id) {
	return function (name) {
		return function (url) {
			return function (length) {
				return function (visible) {
					return function (pending) {
						return function (error) {
							return function (roleMemberId) {
								return function (uploadId) {
									return function (progress) {
										return {d9: error, V: id, eE: length, bH: name, eY: pending, e8: progress, aQ: roleMemberId, fZ: uploadId, jM: url, f5: visible};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Decoders$videoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'progress',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'upload_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'role_member_id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'error',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pending',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'visible',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'length',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'url',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Data$Video$Video)))))))))));
var $author$project$Api$Decoders$videosDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$videoDecoder);
var $author$project$Api$Decoders$pipelineUserDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'resume',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'agency',
		$author$project$Api$Decoders$agencyDecoder,
		$author$project$User$emptyAgency,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'schedule_members',
			$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleMemberDecoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'role_id',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'project_name',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'role_name',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'age',
							$elm$json$Json$Decode$int,
							0,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'application_status',
								$author$project$Api$Decoders$stageDecoder,
								27,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'stage',
									$author$project$Api$Decoders$stageDecoder,
									27,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'current_column',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'role',
											$author$project$Api$Decoders$roleInfoDecoder,
											$author$project$User$emptyRoleInfo,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'selected',
												$elm$json$Json$Decode$bool,
												false,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'role_member_id',
													$elm$json$Json$Decode$string,
													'',
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'hair_length',
														$elm$json$Json$Decode$string,
														'',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'hair_color',
															$elm$json$Json$Decode$string,
															'',
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'videos',
																$author$project$Api$Decoders$videosDecoder,
																_List_Nil,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'images',
																	$author$project$Api$Decoders$imagesDecoder,
																	_List_Nil,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'company',
																		$elm$json$Json$Decode$string,
																		'',
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'state',
																			$elm$json$Json$Decode$string,
																			'',
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'city',
																				$elm$json$Json$Decode$string,
																				'',
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'waist_size',
																					$elm$json$Json$Decode$oneOf(
																						_List_fromArray(
																							[
																								$elm$json$Json$Decode$float,
																								$elm$json$Json$Decode$null(0)
																							])),
																					0,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'weight',
																						$elm$json$Json$Decode$int,
																						0,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'height',
																							$elm$json$Json$Decode$int,
																							0,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'ethnicities',
																								$author$project$Api$Decoders$ethnicitiesDecoder,
																								_List_Nil,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'gender',
																									$elm$json$Json$Decode$string,
																									'',
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'birth_date',
																										$elm$json$Json$Decode$string,
																										'',
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'eye_color',
																											$elm$json$Json$Decode$string,
																											'',
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'phone',
																												$elm$json$Json$Decode$string,
																												'',
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'email',
																													$elm$json$Json$Decode$string,
																													'',
																													A4(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																														'last_name',
																														$elm$json$Json$Decode$string,
																														'',
																														A4(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																															'first_name',
																															$elm$json$Json$Decode$string,
																															'',
																															A4(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																'id',
																																$elm$json$Json$Decode$string,
																																'',
																																$elm$json$Json$Decode$succeed($author$project$User$PipelineUser)))))))))))))))))))))))))))))))));
var $author$project$SharedProjectRoleSchedules$Vote = F5(
	function (id, vote, roleMemberId, votingUserName, votingUserId) {
		return {V: id, aQ: roleMemberId, f6: vote, f8: votingUserId, f9: votingUserName};
	});
var $author$project$Api$Decoders$voteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'voting_user_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'voting_user_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'role_member_id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vote',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$Vote))))));
var $author$project$Api$Decoders$votesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$voteDecoder);
var $author$project$Api$Decoders$timeSlotDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'formatted_time',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'schedule_type',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'comments',
			$author$project$Api$Decoders$commentsDecoder,
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'votes',
				$author$project$Api$Decoders$votesDecoder,
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'schedule_id',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'user',
						$author$project$Api$Decoders$pipelineUserDecoder,
						$author$project$User$emptyPipelineUser,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'event_time',
							$author$project$Api$Decoders$decodeTime,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'id',
								$elm$json$Json$Decode$string,
								'',
								$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$TimeSlot)))))))));
var $author$project$Api$Encoders$timeSlotUpdateEncoder = F4(
	function (roleMemberId, currentTimeSlot, newTimeSlotId, currentColumnId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'new_time_slot',
					$elm$json$Json$Encode$string(newTimeSlotId)),
					_Utils_Tuple2(
					'role_member_id',
					$elm$json$Json$Encode$string(roleMemberId)),
					_Utils_Tuple2(
					'current_column_id',
					$elm$json$Json$Encode$string(currentColumnId)),
					_Utils_Tuple2(
					'current_time_slot',
					$elm$json$Json$Encode$string(currentTimeSlot))
				]));
	});
var $author$project$Api$Request$addUserToSchedule = F5(
	function (roleMemberId, currentTimeSlotId, newTimeSlot, currentColumn, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A4($author$project$Api$Encoders$timeSlotUpdateEncoder, roleMemberId, currentTimeSlotId, newTimeSlot, currentColumn)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$TimeSlotUpdated, $author$project$Api$Decoders$timeSlotDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'PUT',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'schedules/update_time_slot'
			});
	});
var $author$project$Main$addUser = F5(
	function (user, newTimeSlotId, currentTimeSlotId, currentColumn, jwt) {
		return A5($author$project$Api$Request$addUserToSchedule, user.aQ, newTimeSlotId, currentTimeSlotId, currentColumn, jwt);
	});
var $author$project$Utils$eq = F3(
	function (fn, opt, obj) {
		return _Utils_eq(
			fn(obj),
			opt);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$findColumnId = F2(
	function (pipeline, newColumnName) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pipeline$emptyColumn,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.bH;
						},
						newColumnName),
					pipeline))).V;
	});
var $author$project$Main$updateAvailiableTalent = F3(
	function (availableTalent, user, adding) {
		return adding ? A2(
			$elm$core$List$cons,
			_Utils_update(
				user,
				{fx: _List_Nil}),
			availableTalent) : A2(
			$elm$core$List$filter,
			function (talent) {
				return !_Utils_eq(talent.cU, user.cU);
			},
			availableTalent);
	});
var $author$project$MainMsg$StageUpdated = function (a) {
	return {$: 154, a: a};
};
var $author$project$User$NewStage = function (stage) {
	return {jj: stage};
};
var $author$project$Api$Decoders$getStageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'stage',
	$author$project$Api$Decoders$stageDecoder,
	$elm$json$Json$Decode$succeed($author$project$User$NewStage));
var $author$project$Api$Encoders$stageEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(model.jj)),
				_Utils_Tuple2(
				'role_member_id',
				$elm$json$Json$Encode$string(model.aQ)),
				_Utils_Tuple2(
				'body',
				$elm$json$Json$Encode$string(model.bI.dG)),
				_Utils_Tuple2(
				'user_id',
				$elm$json$Json$Encode$string(model.bI.cu)),
				_Utils_Tuple2(
				'kind',
				$elm$json$Json$Encode$string(model.bI.hT)),
				_Utils_Tuple2(
				'notifiable_type',
				$elm$json$Json$Encode$string('RoleMember')),
				_Utils_Tuple2(
				'notifiable_id',
				$elm$json$Json$Encode$string(model.bI.aQ)),
				_Utils_Tuple2(
				'conversation_id',
				$elm$json$Json$Encode$string(model.bI.gY)),
				_Utils_Tuple2(
				'sending_user_id',
				$elm$json$Json$Encode$string(model.jb))
			]));
};
var $author$project$Api$Request$updateUsersRoleStage = F5(
	function (notification, jwt, roleMemberId, stage, sendingUserId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$stageEncoder(
						{bI: notification, aQ: roleMemberId, jb: sendingUserId, jj: stage})),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$StageUpdated, $author$project$Api$Decoders$getStageDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'users/update_user_role_status'
			});
	});
var $author$project$Main$updateRoleMemberAndCreateNotification = F5(
	function (notification, jwt, roleMemberId, stage, sendingUserId) {
		return A5($author$project$Api$Request$updateUsersRoleStage, notification, jwt, roleMemberId, stage, sendingUserId);
	});
var $author$project$Main$updateSchedules = F4(
	function (schedules, user, newTimeSlot, currentTimeSlot) {
		return A2(
			$elm$core$List$map,
			function (schedule) {
				return _Utils_update(
					schedule,
					{
						jD: A2(
							$elm$core$List$map,
							function (timeSlot) {
								return _Utils_eq(timeSlot.V, newTimeSlot) ? _Utils_update(
									timeSlot,
									{f_: user}) : (_Utils_eq(timeSlot.V, currentTimeSlot) ? _Utils_update(
									timeSlot,
									{f_: $author$project$User$emptyPipelineUser}) : timeSlot);
							},
							schedule.jD)
					});
			},
			schedules);
	});
var $author$project$MainMsg$UsersMoved = function (a) {
	return {$: 160, a: a};
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Api$Request$updateUsersPipelinePositionFromSchedule = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: $elm$http$Http$expectWhatever($author$project$MainMsg$UsersMoved),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (model.aQ + ('/project/' + (model.iH + ('/pipeline/move_user/' + model.ic)))))
		});
};
var $author$project$Main$updateUsersPipelinePosition = F4(
	function (jwt, schedulePageData, user, newColumnName) {
		return $author$project$Api$Request$updateUsersPipelinePositionFromSchedule(
			{
				hR: jwt,
				ic: A2($author$project$Main$findColumnId, schedulePageData.ae.v, newColumnName),
				iH: schedulePageData.ae.cU,
				aQ: user.aQ,
				cu: user.cU
			});
	});
var $author$project$Main$addUserToPublishedScheduleAndUpdatePipeline = F7(
	function (model, user, notificationData, newTimeSlotId, currentTimeSlotId, currentColumn, movingToColumn) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5(
						$author$project$Main$addUser,
						user,
						'',
						newTimeSlotId,
						A2($author$project$Main$findColumnId, model.bQ.ae.v, currentColumn),
						model.hR),
						A4($author$project$Main$updateUsersPipelinePosition, model.hR, model.bQ, user, movingToColumn),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, notificationData, model.hR, notificationData.aQ, notificationData.hT, notificationData.cu)
					])),
			A4($author$project$Main$updateSchedules, model.bQ.f, user, newTimeSlotId, currentTimeSlotId),
			A3($author$project$Main$updateAvailiableTalent, model.bQ.D, user, false));
	});
var $author$project$Main$addUserToScheduleAndUpdatePipeline = F6(
	function (model, user, newTimeSlotId, currentTimeSlotId, currentColumn, movingToColumn) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5(
						$author$project$Main$addUser,
						user,
						'',
						newTimeSlotId,
						A2($author$project$Main$findColumnId, model.bQ.ae.v, currentColumn),
						model.hR),
						A4($author$project$Main$updateUsersPipelinePosition, model.hR, model.bQ, user, movingToColumn)
					])),
			A4($author$project$Main$updateSchedules, model.bQ.f, user, newTimeSlotId, currentTimeSlotId),
			A3($author$project$Main$updateAvailiableTalent, model.bQ.D, user, false));
	});
var $andrewMacmurray$elm_delay$Delay$Duration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Process$sleep = _Process_sleep;
var $andrewMacmurray$elm_delay$Delay$after_ = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $andrewMacmurray$elm_delay$Delay$Minute = 2;
var $andrewMacmurray$elm_delay$Delay$Second = 1;
var $andrewMacmurray$elm_delay$Delay$toMillis = function (_v0) {
	var t = _v0.a;
	var u = _v0.b;
	switch (u) {
		case 0:
			return t;
		case 1:
			return 1000 * t;
		case 2:
			return $andrewMacmurray$elm_delay$Delay$toMillis(
				A2($andrewMacmurray$elm_delay$Delay$Duration, 60 * t, 1));
		default:
			return $andrewMacmurray$elm_delay$Delay$toMillis(
				A2($andrewMacmurray$elm_delay$Delay$Duration, 60 * t, 2));
	}
};
var $andrewMacmurray$elm_delay$Delay$after = F3(
	function (time, unit, msg) {
		return A2(
			$andrewMacmurray$elm_delay$Delay$after_,
			$andrewMacmurray$elm_delay$Delay$toMillis(
				A2($andrewMacmurray$elm_delay$Delay$Duration, time, unit)),
			msg);
	});
var $ccapndave$elm_update_extra$Update$Extra$andThen = F3(
	function (update, msg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = A2(update, msg, model);
		var model_ = _v1.a;
		var cmd_ = _v1.b;
		return _Utils_Tuple2(
			model_,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $author$project$MainMsg$SendApplication = function (a) {
	return {$: 66, a: a};
};
var $author$project$Job$JobMessage = function (message) {
	return {h1: message};
};
var $author$project$Api$Decoders$jobAppDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'message',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Job$JobMessage));
var $author$project$Api$Request$applyToRole = F3(
	function (projectId, roleId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$SendApplication, $author$project$Api$Decoders$jobAppDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (projectId + ('/roles/' + (roleId + '/add_to_role'))))
			});
	});
var $author$project$MainMsg$GotBlankSchedules = function (a) {
	return {$: 196, a: a};
};
var $author$project$SharedProjectRoleSchedules$Schedule = function (id) {
	return function (scheduleDate) {
		return function (startTime) {
			return function (endTime) {
				return function (breakStart) {
					return function (breakEnd) {
						return function (timeIncrements) {
							return function (capacity) {
								return function (timeSlots) {
									return function (roles) {
										return function (roleList) {
											return function (roleSearchTerm) {
												return function (scheduleType) {
													return function (published) {
														return function (creatorId) {
															return {gE: breakEnd, gF: breakStart, gK: capacity, g_: creatorId, hi: endTime, V: id, a3: published, da: roleList, i_: roleSearchTerm, fq: roles, fv: scheduleDate, fy: scheduleType, jk: startTime, jC: timeIncrements, jD: timeSlots};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Decoders$scheduleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'creator_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'published',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'schedule_type',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'roleSearchTerm',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'roleList',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'roles',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'time_slots',
							$elm$json$Json$Decode$list($author$project$Api$Decoders$timeSlotDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'capacity',
								$elm$json$Json$Decode$int,
								0,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'time_increments',
									$elm$json$Json$Decode$int,
									0,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'break_end',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'break_start',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'end_time',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'start_time',
													$elm$json$Json$Decode$string,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'schedule_date',
														$elm$json$Json$Decode$string,
														'',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'id',
															$elm$json$Json$Decode$string,
															'',
															$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$Schedule))))))))))))))));
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Api$Encoders$transformRoleNameToId = F2(
	function (roleNames, roles) {
		return A2(
			$elm$core$List$concatMap,
			function (role) {
				return A2(
					$elm$core$List$filter,
					function (roleData) {
						return _Utils_eq(roleData.bH, role);
					},
					roles);
			},
			roleNames);
	});
var $author$project$Api$Encoders$scheduleEncoder = function (scheduleData) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'start_date',
				$elm$json$Json$Encode$string(scheduleData.fO)),
				_Utils_Tuple2(
				'end_date',
				$elm$json$Json$Encode$string(scheduleData.d8)),
				_Utils_Tuple2(
				'start_time',
				$elm$json$Json$Encode$string(scheduleData.aX.jk)),
				_Utils_Tuple2(
				'end_time',
				$elm$json$Json$Encode$string(scheduleData.aX.hi)),
				_Utils_Tuple2(
				'break_start',
				$elm$json$Json$Encode$string(scheduleData.aX.gF)),
				_Utils_Tuple2(
				'break_end',
				$elm$json$Json$Encode$string(scheduleData.aX.gE)),
				_Utils_Tuple2(
				'time_increments',
				$elm$json$Json$Encode$int(scheduleData.aX.jC)),
				_Utils_Tuple2(
				'capacity',
				$elm$json$Json$Encode$int(scheduleData.aX.gK)),
				_Utils_Tuple2(
				'auto_schedule',
				$elm$json$Json$Encode$bool(scheduleData.gB)),
				_Utils_Tuple2(
				'roles',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.cU;
						},
						A2($author$project$Api$Encoders$transformRoleNameToId, scheduleData.aX.fq, scheduleData.ae.fq)))),
				_Utils_Tuple2(
				'schedule_type',
				$elm$json$Json$Encode$string(scheduleData.fy))
			]));
};
var $author$project$Api$Request$autoSchedule = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$scheduleEncoder(model.bQ)),
			eg: A2(
				$elm$http$Http$expectJson,
				$author$project$MainMsg$GotBlankSchedules,
				$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleDecoder)),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.bQ.ae.cU + '/create_auto_schedule'))
		});
};
var $elm$http$Http$cancel = function (tracker) {
	return $elm$http$Http$command(
		$elm$http$Http$Cancel(tracker));
};
var $author$project$User$emptyProfilePage = {V: '', r: ''};
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{G: nodeList, C: nodeListSize, E: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Main$categoryFromIndex = F2(
	function (currentIndex, user) {
		var pagesArray = $elm$core$Array$fromList(user.ck);
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyProfilePage,
			A2($elm$core$Array$get, currentIndex, pagesArray));
	});
var $author$project$Api$Request$moveUserInSchedule = F4(
	function (userId, currentTimeSlotId, newTimeSlot, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A4($author$project$Api$Encoders$timeSlotUpdateEncoder, userId, currentTimeSlotId, newTimeSlot, '')),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$TimeSlotUpdated, $author$project$Api$Decoders$timeSlotDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'PUT',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'schedules/move_user'
			});
	});
var $author$project$Main$changeUsersTimeSlot = F4(
	function (user, currentTimeSlot, newTimeSlotId, jwt) {
		return A4($author$project$Api$Request$moveUserInSchedule, user.aQ, currentTimeSlot, newTimeSlotId, jwt);
	});
var $author$project$Main$changeUsersTimeSlotInPublishedSchedule = F5(
	function (model, user, notificationData, currentTimeSlotId, newTimeSlotId) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$changeUsersTimeSlot, user, currentTimeSlotId, newTimeSlotId, model.hR),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, notificationData, model.hR, notificationData.aQ, notificationData.hT, notificationData.cu)
					])),
			A4($author$project$Main$updateSchedules, model.bQ.f, user, newTimeSlotId, currentTimeSlotId),
			model.bQ.D);
	});
var $author$project$Main$changeUsersTimeSlotInSchedule = F4(
	function (model, user, currentTimeSlotId, newTimeSlotId) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$changeUsersTimeSlot, user, currentTimeSlotId, newTimeSlotId, model.hR)
					])),
			A4($author$project$Main$updateSchedules, model.bQ.f, user, newTimeSlotId, currentTimeSlotId),
			model.bQ.D);
	});
var $author$project$Main$changeWindowHeight = _Platform_outgoingPort('changeWindowHeight', $elm$json$Json$Encode$string);
var $author$project$Main$clearAgencyInfo = function (userProfile) {
	return _Utils_update(
		userProfile,
		{gl: $author$project$User$emptyAgency});
};
var $author$project$Main$closeAddAgentForm = function (profilePageData) {
	return _Utils_update(
		profilePageData,
		{bY: false});
};
var $author$project$Main$columnDefinitions = function (scheduleType) {
	switch (scheduleType) {
		case 'Audition':
			return _Utils_Tuple2('Selected Candidates', 'Scheduled Audition');
		case 'Callback':
			return _Utils_Tuple2('Selected Candidates', 'Scheduled Callbacks');
		default:
			return _Utils_Tuple2('', '');
	}
};
var $author$project$Message$emptyMessage = {dG: '', dS: '', gY: '', g_: '', d2: '', cR: '', V: '', bo: '', bH: '', fK: 0, ct: ''};
var $author$project$Main$nowTimestamp = 'now';
var $author$project$Main$optimisticChannel = F2(
	function (model, message) {
		var conversationData = function () {
			var _v0 = model.aR.jr;
			if (_v0.$ === 3) {
				var talent = _v0.a;
				return _Utils_update(
					$author$project$Message$emptyConversation,
					{
						hO: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Image$emptyImage,
							$elm$core$List$head(model.z.hE)).jM,
						eA: model.z.cU,
						hU: model.y.dG,
						h3: _List_fromArray(
							[message]),
						js: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Image$emptyImage,
							$elm$core$List$head(talent.hE)).jM,
						jt: talent.cU,
						jv: talent.bm + (' ' + talent.bE),
						bW: 0
					});
			} else {
				return _Utils_update(
					$author$project$Message$emptyConversation,
					{
						hO: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Image$emptyImage,
							$elm$core$List$head(model.z.hE)).jM,
						eA: model.z.cU,
						hU: model.y.dG,
						h3: _List_fromArray(
							[message]),
						iH: model.d_,
						iI: model.p.iI,
						iX: model.g3,
						aQ: model.p.aQ,
						iY: model.p.iY,
						js: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Image$emptyImage,
							$elm$core$List$head(model.p.hE)).jM,
						jt: model.p.cU,
						jv: model.p.bm + (' ' + model.p.bE),
						bW: 0
					});
			}
		}();
		return conversationData;
	});
var $author$project$Main$conversationTwilioPayload = function (model) {
	var message = _Utils_update(
		$author$project$Message$emptyMessage,
		{dG: model.y.dG, g_: model.z.cU, bo: 'text', ct: $author$project$Main$nowTimestamp});
	return _Utils_update(
		$author$project$Message$emptyFromTwilioPayload,
		{
			t: 'creatingAConversation',
			k: A2($author$project$Main$optimisticChannel, model, message)
		});
};
var $author$project$MainMsg$AgencyCreated = function (a) {
	return {$: 308, a: a};
};
var $author$project$Api$Encoders$manualAgencyEncoder = function (agency) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(agency.go)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(agency.gp)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(agency.gn)),
				_Utils_Tuple2(
				'agency_name',
				$elm$json$Json$Encode$string(agency.cz)),
				_Utils_Tuple2(
				'phone',
				$elm$json$Json$Encode$string(agency.gq))
			]));
};
var $author$project$Api$Request$createAgency = F2(
	function (agency, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$manualAgencyEncoder(agency)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$AgencyCreated, $author$project$Api$Decoders$updateProfileDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'agencies'
			});
	});
var $author$project$Api$Request$createBlankSchedule = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$scheduleEncoder(model.bQ)),
			eg: A2(
				$elm$http$Http$expectJson,
				$author$project$MainMsg$GotBlankSchedules,
				$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleDecoder)),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.bQ.ae.cU + '/schedules'))
		});
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {ha: d, h9: m, jZ: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		c3: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		jZ: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.jZ, 0, date.c3);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.ha;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.h9;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.c3;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		ga: 1 + (((rd - week1Day1) / 7) | 0),
		gb: wy,
		jW: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.ga;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.gb;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.ce(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.c$(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.ce(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.cN(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.bd(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.bd(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.bd(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.dl(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.bd(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.bd(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {dM: col, gX: contextStack, e3: problem, fr: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.fr, s.dM, x, s.n));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.io, s.fr, s.dM, s.d);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{dM: newCol, n: s.n, s: s.s, io: newOffset, fr: newRow, d: s.d});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.io, s.d);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dM: 1, n: s.n, s: s.s, io: s.io + 1, fr: s.fr + 1, d: s.d}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dM: s.dM + 1, n: s.n, s: s.s, io: newOffset, fr: s.fr, d: s.d}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.d);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.io, offset) < 0,
					0,
					{dM: col, n: s0.n, s: s0.s, io: offset, fr: row, d: s0.d});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.io, s.fr, s.dM, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.io, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.io, s1.io, s0.d),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.d),
			s.io) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {dM: col, e3: problem, fr: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.fr, p.dM, p.e3);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{dM: 1, n: _List_Nil, s: 1, io: 0, fr: 1, d: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	cN: $justinmimbs$date$Date$withOrdinalSuffix,
	c$: $justinmimbs$date$Date$monthToName,
	ce: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	dl: $justinmimbs$date$Date$weekdayToName,
	bd: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $author$project$Main$createDates = function (dateEvent) {
	if (dateEvent.$ === 2) {
		var changedDate = dateEvent.a;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(changedDate),
			A2($justinmimbs$date$Date$format, 'y-MM-dd', changedDate));
	} else {
		return _Utils_Tuple2($elm$core$Maybe$Nothing, '');
	}
};
var $author$project$Message$emptyToTwilioPayload = {dz: false, dG: '', gM: '', gN: _List_Nil, b0: '', g_: '', hv: '', hO: '', eA: '', hP: '', hQ: '', iH: '', iI: '', iX: '', aQ: '', iY: '', js: '', ju: '', jv: '', jJ: ''};
var $author$project$Main$twilio = _Platform_outgoingPort(
	'twilio',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cmd',
					$elm$json$Json$Encode$string($.t)),
					_Utils_Tuple2(
					'payload',
					$elm$core$Basics$identity($.X)),
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string($.aa))
				]));
	});
var $author$project$Api$Encoders$twilioPayloadEncoder = function (payload) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'friendlyName',
				$elm$json$Json$Encode$string(payload.hv)),
				_Utils_Tuple2(
				'uniqueName',
				$elm$json$Json$Encode$string(payload.jJ)),
				_Utils_Tuple2(
				'jobPosterAvatar',
				$elm$json$Json$Encode$string(payload.hO)),
				_Utils_Tuple2(
				'jobPosterName',
				$elm$json$Json$Encode$string(payload.hQ)),
				_Utils_Tuple2(
				'talentAvatar',
				$elm$json$Json$Encode$string(payload.js)),
				_Utils_Tuple2(
				'talentName',
				$elm$json$Json$Encode$string(payload.jv)),
				_Utils_Tuple2(
				'jobPosterIdentity',
				$elm$json$Json$Encode$string(payload.hP)),
				_Utils_Tuple2(
				'talentIdentity',
				$elm$json$Json$Encode$string(payload.ju)),
				_Utils_Tuple2(
				'roleName',
				$elm$json$Json$Encode$string(payload.iY)),
				_Utils_Tuple2(
				'projectName',
				$elm$json$Json$Encode$string(payload.iI)),
				_Utils_Tuple2(
				'body',
				$elm$json$Json$Encode$string(payload.dG)),
				_Utils_Tuple2(
				'channelId',
				$elm$json$Json$Encode$string(payload.gM)),
				_Utils_Tuple2(
				'creatorId',
				$elm$json$Json$Encode$string(payload.g_)),
				_Utils_Tuple2(
				'roleMemberId',
				$elm$json$Json$Encode$string(payload.aQ)),
				_Utils_Tuple2(
				'projectId',
				$elm$json$Json$Encode$string(payload.iH)),
				_Utils_Tuple2(
				'roleId',
				$elm$json$Json$Encode$string(payload.iX)),
				_Utils_Tuple2(
				'channelIds',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, payload.gN)),
				_Utils_Tuple2(
				'jobPosterId',
				$elm$json$Json$Encode$string(payload.eA))
			]));
};
var $author$project$Main$createMessage = F4(
	function (channelId, body, token, creatorId) {
		var twilioPayload = _Utils_update(
			$author$project$Message$emptyToTwilioPayload,
			{dG: body, gM: channelId, g_: creatorId});
		return $author$project$Main$twilio(
			{
				t: 'sendMessage',
				X: $author$project$Api$Encoders$twilioPayloadEncoder(twilioPayload),
				aa: token
			});
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Main$addIfNotPresent = F2(
	function (item, items) {
		return (A2($elm$core$List$member, item, items) || (item.bH === '-')) ? items : A2($elm$core$List$cons, item, items);
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Main$createRole = F2(
	function (msg, model) {
		var role = model.P;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{bH: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{iZ: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{iV: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									cZ: A2(
										$elm$core$Maybe$withDefault,
										17,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									cX: A2(
										$elm$core$Maybe$withDefault,
										75,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									hy: A2(
										$author$project$Main$addIfNotPresent,
										A2(
											$elm$core$Maybe$withDefault,
											{V: '', bH: ''},
											$elm$core$List$head(
												A2(
													$elm$core$List$filter,
													A2(
														$author$project$Utils$eq,
														function ($) {
															return $.V;
														},
														value),
													model.hy))),
										model.P.hy)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									ea: A2(
										$author$project$Main$addIfNotPresent,
										A2(
											$elm$core$Maybe$withDefault,
											{V: '', bH: ''},
											$elm$core$List$head(
												A2(
													$elm$core$List$filter,
													A2(
														$author$project$Utils$eq,
														function ($) {
															return $.V;
														},
														value),
													model.ea))),
										model.P.ea)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									h4: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									hZ: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									eN: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toFloat(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									eI: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toFloat(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$createSingleNotificationKind = F2(
	function (model, userInSchedule) {
		return (userInSchedule && (model.bQ.fy === 'Audition')) ? 'Audition Rescheduled' : (((!userInSchedule) && (model.bQ.fy === 'Audition')) ? 'Audition Requested' : ((userInSchedule && (model.bQ.fy === 'Callback')) ? 'Callback Rescheduled' : (((!userInSchedule) && (model.bQ.fy === 'Callback')) ? 'Callback Requested' : '')));
	});
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $CurrySoftware$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.e3;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($justinmimbs$date$Date$deadEndToString),
			$elm$core$String$join('; '))));
var $CurrySoftware$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$off = $CurrySoftware$elm_datepicker$DatePicker$Date$Off;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $CurrySoftware$elm_datepicker$DatePicker$defaultSettings = {
	cD: $CurrySoftware$elm_datepicker$DatePicker$formatCell,
	b$: $CurrySoftware$elm_datepicker$DatePicker$off,
	bg: 'elm-datepicker--',
	cG: _List_Nil,
	cL: $justinmimbs$date$Date$format('yyyy/MM/dd'),
	cM: $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay,
	b9: 6,
	cV: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	hH: _List_Nil,
	hI: $elm$core$Maybe$Nothing,
	cW: $elm$core$Maybe$Nothing,
	bD: $elm$core$Basics$always(false),
	c_: $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth,
	c4: $justinmimbs$date$Date$fromIsoString,
	c5: 'Please pick a date...',
	dm: $elm$core$String$fromInt
};
var $author$project$Views$DatePicker$dateSettings = _Utils_update(
	$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
	{
		hH: _List_fromArray(
			[
				_Utils_Tuple2('form-control', true)
			]),
		hI: $elm$core$Maybe$Just('datepicker'),
		c5: ''
	});
var $author$project$Api$Request$deleteAgent = F3(
	function (agentId, agencyId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$AddedUpdatedAgent, $author$project$Api$Decoders$agentsDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'DELETE',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('agencies/' + (agencyId + ('/agents/' + agentId)))
			});
	});
var $author$project$MainMsg$DeletedImage = function (a) {
	return {$: 133, a: a};
};
var $author$project$Api$Request$deleteImage = F3(
	function (imageId, jwt, userId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: $elm$http$Http$expectWhatever($author$project$MainMsg$DeletedImage),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'DELETE',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (userId + ('/images/' + imageId)))
			});
	});
var $author$project$MainMsg$DeletedResume = function (a) {
	return {$: 129, a: a};
};
var $author$project$Api$Request$deleteResume = F2(
	function (jwt, userId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: $elm$http$Http$expectWhatever($author$project$MainMsg$DeletedResume),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'DELETE',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Just('upload'),
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (userId + '/resume'))
			});
	});
var $author$project$MainMsg$RemovedAgentFromTalent = function (a) {
	return {$: 33, a: a};
};
var $author$project$Api$Encoders$deleteTalentAgentEncoder = F2(
	function (associationId, agentId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'association_id',
					$elm$json$Json$Encode$string(associationId)),
					_Utils_Tuple2(
					'agent_id',
					$elm$json$Json$Encode$string(agentId))
				]));
	});
var $author$project$Api$Request$deleteTalentAgent = F3(
	function (associationId, agentId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$deleteTalentAgentEncoder, associationId, agentId)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$RemovedAgentFromTalent, $author$project$Api$Decoders$updateProfileDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'DELETE',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'agencies/talent/remove_agent'
			});
	});
var $author$project$MainMsg$VideoDeleted = function (a) {
	return {$: 288, a: a};
};
var $author$project$Api$Request$deleteVideo = F2(
	function (videoId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$VideoDeleted, $author$project$Api$Decoders$videoDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'DELETE',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('video/' + videoId)
			});
	});
var $author$project$SharedProjectRoleSchedules$ProjectSchedule = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Main$determineSchedulePageView = F3(
	function (schedules, scheduleType, project) {
		return ($elm$core$List$length(
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.fy;
					},
					scheduleType),
				schedules)) > 0) ? A2($author$project$SharedProjectRoleSchedules$ProjectSchedule, project, scheduleType) : $author$project$SharedProjectRoleSchedules$DefaultSchedulePage(scheduleType);
	});
var $author$project$MainMsg$DismissAlert = {$: 81};
var $author$project$Utils$delay = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Task$andThen,
				$elm$core$Basics$always(
					$elm$core$Task$succeed(msg)),
				$elm$core$Process$sleep(time)));
	});
var $author$project$Main$dismissAlert = A2($author$project$Utils$delay, 5000, $author$project$MainMsg$DismissAlert);
var $author$project$Main$droppedOnBookingColumn = F2(
	function (columnId, columns) {
		var column = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pipeline$emptyColumn,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.V;
						},
						columnId),
					columns)));
		return column.bH === 'Holding/Booked';
	});
var $author$project$Main$droppedOnSchedulingColumn = F2(
	function (columnId, columns) {
		var column = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pipeline$emptyColumn,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.V;
						},
						columnId),
					columns)));
		return _Utils_Tuple2(
			A2(
				$elm$core$List$member,
				column.bH,
				_List_fromArray(
					['Scheduled Audition', 'Scheduled Callbacks'])),
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(
					$elm$core$List$reverse(
						A2($elm$core$String$split, ' ', column.bH)))));
	});
var $author$project$User$emptyUserConvoInfo = {iC: $author$project$Data$Image$emptyImage, iH: '', iI: '', iX: '', aQ: '', iY: '', jO: ''};
var $author$project$User$emptyUserNotification = {dG: '', gY: '', dU: 1, V: '', hN: false, hO: '', eA: '', hQ: '', hT: 27, iH: '', iI: '', iX: '', aQ: '', iY: '', js: '', jt: '', jv: '', fY: ''};
var $author$project$Main$evaluateAuthStatus = function (token) {
	return (token === '') ? 0 : 1;
};
var $author$project$User$emptyScheduleMember = {dG: '', V: '', dc: 27, fy: '', fA: ''};
var $author$project$Main$getFirstOrLatestScheduleStatus = function (scheduleMembers) {
	return ($elm$core$List$length(scheduleMembers) > 1) ? A2(
		$elm$core$Maybe$withDefault,
		$author$project$User$emptyScheduleMember,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (scheduleMember) {
					return A2(
						$elm$core$List$member,
						scheduleMember.dc,
						_List_fromArray(
							[6]));
				},
				scheduleMembers))).dc : A2(
		$elm$core$Maybe$withDefault,
		$author$project$User$emptyScheduleMember,
		$elm$core$List$head(scheduleMembers)).dc;
};
var $author$project$Main$extractStage = function (pipelineUser) {
	var _v0 = pipelineUser.jj;
	if (_v0 === 26) {
		return $author$project$Main$getFirstOrLatestScheduleStatus(pipelineUser.fx);
	} else {
		return pipelineUser.jj;
	}
};
var $author$project$MainMsg$AllProjects = function (a) {
	return {$: 45, a: a};
};
var $author$project$SharedProjectRoleSchedules$ProjectData = function (id_) {
	return function (name) {
		return function (agencyNotes) {
			return function (talentNotes) {
				return function (projectRate) {
					return function (union) {
						return function (deadlines) {
							return function (projectDescription) {
								return function (userID) {
									return function (archived) {
										return function (isActive) {
											return function (schedules) {
												return function (roles) {
													return function (pipeline) {
														return function (createdAt) {
															return {gm: agencyNotes, dz: archived, gZ: createdAt, hb: deadlines, cU: id_, hK: isActive, bH: name, v: pipeline, iE: projectDescription, iJ: projectRate, fq: roles, f: schedules, jw: talentNotes, jI: union, jN: userID};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pipeline$Column = F8(
	function (id, position, name, customName, isHidden, users, sort, filter) {
		return {g6: customName, hs: filter, V: id, hL: isHidden, bH: name, iz: position, ji: sort, jR: users};
	});
var $author$project$User$NoFilter = 3;
var $author$project$User$AcceptedInvite = 2;
var $author$project$User$Invited = 1;
var $author$project$Api$Decoders$decodeFilterType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Applied':
				return $elm$json$Json$Decode$succeed(0);
			case 'Requested to Apply':
				return $elm$json$Json$Decode$succeed(1);
			case 'Accepted Application':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$succeed(3);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$User$Datedesc = 1;
var $author$project$User$RoleType = 2;
var $author$project$User$StatusType = 3;
var $author$project$Api$Decoders$decodeSortType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'asc':
				return $elm$json$Json$Decode$succeed(0);
			case 'desc':
				return $elm$json$Json$Decode$succeed(1);
			case 'role':
				return $elm$json$Json$Decode$succeed(2);
			case 'status':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$usersInPipelineDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$pipelineUserDecoder);
var $author$project$Api$Decoders$columnDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'filter',
	$author$project$Api$Decoders$decodeFilterType,
	3,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'sort',
		$author$project$Api$Decoders$decodeSortType,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'users',
			$author$project$Api$Decoders$usersInPipelineDecoder,
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_hidden',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'custom_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'position',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Pipeline$Column)))))))));
var $author$project$SharedProjectRoleSchedules$Deadline = F9(
	function (name, startDate, endDate, location, address1, address2, city, state, zip) {
		return {bv: address1, bw: address2, aV: city, d8: endDate, hV: location, bH: name, fO: startDate, a7: state, dn: zip};
	});
var $author$project$Api$Decoders$deadlineDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'zip_code',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'state',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'city',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'address_2',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'address_1',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'location',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'due_at',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'starts_at',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$Deadline))))))))));
var $author$project$SharedProjectRoleSchedules$ProjectRoleData = F4(
	function (id_, name, roleDescription, active) {
		return {gg: active, cU: id_, bH: name, iV: roleDescription};
	});
var $author$project$Api$Decoders$projectRoleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'active',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$ProjectRoleData)))));
var $author$project$Api$Decoders$projectDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'created_at',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'pipeline',
		$elm$json$Json$Decode$list($author$project$Api$Decoders$columnDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'roles',
			$elm$json$Json$Decode$list($author$project$Api$Decoders$projectRoleDecoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'schedules',
				$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleDecoder),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_active',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'archived',
						$elm$json$Json$Decode$bool,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'user_id',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'notes',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'deadlines',
									$elm$json$Json$Decode$list($author$project$Api$Decoders$deadlineDecoder),
									_List_Nil,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'union',
										$elm$json$Json$Decode$bool,
										false,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'rate',
											$elm$json$Json$Decode$string,
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'talent_notes',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'agency_notes',
													$elm$json$Json$Decode$string,
													'',
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'name',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$ProjectData))))))))))))))));
var $author$project$Api$Request$getProjects = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2(
				$elm$http$Http$expectJson,
				$author$project$MainMsg$AllProjects,
				$elm$json$Json$Decode$list($author$project$Api$Decoders$projectDecoder)),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'projects'
		});
};
var $author$project$Main$fetchAllProjects = function (token) {
	return $author$project$Api$Request$getProjects(token);
};
var $author$project$MainMsg$AllApplicants = function (a) {
	return {$: 141, a: a};
};
var $author$project$Job$ApplicantData = F5(
	function (roleID, userID, id, stage, user) {
		return {V: id, iW: roleID, jj: stage, f_: user, jN: userID};
	});
var $author$project$User$SearchResultTalentProfile = function (id_) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phone) {
					return function (eyeColor) {
						return function (birthDate) {
							return function (gender) {
								return function (ethnicities) {
									return function (height) {
										return function (weight) {
											return function (waistSize) {
												return function (city) {
													return function (state) {
														return function (company) {
															return function (images) {
																return function (videos) {
																	return function (hairColor) {
																		return function (hairLength) {
																			return function (roleMemberId) {
																				return function (selected) {
																					return function (currentColumn) {
																						return function (stage) {
																							return function (age) {
																								return function (roleName) {
																									return function (projectName) {
																										return function (roleId) {
																											return function (canLoadMore) {
																												return function (currentOffset) {
																													return function (agency) {
																														return function (inRole) {
																															return function (scheduleMembers) {
																																return function (resume) {
																																	return {gk: age, gl: agency, gC: birthDate, dK: canLoadMore, aV: city, cE: company, g0: currentColumn, dY: currentOffset, bl: email, ea: ethnicities, ho: eyeColor, bm: firstName, hw: gender, hz: hairColor, hA: hairLength, hB: height, cU: id_, hE: images, ev: inRole, bE: lastName, eZ: phone, iI: projectName, iU: resume, iX: roleId, aQ: roleMemberId, iY: roleName, fx: scheduleMembers, cs: selected, jj: stage, a7: state, jT: videos, jV: waistSize, jX: weight};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Decoders$searchResultTalentProfileDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'resume',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'schedule_members',
		$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleMemberDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'in_role',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'agency',
				$author$project$Api$Decoders$agencyDecoder,
				$author$project$User$emptyAgency,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'current_offset',
					$elm$json$Json$Decode$int,
					0,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'can_load_more',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'role_id',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'project_name',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'role_name',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'age',
										$elm$json$Json$Decode$int,
										0,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'stage',
											$author$project$Api$Decoders$stageDecoder,
											27,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'current_column',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'selected',
													$elm$json$Json$Decode$bool,
													false,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'role_member_id',
														$elm$json$Json$Decode$string,
														'',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'hair_length',
															$elm$json$Json$Decode$string,
															'',
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'hair_color',
																$elm$json$Json$Decode$string,
																'',
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'videos',
																	$author$project$Api$Decoders$videosDecoder,
																	_List_Nil,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'images',
																		$author$project$Api$Decoders$imagesDecoder,
																		_List_Nil,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'company',
																			$elm$json$Json$Decode$string,
																			'',
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'state',
																				$elm$json$Json$Decode$string,
																				'',
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'city',
																					$elm$json$Json$Decode$string,
																					'',
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'waist_size',
																						$elm$json$Json$Decode$oneOf(
																							_List_fromArray(
																								[
																									$elm$json$Json$Decode$float,
																									$elm$json$Json$Decode$null(0)
																								])),
																						0,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'weight',
																							$elm$json$Json$Decode$int,
																							0,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'height',
																								$elm$json$Json$Decode$int,
																								0,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'ethnicities',
																									$author$project$Api$Decoders$ethnicitiesDecoder,
																									_List_Nil,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'gender',
																										$elm$json$Json$Decode$string,
																										'',
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'birth_date',
																											$elm$json$Json$Decode$string,
																											'',
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'eye_color',
																												$elm$json$Json$Decode$string,
																												'',
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'phone',
																													$elm$json$Json$Decode$string,
																													'',
																													A4(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																														'email',
																														$elm$json$Json$Decode$string,
																														'',
																														A4(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																															'last_name',
																															$elm$json$Json$Decode$string,
																															'',
																															A4(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																'first_name',
																																$elm$json$Json$Decode$string,
																																'',
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'id',
																																	$elm$json$Json$Decode$string,
																																	$elm$json$Json$Decode$succeed($author$project$User$SearchResultTalentProfile))))))))))))))))))))))))))))))))));
var $author$project$Api$Decoders$applicantDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$author$project$Api$Decoders$searchResultTalentProfileDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'stage',
		$author$project$Api$Decoders$stageDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'userID',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'roleID',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Job$ApplicantData))))));
var $author$project$Api$Decoders$applicantListDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$applicantDecoder);
var $author$project$Api$Request$getRoleApplicants = F2(
	function (roleID, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$AllApplicants, $author$project$Api$Decoders$applicantListDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('role/member?roleId=' + roleID)
			});
	});
var $author$project$Main$fetchApplicantData = F2(
	function (roleId, token) {
		return A2($author$project$Api$Request$getRoleApplicants, roleId, token);
	});
var $author$project$MainMsg$GotCollaboratorProjects = function (a) {
	return {$: 271, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollaboratingProject = F4(
	function (id, name, schedule_id, accepted) {
		return {cw: accepted, V: id, bH: name, fz: schedule_id};
	});
var $author$project$Api$Decoders$collaboratingProjectDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accepted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'schedule_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$CollaboratingProject)))));
var $author$project$Api$Decoders$collaboratingProjectsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$collaboratingProjectDecoder);
var $author$project$Api$Request$getCollaboratingProjects = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotCollaboratorProjects, $author$project$Api$Decoders$collaboratingProjectsDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'collaborator/projects'
		});
};
var $author$project$Main$fetchCollaboratingProjects = function (jwt) {
	return $author$project$Api$Request$getCollaboratingProjects(jwt);
};
var $author$project$Main$fetchConversations = F2(
	function (twilioToken, twilioData) {
		return $author$project$Main$twilio(
			{
				t: 'getChannels',
				X: $author$project$Api$Encoders$twilioPayloadEncoder($author$project$Message$emptyToTwilioPayload),
				aa: twilioToken
			});
	});
var $author$project$MainMsg$GotPipeline = function (a) {
	return {$: 157, a: a};
};
var $author$project$Api$Decoders$pipelineDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$columnDecoder);
var $author$project$Api$Request$getPipeline = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotPipeline, $author$project$Api$Decoders$pipelineDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.d_ + '/pipeline'))
		});
};
var $author$project$Main$fetchPipeline = function (model) {
	return $author$project$Api$Request$getPipeline(model);
};
var $author$project$MainMsg$AllRoles = function (a) {
	return {$: 52, a: a};
};
var $author$project$SharedProjectRoleSchedules$RoleData = function (id_) {
	return function (name) {
		return function (projectID) {
			return function (roleDescription) {
				return function (genders) {
					return function (minAge) {
						return function (maxAge) {
							return function (roleRate) {
								return function (ethnicities) {
									return function (minHeight) {
										return function (maxHeight) {
											return function (minWeight) {
												return function (maxWeight) {
													return function (archived) {
														return function (projectId) {
															return function (projectName) {
																return function (projectDescription) {
																	return function (deadlines) {
																		return function (active) {
																			return {gg: active, dz: archived, hb: deadlines, ea: ethnicities, hy: genders, cU: id_, cX: maxAge, hZ: maxHeight, eI: maxWeight, cZ: minAge, h4: minHeight, eN: minWeight, bH: name, iE: projectDescription, fb: projectID, iH: projectId, iI: projectName, iV: roleDescription, iZ: roleRate};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Decoders$roleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'active',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'deadlines',
		$elm$json$Json$Decode$list($author$project$Api$Decoders$deadlineDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'project_description',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'project_name',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'project_id',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'archived',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'max_weight',
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$float,
										$elm$json$Json$Decode$null(0)
									])),
							0,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'min_weight',
								$elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											$elm$json$Json$Decode$float,
											$elm$json$Json$Decode$null(0)
										])),
								0,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'max_height',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$int,
												$elm$json$Json$Decode$null(0)
											])),
									0,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'min_height',
										$elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													$elm$json$Json$Decode$int,
													$elm$json$Json$Decode$null(0)
												])),
										0,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'ethnicities',
											$author$project$Api$Decoders$ethnicitiesDecoder,
											_List_Nil,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'rate',
												$elm$json$Json$Decode$string,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'max_age',
													$elm$json$Json$Decode$int,
													100,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'min_age',
														$elm$json$Json$Decode$int,
														0,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'genders',
															$author$project$Api$Decoders$ethnicitiesDecoder,
															_List_Nil,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'description',
																$elm$json$Json$Decode$string,
																'',
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'project_id',
																	$elm$json$Json$Decode$string,
																	'',
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'name',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$RoleData))))))))))))))))))));
var $author$project$Api$Request$getRoles = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2(
				$elm$http$Http$expectJson,
				$author$project$MainMsg$AllRoles,
				$elm$json$Json$Decode$list($author$project$Api$Decoders$roleDecoder)),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'roles'
		});
};
var $author$project$Main$fetchRoleData = function (token) {
	return $author$project$Api$Request$getRoles(token);
};
var $author$project$MainMsg$GotTalent = function (a) {
	return {$: 316, a: a};
};
var $author$project$SharedProjectRoleSchedules$TalentUser = F6(
	function (id, name, accepted, currentJobs, membershipId, profileImage) {
		return {cw: accepted, g1: currentJobs, V: id, h0: membershipId, bH: name, iC: profileImage};
	});
var $author$project$SharedProjectRoleSchedules$UserJob = F6(
	function (role, state, applicationStatus, timeSlots, roleMemberId, scheduleMembers) {
		return {gv: applicationStatus, P: role, aQ: roleMemberId, fx: scheduleMembers, a7: state, jD: timeSlots};
	});
var $author$project$SharedProjectRoleSchedules$BasicSchedulingInfo = F2(
	function (eventTime, scheduleType) {
		return {hj: eventTime, fy: scheduleType};
	});
var $author$project$Api$Decoders$basicSchedulingInfoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'schedule_type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'event_time',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$BasicSchedulingInfo)));
var $author$project$Api$Decoders$jobDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'schedule_members',
	$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleMemberDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'roleMemberId',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'time_slots',
			$elm$json$Json$Decode$list($author$project$Api$Decoders$basicSchedulingInfoDecoder),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'application_status',
				$author$project$Api$Decoders$stageDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'state',
					$author$project$Api$Decoders$stageDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'role',
						$author$project$Api$Decoders$roleDecoder,
						$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$UserJob)))))));
var $author$project$Api$Decoders$jobsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$jobDecoder);
var $author$project$SharedProjectRoleSchedules$MembershipAccepted = 0;
var $author$project$SharedProjectRoleSchedules$MembershipPending = 2;
var $author$project$SharedProjectRoleSchedules$MembershipRejected = 1;
var $author$project$Api$Decoders$talentMembershipDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Accepted':
				return $elm$json$Json$Decode$succeed(0);
			case 'Rejected':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$succeed(2);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$talentUserDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'profile_image',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'current_jobs',
			$author$project$Api$Decoders$jobsDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'accepted',
				$author$project$Api$Decoders$talentMembershipDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$TalentUser)))))));
var $author$project$Api$Decoders$talentUsersDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$talentUserDecoder);
var $author$project$Api$Request$getAgentTalent = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotTalent, $author$project$Api$Decoders$talentUsersDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'agency/talent'
		});
};
var $author$project$Main$fetchTalent = function (token) {
	return $author$project$Api$Request$getAgentTalent(token);
};
var $author$project$MainMsg$GotJobs = function (a) {
	return {$: 174, a: a};
};
var $author$project$Api$Request$getUserJobs = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotJobs, $author$project$Api$Decoders$jobsDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + ('user_id' + '/jobs'))
		});
};
var $author$project$Main$fetchUsersJobs = function (jwt) {
	return $author$project$Api$Request$getUserJobs(jwt);
};
var $author$project$MainMsg$GotCollaboratorsOnProject = function (a) {
	return {$: 278, a: a};
};
var $author$project$Api$Request$getCollaboratorsOnProject = F2(
	function (projectId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotCollaboratorsOnProject, $author$project$Api$Decoders$collaboratorsDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('project/' + (projectId + '/collaborators'))
			});
	});
var $author$project$MainMsg$GotOptions = function (a) {
	return {$: 172, a: a};
};
var $author$project$User$Options = F2(
	function (ethnicities, genders) {
		return {ea: ethnicities, hy: genders};
	});
var $author$project$Api$Decoders$optionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'genders',
	$author$project$Api$Decoders$ethnicitiesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ethnicities',
		$author$project$Api$Decoders$ethnicitiesDecoder,
		$elm$json$Json$Decode$succeed($author$project$User$Options)));
var $author$project$Api$Request$getOptions = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotOptions, $author$project$Api$Decoders$optionsDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'ethnicities'
		});
};
var $author$project$MainMsg$GotProject = function (a) {
	return {$: 206, a: a};
};
var $author$project$Api$Request$getProjectData = F2(
	function (jwt, projectId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotProject, $author$project$Api$Decoders$projectDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + projectId)
			});
	});
var $author$project$MainMsg$GotSchedule = function (a) {
	return {$: 291, a: a};
};
var $author$project$Api$Request$getSchedule = F3(
	function (jwt, projectId, scheduleId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotSchedule, $author$project$Api$Decoders$scheduleDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (projectId + ('/schedules/' + scheduleId)))
			});
	});
var $author$project$MainMsg$GotProjectSchedules = function (a) {
	return {$: 191, a: a};
};
var $author$project$Api$Request$getSchedules = F2(
	function (projectId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2(
					$elm$http$Http$expectJson,
					$author$project$MainMsg$GotProjectSchedules,
					$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleDecoder)),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (projectId + '/schedules'))
			});
	});
var $author$project$MainMsg$AccountVerified = function (a) {
	return {$: 139, a: a};
};
var $author$project$Api$Request$verification = F3(
	function (jwt, id, code) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: $elm$http$Http$expectWhatever($author$project$MainMsg$AccountVerified),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('account/' + (id + ('/verify/' + code)))
			});
	});
var $author$project$Main$verifyAccount = F3(
	function (jwt, id, code) {
		return A3($author$project$Api$Request$verification, jwt, id, code);
	});
var $author$project$Main$fetchAppropriateData = F8(
	function (route, id, jwt, sort, filter, twilioToken, twilioData, user) {
		switch (route.$) {
			case 10:
				return _List_fromArray(
					[
						A2($author$project$Main$fetchConversations, twilioToken, twilioData),
						$author$project$Main$fetchAllProjects(jwt)
					]);
			case 13:
				switch (user) {
					case 0:
						return _List_fromArray(
							[
								A2($author$project$Main$fetchConversations, twilioToken, twilioData),
								$author$project$Main$fetchUsersJobs(jwt)
							]);
					case 1:
						return _List_fromArray(
							[
								$author$project$Main$fetchAllProjects(jwt),
								$author$project$Main$fetchRoleData(jwt),
								A2($author$project$Main$fetchConversations, twilioToken, twilioData),
								$author$project$Main$fetchCollaboratingProjects(jwt)
							]);
					case 3:
						return _List_fromArray(
							[
								$author$project$Main$fetchAllProjects(jwt),
								$author$project$Main$fetchTalent(jwt),
								$author$project$Main$fetchRoleData(jwt),
								A2($author$project$Main$fetchConversations, twilioToken, twilioData),
								$author$project$Main$fetchCollaboratingProjects(jwt)
							]);
					case 2:
						return _List_fromArray(
							[
								$author$project$Main$fetchCollaboratingProjects(jwt)
							]);
					default:
						return _List_Nil;
				}
			case 21:
				var i = route.a;
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(jwt),
						$author$project$Main$fetchPipeline(
						{d_: i, hR: jwt, ji: sort}),
						A2($author$project$Api$Request$getSchedules, i, jwt),
						$author$project$Main$fetchRoleData(jwt),
						A2($author$project$Api$Request$getProjectData, jwt, i),
						$author$project$Main$fetchCollaboratingProjects(jwt)
					]);
			case 12:
				var i = route.a;
				return _List_fromArray(
					[
						$author$project$Main$fetchRoleData(jwt),
						A2($author$project$Main$fetchApplicantData, i, jwt)
					]);
			case 22:
				var i = route.a;
				var code = route.b;
				return _List_fromArray(
					[
						A3($author$project$Main$verifyAccount, jwt, i, code)
					]);
			case 8:
				return _List_Nil;
			case 7:
				return _List_Nil;
			case 9:
				return _List_fromArray(
					[
						$author$project$Main$fetchRoleData(jwt),
						$author$project$Main$fetchUsersJobs(jwt),
						A2($author$project$Main$fetchConversations, twilioToken, twilioData)
					]);
			case 23:
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(jwt),
						$author$project$Main$fetchRoleData(jwt)
					]);
			case 24:
				var i = route.a;
				var scheduleType = route.b;
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(jwt),
						$author$project$Main$fetchRoleData(jwt),
						A2($author$project$Api$Request$getProjectData, jwt, i)
					]);
			case 25:
				var projectId = route.a;
				var scheduleId = route.b;
				return _List_fromArray(
					[
						A3($author$project$Api$Request$getSchedule, jwt, projectId, scheduleId),
						A2($author$project$Api$Request$getSchedules, projectId, jwt),
						A2($author$project$Api$Request$getCollaboratorsOnProject, projectId, jwt)
					]);
			default:
				return _List_fromArray(
					[
						$author$project$Api$Request$getOptions(jwt)
					]);
		}
	});
var $author$project$MainMsg$GotDashboardPageData = function (a) {
	return {$: 40, a: a};
};
var $author$project$SharedProjectRoleSchedules$DashboardPage = F6(
	function (projects, roles, myJobs, talent, timeSlots, talentRolesSummary) {
		return {eO: myJobs, fe: projects, fq: roles, jr: talent, jy: talentRolesSummary, jD: timeSlots};
	});
var $author$project$SharedProjectRoleSchedules$BasicProjectData = function (id) {
	return function (name) {
		return function (agencyNotes) {
			return function (talentNotes) {
				return function (projectRate) {
					return function (companyName) {
						return function (union) {
							return function (postedDate) {
								return function (description) {
									return function (shootDate) {
										return function (projectLocation) {
											return function (auditionLocation) {
												return function (shootLocation) {
													return function (roles) {
														return function (matchingCandidatesColumn) {
															return function (projectDates) {
																return function (talent) {
																	return {gm: agencyNotes, dE: auditionLocation, gS: companyName, hf: description, V: id, hY: matchingCandidatesColumn, bH: name, e1: postedDate, e9: projectDates, fc: projectLocation, iJ: projectRate, fq: roles, jg: shootDate, fH: shootLocation, jr: talent, jw: talentNotes, jI: union};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$SharedProjectRoleSchedules$BasicRoleData = F8(
	function (id, name, description, genders, ethnicities, ageRange, projectId, projectName) {
		return {dt: ageRange, hf: description, ea: ethnicities, hy: genders, V: id, bH: name, iH: projectId, iI: projectName};
	});
var $author$project$Api$Decoders$basicRoleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'project_name',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'project_id',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'age_range',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'ethnicities',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'genders',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'name',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'id',
								$elm$json$Json$Decode$string,
								'',
								$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$BasicRoleData)))))))));
var $author$project$Api$Decoders$basicRolesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$basicRoleDecoder);
var $author$project$Api$Decoders$basicProjectDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'talent',
	$author$project$Api$Decoders$searchResultTalentProfileDecoder,
	$author$project$User$emptySearchTalentProfile,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'project_dates',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'matching_candidates_column',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'roles',
				$author$project$Api$Decoders$basicRolesDecoder,
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'shoot_location',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'audition_location',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'project_location',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'shoot_date',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'posted_date',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'union',
											$elm$json$Json$Decode$bool,
											false,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'company_name',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'project_rate',
													$elm$json$Json$Decode$string,
													'',
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'talent_notes',
														$elm$json$Json$Decode$string,
														'',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'agency_notes',
															$elm$json$Json$Decode$string,
															'',
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'name',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$BasicProjectData))))))))))))))))));
var $author$project$Api$Decoders$basicProjectsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$basicProjectDecoder);
var $author$project$SharedProjectRoleSchedules$RoleSummary = F8(
	function (projectName, projectId, roleName, roleId, bookedCount, scheduledCount, rejectedCount, matchedCount) {
		return {gD: bookedCount, hX: matchedCount, iH: projectId, iI: projectName, iS: rejectedCount, iX: roleId, iY: roleName, i1: scheduledCount};
	});
var $author$project$Data$RoleId$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Data$RoleId$emptyRoleId = '';
var $author$project$Api$Decoders$talentRoleSummaryDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'matched_count',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'rejected_count',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'scheduled_count',
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'booked_count',
				$elm$json$Json$Decode$int,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'role_id',
					$author$project$Data$RoleId$decoder,
					$author$project$Data$RoleId$emptyRoleId,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'role_name',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'project_id',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'project_name',
								$elm$json$Json$Decode$string,
								'',
								$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$RoleSummary)))))))));
var $author$project$Api$Decoders$dashboardPageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'talent_roles_summary',
	$elm$json$Json$Decode$list($author$project$Api$Decoders$talentRoleSummaryDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'time_slots',
		$elm$json$Json$Decode$list($author$project$Api$Decoders$timeSlotDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'talent',
			$author$project$Api$Decoders$talentUsersDecoder,
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'myJobs',
				$author$project$Api$Decoders$jobsDecoder,
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'roles',
					$author$project$Api$Decoders$basicRolesDecoder,
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'projects',
						$author$project$Api$Decoders$basicProjectsDecoder,
						_List_Nil,
						$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$DashboardPage)))))));
var $author$project$Api$Request$getDashboardData = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotDashboardPageData, $author$project$Api$Decoders$dashboardPageDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'dashboard'
		});
};
var $author$project$MainMsg$GotJobPageData = function (a) {
	return {$: 320, a: a};
};
var $author$project$Job$JobPageData = F6(
	function (projects, myJobs, searchTerm, searchStatus, viewingJob, selectedProject) {
		return {eO: myJobs, fe: projects, fB: searchStatus, fC: searchTerm, fD: selectedProject, f3: viewingJob};
	});
var $author$project$Job$Results = 1;
var $author$project$Api$Decoders$searchStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return $elm$json$Json$Decode$succeed(1);
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$viewingJobDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return $elm$json$Json$Decode$succeed(1);
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$jobPageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'selected_project',
	$author$project$Api$Decoders$basicProjectDecoder,
	$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'viewing_job',
		$author$project$Api$Decoders$viewingJobDecoder,
		1,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'search_status',
			$author$project$Api$Decoders$searchStatusDecoder,
			1,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'search_term',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'my_jobs',
					$author$project$Api$Decoders$jobsDecoder,
					_List_Nil,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'projects',
						$author$project$Api$Decoders$basicProjectsDecoder,
						$elm$json$Json$Decode$succeed($author$project$Job$JobPageData)))))));
var $author$project$Api$Request$getJobPageData = F2(
	function (jwt, projectId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotJobPageData, $author$project$Api$Decoders$jobPageDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('job_page_data/' + projectId)
			});
	});
var $author$project$Main$fetchDataForPage = F2(
	function (route, model) {
		switch (route.$) {
			case 13:
				return _List_fromArray(
					[
						$author$project$Api$Request$getDashboardData(model.hR),
						A2($author$project$Main$fetchConversations, model.z.u, model.j),
						$author$project$Main$fetchCollaboratingProjects(model.hR)
					]);
			case 21:
				var projectId = route.a;
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(model.hR),
						$author$project$Main$fetchPipeline(
						{d_: projectId, hR: model.hR, ji: model.ji}),
						A2($author$project$Api$Request$getSchedules, projectId, model.hR),
						$author$project$Main$fetchRoleData(model.hR),
						A2($author$project$Api$Request$getProjectData, model.hR, projectId),
						$author$project$Main$fetchCollaboratingProjects(model.hR)
					]);
			case 23:
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(model.hR)
					]);
			case 8:
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(model.hR),
						$author$project$Main$fetchRoleData(model.hR),
						$author$project$Main$fetchUsersJobs(model.hR)
					]);
			case 7:
				var projectId = route.a;
				return _List_fromArray(
					[
						A2($author$project$Api$Request$getJobPageData, model.hR, projectId)
					]);
			default:
				return _List_Nil;
		}
	});
var $author$project$MainMsg$GotMessages = function (a) {
	return {$: 99, a: a};
};
var $author$project$Message$MessageData = function (id) {
	return function (creatorId) {
		return function (name) {
			return function (timeStamp) {
				return function (body) {
					return function (conversationId) {
						return function (downloadUrl) {
							return function (fileName) {
								return function (size) {
									return function (messageType) {
										return function (contentType) {
											return {dG: body, dS: contentType, gY: conversationId, g_: creatorId, d2: downloadUrl, cR: fileName, V: id, bo: messageType, bH: name, fK: size, ct: timeStamp};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Decoders$messageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'contentType',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'messageType',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'size',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fileName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'downloadUrl',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'conversationId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'body',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'timeStamp',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'creatorId',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Message$MessageData))))))))))));
var $author$project$Api$Decoders$messagesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$messageDecoder);
var $author$project$Api$Request$getMessages = F3(
	function (creatorId, conversationId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotMessages, $author$project$Api$Decoders$messagesDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (creatorId + ('/conversations/' + (conversationId + '/messages'))))
			});
	});
var $author$project$Main$fetchMessages = F3(
	function (conversationId, token, userId) {
		return (conversationId !== '') ? A3($author$project$Api$Request$getMessages, userId, conversationId, token) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Main$fetchNewToken = _Platform_outgoingPort('fetchNewToken', $elm$json$Json$Encode$string);
var $author$project$MainMsg$GotUnreadMessages = function (a) {
	return {$: 134, a: a};
};
var $author$project$Api$Request$getUnreadMessages = F2(
	function (userId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotUnreadMessages, $author$project$Api$Decoders$messagesDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (userId + '/messages/unread'))
			});
	});
var $author$project$Main$fetchUnreadMessages = F2(
	function (userId, token) {
		return A2($author$project$Api$Request$getUnreadMessages, userId, token);
	});
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$Main$fileUploadPayload = F3(
	function (file, channelId, roleMemberId) {
		return _Utils_update(
			$author$project$Message$emptyToTwilioPayload,
			{dG: file, gM: channelId, aQ: roleMemberId});
	});
var $author$project$Main$filterImages = F2(
	function (id, images) {
		return A2(
			$elm$core$List$filter,
			function (image) {
				return !_Utils_eq(image.V, id);
			},
			images);
	});
var $author$project$Main$updatePipelineUsers = F2(
	function (pipeline, column) {
		return A2(
			$elm$core$List$map,
			function (c) {
				return _Utils_eq(c.V, column.V) ? column : c;
			},
			pipeline);
	});
var $author$project$Main$filterOrSortViewingProjectPipeline = F2(
	function (viewingProject, column) {
		return _Utils_update(
			viewingProject,
			{
				v: A2($author$project$Main$updatePipelineUsers, viewingProject.v, column)
			});
	});
var $author$project$MainMsg$FilteredColumn = function (a) {
	return {$: 182, a: a};
};
var $author$project$Api$Encoders$filterEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'filter',
				$elm$json$Json$Encode$string(model.hs)),
				_Utils_Tuple2(
				'column_id',
				$elm$json$Json$Encode$string(model.V))
			]));
};
var $author$project$Api$Request$filterPipeline = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$filterEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$FilteredColumn, $author$project$Api$Decoders$pipelineDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.d_ + '/pipeline'))
		});
};
var $author$project$Main$filterPipelineUsers = function (model) {
	return $author$project$Api$Request$filterPipeline(model);
};
var $author$project$Main$filterProject = F2(
	function (id, projects) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.cU;
					},
					id),
				projects));
	});
var $author$project$Main$filterRole = F2(
	function (id, roles) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.cU;
					},
					id),
				roles));
	});
var $author$project$Main$filteringMap = function (filter) {
	switch (filter) {
		case 0:
			return 'Applied';
		case 1:
			return 'Requested to Apply';
		case 2:
			return 'Accepted Application';
		default:
			return 'no_filter';
	}
};
var $author$project$Utils$findProject = F2(
	function (projects, projectId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyProject,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.cU;
						},
						projectId),
					projects)));
	});
var $author$project$Views$Messages$findRole = F2(
	function (roles, roleId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyRole,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.cU;
						},
						roleId),
					roles)));
	});
var $author$project$Main$fireBaseLogin = _Platform_outgoingPort(
	'fireBaseLogin',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Main$fireBaseSignUp = _Platform_outgoingPort(
	'fireBaseSignUp',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Views$Project$firstProject = function (allProjects) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptyProject,
		$elm$core$List$head(allProjects));
};
var $elm$http$Http$fractionSent = function (p) {
	return (!p.fK) ? 1 : A3($elm$core$Basics$clamp, 0, 1, p.je / p.fK);
};
var $author$project$Message$FromTwilioPayload = F4(
	function (channels, messages, currentChannel, cmd) {
		return {g: channels, t: cmd, k: currentChannel, h3: messages};
	});
var $author$project$Message$Conversation = function (id) {
	return function (roleName) {
		return function (projectName) {
			return function (projectId) {
				return function (roleId) {
					return function (jobPosterName) {
						return function (jobPosterAvatar) {
							return function (talentName) {
								return function (talentAvatar) {
									return function (unreadMessages) {
										return function (dateUpdated) {
											return function (lastMessage) {
												return function (talentId) {
													return function (roleMemberId) {
														return function (archived) {
															return function (messages) {
																return function (jobPosterId) {
																	return function (channelType) {
																		return {dz: archived, b0: channelType, g9: dateUpdated, V: id, hO: jobPosterAvatar, eA: jobPosterId, hQ: jobPosterName, hU: lastMessage, h3: messages, iH: projectId, iI: projectName, iX: roleId, aQ: roleMemberId, iY: roleName, js: talentAvatar, jt: talentId, jv: talentName, bW: unreadMessages};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Message$AgencyTalentChannel = 1;
var $author$project$Message$channelTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'ProjectRoleChannel':
				return $elm$json$Json$Decode$succeed(0);
			case 'AgencyTalentChannel':
				return $elm$json$Json$Decode$succeed(1);
			case '':
				return $elm$json$Json$Decode$succeed(0);
			default:
				var name = str;
				return $elm$json$Json$Decode$fail('Not valid channel type: ' + name);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Message$messageDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'contentType',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'messageType',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'size',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fileName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'downloadUrl',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'conversationId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'body',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'timeStamp',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'creatorId',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Message$MessageData))))))))))));
var $author$project$Message$conversationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'channelType',
	$author$project$Message$channelTypeDecoder,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'jobPosterId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'messages',
			$elm$json$Json$Decode$list($author$project$Message$messageDataDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'archived',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'roleMemberId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'talentId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'lastMessage',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'dateUpdated',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'unreadMessages',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'talentAvatar',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'talentName',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'jobPosterAvatar',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'jobPosterName',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'roleId',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'projectId',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'projectName',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'roleName',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'id',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$Message$Conversation)))))))))))))))))));
var $author$project$Message$fromTwilioDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cmd',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'currentChannel',
		$author$project$Message$conversationDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'messages',
			$elm$json$Json$Decode$list($author$project$Message$messageDataDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'channels',
				$elm$json$Json$Decode$list($author$project$Message$conversationDecoder),
				$elm$json$Json$Decode$succeed($author$project$Message$FromTwilioPayload)))));
var $author$project$MainMsg$GotAgencies = function (a) {
	return {$: 302, a: a};
};
var $author$project$Api$Decoders$agenciesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$agencyDecoder);
var $author$project$Api$Request$getAgencies = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotAgencies, $author$project$Api$Decoders$agenciesDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'agencies'
		});
};
var $author$project$MainMsg$GotAgent = function (a) {
	return {$: 108, a: a};
};
var $author$project$User$Invitation = F2(
	function (user, create_account) {
		return {b3: create_account, f_: user};
	});
var $author$project$Api$Decoders$invitationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'create_account',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user',
		$author$project$Api$Decoders$collaboratorDecoder,
		$elm$json$Json$Decode$succeed($author$project$User$Invitation)));
var $author$project$Api$Request$getAgentInfo = F2(
	function (jwt, secretKey) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotAgent, $author$project$Api$Decoders$invitationDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('agencies/invite/' + secretKey)
			});
	});
var $author$project$MainMsg$GotCollaborator = function (a) {
	return {$: 270, a: a};
};
var $author$project$Api$Request$getCollaboratorInfo = F2(
	function (jwt, secretKey) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotCollaborator, $author$project$Api$Decoders$invitationDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('collaborator/invite/' + secretKey)
			});
	});
var $author$project$MainMsg$GotCollaborators = function (a) {
	return {$: 268, a: a};
};
var $author$project$Api$Request$getCollaborators = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotCollaborators, $author$project$Api$Decoders$collaboratorsDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + '/collaborators'
		});
};
var $author$project$MainMsg$UserSignIn = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Request$getCurrentUser = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UserSignIn, $author$project$Api$Decoders$updateProfileDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'users/user_id'
		});
};
var $author$project$MainMsg$GotDetailedTalentInfo = function (a) {
	return {$: 261, a: a};
};
var $author$project$Api$Request$getDetailedTalentInfo = F3(
	function (jwt, projectId, userId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotDetailedTalentInfo, $author$project$Api$Decoders$searchResultTalentProfileDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (userId + ('/' + (projectId + '/detailed'))))
			});
	});
var $author$project$MainMsg$NotificationsRefreshed = function (a) {
	return {$: 241, a: a};
};
var $author$project$Api$Request$getNotifications = F2(
	function (jwt, notificationCount) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$NotificationsRefreshed, $author$project$Api$Decoders$notificationsDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (jwt + ('/get_notifications/' + notificationCount)))
			});
	});
var $author$project$MainMsg$GotProxiedImage = function (a) {
	return {$: 259, a: a};
};
var $author$project$Api$Encoders$imageProxyEncoder = F2(
	function (url, id) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'url',
					$elm$json$Json$Encode$string(url)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id))
				]));
	});
var $author$project$User$ProxyImage = F2(
	function (id, url) {
		return {V: id, jM: url};
	});
var $author$project$Api$Decoders$proxyImageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'image_url',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'id',
		$elm$json$Json$Decode$string,
		'',
		$elm$json$Json$Decode$succeed($author$project$User$ProxyImage)));
var $author$project$Api$Request$getProxiedImage = F2(
	function (image, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$imageProxyEncoder, image.jM, image.V)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotProxiedImage, $author$project$Api$Decoders$proxyImageDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'images/proxy'
			});
	});
var $author$project$MainMsg$GotTempfile = function (a) {
	return {$: 295, a: a};
};
var $author$project$Api$Request$getTempfile = F2(
	function (jwt, roleMemberId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotTempfile, $author$project$Api$Decoders$videoDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (roleMemberId + '/tempfile'))
			});
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Data$RoleId$toString = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Route$routeToString = function (page) {
	switch (page.$) {
		case 0:
			return '/login';
		case 1:
			return '/talent-signup';
		case 5:
			return '/agency-signup';
		case 2:
			var email = page.a;
			return '/talent-signup/' + email;
		case 4:
			return '/casting-signup';
		case 3:
			var email = page.a;
			return '/casting-signup/' + email;
		case 28:
			var roleId = page.a;
			return '/talent-schedule/' + $author$project$Data$RoleId$toString(roleId);
		case 9:
			return '/jobs';
		case 8:
			return '/discover-jobs';
		case 7:
			var s = page.a;
			return '/discover-jobs/' + s;
		case 10:
			return '/inbox';
		case 13:
			return '/dashboard';
		case 14:
			return '/talent-profile';
		case 15:
			return '/agency-profile';
		case 16:
			return '/agent-profile';
		case 6:
			return '/account/profile';
		case 18:
			var p = page.a;
			return '/account/profile';
		case 20:
			return '/talent-search';
		case 21:
			var i = page.a;
			return '/projects/' + i;
		case 19:
			var s = page.a;
			return '/account';
		case 11:
			return '/roles';
		case 12:
			var i = page.a;
			return '/role/' + i;
		case 22:
			var id = page.a;
			var code = page.b;
			return '/account/' + (id + ('/' + code));
		case 23:
			return '/schedules';
		case 24:
			var i = page.a;
			var scheduleType = page.b;
			return '/schedules/' + (i + ('/' + scheduleType));
		case 25:
			var projectId = page.a;
			var scheduleId = page.b;
			return '/schedule/' + (projectId + ('/' + scheduleId));
		case 26:
			var secretKey = page.a;
			return '/signup-collaborators/' + secretKey;
		case 27:
			var secretKey = page.a;
			return '/signup-agents/' + secretKey;
		default:
			return '/404';
	}
};
var $author$project$Main$goTo = F2(
	function (_v0, route) {
		var key = _v0.eB;
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			key,
			$author$project$Route$routeToString(route));
	});
var $author$project$Pages$AgencyTalentSchedule$GotRoleInfo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$RoleInfo$RoleInfo = function (id) {
	return function (name) {
		return function (description) {
			return function (minAge) {
				return function (maxAge) {
					return function (rate) {
						return function (createdAt) {
							return function (ethnicities) {
								return function (genders) {
									return function (project) {
										return function (talentPipeline) {
											return {gZ: createdAt, hf: description, ea: ethnicities, hy: genders, V: id, cX: maxAge, cZ: minAge, bH: name, ae: project, iN: rate, jx: talentPipeline};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Pipeline$PipelineItem = F3(
	function (id, name, talentPipeline) {
		return {V: id, bH: name, jx: talentPipeline};
	});
var $author$project$Data$Pipeline$PipelineTalent = F5(
	function (id, firstName, lastName, profileImage, scheduledDate) {
		return {bm: firstName, V: id, bE: lastName, iC: profileImage, i2: scheduledDate};
	});
var $author$project$Data$Pipeline$pipelineTalentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'scheduled_date',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'profile_image',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'first_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Data$Pipeline$PipelineTalent))))));
var $author$project$Data$Pipeline$pipelineTalentListDecoder = $elm$json$Json$Decode$list($author$project$Data$Pipeline$pipelineTalentDecoder);
var $author$project$Data$Pipeline$pipelineItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'talent',
	$author$project$Data$Pipeline$pipelineTalentListDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Pipeline$PipelineItem))));
var $author$project$Data$Pipeline$decoder = $elm$json$Json$Decode$list($author$project$Data$Pipeline$pipelineItemDecoder);
var $author$project$Data$ProjectInfo$ProjectInfo = F5(
	function (id, name, notes, agencyNotes, union) {
		return {gm: agencyNotes, V: id, bH: name, im: notes, jI: union};
	});
var $author$project$Data$ProjectId$ProjectId = $elm$core$Basics$identity;
var $author$project$Data$ProjectId$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Data$ProjectInfo$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'union',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'agencyNotes',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'notes',
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$author$project$Data$ProjectId$decoder,
					$elm$json$Json$Decode$succeed($author$project$Data$ProjectInfo$ProjectInfo))))));
var $author$project$Data$Ethnicity$Ethnicity = F2(
	function (id, name) {
		return {V: id, bH: name};
	});
var $author$project$Data$Ethnicity$ethnicityDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Ethnicity$Ethnicity)));
var $author$project$Data$Ethnicity$ethnicitiesDecoder = $elm$json$Json$Decode$list($author$project$Data$Ethnicity$ethnicityDecoder);
var $author$project$Data$RoleInfo$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'talent_pipeline',
	$author$project$Data$Pipeline$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'project',
		$author$project$Data$ProjectInfo$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'genders',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'ethnicities',
				$author$project$Data$Ethnicity$ethnicitiesDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'rate',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'maxAge',
							$elm$json$Json$Decode$int,
							100,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'minAge',
								$elm$json$Json$Decode$int,
								0,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$author$project$Data$RoleId$decoder,
											$elm$json$Json$Decode$succeed($author$project$Data$RoleInfo$RoleInfo))))))))))));
var $author$project$Api$Main$authorizationHeader = function (token) {
	return A2($elm$http$Http$header, 'jwt', token);
};
var $author$project$Api$Endpoint$unwrap = function (_v0) {
	var str = _v0;
	return str;
};
var $author$project$Api$Endpoint$request = function (config) {
	return $elm$http$Http$request(
		{
			dG: config.dG,
			eg: config.eg,
			eq: config.eq,
			eK: config.eK,
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$Endpoint$unwrap(config.jM)
		});
};
var $author$project$Api$Main$get = F4(
	function (url, jwt, msg, decoder) {
		return $author$project$Api$Endpoint$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, msg, decoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Main$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jM: url
			});
	});
var $author$project$Api$Endpoint$Endpoint = $elm$core$Basics$identity;
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Api$Endpoint$apiBasePath = function () {
	var _v0 = A2($elm$core$String$endsWith, '/', $author$project$Api$BaseUrl$talentSourceUrl);
	if (_v0) {
		return A2($elm$core$String$dropRight, 1, $author$project$Api$BaseUrl$talentSourceUrl);
	} else {
		return $author$project$Api$BaseUrl$talentSourceUrl;
	}
}();
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Api$Endpoint$makeUrl = function (paths) {
	return A3($elm$url$Url$Builder$crossOrigin, $author$project$Api$Endpoint$apiBasePath, paths, _List_Nil);
};
var $author$project$Api$Endpoint$roleInfo = function (roleId) {
	return $author$project$Api$Endpoint$makeUrl(
		_List_fromArray(
			[
				'role_info',
				$author$project$Data$RoleId$toString(roleId)
			]));
};
var $author$project$Data$RoleInfo$fetch = F3(
	function (jwt, roleId, msg) {
		return A4(
			$author$project$Api$Main$get,
			$author$project$Api$Endpoint$roleInfo(roleId),
			jwt,
			msg,
			$author$project$Data$RoleInfo$decoder);
	});
var $author$project$Api$Utils$Failure = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Utils$Success = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Utils$makeApiData = function (result) {
	if (!result.$) {
		var value = result.a;
		return $author$project$Api$Utils$Success(value);
	} else {
		var error = result.a;
		return $author$project$Api$Utils$Failure(error);
	}
};
var $author$project$Pages$AgencyTalentSchedule$update = F3(
	function (msg, model, jwt) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cp: $author$project$Api$Utils$makeApiData(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cq: $author$project$Api$Utils$makeApiData(result)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var roleId = msg.a;
				return _Utils_Tuple2(
					model,
					A3($author$project$Data$RoleInfo$fetch, jwt, roleId, $author$project$Pages$AgencyTalentSchedule$GotRoleInfo));
		}
	});
var $author$project$Main$updateWith = F4(
	function (toModel, toMsg, model, _v0) {
		var subModel = _v0.a;
		var subCmd = _v0.b;
		var routeData = toModel(subModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cJ: routeData}),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Main$handlePageSpecificSubMsgs = F2(
	function (model, msg) {
		var _v0 = _Utils_Tuple2(msg, model.cJ);
		if ((_v0.a.$ === 326) && (!_v0.b.$)) {
			var subMsg = _v0.a.a;
			var routeData = _v0.b.a;
			return A4(
				$author$project$Main$updateWith,
				$author$project$Model$AgencyTalentScheduleRouteData,
				$author$project$MainMsg$GotAgencyTalentScheduleMsg,
				model,
				A3($author$project$Pages$AgencyTalentSchedule$update, subMsg, routeData, model.hR));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$MainMsg$GotTalentProfileModalMsg = function (a) {
	return {$: 325, a: a};
};
var $author$project$Message$TwilioDataReceived = 2;
var $author$project$Message$TwilioMessageSent = 3;
var $author$project$Main$archiveChannelIndex = F2(
	function (conversations, id) {
		return A2(
			$elm$core$List$map,
			function (conversation) {
				return _Utils_eq(conversation.V, id) ? _Utils_update(
					conversation,
					{dz: !conversation.dz}) : conversation;
			},
			conversations);
	});
var $author$project$MainMsg$DoNothing = function (a) {
	return {$: 237, a: a};
};
var $author$project$Api$Encoders$newMessageEncoder = function (conversation) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'role_member_id',
				$elm$json$Json$Encode$string(conversation.aQ)),
				_Utils_Tuple2(
				'message',
				$elm$json$Json$Encode$string(
					A3($elm$core$String$slice, 0, 99, conversation.hU) + '...'))
			]));
};
var $author$project$Api$Request$channelCreated = F2(
	function (conversation, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$newMessageEncoder(conversation)),
				eg: $elm$http$Http$expectWhatever($author$project$MainMsg$DoNothing),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'users/created_channel'
			});
	});
var $author$project$Main$checkIfChannelsAreDifferent = F2(
	function (receivedConversations, frontendConversations) {
		return (_Utils_cmp(
			$elm$core$List$length(receivedConversations),
			$elm$core$List$length(frontendConversations)) < 0) ? frontendConversations : receivedConversations;
	});
var $author$project$Main$createAgencyConversation = F2(
	function (model, talent) {
		var message = model.y.dG;
		var creator = model.z;
		var twilioPayload = _Utils_update(
			$author$project$Message$emptyToTwilioPayload,
			{
				dG: message,
				g_: creator.cU,
				hv: talent.bm + (' ' + talent.bE),
				hO: A2(
					$elm$core$Maybe$withDefault,
					{V: '', jM: ''},
					$elm$core$List$head(creator.hE)).jM,
				eA: creator.cU,
				hP: creator.cU,
				hQ: creator.bm + (' ' + creator.bE),
				js: A2(
					$elm$core$Maybe$withDefault,
					{V: '', jM: ''},
					$elm$core$List$head(talent.hE)).jM,
				ju: talent.cU,
				jv: talent.bm + (' ' + talent.bE),
				jJ: ''
			});
		return $author$project$Main$twilio(
			{
				t: 'createChannel',
				X: $author$project$Api$Encoders$twilioPayloadEncoder(twilioPayload),
				aa: creator.u
			});
	});
var $author$project$Main$createProjectRoleConversation = function (model) {
	var user = model.p;
	var roleId = model.g3;
	var projectId = model.d_;
	var message = model.y.dG;
	var creator = model.z;
	var twilioPayload = _Utils_update(
		$author$project$Message$emptyToTwilioPayload,
		{
			dG: message,
			g_: creator.cU,
			hv: user.bm + (' ' + user.bE),
			hO: A2(
				$elm$core$Maybe$withDefault,
				{V: '', jM: ''},
				$elm$core$List$head(creator.hE)).jM,
			eA: creator.cU,
			hP: creator.cU,
			hQ: creator.bm + (' ' + creator.bE),
			iH: projectId,
			iI: user.iI,
			iX: roleId,
			aQ: user.aQ,
			iY: user.iY,
			js: A2(
				$elm$core$Maybe$withDefault,
				{V: '', jM: ''},
				$elm$core$List$head(user.hE)).jM,
			ju: user.cU,
			jv: user.bm + (' ' + user.bE),
			jJ: ''
		});
	return $author$project$Main$twilio(
		{
			t: 'createChannel',
			X: $author$project$Api$Encoders$twilioPayloadEncoder(twilioPayload),
			aa: creator.u
		});
};
var $author$project$Main$createConversation = function (model) {
	var _v0 = model.aR.jr;
	if (_v0.$ === 3) {
		var talent = _v0.a;
		return A2($author$project$Main$createAgencyConversation, model, talent);
	} else {
		return $author$project$Main$createProjectRoleConversation(model);
	}
};
var $author$project$Api$Encoders$notificationEncoder = F4(
	function (sendingUser, body, notificationType, conversation) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sending_user_id',
					$elm$json$Json$Encode$string(sendingUser)),
					_Utils_Tuple2(
					'role_member_id',
					$elm$json$Json$Encode$string(conversation.aQ)),
					_Utils_Tuple2(
					'body',
					$elm$json$Json$Encode$string(body)),
					_Utils_Tuple2(
					'notification_type',
					$elm$json$Json$Encode$string(notificationType)),
					_Utils_Tuple2(
					'conversation_id',
					$elm$json$Json$Encode$string(conversation.V)),
					_Utils_Tuple2(
					'job_poster_id',
					$elm$json$Json$Encode$string(conversation.eA)),
					_Utils_Tuple2(
					'talent_id',
					$elm$json$Json$Encode$string(conversation.jt))
				]));
	});
var $author$project$Api$Request$createNotification = F5(
	function (jwt, sendingUser, body, notificationType, conversation) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A4($author$project$Api$Encoders$notificationEncoder, sendingUser, body, notificationType, conversation)),
				eg: $elm$http$Http$expectWhatever($author$project$MainMsg$DoNothing),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'users/create_notification'
			});
	});
var $author$project$MainMsg$ProjectDeleted = function (a) {
	return {$: 50, a: a};
};
var $author$project$Api$Encoders$deleteEncoder = $elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'archived',
			$elm$json$Json$Encode$bool(true))
		]));
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $author$project$Api$Request$deleteProject = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody($author$project$Api$Encoders$deleteEncoder),
			eg: $elm$http$Http$expectString($author$project$MainMsg$ProjectDeleted),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'PUT',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + model.d_)
		});
};
var $author$project$MainMsg$RoleDeleted = function (a) {
	return {$: 63, a: a};
};
var $author$project$Api$Request$deleteRole = F3(
	function (projectId, roleId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody($author$project$Api$Encoders$deleteEncoder),
				eg: $elm$http$Http$expectString($author$project$MainMsg$RoleDeleted),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'PUT',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (projectId + ('/roles/' + roleId)))
			});
	});
var $author$project$Main$findChannel = F2(
	function (conversations, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Message$emptyConversation,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.V;
						},
						id),
					conversations)));
	});
var $author$project$Main$findChannelIdsByProject = F2(
	function (projectId, conversations) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.V;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.iH;
					},
					projectId),
				conversations));
	});
var $author$project$Main$findChannelIdsByRole = F2(
	function (roleId, conversations) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.V;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.iX;
					},
					roleId),
				conversations));
	});
var $author$project$Main$findMatchingChannel = function (model) {
	var channels = model.j.g;
	var _v0 = model.aR.jr;
	if (_v0.$ === 3) {
		var talentData = _v0.a;
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (channel) {
					return _Utils_eq(channel.jt, talentData.cU);
				},
				channels));
	} else {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (channel) {
					return _Utils_eq(channel.aQ, model.p.aQ);
				},
				channels));
	}
};
var $author$project$MainMsg$GotUserConvoInfo = function (a) {
	return {$: 238, a: a};
};
var $author$project$Api$Encoders$roleMemberIdEncoder = function (roleMemberIds) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'role_member_ids',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, roleMemberIds))
			]));
};
var $author$project$User$UserConvoInfo = F7(
	function (projectName, roleName, userName, projectId, roleId, profileImage, roleMemberId) {
		return {iC: profileImage, iH: projectId, iI: projectName, iX: roleId, aQ: roleMemberId, iY: roleName, jO: userName};
	});
var $author$project$Api$Decoders$userConvoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'role_member_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'profile_image',
		$author$project$Api$Decoders$imageDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'role_id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'project_id',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'user_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'role_name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'project_name',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$User$UserConvoInfo))))))));
var $author$project$Api$Decoders$userConvosDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$userConvoDecoder);
var $author$project$Api$Request$getChannelInfo = F2(
	function (jwt, roleMemberIds) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$roleMemberIdEncoder(roleMemberIds)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotUserConvoInfo, $author$project$Api$Decoders$userConvosDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'users/user_info_for_convos'
			});
	});
var $author$project$MainMsg$GotUserJobStageInfo = function (a) {
	return {$: 228, a: a};
};
var $author$project$Api$Request$getUserJobStageInfo = F2(
	function (roleMemberId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotUserJobStageInfo, $author$project$Api$Decoders$pipelineUserDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (roleMemberId + '/job_stage_info'))
			});
	});
var $author$project$Main$addMessageToChannelIndex = F4(
	function (channels, message, currentConversation, userProfile) {
		return A2(
			$elm$core$List$map,
			function (channel) {
				return _Utils_eq(channel.V, message.gY) ? _Utils_update(
					channel,
					{
						g9: 'now',
						hU: message.dG,
						h3: _Utils_ap(
							channel.h3,
							_List_fromArray(
								[message])),
						bW: _Utils_eq(message.g_, userProfile.cU) ? 0 : (channel.bW + 1)
					}) : channel;
			},
			channels);
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$Main$removeLastMessage = function (conversation) {
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$drop,
			1,
			$elm$core$List$reverse(conversation.h3)));
};
var $author$project$Main$myMessageMedia = F2(
	function (currentConversation, receivedMessage) {
		var messages = $author$project$Main$removeLastMessage(currentConversation);
		return _Utils_update(
			currentConversation,
			{
				h3: _Utils_ap(
					messages,
					_List_fromArray(
						[receivedMessage]))
			});
	});
var $author$project$Main$otherUsersMessage = F2(
	function (currentConversation, receivedMessage) {
		return _Utils_update(
			currentConversation,
			{
				h3: _Utils_ap(
					currentConversation.h3,
					_List_fromArray(
						[receivedMessage]))
			});
	});
var $author$project$Main$checkIfViewingChannel = F3(
	function (currentConversation, receivedMessage, userProfile) {
		var viewingChannel = _Utils_eq(receivedMessage.gY, currentConversation.V);
		var myMessage = _Utils_eq(receivedMessage.g_, userProfile.cU);
		return (viewingChannel && myMessage) ? A2($author$project$Main$myMessageMedia, currentConversation, receivedMessage) : ((viewingChannel && (!myMessage)) ? A2($author$project$Main$otherUsersMessage, currentConversation, receivedMessage) : currentConversation);
	});
var $author$project$Main$pullOutMessage = function (messages) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Message$emptyMessage,
		$elm$core$List$head(messages));
};
var $author$project$Main$replacePendingUploadMessageInChannelIndex = F2(
	function (conversations, receivedMessage) {
		return A2(
			$elm$core$List$map,
			function (conversation) {
				if (_Utils_eq(conversation.V, receivedMessage.gY)) {
					var updatedMessages = $author$project$Main$removeLastMessage(conversation);
					return _Utils_update(
						conversation,
						{
							hU: 'Media Message',
							h3: _Utils_ap(
								updatedMessages,
								_List_fromArray(
									[receivedMessage]))
						});
				} else {
					return conversation;
				}
			},
			conversations);
	});
var $author$project$Main$handleNewMessagePayload = F2(
	function (payload, model) {
		var twilioData = model.j;
		var receivedMessage = $author$project$Main$pullOutMessage(payload.h3);
		if (_Utils_eq(receivedMessage.g_, model.z.cU)) {
			var _v0 = receivedMessage.bo;
			if (_v0 === 'media') {
				return _Utils_update(
					twilioData,
					{
						g: A2($author$project$Main$replacePendingUploadMessageInChannelIndex, twilioData.g, receivedMessage),
						k: A3($author$project$Main$checkIfViewingChannel, twilioData.k, receivedMessage, model.z)
					});
			} else {
				return _Utils_update(
					twilioData,
					{
						g: A4($author$project$Main$addMessageToChannelIndex, twilioData.g, receivedMessage, twilioData.k, model.z),
						k: A3($author$project$Main$checkIfViewingChannel, twilioData.k, receivedMessage, model.z)
					});
			}
		} else {
			return _Utils_update(
				twilioData,
				{
					g: A4($author$project$Main$addMessageToChannelIndex, twilioData.g, receivedMessage, twilioData.k, model.z),
					k: A3($author$project$Main$checkIfViewingChannel, twilioData.k, receivedMessage, model.z)
				});
		}
	});
var $author$project$Main$markMessagesAsRead = F2(
	function (allChannels, channel) {
		return A2(
			$elm$core$List$map,
			function (chan) {
				return _Utils_eq(chan.V, channel.V) ? _Utils_update(
					chan,
					{bW: 0}) : chan;
			},
			allChannels);
	});
var $author$project$MainMsg$GotNewTwilioToken = function (a) {
	return {$: 224, a: a};
};
var $author$project$Api$Encoders$twilioTokenEncoder = function (token) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'old-twilio_token',
				$elm$json$Json$Encode$string(token))
			]));
};
var $author$project$Api$Request$refreshTwilioToken = F3(
	function (token, jwt, uid) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$twilioTokenEncoder(token)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotNewTwilioToken, $author$project$Api$Decoders$updateProfileDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (uid + '/refresh_twilio'))
			});
	});
var $author$project$MainMsg$MimicDataReceivedFromTwilio = function (a) {
	return {$: 226, a: a};
};
var $author$project$Main$resetButtonTimeout = A2(
	$author$project$Utils$delay,
	200,
	$author$project$MainMsg$MimicDataReceivedFromTwilio(
		_Utils_update(
			$author$project$Message$emptyFromTwilioPayload,
			{t: 'reset-send-button'})));
var $author$project$Main$roleMemberIdsFromChannels = function (conversations) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.aQ;
		},
		conversations);
};
var $author$project$Main$findUserConvoInfo = F2(
	function (userInfoList, roleMemberId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyUserConvoInfo,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.aQ;
						},
						roleMemberId),
					userInfoList)));
	});
var $author$project$Main$updateChannelInfo = F2(
	function (conversations, userInfoList) {
		return A2(
			$elm$core$List$map,
			function (conversation) {
				var roleMemberIds = A2(
					$elm$core$List$map,
					function ($) {
						return $.aQ;
					},
					userInfoList);
				if (A2($elm$core$List$member, conversation.aQ, roleMemberIds)) {
					var userInfo = A2($author$project$Main$findUserConvoInfo, userInfoList, conversation.aQ);
					return _Utils_update(
						conversation,
						{iH: userInfo.iH, iI: userInfo.iI, iX: userInfo.iX, iY: userInfo.iY, js: userInfo.iC.jM, jv: userInfo.jO});
				} else {
					return conversation;
				}
			},
			conversations);
	});
var $author$project$Main$updateChannelMessages = F2(
	function (currentChannel, message) {
		return _Utils_update(
			currentChannel,
			{
				hU: message.dG,
				h3: _Utils_ap(
					currentChannel.h3,
					_List_fromArray(
						[message]))
			});
	});
var $author$project$Main$updateTwilioData = F4(
	function (data, model, id, userConvosInfo) {
		var twilioData = model.j;
		var newMessageData = model.y;
		var _v0 = data.t;
		switch (_v0) {
			case 'refreshTwilioToken':
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Api$Request$refreshTwilioToken, model.z.u, model.hR, model.z.cU),
								$author$project$Main$changeWindowHeight('')
							])));
			case 'gotChannels':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								twilioData,
								{
									g: A2($author$project$Main$checkIfChannelsAreDifferent, data.g, twilioData.g)
								}),
							au: 2
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Main$changeWindowHeight(''),
								A2(
								$author$project$Api$Request$getChannelInfo,
								model.hR,
								$author$project$Main$roleMemberIdsFromChannels(data.g))
							])));
			case 'gotUserConvoInfo':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								twilioData,
								{
									g: A2($author$project$Main$updateChannelInfo, twilioData.g, userConvosInfo)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'switchChannel':
				var channelSwitchedTo = A2($author$project$Main$findChannel, twilioData.g, id);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bn: false,
							bp: false,
							dj: true,
							j: _Utils_update(
								twilioData,
								{
									g: A2($author$project$Main$markMessagesAsRead, twilioData.g, channelSwitchedTo),
									k: channelSwitchedTo
								})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Main$changeWindowHeight(''),
								A2($author$project$Api$Request$getUserJobStageInfo, channelSwitchedTo.aQ, model.hR),
								$author$project$Main$twilio(
								{
									t: 'markConversationAsRead',
									X: $author$project$Api$Encoders$twilioPayloadEncoder(
										_Utils_update(
											$author$project$Message$emptyToTwilioPayload,
											{gM: id})),
									aa: model.z.u
								})
							])));
			case 'archiveConversationsByProject':
				var channelIds = A2($author$project$Main$findChannelIdsByProject, id, twilioData.g);
				var archivedChannels = A2(
					$elm$core$List$map,
					function (channel) {
						return A2($elm$core$List$member, channel.V, channelIds) ? _Utils_update(
							channel,
							{dz: !channel.dz}) : channel;
					},
					twilioData.g);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: false,
							j: _Utils_update(
								twilioData,
								{g: archivedChannels})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Api$Request$deleteProject(model),
								$author$project$Main$twilio(
								{
									t: 'archiveAllConversations',
									X: $author$project$Api$Encoders$twilioPayloadEncoder(
										_Utils_update(
											$author$project$Message$emptyToTwilioPayload,
											{gN: channelIds})),
									aa: model.z.u
								})
							])));
			case 'archiveConversationsByRole':
				var channelIds = A2($author$project$Main$findChannelIdsByRole, id, twilioData.g);
				var archivedChannels = A2(
					$elm$core$List$map,
					function (channel) {
						return A2($elm$core$List$member, channel.V, channelIds) ? _Utils_update(
							channel,
							{dz: !channel.dz}) : channel;
					},
					twilioData.g);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: false,
							j: _Utils_update(
								twilioData,
								{g: archivedChannels})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Api$Request$deleteRole, model.d_, id, model.hR),
								$author$project$Main$twilio(
								{
									t: 'archiveAllConversations',
									X: $author$project$Api$Encoders$twilioPayloadEncoder(
										_Utils_update(
											$author$project$Message$emptyToTwilioPayload,
											{gN: channelIds})),
									aa: model.z.u
								})
							])));
			case 'archiveConversation':
				var channel = A2($author$project$Main$findChannel, twilioData.g, id);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								twilioData,
								{
									g: A2($author$project$Main$archiveChannelIndex, twilioData.g, id)
								})
						}),
					$author$project$Main$twilio(
						{
							t: 'archiveChannel',
							X: $author$project$Api$Encoders$twilioPayloadEncoder(
								_Utils_update(
									$author$project$Message$emptyToTwilioPayload,
									{gM: id})),
							aa: model.z.u
						}));
			case 'newMessage':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: A2($author$project$Main$handleNewMessagePayload, data, model)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Main$changeWindowHeight('')
							])));
			case 'sentMessage':
				var message = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Message$emptyMessage,
					$elm$core$List$head(
						$elm$core$List$reverse(data.k.h3)));
				var _v1 = message.bo;
				if (_v1 === 'media') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								j: _Utils_update(
									twilioData,
									{
										h3: _Utils_ap(twilioData.h3, data.h3)
									}),
								au: 3
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$changeWindowHeight(''),
									A5($author$project$Api$Request$createNotification, model.hR, model.z.cU, 'Media Message', 'message', data.k),
									$author$project$Main$resetButtonTimeout
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{au: 3}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Api$Request$createNotification, model.hR, model.z.cU, message.dG, 'message', data.k),
									$author$project$Main$resetButtonTimeout
								])));
				}
			case 'reset-send-button':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{au: 2}),
					$elm$core$Platform$Cmd$none);
			case 'closeTalentConversationContainer':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dj: false,
							j: _Utils_update(
								twilioData,
								{k: $author$project$Message$emptyConversation})
						}),
					$elm$core$Platform$Cmd$none);
			case 'createdChannel':
				var receivedConvoId = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Message$emptyConversation,
					$elm$core$List$head(data.g)).V;
				var updatedChannels = A2(
					$elm$core$List$map,
					function (convo) {
						return (convo.V === '') ? _Utils_update(
							convo,
							{V: receivedConvoId}) : convo;
					},
					twilioData.g);
				var message = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Message$emptyMessage,
					$elm$core$List$head(
						$elm$core$List$reverse(data.k.h3)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								twilioData,
								{g: updatedChannels, k: data.k}),
							au: 2
						}),
					A5($author$project$Api$Request$createNotification, model.hR, model.z.cU, message.dG, 'message', data.k));
			case 'creatingAConversation':
				var conversation = $author$project$Main$findMatchingChannel(model);
				var _v2 = function () {
					if (!conversation.$) {
						var convo = conversation.a;
						var message = A2(
							$elm$core$Maybe$withDefault,
							$author$project$Message$emptyMessage,
							$elm$core$List$head(data.k.h3));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									y: _Utils_update(
										newMessageData,
										{dG: ''}),
									j: _Utils_update(
										twilioData,
										{
											g: twilioData.g,
											k: A2($author$project$Main$updateChannelMessages, convo, message)
										}),
									au: 0
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A4($author$project$Main$createMessage, convo.V, model.y.dG, model.z.u, model.z.cU)
									])));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									y: _Utils_update(
										newMessageData,
										{dG: ''}),
									j: _Utils_update(
										twilioData,
										{
											g: A2($elm$core$List$cons, data.k, twilioData.g),
											k: data.k,
											h3: data.h3
										}),
									au: 0
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Main$createConversation(model),
										A2(
										$author$project$Api$Request$channelCreated,
										_Utils_update(
											$author$project$Message$emptyConversation,
											{hU: model.y.dG, aQ: model.p.aQ}),
										model.hR)
									])));
					}
				}();
				var optiModel = _v2.a;
				var action = _v2.b;
				return _Utils_Tuple2(optiModel, action);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$handleSavingMessage = F3(
	function (model, userId, message) {
		var messageData = {dG: message};
		var updatedModel = _Utils_update(
			model,
			{y: messageData});
		var twilioPayload = $author$project$Main$conversationTwilioPayload(updatedModel);
		return A4(
			$author$project$Main$updateTwilioData,
			twilioPayload,
			updatedModel,
			userId,
			_List_fromArray(
				[$author$project$User$emptyUserConvoInfo]));
	});
var $author$project$TalentProfileModal$GotTalentInfo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$TalentProfileInfo$TalentProfileInfo = function (id_) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phone) {
					return function (eyeColor) {
						return function (gender) {
							return function (ethnicities) {
								return function (height) {
									return function (weight) {
										return function (waistSize) {
											return function (city) {
												return function (state) {
													return function (images) {
														return function (videos) {
															return function (hairColor) {
																return function (hairLength) {
																	return function (age) {
																		return function (resume) {
																			return {gk: age, aV: city, bl: email, ea: ethnicities, ho: eyeColor, bm: firstName, hw: gender, hz: hairColor, hA: hairLength, hB: height, cU: id_, hE: images, bE: lastName, eZ: phone, iU: resume, a7: state, jT: videos, jV: waistSize, jX: weight};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Image$imageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'image_url',
	$elm$json$Json$Decode$string,
	'./default_user.png',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'id',
		$elm$json$Json$Decode$string,
		'',
		$elm$json$Json$Decode$succeed($author$project$Data$Image$Image)));
var $author$project$Data$Image$imagesDecoder = $elm$json$Json$Decode$list($author$project$Data$Image$imageDecoder);
var $author$project$Data$Video$videoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'progress',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'upload_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'role_member_id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'error',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pending',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'visible',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'length',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'url',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Data$Video$Video)))))))))));
var $author$project$Data$Video$videosDecoder = $elm$json$Json$Decode$list($author$project$Data$Video$videoDecoder);
var $author$project$Data$TalentProfileInfo$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'resume',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'age',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'hair_length',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'hair_color',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'videos',
					$author$project$Data$Video$videosDecoder,
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'images',
						$author$project$Data$Image$imagesDecoder,
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'state',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'city',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'waist_size',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$float,
												$elm$json$Json$Decode$null(0)
											])),
									0,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'weight',
										$elm$json$Json$Decode$int,
										0,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'height',
											$elm$json$Json$Decode$int,
											0,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'ethnicities',
												$author$project$Data$Ethnicity$ethnicitiesDecoder,
												_List_Nil,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'gender',
													$elm$json$Json$Decode$string,
													'',
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'eye_color',
														$elm$json$Json$Decode$string,
														'',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'phone',
															$elm$json$Json$Decode$string,
															'',
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'email',
																$elm$json$Json$Decode$string,
																'',
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'last_name',
																	$elm$json$Json$Decode$string,
																	'',
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'first_name',
																		$elm$json$Json$Decode$string,
																		'',
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Data$TalentProfileInfo$TalentProfileInfo))))))))))))))))))));
var $author$project$Api$Endpoint$talentProfile = function (talentId) {
	return $author$project$Api$Endpoint$makeUrl(
		_List_fromArray(
			['talent_profiles', talentId]));
};
var $author$project$Data$TalentProfileInfo$fetch = F3(
	function (jwt, talentId, msg) {
		return A4(
			$author$project$Api$Main$get,
			$author$project$Api$Endpoint$talentProfile(talentId),
			jwt,
			msg,
			$author$project$Data$TalentProfileInfo$decoder);
	});
var $author$project$TalentProfileModal$update = F3(
	function (msg, model, jwt) {
		switch (msg.$) {
			case 0:
				var talentId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cc: true}),
					A3($author$project$Data$TalentProfileInfo$fetch, jwt, talentId, $author$project$TalentProfileModal$GotTalentInfo));
			case 1:
				return _Utils_Tuple2($author$project$TalentProfileModal$initialModel, $elm$core$Platform$Cmd$none);
			case 2:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jr: $author$project$Api$Utils$makeApiData(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var image = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cb: image}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{h1: value}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{h1: ''}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$handleTalentProfileModalSubMsgs = F2(
	function (model, subMsg) {
		var talentData = model.aR.jr;
		var message = model.aR.h1;
		var _v0 = A3($author$project$TalentProfileModal$update, subMsg, model.aR, model.hR);
		var subModel = _v0.a;
		var subCmd = _v0.b;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(subMsg, talentData);
			if ((_v2.a.$ === 5) && (_v2.b.$ === 3)) {
				var _v3 = _v2.a;
				var talent = _v2.b.a;
				return A3($author$project$Main$handleSavingMessage, model, talent.cU, message);
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}();
		var updatedModel = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				updatedModel,
				{aR: subModel}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$GotTalentProfileModalMsg, subCmd),
						cmd
					])));
	});
var $author$project$SharedProjectRoleSchedules$Done = {$: 2};
var $author$project$Main$imageUploadStatus = function (images) {
	return (images >= 5) ? $author$project$SharedProjectRoleSchedules$Done : $author$project$SharedProjectRoleSchedules$Waiting;
};
var $author$project$Pages$AgencyTalentSchedule$GotRolesList = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$agencyTalentRoles = $author$project$Api$Endpoint$makeUrl(
	_List_fromArray(
		['agencies', 'talent_roles']));
var $author$project$Data$RoleInfo$roleInfoListDecoder = $elm$json$Json$Decode$list($author$project$Data$RoleInfo$decoder);
var $author$project$Data$RoleInfo$fetchAgencyTalentRoles = F2(
	function (jwt, msg) {
		return A4($author$project$Api$Main$get, $author$project$Api$Endpoint$agencyTalentRoles, jwt, msg, $author$project$Data$RoleInfo$roleInfoListDecoder);
	});
var $author$project$Pages$AgencyTalentSchedule$initialModel = function (roleId) {
	return {cp: $author$project$Api$Utils$NotAsked, cq: $author$project$Api$Utils$NotAsked, fE: roleId, fV: $author$project$TalentProfileModal$initialModel};
};
var $author$project$Pages$AgencyTalentSchedule$init = F2(
	function (jwt, roleId) {
		var model = $author$project$Pages$AgencyTalentSchedule$initialModel(roleId);
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Data$RoleInfo$fetch, jwt, roleId, $author$project$Pages$AgencyTalentSchedule$GotRoleInfo),
					A2($author$project$Data$RoleInfo$fetchAgencyTalentRoles, jwt, $author$project$Pages$AgencyTalentSchedule$GotRolesList)
				]));
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$Main$kickOffResizing = _Platform_outgoingPort('kickOffResizing', $elm$json$Json$Encode$string);
var $author$project$MainMsg$UsersAdded = function (a) {
	return {$: 173, a: a};
};
var $author$project$Pipeline$PipelineMessage = function (message) {
	return {h1: message};
};
var $author$project$Api$Decoders$pipelineMessageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'message',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Pipeline$PipelineMessage));
var $author$project$Api$Encoders$roleMemberEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'users',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, model.jR)),
				_Utils_Tuple2(
				'column',
				$elm$json$Json$Encode$string(model.gQ)),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(model.a7))
			]));
};
var $author$project$Api$Request$addUsersToRole = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$roleMemberEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UsersAdded, $author$project$Api$Decoders$pipelineMessageDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.iH + ('/roles/' + (model.iX + '/add_users'))))
		});
};
var $author$project$Utils$determineApplicationState = function (userProfile) {
	var _v0 = userProfile.P;
	switch (_v0) {
		case 1:
			return 'Requested to Apply';
		case 3:
			return 'Agent Added';
		case 4:
			return 'Agent Added';
		default:
			return '';
	}
};
var $author$project$Main$linkToRole = F6(
	function (project, role, users, jwt, column, userProfile) {
		return ((project !== '') && (role !== '')) ? $author$project$Api$Request$addUsersToRole(
			{
				gQ: column,
				hR: jwt,
				iH: project,
				iX: role,
				a7: $author$project$Utils$determineApplicationState(userProfile),
				jR: users
			}) : $elm$core$Platform$Cmd$none;
	});
var $author$project$MainMsg$MoreUsersLoaded = function (a) {
	return {$: 251, a: a};
};
var $author$project$Api$Encoders$searchAllIfEmpty = function (selectedValue) {
	return (selectedValue === 'ANY') ? '' : selectedValue;
};
var $author$project$Api$Encoders$searchEncoder = F2(
	function (talentFilterValues, projectId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'gender',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, talentFilterValues.hx)),
					_Utils_Tuple2(
					'eyeColor',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, talentFilterValues.hp)),
					_Utils_Tuple2(
					'heightLow',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.h6))),
					_Utils_Tuple2(
					'heightHigh',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.h$))),
					_Utils_Tuple2(
					'weightLow',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.eN))),
					_Utils_Tuple2(
					'weightHigh',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.eI))),
					_Utils_Tuple2(
					'race',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, talentFilterValues.iM)),
					_Utils_Tuple2(
					'ageLow',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.cZ))),
					_Utils_Tuple2(
					'ageHigh',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.cX))),
					_Utils_Tuple2(
					'waistSizeLow',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.h5))),
					_Utils_Tuple2(
					'waistSizeHigh',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.h_))),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(talentFilterValues.i6)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$int(talentFilterValues.io)),
					_Utils_Tuple2(
					'project_id',
					$elm$json$Json$Encode$string(projectId))
				]));
	});
var $author$project$Api$Decoders$userSearchResultsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$searchResultTalentProfileDecoder);
var $author$project$Api$Request$loadMoreUsers = F3(
	function (jwt, talentFilterValues, roleId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$searchEncoder, talentFilterValues, roleId)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$MoreUsersLoaded, $author$project$Api$Decoders$userSearchResultsDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'users/search'
			});
	});
var $author$project$MainMsg$PipelineLoaded = function (a) {
	return {$: 158, a: a};
};
var $author$project$Api$Request$loadPipeline = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$PipelineLoaded, $author$project$Api$Decoders$pipelineDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.d_ + '/pipeline'))
		});
};
var $author$project$Main$loadPipelineForProject = function (model) {
	return $author$project$Api$Request$loadPipeline(model);
};
var $author$project$MainMsg$MarkedConversationAsRead = function (a) {
	return {$: 153, a: a};
};
var $author$project$Api$Encoders$userIdEncoder = function (userId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userID',
				$elm$json$Json$Encode$string(userId))
			]));
};
var $author$project$Api$Request$markConversationAsRead = F3(
	function (userId, jwt, conversationId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$userIdEncoder(userId)),
				eg: $elm$http$Http$expectWhatever($author$project$MainMsg$MarkedConversationAsRead),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (userId + ('/conversations/' + (conversationId + '/mark_as_read'))))
			});
	});
var $author$project$Api$Encoders$notificationIdsEncoder = function (notificationIds) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'notification_ids',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, notificationIds))
			]));
};
var $author$project$Api$Request$markNotificationsAsRead = F2(
	function (jwt, notificationIds) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$notificationIdsEncoder(notificationIds)),
				eg: $elm$http$Http$expectWhatever($author$project$MainMsg$DoNothing),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'users/mark_notifications_as_read'
			});
	});
var $author$project$Api$Encoders$userEncoder = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'role_member_id',
				$elm$json$Json$Encode$string(user.aQ)),
				_Utils_Tuple2(
				'new_column_id',
				$elm$json$Json$Encode$string(user.ic))
			]));
};
var $author$project$Api$Encoders$moveUsersEncoder = function (users) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'targets',
				A2($elm$json$Json$Encode$list, $author$project$Api$Encoders$userEncoder, users))
			]));
};
var $author$project$Api$Request$moveUsersInPipeline = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$moveUsersEncoder(model.jS)),
			eg: $elm$http$Http$expectWhatever($author$project$MainMsg$UsersMoved),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.d_ + '/pipeline/move_users'))
		});
};
var $elm$file$File$name = _File_name;
var $author$project$Main$optimisticMessages = F3(
	function (body, creator, model) {
		var twilioData = model.j;
		var message = (body === '') ? _Utils_update(
			$author$project$Message$emptyMessage,
			{dG: model.bf + ' Uploading file...', gY: twilioData.k.V, g_: creator, bo: 'media', ct: $author$project$Main$nowTimestamp}) : _Utils_update(
			$author$project$Message$emptyMessage,
			{dG: body, gY: twilioData.k.V, g_: creator, bo: 'text', ct: $author$project$Main$nowTimestamp});
		return _Utils_update(
			twilioData,
			{
				g: A4($author$project$Main$addMessageToChannelIndex, twilioData.g, message, twilioData.k, model.z),
				k: A2($author$project$Main$updateChannelMessages, twilioData.k, message)
			});
	});
var $author$project$MainMsg$NewUser = function (a) {
	return {$: 34, a: a};
};
var $author$project$User$userTypeConvertToString = function (role) {
	switch (role) {
		case 0:
			return 'Talent';
		case 1:
			return 'Director';
		case 2:
			return 'Collaborator';
		case 3:
			return 'Agency';
		case 4:
			return 'Agent';
		default:
			return 'Invalid';
	}
};
var $author$project$Api$Encoders$newAgencyEncoder = F3(
	function (agency, userData, firebaseId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(firebaseId)),
					_Utils_Tuple2(
					'agency_name',
					$elm$json$Json$Encode$string(agency.cz)),
					_Utils_Tuple2(
					'agency_email',
					$elm$json$Json$Encode$string(agency.bl)),
					_Utils_Tuple2(
					'first_name',
					$elm$json$Json$Encode$string(agency.bm)),
					_Utils_Tuple2(
					'last_name',
					$elm$json$Json$Encode$string(agency.bE)),
					_Utils_Tuple2(
					'agency_address1',
					$elm$json$Json$Encode$string(agency.bv)),
					_Utils_Tuple2(
					'agency_address2',
					$elm$json$Json$Encode$string(agency.bw)),
					_Utils_Tuple2(
					'agency_city',
					$elm$json$Json$Encode$string(agency.aV)),
					_Utils_Tuple2(
					'agency_state',
					$elm$json$Json$Encode$string(agency.a7)),
					_Utils_Tuple2(
					'agency_zip',
					$elm$json$Json$Encode$string(agency.dn)),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(
						$author$project$User$userTypeConvertToString(userData.P)))
				]));
	});
var $author$project$Api$Request$postNewAgency = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				A3($author$project$Api$Encoders$newAgencyEncoder, model.gl, model.aT, model.ht)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewUser, $author$project$Api$Decoders$updateProfileDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'user/login'
		});
};
var $author$project$MainMsg$NewCompany = function (a) {
	return {$: 35, a: a};
};
var $author$project$Api$Encoders$createCompanyEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.aT.cE))
			]));
};
var $author$project$Api$Request$postNewCompany = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$createCompanyEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewCompany, $author$project$Api$Decoders$companyDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'companies/'
		});
};
var $author$project$MainMsg$NewRole = function (a) {
	return {$: 58, a: a};
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Api$Encoders$roleEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.P.bH)),
				_Utils_Tuple2(
				'project_id',
				$elm$json$Json$Encode$string(model.d_)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(model.P.iV)),
				_Utils_Tuple2(
				'genders',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$List$map,
						function (option) {
							return option.V;
						},
						model.P.hy))),
				_Utils_Tuple2(
				'min_age',
				$elm$json$Json$Encode$int(model.P.cZ)),
				_Utils_Tuple2(
				'max_age',
				$elm$json$Json$Encode$int(model.P.cX)),
				_Utils_Tuple2(
				'rate',
				$elm$json$Json$Encode$string(model.P.iZ)),
				_Utils_Tuple2(
				'ethnicities',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$List$map,
						function (option) {
							return option.V;
						},
						model.P.ea))),
				_Utils_Tuple2(
				'min_height',
				$elm$json$Json$Encode$int(model.P.h4)),
				_Utils_Tuple2(
				'max_height',
				$elm$json$Json$Encode$int(model.P.hZ)),
				_Utils_Tuple2(
				'min_weight',
				$elm$json$Json$Encode$float(model.P.eN)),
				_Utils_Tuple2(
				'max_weight',
				$elm$json$Json$Encode$float(model.P.eI)),
				_Utils_Tuple2(
				'archived',
				$elm$json$Json$Encode$bool(model.P.dz)),
				_Utils_Tuple2(
				'creator_id',
				$elm$json$Json$Encode$string(model.hR)),
				_Utils_Tuple2(
				'active',
				$elm$json$Json$Encode$bool(model.P.gg))
			]));
};
var $author$project$Api$Request$postNewRole = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$roleEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewRole, $author$project$Api$Decoders$roleDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.d_ + '/roles'))
		});
};
var $author$project$Api$Encoders$newUserEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(model.ht)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(model.aT.bm)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(model.aT.bE)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(model.aT.bl)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					$author$project$User$userTypeConvertToString(model.aT.P))),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(model.aT.eW)),
				_Utils_Tuple2(
				'company_id',
				$elm$json$Json$Encode$string(model.bz.gR)),
				_Utils_Tuple2(
				'original_id',
				$elm$json$Json$Encode$string(model.aT.cU)),
				_Utils_Tuple2(
				'secret_key',
				$elm$json$Json$Encode$string(model.aT.i8))
			]));
};
var $author$project$Api$Request$postNewUser = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$newUserEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewUser, $author$project$Api$Decoders$updateProfileDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'user/login'
		});
};
var $author$project$Api$Encoders$applicationEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user_id',
				$elm$json$Json$Encode$string(model.dx.jN)),
				_Utils_Tuple2(
				'role_id',
				$elm$json$Json$Encode$string(model.dx.iW)),
				_Utils_Tuple2(
				'stage',
				$elm$json$Json$Encode$string('applied')),
				_Utils_Tuple2(
				'project_id',
				$elm$json$Json$Encode$string(model.d_))
			]));
};
var $author$project$Api$Request$postRoleApplication = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$applicationEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$SendApplication, $author$project$Api$Decoders$jobAppDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.d_ + ('/roles/' + (model.dx.iW + '/add_to_role'))))
		});
};
var $author$project$MainMsg$NewRoleResetForm = function (a) {
	return {$: 59, a: a};
};
var $author$project$Api$Request$postRoleResetForm = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$roleEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewRoleResetForm, $author$project$Api$Decoders$roleDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.d_ + '/roles'))
		});
};
var $author$project$MainMsg$SchedulePublished = function (a) {
	return {$: 205, a: a};
};
var $author$project$Api$Encoders$convertStage = function (stage) {
	switch (stage) {
		case 5:
			return 'Audition Requested';
		case 11:
			return 'Callback Requested';
		default:
			return '';
	}
};
var $author$project$Api$Encoders$scheduledTalentEncoder = function (scheduledTalent) {
	return $elm$json$Json$Encode$string(scheduledTalent.aQ);
};
var $author$project$Api$Encoders$updateScheduleEncoder = F2(
	function (scheduleData, stage) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'schedule_type',
					$elm$json$Json$Encode$string(scheduleData.fy)),
					_Utils_Tuple2(
					'project_id',
					$elm$json$Json$Encode$string(scheduleData.ae.cU)),
					_Utils_Tuple2(
					'published',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2(
					'scheduled_talent',
					A2($elm$json$Json$Encode$list, $author$project$Api$Encoders$scheduledTalentEncoder, scheduleData.i3)),
					_Utils_Tuple2(
					'state',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$convertStage(stage)))
				]));
	});
var $author$project$Api$Request$publishSchedule = F2(
	function (model, stage) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$updateScheduleEncoder, model.bQ, stage)),
				eg: A2(
					$elm$http$Http$expectJson,
					$author$project$MainMsg$SchedulePublished,
					$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleDecoder)),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(model.hR)
					]),
				eK: 'PUT',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'publish_schedule'
			});
	});
var $author$project$Schedule$MovePublishedUser = 0;
var $author$project$Schedule$RemovePublishedUser = 1;
var $author$project$Views$Schedule$schedulePublished = function (schedules) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptySchedule,
		$elm$core$List$head(schedules)).a3;
};
var $author$project$Main$publishedModalState = F2(
	function (model, dropTarget) {
		if ($author$project$Views$Schedule$schedulePublished(model.bQ.f)) {
			switch (dropTarget.$) {
				case 2:
					var timeSlotId = dropTarget.a;
					var droppedOnUser = dropTarget.b;
					var schedId = dropTarget.c;
					return 0;
				case 3:
					var timeSlotId = dropTarget.a;
					var droppedOnUser = dropTarget.b;
					var schedId = dropTarget.c;
					return 1;
				default:
					return 2;
			}
		} else {
			return 2;
		}
	});
var $author$project$Main$redirectAway = F3(
	function (role, model, route) {
		switch (role) {
			case 2:
				return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
			case 0:
				return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
			case 3:
				switch (route.$) {
					case 21:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 24:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 25:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 23:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					default:
						return $elm$core$Platform$Cmd$none;
				}
			case 4:
				switch (route.$) {
					case 21:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 24:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 25:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 23:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 10:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					default:
						return $elm$core$Platform$Cmd$none;
				}
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$MainMsg$SignInRefreshed = function (a) {
	return {$: 132, a: a};
};
var $author$project$Api$Request$refreshUser = function (jwt) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$emptyBody,
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$SignInRefreshed, $author$project$Api$Decoders$updateProfileDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			eK: 'GET',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'users/user_id'
		});
};
var $author$project$Main$redirectToLoginOrRefresh = F2(
	function (jwt, model) {
		var _v0 = model.i;
		switch (_v0.$) {
			case 22:
				var id = _v0.a;
				var code = _v0.b;
				return _List_fromArray(
					[
						A3($author$project$Main$verifyAccount, jwt, id, code)
					]);
			case 3:
				var email = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Main$goTo,
						model,
						$author$project$Route$MarketingDirectorRegistration(email))
					]);
			case 2:
				var email = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Main$goTo,
						model,
						$author$project$Route$MarketingTalentRegistration(email))
					]);
			case 26:
				var secretKey = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Main$goTo,
						model,
						$author$project$Route$CollaboratorsSignupPage(secretKey))
					]);
			case 27:
				var secretKey = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Main$goTo,
						model,
						$author$project$Route$AgentsSignupPage(secretKey))
					]);
			default:
				if (jwt === '') {
					return _List_fromArray(
						[
							A2($author$project$Main$goTo, model, $author$project$Route$Login)
						]);
				} else {
					var loginRefresh = $author$project$Api$Request$refreshUser(jwt);
					var _v1 = model.i;
					switch (_v1.$) {
						case 0:
							return _List_fromArray(
								[
									A2($author$project$Main$goTo, model, $author$project$Route$Dashboard),
									loginRefresh
								]);
						case 13:
							return _List_fromArray(
								[loginRefresh]);
						case 22:
							var id = _v1.a;
							var code = _v1.b;
							return _List_fromArray(
								[
									A3($author$project$Main$verifyAccount, model.hR, id, code)
								]);
						default:
							return _List_fromArray(
								[loginRefresh]);
					}
				}
		}
	});
var $author$project$MainMsg$RefreshedTalentProfile = function (a) {
	return {$: 294, a: a};
};
var $author$project$Api$Request$refreshTalentData = F2(
	function (roleMemberId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$RefreshedTalentProfile, $author$project$Api$Decoders$searchResultTalentProfileDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (roleMemberId + '/refresh_user'))
			});
	});
var $author$project$MainMsg$RemovedCollaborator = function (a) {
	return {$: 280, a: a};
};
var $author$project$Api$Request$removeCollaborator = F2(
	function (invitationId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$RemovedCollaborator, $author$project$Api$Decoders$collaboratorsDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'DELETE',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('collaborators/' + (invitationId + '/remove'))
			});
	});
var $author$project$Api$Encoders$updatingRemovedUserSpot = function (movingUserId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'moving_user_id',
				$elm$json$Json$Encode$string(movingUserId))
			]));
};
var $author$project$Api$Request$removeUserFromSchedule = F4(
	function (userId, timeSlotId, movingUserId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$updatingRemovedUserSpot(movingUserId)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$TimeSlotUpdated, $author$project$Api$Decoders$timeSlotDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'PUT',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('schedules/time_slots/' + (timeSlotId + ('/users/' + (userId + '/remove_user'))))
			});
	});
var $author$project$Main$removeUser = F4(
	function (user, currentTimeSlotId, movingRoleMemberId, jwt) {
		return A4($author$project$Api$Request$removeUserFromSchedule, user.cU, currentTimeSlotId, movingRoleMemberId, jwt);
	});
var $author$project$Main$removeCurrentPublishedUserAndAddMovingUser = F9(
	function (data, jwt, schedulePageData, notificationData, swapNotificationData, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$removeUser, data.S, data.U, data.q.aQ, jwt),
						A4($author$project$Main$removeUser, data.q, data.J, '', jwt),
						A4($author$project$Main$updateUsersPipelinePosition, jwt, schedulePageData, data.S, pendingColumn),
						A4($author$project$Main$updateUsersPipelinePosition, jwt, schedulePageData, data.q, scheduledColumn),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, notificationData, jwt, data.q.aQ, notificationData.hT, notificationData.cu),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, swapNotificationData, jwt, data.S.aQ, swapNotificationData.hT, notificationData.cu)
					])),
			firstScheduleUpdate,
			A3($author$project$Main$updateAvailiableTalent, firstTalentUpdate, data.S, true));
	});
var $author$project$Main$removeCurrentUserAndAddMovingUser = F7(
	function (data, jwt, schedulePageData, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$removeUser, data.S, data.U, data.q.aQ, jwt),
						A4($author$project$Main$removeUser, data.q, data.J, '', jwt),
						A4($author$project$Main$updateUsersPipelinePosition, jwt, schedulePageData, data.S, pendingColumn),
						A4($author$project$Main$updateUsersPipelinePosition, jwt, schedulePageData, data.q, scheduledColumn)
					])),
			firstScheduleUpdate,
			A3($author$project$Main$updateAvailiableTalent, firstTalentUpdate, data.S, true));
	});
var $author$project$Main$removeMultiItems = F2(
	function (msg, model) {
		var role = model.P;
		var userProfile = model.z;
		switch (msg) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{hy: _List_Nil})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{ea: _List_Nil})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{ea: _List_Nil})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$removeNotificationKind = F2(
	function (model, movedFromOutsideSchedule) {
		return ((!movedFromOutsideSchedule) && (model.bQ.fy === 'Audition')) ? _Utils_Tuple2('Audition Rescheduled', 'Audition Canceled') : ((movedFromOutsideSchedule && (model.bQ.fy === 'Audition')) ? _Utils_Tuple2('Audition Requested', 'Audition Canceled') : (((!movedFromOutsideSchedule) && (model.bQ.fy === 'Callback')) ? _Utils_Tuple2('Callback Rescheduled', 'Callback Canceled') : ((movedFromOutsideSchedule && (model.bQ.fy === 'Callback')) ? _Utils_Tuple2('Callback Requested', 'Callback Canceled') : _Utils_Tuple2('', ''))));
	});
var $author$project$Main$originalImage = F2(
	function (images, image) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Image$emptyImage,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.V;
						},
						image.V),
					images))).V;
	});
var $author$project$MainMsg$Uploaded = function (a) {
	return {$: 127, a: a};
};
var $author$project$Api$Encoders$croppedImageEncoder = function (imageUrl) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'image_url',
				$elm$json$Json$Encode$string(imageUrl))
			]));
};
var $author$project$Api$Request$uploadCroppedImage = F3(
	function (image, jwt, userId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$croppedImageEncoder(image)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$Uploaded, $author$project$Api$Decoders$imageDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Just('upload'),
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (userId + '/upload_cropped_image'))
			});
	});
var $author$project$Main$removeOriginalImage = F5(
	function (jwt, currentUserId, newUrl, image, images) {
		return (newUrl === '') ? _Utils_Tuple3(images, $elm$core$Platform$Cmd$none, $elm$core$Platform$Cmd$none) : _Utils_Tuple3(
			A2($author$project$Main$filterImages, image.V, images),
			A3(
				$author$project$Api$Request$deleteImage,
				A2($author$project$Main$originalImage, images, image),
				jwt,
				currentUserId),
			A3($author$project$Api$Request$uploadCroppedImage, newUrl, jwt, currentUserId));
	});
var $author$project$MainMsg$TalentRemovedFromRole = function (a) {
	return {$: 324, a: a};
};
var $author$project$Api$Encoders$removeTalentEncoder = function (reason) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'reason',
				$elm$json$Json$Encode$string(reason))
			]));
};
var $author$project$Api$Request$removeTalent = F2(
	function (talentMenu, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$removeTalentEncoder(talentMenu.iP)),
				eg: $elm$http$Http$expectWhatever($author$project$MainMsg$TalentRemovedFromRole),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'DELETE',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('role_members/' + talentMenu.jr.aQ)
			});
	});
var $author$project$Main$removeUserFromScheduleAndUpdatePipeline = F5(
	function (model, user, newTimeSlotId, currentTimeSlotId, movingToColumn) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$removeUser, user, currentTimeSlotId, '', model.hR),
						A4($author$project$Main$updateUsersPipelinePosition, model.hR, model.bQ, user, movingToColumn)
					])),
			A4($author$project$Main$updateSchedules, model.bQ.f, user, newTimeSlotId, currentTimeSlotId),
			A3($author$project$Main$updateAvailiableTalent, model.bQ.D, user, true));
	});
var $author$project$Main$removeUserToken = _Platform_outgoingPort('removeUserToken', $elm$json$Json$Encode$string);
var $author$project$Main$removeVideoFromTalent = F2(
	function (profile, deletedVideoId) {
		return _Utils_update(
			profile,
			{
				jT: A2(
					$elm$core$List$filter,
					function (video) {
						return !_Utils_eq(video.V, deletedVideoId);
					},
					profile.jT)
			});
	});
var $author$project$Main$replacingData = F2(
	function (fileAction, model) {
		switch (fileAction) {
			case 0:
				return _Utils_Tuple3(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Data$Image$emptyImage,
						$elm$core$List$head(model.hE)).V,
					_List_Nil,
					A3(
						$author$project$Api$Request$deleteImage,
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Image$emptyImage,
							$elm$core$List$head(model.hE)).V,
						model.hR,
						model.g5));
			case 1:
				return _Utils_Tuple3('', model.hE, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple3('', model.hE, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$MainMsg$ResetErrorMessage = {$: 311};
var $author$project$Main$resetErrorMessage = A2($author$project$Utils$delay, 2000, $author$project$MainMsg$ResetErrorMessage);
var $author$project$Main$resetModel = function (model) {
	return _Utils_update(
		model,
		{a: $author$project$Model$Hiding, dv: _List_Nil, bZ: $author$project$Message$LoadingMessages, A: _List_Nil, aw: _List_Nil, L: 0, bC: '', d_: '', g3: '', g5: '', am: '', d1: '', bj: false, ht: '', aj: 4, hE: _List_Nil, hR: '', bn: false, ae: $author$project$SharedProjectRoleSchedules$emptyProject, P: $author$project$SharedProjectRoleSchedules$emptyRole, bR: '', aG: '', dj: false, j: $author$project$Message$emptyFromTwilioPayload});
};
var $author$project$MainMsg$GotSearchedJobs = function (a) {
	return {$: 306, a: a};
};
var $author$project$Api$Request$searchJobs = F2(
	function (jwt, searchTerm) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotSearchedJobs, $author$project$Api$Decoders$basicProjectsDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('jobs/' + searchTerm)
			});
	});
var $author$project$MainMsg$ReceivedSearchResults = function (a) {
	return {$: 138, a: a};
};
var $author$project$Api$Request$searchUsers = F3(
	function (jwt, talentFilterValues, roleId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$searchEncoder, talentFilterValues, roleId)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$ReceivedSearchResults, $author$project$Api$Decoders$userSearchResultsDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'users/search'
			});
	});
var $author$project$Main$sendPasswordResetEmail = _Platform_outgoingPort('sendPasswordResetEmail', $elm$json$Json$Encode$string);
var $author$project$Main$setUserDataToAgency = function (userData) {
	return _Utils_update(
		userData,
		{P: 3});
};
var $author$project$Main$setUserRegistrationType = function (model) {
	return A2(
		$elm$core$List$member,
		model.i,
		_List_fromArray(
			[
				$author$project$Route$DirectorRegistration,
				$author$project$Route$MarketingDirectorRegistration(model.aT.bl)
			])) ? 1 : (A2(
		$elm$core$List$member,
		model.i,
		_List_fromArray(
			[
				$author$project$Route$TalentRegistration,
				$author$project$Route$MarketingTalentRegistration(model.aT.bl)
			])) ? 0 : (A2(
		$elm$core$List$member,
		model.i,
		_List_fromArray(
			[
				$author$project$Route$CollaboratorsSignupPage(model.aT.i8)
			])) ? 2 : (A2(
		$elm$core$List$member,
		model.i,
		_List_fromArray(
			[
				$author$project$Route$AgentsSignupPage(model.aT.i8)
			])) ? 4 : (_Utils_eq(model.i, $author$project$Route$AgencyRegistration) ? 3 : 5))));
};
var $author$project$Main$setUserType = F2(
	function (model, role) {
		var userData = model.aT;
		return _Utils_update(
			userData,
			{P: role});
	});
var $author$project$MainMsg$SortedColumn = function (a) {
	return {$: 181, a: a};
};
var $author$project$Api$Encoders$sortEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sort',
				$elm$json$Json$Encode$string(model.ji)),
				_Utils_Tuple2(
				'column_id',
				$elm$json$Json$Encode$string(model.V))
			]));
};
var $author$project$Api$Request$sortPipeline = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$sortEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$SortedColumn, $author$project$Api$Decoders$pipelineDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.d_ + '/pipeline'))
		});
};
var $author$project$Main$sortPipelineUsers = function (model) {
	return $author$project$Api$Request$sortPipeline(model);
};
var $author$project$Main$sortingMap = function (sort) {
	switch (sort) {
		case 0:
			return 'asc';
		case 1:
			return 'desc';
		case 2:
			return 'role';
		default:
			return 'status';
	}
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$startDragging = F2(
	function (_v0, id) {
		var stateData = _v0;
		var updatedStateData = _Utils_update(
			stateData,
			{
				b7: $elm$core$Maybe$Just(id)
			});
		return updatedStateData;
	});
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$stopDragging = function (_v0) {
	var stateData = _v0;
	return $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState;
};
var $author$project$MainMsg$VoteRecorded = function (a) {
	return {$: 273, a: a};
};
var $author$project$Api$Encoders$voteEncoder = F4(
	function (vote, comment, roleMemberId, timeSlotId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'vote',
					$elm$json$Json$Encode$string(vote)),
					_Utils_Tuple2(
					'role_member_id',
					$elm$json$Json$Encode$string(roleMemberId)),
					_Utils_Tuple2(
					'time_slot_id',
					$elm$json$Json$Encode$string(timeSlotId))
				]));
	});
var $author$project$Api$Request$submitVote = F5(
	function (roleMemberId, vote, comment, jwt, timeSlotId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A4($author$project$Api$Encoders$voteEncoder, vote, comment, roleMemberId, timeSlotId)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$VoteRecorded, $author$project$Api$Decoders$timeSlotDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'vote/'
			});
	});
var $author$project$MainMsg$CommentSubmitted = function (a) {
	return {$: 284, a: a};
};
var $author$project$Api$Encoders$commentEncoder = F2(
	function (body, timeSlotId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'body',
					$elm$json$Json$Encode$string(body)),
					_Utils_Tuple2(
					'time_slot_id',
					$elm$json$Json$Encode$string(timeSlotId))
				]));
	});
var $author$project$Api$Request$submitVotingComment = F3(
	function (comment, jwt, timeSlotId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$commentEncoder, comment, timeSlotId)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$CommentSubmitted, $author$project$Api$Decoders$timeSlotDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'timeslot/comment'
			});
	});
var $author$project$Main$swapNotificationKind = F2(
	function (model, movedFromOutsideSchedule) {
		return ((!movedFromOutsideSchedule) && (model.bQ.fy === 'Audition')) ? _Utils_Tuple2('Audition Rescheduled', 'Audition Rescheduled') : ((movedFromOutsideSchedule && (model.bQ.fy === 'Audition')) ? _Utils_Tuple2('Audition Requested', 'Audition Canceled') : (((!movedFromOutsideSchedule) && (model.bQ.fy === 'Callback')) ? _Utils_Tuple2('Callback Rescheduled', 'Callback Rescheduled') : ((movedFromOutsideSchedule && (model.bQ.fy === 'Callback')) ? _Utils_Tuple2('Callback Requested', 'Callback Canceled') : _Utils_Tuple2('', ''))));
	});
var $elm$file$File$toString = _File_toString;
var $author$project$Main$toggleAgencyFields = function (profilePage) {
	return _Utils_update(
		profilePage,
		{fI: !profilePage.fI});
};
var $author$project$Main$toggleAgentForm = F3(
	function (profilePageData, agentId, userProfile) {
		return (agentId === '') ? _Utils_update(
			profilePageData,
			{bY: false, bB: $author$project$User$emptyAgent}) : _Utils_update(
			profilePageData,
			{
				bY: true,
				bB: A2(
					$elm$core$Maybe$withDefault,
					$author$project$User$emptyAgent,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$author$project$Utils$eq,
								function ($) {
									return $.V;
								},
								agentId),
							userProfile.gl.gr)))
			});
	});
var $author$project$Filter$TAge = 4;
var $author$project$Filter$TEye = 5;
var $author$project$Filter$TGender = 0;
var $author$project$Filter$THeight = 1;
var $author$project$Filter$TMenu = 7;
var $author$project$Filter$TRace = 6;
var $author$project$Filter$TSizes = 3;
var $author$project$Filter$TWeight = 2;
var $author$project$Main$toggleFilter = F2(
	function (current, toggle) {
		return _Utils_eq(current, toggle) ? 8 : toggle;
	});
var $author$project$Main$toggleFilters = F2(
	function (toggle, model) {
		var talentFilter = model.F;
		switch (toggle) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F: A2($author$project$Main$toggleFilter, model.F, 0)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F: A2($author$project$Main$toggleFilter, model.F, 4)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F: A2($author$project$Main$toggleFilter, model.F, 1)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F: A2($author$project$Main$toggleFilter, model.F, 2)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F: A2($author$project$Main$toggleFilter, model.F, 5)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F: A2($author$project$Main$toggleFilter, model.F, 6)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F: A2($author$project$Main$toggleFilter, model.F, 7)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F: A2($author$project$Main$toggleFilter, model.F, 3)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{F: 8}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Utils$Open = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$toggleMultiModal = F2(
	function (id, multiModalStatus) {
		if (!multiModalStatus.$) {
			var str = multiModalStatus.a;
			return _Utils_eq(id, str) ? $author$project$Utils$Closed : $author$project$Utils$Open(id);
		} else {
			return $author$project$Utils$Open(id);
		}
	});
var $author$project$Main$toggleProfilePageNav = function (profilePageData) {
	return _Utils_update(
		profilePageData,
		{c7: !profilePageData.c7});
};
var $author$project$Main$togglePublishProject = function (project) {
	return _Utils_update(
		project,
		{hK: !project.hK});
};
var $author$project$Main$togglePublishRole = function (role) {
	return _Utils_update(
		role,
		{gg: !role.gg});
};
var $author$project$Views$Schedule$findSchedule = function (schedules) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptySchedule,
		$elm$core$List$head(schedules));
};
var $author$project$Views$Schedule$resetScheduleForm = function (model) {
	return _Utils_update(
		model,
		{gB: false, aX: $author$project$SharedProjectRoleSchedules$emptySchedule, d8: '', bP: 0, fy: '', fO: ''});
};
var $author$project$Views$Schedule$scheduleDates = F2(
	function (project, scheduleType) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyDeadline,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.bH;
						},
						scheduleType),
					project.hb)));
	});
var $author$project$Views$Schedule$showCorrectSchedule = F4(
	function (model, schedule, deadlineValue, scheduleView) {
		return _Utils_update(
			model,
			{gB: false, aX: schedule, d8: deadlineValue.d8, bP: scheduleView, fy: deadlineValue.bH, fO: deadlineValue.fO});
	});
var $author$project$Views$Schedule$toggleScheduleForm = F2(
	function (model, scheduleView) {
		var schedule = $author$project$Views$Schedule$findSchedule(model.f);
		var deadlineValue = function () {
			var _v1 = model.aE;
			switch (_v1.$) {
				case 3:
					var project = _v1.a;
					var sType = _v1.b;
					return A2($author$project$Views$Schedule$scheduleDates, project, sType);
				case 0:
					var sType = _v1.a;
					return A2($author$project$Views$Schedule$scheduleDates, model.ae, sType);
				default:
					return $author$project$SharedProjectRoleSchedules$emptyDeadline;
			}
		}();
		if (scheduleView === 1) {
			return A4($author$project$Views$Schedule$showCorrectSchedule, model, schedule, deadlineValue, scheduleView);
		} else {
			return $author$project$Views$Schedule$resetScheduleForm(model);
		}
	});
var $author$project$Main$toggleSelectedTalent = F2(
	function (users, id) {
		if (users.$ === 3) {
			var profiles = users.a;
			return A2(
				$elm$core$List$map,
				function (result) {
					return _Utils_eq(result.cU, id) ? _Utils_update(
						result,
						{cs: !result.cs}) : result;
				},
				profiles);
		} else {
			return _List_Nil;
		}
	});
var $author$project$MainMsg$VideoUpdated = function (a) {
	return {$: 287, a: a};
};
var $author$project$Api$Encoders$videoEncoder = function (videoId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(videoId))
			]));
};
var $author$project$Api$Request$toggleVideoVisibility = F2(
	function (videoId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$videoEncoder(videoId)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$VideoUpdated, $author$project$Api$Decoders$videoDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'PUT',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'video/toggle_visibility'
			});
	});
var $author$project$Views$Form$transformIdToOption = F2(
	function (id, options) {
		return A2(
			$elm$core$Maybe$withDefault,
			{V: '', bH: ''},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.V;
						},
						id),
					options)));
	});
var $author$project$Views$Form$transformNameToOption = F2(
	function (name, options) {
		return A2(
			$elm$core$Maybe$withDefault,
			{V: '', bH: ''},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.bH;
						},
						name),
					options)));
	});
var $author$project$Utils$transformToSearchResultTalentProfile = function (user) {
	return {gk: user.gk, gl: user.gl, gC: user.gC, dK: false, aV: user.aV, cE: user.cE, g0: user.g0, dY: 0, bl: user.bl, ea: user.ea, ho: user.ho, bm: user.bm, hw: user.hw, hz: user.hz, hA: user.hA, hB: user.hB, cU: user.cU, hE: user.hE, ev: true, bE: user.bE, eZ: user.eZ, iI: user.iI, iU: user.iU, iX: user.iX, aQ: user.aQ, iY: user.iY, fx: user.fx, cs: user.cs, jj: user.jj, a7: user.a7, jT: user.jT, jV: user.jV, jX: user.jX};
};
var $CurrySoftware$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$None = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.aL;
		var focused = model.ad;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ad: $elm$core$Maybe$Just(date),
							a9: date
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ad: $elm$core$Maybe$Just(date)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ad: $elm$core$Maybe$Nothing, an: $elm$core$Maybe$Nothing, c2: false}),
					$CurrySoftware$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							an: $elm$core$Maybe$Just(text)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $CurrySoftware$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = settings.c4(
							A2($elm$core$Maybe$withDefault, '', model.an));
						if (!_v5.$) {
							var date = _v5.a;
							return settings.bD(date) ? $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
								$CurrySoftware$elm_datepicker$DatePicker$Disabled(date)) : $CurrySoftware$elm_datepicker$DatePicker$Picked(date);
						} else {
							var e = _v5.a;
							return $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
								$CurrySoftware$elm_datepicker$DatePicker$Invalid(e));
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ad: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.ad;
									}
								}(),
								an: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.an;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aL: false, c2: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c2: forceOpen}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aL: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aL: false}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
		}
	});
var $author$project$Main$updateAgeInUserProfile = F2(
	function (age, _v0) {
		var userProfile = _v0.z;
		return _Utils_update(
			userProfile,
			{gk: age});
	});
var $author$project$Main$updateAgencies = F2(
	function (agencies, profilePageData) {
		return _Utils_update(
			profilePageData,
			{cx: agencies});
	});
var $author$project$Main$updateAgency = F2(
	function (agency, aMsg) {
		switch (aMsg.$) {
			case 0:
				var name = aMsg.a;
				return _Utils_update(
					agency,
					{cz: name});
			case 4:
				var email = aMsg.a;
				return _Utils_update(
					agency,
					{bl: email});
			case 1:
				var name = aMsg.a;
				return _Utils_update(
					agency,
					{bm: name});
			case 2:
				var name = aMsg.a;
				return _Utils_update(
					agency,
					{bE: name});
			case 5:
				var address = aMsg.a;
				return _Utils_update(
					agency,
					{bv: address});
			case 6:
				var address = aMsg.a;
				return _Utils_update(
					agency,
					{bw: address});
			case 7:
				var city = aMsg.a;
				return _Utils_update(
					agency,
					{aV: city});
			case 8:
				var state = aMsg.a;
				return _Utils_update(
					agency,
					{a7: state});
			case 9:
				var zip = aMsg.a;
				return _Utils_update(
					agency,
					{dn: zip});
			case 10:
				var password = aMsg.a;
				return _Utils_update(
					agency,
					{eW: password});
			case 11:
				var passwordConfirmation = aMsg.a;
				return _Utils_update(
					agency,
					{cF: passwordConfirmation});
			default:
				return agency;
		}
	});
var $author$project$Main$updateCurrentAgent = F2(
	function (agent, agentMsg) {
		switch (agentMsg.$) {
			case 0:
				var value = agentMsg.a;
				return _Utils_update(
					agent,
					{bm: value});
			case 1:
				var value = agentMsg.a;
				return _Utils_update(
					agent,
					{bE: value});
			case 2:
				var value = agentMsg.a;
				return _Utils_update(
					agent,
					{aV: value});
			default:
				var value = agentMsg.a;
				return _Utils_update(
					agent,
					{bl: value});
		}
	});
var $author$project$Main$updateAgentInfo = F2(
	function (profilePageData, agentMsg) {
		return _Utils_update(
			profilePageData,
			{
				bB: A2($author$project$Main$updateCurrentAgent, profilePageData.bB, agentMsg)
			});
	});
var $author$project$Main$updateAgents = F2(
	function (agency, agents) {
		return _Utils_update(
			agency,
			{gr: agents});
	});
var $author$project$Main$updateAgentsList = F2(
	function (userProfile, agents) {
		return _Utils_update(
			userProfile,
			{
				gl: A2($author$project$Main$updateAgents, userProfile.gl, agents)
			});
	});
var $author$project$Main$updateAllProjects = F2(
	function (allProjects, updatedProject) {
		return A2(
			$elm$core$List$map,
			function (project) {
				return _Utils_eq(project.cU, updatedProject.cU) ? updatedProject : project;
			},
			allProjects);
	});
var $author$project$Main$updateAllRoles = F2(
	function (updatedRole, roleList) {
		return A2(
			$elm$core$List$map,
			function (role) {
				return _Utils_eq(role.cU, updatedRole.cU) ? updatedRole : role;
			},
			roleList);
	});
var $author$project$Main$updateBillingAddress = F2(
	function (msg, model) {
		var billingAddress = model.ax;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ax: _Utils_update(
								billingAddress,
								{bv: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ax: _Utils_update(
								billingAddress,
								{bw: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ax: _Utils_update(
								billingAddress,
								{aV: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ax: _Utils_update(
								billingAddress,
								{a7: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ax: _Utils_update(
								billingAddress,
								{e0: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ax: _Utils_update(
								billingAddress,
								{dr: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateBothUsersPositionsInPublishedSchedule = F5(
	function (data, jwt, schedulePageData, notificationData, swapNotificationData) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$changeUsersTimeSlot, data.q, data.J, data.U, jwt),
						A4($author$project$Main$changeUsersTimeSlot, data.S, data.U, data.J, jwt),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, notificationData, jwt, data.q.aQ, notificationData.hT, notificationData.cu),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, swapNotificationData, jwt, data.S.aQ, swapNotificationData.hT, notificationData.cu)
					])),
			A4($author$project$Main$updateSchedules, schedulePageData.f, data.q, data.U, data.J),
			schedulePageData.D);
	});
var $author$project$Main$updateBothUsersPositionsInSchedule = F3(
	function (data, jwt, schedulePageData) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$changeUsersTimeSlot, data.q, data.J, data.U, jwt),
						A4($author$project$Main$changeUsersTimeSlot, data.S, data.U, data.J, jwt)
					])),
			A4($author$project$Main$updateSchedules, schedulePageData.f, data.q, data.U, data.J),
			schedulePageData.D);
	});
var $author$project$Main$chatFilterRoleList = F2(
	function (projects, project) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyProject,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.bH;
						},
						project),
					projects))).fq;
	});
var $author$project$Main$updateChatFilterValues = F2(
	function (filterType, model) {
		var chatFilterValues = model.b1;
		switch (filterType.$) {
			case 0:
				var project = filterType.a;
				return _Utils_update(
					chatFilterValues,
					{
						iG: project,
						fo: 'Role',
						da: A2($author$project$Main$chatFilterRoleList, model.A, project)
					});
			case 1:
				var role = filterType.a;
				return _Utils_update(
					chatFilterValues,
					{fo: role});
			case 2:
				var read = filterType.a;
				return _Utils_update(
					chatFilterValues,
					{iO: read});
			case 3:
				var archived = filterType.a;
				return _Utils_update(
					chatFilterValues,
					{gw: archived});
			default:
				var term = filterType.a;
				return _Utils_update(
					chatFilterValues,
					{fC: term});
		}
	});
var $author$project$Main$verifyCompleteCollabForm = function (data) {
	return (data.bl !== '') && ((data.bm !== '') && (data.bE !== ''));
};
var $author$project$Main$updateCollaboratorData = F2(
	function (collaboratorData, collabMsg) {
		switch (collabMsg.$) {
			case 0:
				return collaboratorData.c2 ? $author$project$SharedProjectRoleSchedules$emptyCollaboratorForm : _Utils_update(
					collaboratorData,
					{c2: true});
			case 1:
				var val = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{bl: val, aZ: true, cu: ''});
			case 4:
				var val = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{aZ: false, bm: val});
			case 5:
				var val = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{aZ: false, bE: val});
			case 2:
				var val = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{cE: val, aZ: false});
			case 3:
				var val = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{aZ: false, iv: val});
			case 6:
				return _Utils_update(
					collaboratorData,
					{
						cS: $author$project$Main$verifyCompleteCollabForm(collaboratorData)
					});
			case 7:
				var collaborators = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{dO: collaborators});
			case 8:
				var collaborator = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{cE: collaborator.cE, bl: collaborator.bl, aZ: false, bm: collaborator.bm, bE: collaborator.bE, iv: collaborator.iv, cu: collaborator.V});
			case 9:
				return _Utils_update(
					collaboratorData,
					{aZ: false});
			case 10:
				return _Utils_update(
					collaboratorData,
					{gi: collaboratorData.cS});
			default:
				var collaborators = collabMsg.a;
				return _Utils_update(
					$author$project$SharedProjectRoleSchedules$emptyCollaboratorForm,
					{dO: collaborators});
		}
	});
var $author$project$Main$updateCollaborator = F2(
	function (schedulePageData, amsg) {
		return _Utils_update(
			schedulePageData,
			{
				by: A2($author$project$Main$updateCollaboratorData, schedulePageData.by, amsg)
			});
	});
var $author$project$Main$updateCollaboratorProfile = F2(
	function (profile, collaborator) {
		return _Utils_update(
			profile,
			{cE: collaborator.cE, bl: collaborator.bl, bm: collaborator.bm, cU: collaborator.V, bE: collaborator.bE});
	});
var $author$project$Main$updateColumn = F2(
	function (msg, model) {
		var column = model.gQ;
		if (!msg.$) {
			var value = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						gQ: _Utils_update(
							column,
							{g6: value})
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$MainMsg$ColumnUpdated = function (a) {
	return {$: 171, a: a};
};
var $author$project$Api$Encoders$columnEncoder = function (column) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'position',
				$elm$json$Json$Encode$int(column.iz)),
				_Utils_Tuple2(
				'custom_name',
				$elm$json$Json$Encode$string(column.g6)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(column.V)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(column.bH)),
				_Utils_Tuple2(
				'is_hidden',
				$elm$json$Json$Encode$bool(column.hL))
			]));
};
var $author$project$Api$Request$updateColumnData = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$columnEncoder(model.gQ)),
			eg: $elm$http$Http$expectWhatever($author$project$MainMsg$ColumnUpdated),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'PUT',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.d_ + ('/columns/' + model.gQ.V)))
		});
};
var $author$project$MainMsg$UpdateUserProfile = function (a) {
	return {$: 38, a: a};
};
var $author$project$Api$Encoders$updateCompanyEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.bz.gS)),
				_Utils_Tuple2(
				'kind',
				$elm$json$Json$Encode$string(model.bz.gU)),
				_Utils_Tuple2(
				'web_address',
				$elm$json$Json$Encode$string(model.bz.gV)),
				_Utils_Tuple2(
				'phone',
				$elm$json$Json$Encode$string(model.bz.gT))
			]));
};
var $author$project$Api$Request$updateCompany = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$updateCompanyEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdateUserProfile, $author$project$Api$Decoders$updateProfileDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'PUT',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('companies/' + model.bz.gR)
		});
};
var $author$project$Main$updateCompanyProfile = F2(
	function (msg, model) {
		var companyProfile = model.bz;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bz: _Utils_update(
								companyProfile,
								{gS: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bz: _Utils_update(
								companyProfile,
								{gU: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bz: _Utils_update(
								companyProfile,
								{gT: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bz: _Utils_update(
								companyProfile,
								{gV: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateCurrentProfilePage = F2(
	function (profilePageData, pageIndex) {
		var _v0 = profilePageData.z;
		if (_v0.$ === 3) {
			var userProfile = _v0.a;
			return ((_Utils_cmp(
				pageIndex + 1,
				$elm$core$List$length(userProfile.ck)) > 0) || (pageIndex < 0)) ? profilePageData : _Utils_update(
				profilePageData,
				{bY: false, dZ: pageIndex, c7: false, bN: $author$project$MainMsg$Loadings});
		} else {
			return profilePageData;
		}
	});
var $author$project$Project$AuditionEndDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Project$AuditionStartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Project$CallbackEndDate = function (a) {
	return {$: 13, a: a};
};
var $author$project$Project$CallbackStartDate = function (a) {
	return {$: 12, a: a};
};
var $author$project$Project$FittingDate = function (a) {
	return {$: 22, a: a};
};
var $author$project$Project$ProjectEndDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Project$ProjectStartDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Project$ShootDate = function (a) {
	return {$: 15, a: a};
};
var $author$project$Project$SubmissionDueDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$updateDeadlines = F3(
	function (deadlines, name, action) {
		var existingDeadline = A2(
			$elm$core$List$filter,
			A2(
				$author$project$Utils$eq,
				function ($) {
					return $.bH;
				},
				name),
			deadlines);
		var deadlineList = ($elm$core$List$length(existingDeadline) > 0) ? deadlines : A2(
			$elm$core$List$cons,
			_Utils_update(
				$author$project$SharedProjectRoleSchedules$emptyDeadline,
				{bH: name}),
			deadlines);
		return A2(
			$elm$core$List$map,
			function (dl) {
				if (_Utils_eq(dl.bH, name)) {
					switch (action.$) {
						case 1:
							var value = action.a;
							return _Utils_update(
								dl,
								{d8: value, fO: value});
						case 2:
							var value = action.a;
							return _Utils_update(
								dl,
								{fO: value});
						case 3:
							var value = action.a;
							return _Utils_update(
								dl,
								{d8: value});
						case 11:
							var value = action.a;
							return _Utils_update(
								dl,
								{hV: value});
						case 12:
							var value = action.a;
							return _Utils_update(
								dl,
								{fO: value});
						case 13:
							var value = action.a;
							return _Utils_update(
								dl,
								{d8: value});
						case 14:
							var value = action.a;
							return _Utils_update(
								dl,
								{hV: value});
						case 4:
							var value = action.a;
							return _Utils_update(
								dl,
								{fO: value});
						case 5:
							var value = action.a;
							return _Utils_update(
								dl,
								{d8: value});
						case 6:
							var value = action.a;
							return _Utils_update(
								dl,
								{bv: value});
						case 7:
							var value = action.a;
							return _Utils_update(
								dl,
								{bw: value});
						case 8:
							var value = action.a;
							return _Utils_update(
								dl,
								{aV: value});
						case 9:
							var value = action.a;
							return _Utils_update(
								dl,
								{a7: value});
						case 10:
							var value = action.a;
							return _Utils_update(
								dl,
								{dn: value});
						case 15:
							var value = action.a;
							return _Utils_update(
								dl,
								{d8: value, fO: value});
						case 22:
							var value = action.a;
							return _Utils_update(
								dl,
								{d8: value, fO: value});
						default:
							return dl;
					}
				} else {
					return dl;
				}
			},
			deadlineList);
	});
var $author$project$Main$updateDatesInModel = F5(
	function (model, date, newDate, dateString, newDatePicker) {
		var rawDates = model.at;
		var project = model.ae;
		var datePickers = model.B;
		var projectValidations = model.aP;
		var userProfile = model.z;
		switch (date) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: _Utils_update(
								datePickers,
								{fR: newDatePicker}),
							ae: _Utils_update(
								project,
								{
									hb: A3(
										$author$project$Main$updateDeadlines,
										project.hb,
										'Submission',
										$author$project$Project$SubmissionDueDate(dateString))
								}),
							at: _Utils_update(
								rawDates,
								{jn: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: _Utils_update(
								datePickers,
								{dD: newDatePicker}),
							ae: _Utils_update(
								project,
								{
									hb: A3(
										$author$project$Main$updateDeadlines,
										project.hb,
										'Audition',
										$author$project$Project$AuditionStartDate(dateString))
								}),
							at: _Utils_update(
								rawDates,
								{gA: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: _Utils_update(
								datePickers,
								{dC: newDatePicker}),
							ae: _Utils_update(
								project,
								{
									hb: A3(
										$author$project$Main$updateDeadlines,
										project.hb,
										'Audition',
										$author$project$Project$AuditionEndDate(dateString))
								}),
							at: _Utils_update(
								rawDates,
								{gz: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: _Utils_update(
								datePickers,
								{fd: newDatePicker}),
							ae: _Utils_update(
								project,
								{
									hb: A3(
										$author$project$Main$updateDeadlines,
										project.hb,
										'Project',
										$author$project$Project$ProjectStartDate(dateString))
								}),
							at: _Utils_update(
								rawDates,
								{iK: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: _Utils_update(
								datePickers,
								{dJ: newDatePicker}),
							ae: _Utils_update(
								project,
								{
									hb: A3(
										$author$project$Main$updateDeadlines,
										project.hb,
										'Callback',
										$author$project$Project$CallbackStartDate(dateString))
								}),
							at: _Utils_update(
								rawDates,
								{gJ: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: _Utils_update(
								datePickers,
								{dI: newDatePicker}),
							ae: _Utils_update(
								project,
								{
									hb: A3(
										$author$project$Main$updateDeadlines,
										project.hb,
										'Callback',
										$author$project$Project$CallbackEndDate(dateString))
								}),
							at: _Utils_update(
								rawDates,
								{gI: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: _Utils_update(
								datePickers,
								{fa: newDatePicker}),
							ae: _Utils_update(
								project,
								{
									hb: A3(
										$author$project$Main$updateDeadlines,
										project.hb,
										'Project',
										$author$project$Project$ProjectEndDate(dateString))
								}),
							at: _Utils_update(
								rawDates,
								{iF: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: _Utils_update(
								datePickers,
								{ej: newDatePicker}),
							ae: _Utils_update(
								project,
								{
									hb: A3(
										$author$project$Main$updateDeadlines,
										project.hb,
										'Fitting',
										$author$project$Project$FittingDate(dateString))
								}),
							at: _Utils_update(
								rawDates,
								{hu: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							B: _Utils_update(
								datePickers,
								{fG: newDatePicker}),
							ae: _Utils_update(
								project,
								{
									hb: A3(
										$author$project$Main$updateDeadlines,
										project.hb,
										'Shoot',
										$author$project$Project$ShootDate(dateString))
								}),
							at: _Utils_update(
								rawDates,
								{jg: newDate})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$State$SpecificDropTarget = function (a) {
	return {$: 1, a: a};
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$updateDropTarget = F2(
	function (_v0, id) {
		var stateData = _v0;
		var updatedStateData = _Utils_update(
			stateData,
			{
				bi: $arsduo$elm_dom_drag_drop$Dom$DragDrop$State$SpecificDropTarget(id)
			});
		return updatedStateData;
	});
var $author$project$MainMsg$UpdateExistingProject = function (a) {
	return {$: 48, a: a};
};
var $author$project$Api$Encoders$deadlineEncoder = function (deadline) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(deadline.bH)),
				_Utils_Tuple2(
				'starts_at',
				$elm$json$Json$Encode$string(deadline.fO)),
				_Utils_Tuple2(
				'due_at',
				$elm$json$Json$Encode$string(deadline.d8)),
				_Utils_Tuple2(
				'location',
				$elm$json$Json$Encode$string(deadline.hV)),
				_Utils_Tuple2(
				'address_1',
				$elm$json$Json$Encode$string(deadline.bv)),
				_Utils_Tuple2(
				'address_2',
				$elm$json$Json$Encode$string(deadline.bw)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(deadline.aV)),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(deadline.a7)),
				_Utils_Tuple2(
				'zip_code',
				$elm$json$Json$Encode$string(deadline.dn))
			]));
};
var $author$project$Api$Encoders$projectEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.ae.bH)),
				_Utils_Tuple2(
				'userID',
				$elm$json$Json$Encode$string(model.g5)),
				_Utils_Tuple2(
				'notes',
				$elm$json$Json$Encode$string(model.ae.iE)),
				_Utils_Tuple2(
				'rate',
				$elm$json$Json$Encode$string(model.ae.iJ)),
				_Utils_Tuple2(
				'union',
				$elm$json$Json$Encode$bool(model.ae.jI)),
				_Utils_Tuple2(
				'deadlines',
				A2($elm$json$Json$Encode$list, $author$project$Api$Encoders$deadlineEncoder, model.ae.hb)),
				_Utils_Tuple2(
				'talent_notes',
				$elm$json$Json$Encode$string(model.ae.jw)),
				_Utils_Tuple2(
				'agency_notes',
				$elm$json$Json$Encode$string(model.ae.gm)),
				_Utils_Tuple2(
				'archived',
				$elm$json$Json$Encode$bool(model.ae.dz)),
				_Utils_Tuple2(
				'is_active',
				$elm$json$Json$Encode$bool(model.ae.hK))
			]));
};
var $author$project$Api$Request$updateExistingProject = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$projectEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdateExistingProject, $author$project$Api$Decoders$projectDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'PUT',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + model.d_)
		});
};
var $author$project$MainMsg$UpdateExistingRole = function (a) {
	return {$: 61, a: a};
};
var $author$project$Api$Request$updateExistingRole = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$roleEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdateExistingRole, $author$project$Api$Decoders$roleDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'PUT',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('projects/' + (model.d_ + ('/roles/' + model.g3)))
		});
};
var $author$project$Main$updateFilterValues = F2(
	function (val, filterValues) {
		return A2($elm$core$List$member, val, filterValues) ? A2(
			$elm$core$List$filter,
			function (value) {
				return !_Utils_eq(val, value);
			},
			filterValues) : A2($elm$core$List$cons, val, filterValues);
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Main$updateFiltersBasedOnRole = F2(
	function (role, talentFilterValues) {
		return _Utils_update(
			talentFilterValues,
			{
				hx: A2(
					$elm$core$List$map,
					function (gender) {
						return gender.bH;
					},
					role.hy),
				cX: $elm$core$String$fromInt(role.cX),
				eI: $elm$core$String$fromFloat(role.eI),
				h$: $elm$core$String$fromInt(role.hZ),
				cZ: $elm$core$String$fromInt(role.cZ),
				eN: $elm$core$String$fromFloat(role.eN),
				h6: $elm$core$String$fromInt(role.h4),
				iM: A2(
					$elm$core$List$map,
					function (ethnicity) {
						return ethnicity.bH;
					},
					role.ea)
			});
	});
var $author$project$MainMsg$UpdatedInvitation = function (a) {
	return {$: 276, a: a};
};
var $author$project$Api$Encoders$invitationEncoder = F2(
	function (response, invitationId) {
		var res = function () {
			if (!response) {
				return 'accept';
			} else {
				return 'reject';
			}
		}();
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'response',
					$elm$json$Json$Encode$string(res)),
					_Utils_Tuple2(
					'project_id',
					$elm$json$Json$Encode$string(invitationId))
				]));
	});
var $author$project$Api$Request$updateInvitation = F3(
	function (response, invitationId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$invitationEncoder, response, invitationId)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdatedInvitation, $author$project$Api$Decoders$collaboratingProjectsDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'invitation/update'
			});
	});
var $author$project$Job$ViewingJobOpen = 0;
var $author$project$Main$updateJobPageData = F2(
	function (jMsg, jobPageData) {
		switch (jMsg.$) {
			case 0:
				var data = jMsg.a;
				return _Utils_update(
					data,
					{f3: 0});
			case 4:
				var state = function () {
					var _v1 = jobPageData.f3;
					if (_v1 === 1) {
						return 0;
					} else {
						return 1;
					}
				}();
				return _Utils_update(
					jobPageData,
					{fD: $author$project$SharedProjectRoleSchedules$emptyBasicProjectData, f3: state});
			case 2:
				return _Utils_update(
					jobPageData,
					{fB: 0});
			case 1:
				var searchTerm = jMsg.a;
				return _Utils_update(
					jobPageData,
					{fC: searchTerm});
			case 5:
				var projects = jMsg.a;
				return _Utils_update(
					jobPageData,
					{
						fe: projects,
						fB: 1,
						fD: A2(
							$elm$core$Maybe$withDefault,
							$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
							$elm$core$List$head(projects))
					});
			default:
				var projectId = jMsg.a;
				return _Utils_update(
					jobPageData,
					{
						fD: A2(
							$elm$core$Maybe$withDefault,
							$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$author$project$Utils$eq,
										function ($) {
											return $.V;
										},
										projectId),
									jobPageData.fe))),
						f3: 0
					});
		}
	});
var $author$project$Main$updateMessage = F2(
	function (msg, model) {
		var newMessageData = model.y;
		var value = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					y: _Utils_update(
						newMessageData,
						{dG: value})
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Main$updateNotification = F2(
	function (msg, model) {
		var notificationData = model.bI;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bI: _Utils_update(
								notificationData,
								{dG: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bI: _Utils_update(
								notificationData,
								{cu: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bI: _Utils_update(
								notificationData,
								{hT: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bI: _Utils_update(
								notificationData,
								{aQ: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateNotificationSetting = F2(
	function (nMsg, notificationSettings) {
		switch (nMsg.$) {
			case 0:
				var value = nMsg.a;
				return _Utils_update(
					notificationSettings,
					{ae: value});
			case 1:
				var value = nMsg.a;
				return _Utils_update(
					notificationSettings,
					{jr: value});
			case 3:
				var value = nMsg.a;
				return _Utils_update(
					notificationSettings,
					{iD: value});
			case 2:
				var value = nMsg.a;
				return _Utils_update(
					notificationSettings,
					{gy: value});
			default:
				var value = nMsg.a;
				return _Utils_update(
					notificationSettings,
					{h3: value});
		}
	});
var $author$project$Main$updateNotificationSettings = F2(
	function (nMsg, userProfile) {
		return _Utils_update(
			userProfile,
			{
				$9: A2($author$project$Main$updateNotificationSetting, nMsg, userProfile.$9)
			});
	});
var $author$project$Main$updateNotifications = F2(
	function (userProfile, notificationIds) {
		var filteredNotifications = A2(
			$elm$core$List$map,
			function (notification) {
				return A2($elm$core$List$member, notification.V, notificationIds) ? _Utils_update(
					notification,
					{hN: true}) : notification;
			},
			userProfile.bJ);
		return _Utils_update(
			userProfile,
			{bJ: filteredNotifications});
	});
var $author$project$Main$updateNotificationsForUser = F2(
	function (currentUser, notifications) {
		return _Utils_update(
			currentUser,
			{bJ: notifications});
	});
var $author$project$Main$updatePassword = F2(
	function (msg, model) {
		var userPasswords = model.jP;
		switch (msg.$) {
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jP: _Utils_update(
								userPasswords,
								{eR: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jP: _Utils_update(
								userPasswords,
								{eW: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jP: _Utils_update(
								userPasswords,
								{cF: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updatePhysicalAddress = F2(
	function (msg, model) {
		var physicalAddress = model.aB;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: _Utils_update(
								physicalAddress,
								{bv: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: _Utils_update(
								physicalAddress,
								{bw: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: _Utils_update(
								physicalAddress,
								{aV: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: _Utils_update(
								physicalAddress,
								{a7: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: _Utils_update(
								physicalAddress,
								{e0: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: _Utils_update(
								physicalAddress,
								{dr: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateAgencyInfo = F2(
	function (agency, aMsg) {
		switch (aMsg.$) {
			case 0:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{cz: value});
			case 1:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{go: value});
			case 2:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{gp: value});
			case 4:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{gn: value});
			case 3:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{gq: value});
			default:
				return agency;
		}
	});
var $author$project$Main$updateAgentData = F2(
	function (agency, agent) {
		return _Utils_update(
			agency,
			{
				gr: _List_fromArray(
					[agent])
			});
	});
var $author$project$Main$updateProfileAgencyInfo = F2(
	function (agency, aMsg) {
		switch (aMsg.$) {
			case 0:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{cz: value});
			case 1:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{bm: value});
			case 2:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{bE: value});
			case 5:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{bv: value});
			case 6:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{bw: value});
			case 8:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{a7: value});
			case 7:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{aV: value});
			case 9:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{dn: value});
			default:
				return agency;
		}
	});
var $author$project$Main$updateProfile = F2(
	function (msg, model) {
		var userProfile = model.z;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{bm: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{bE: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{bl: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{aV: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{a7: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{eZ: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{ho: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var part = msg.a;
				switch (part.$) {
					case 0:
						var val = part.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									z: _Utils_update(
										userProfile,
										{h9: val})
								}),
							$elm$core$Platform$Cmd$none);
					case 1:
						var val = part.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									z: _Utils_update(
										userProfile,
										{ha: val})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						var val = part.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									z: _Utils_update(
										userProfile,
										{jZ: val})
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{hw: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eL: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(value))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eM: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(value))
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{
									jV: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toFloat(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{
									jX: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{
									cZ: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{
									cX: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var aMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{
									cy: A2($author$project$Main$updateAgencyInfo, model.z.cy, aMsg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var aMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{
									gl: A2($author$project$Main$updateProfileAgencyInfo, model.z.gl, aMsg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var id = msg.a;
				var agency = A2(
					$elm$core$Maybe$withDefault,
					$author$project$User$emptyAgency,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$author$project$Utils$eq,
								function ($) {
									return $.V;
								},
								id),
							model.c.cx)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{gl: agency})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var id = msg.a;
				var agency = A2(
					$elm$core$Maybe$withDefault,
					$author$project$User$emptyAgency,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$author$project$Utils$eq,
								function ($) {
									return $.V;
								},
								model.z.gl.V),
							model.c.cx)));
				var agent = A2(
					$elm$core$Maybe$withDefault,
					$author$project$User$emptyAgent,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$author$project$Utils$eq,
								function ($) {
									return $.V;
								},
								id),
							agency.gr)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{
									gl: A2($author$project$Main$updateAgentData, model.z.gl, agent)
								})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateProfileHeightValue = function (model) {
	var userProfile = model.z;
	return _Utils_update(
		userProfile,
		{hB: (model.eL * 12) + model.eM});
};
var $author$project$Main$updateProject = F2(
	function (msg, model) {
		var project = model.ae;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{bH: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Submission', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Audition', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Audition', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Audition', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Callback', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Callback', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Callback', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 22:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Fitting', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{
									hb: A3($author$project$Main$updateDeadlines, project.hb, 'Shoot', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{jw: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{gm: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{iE: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 19:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{iJ: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 20:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{jI: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 21:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{jI: false})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ae: _Utils_update(
								project,
								{hK: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Project$RoleMenuOpen = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$updateProjectMenuState = F2(
	function (model, msg) {
		var projectMenuState = model.aC;
		var role = model.P;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aC: _Utils_update(
								projectMenuState,
								{ee: !model.aC.ee})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aC: _Utils_update(
								projectMenuState,
								{ed: !model.aC.ed})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aC: _Utils_update(
								projectMenuState,
								{ef: !model.aC.ef, db: $author$project$Project$RoleMenuClosed})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var projectRoleData = msg.a;
				var _v1 = function () {
					if (!projectRoleData.$) {
						var roleData = projectRoleData.a;
						return _Utils_eq(model.aC.db, $author$project$Project$RoleMenuClosed) ? _Utils_Tuple2(
							$author$project$Project$RoleMenuOpen(roleData),
							roleData.cU) : _Utils_Tuple2($author$project$Project$RoleMenuClosed, '');
					} else {
						return _Utils_Tuple2($author$project$Project$RoleMenuClosed, '');
					}
				}();
				var state = _v1.a;
				var roleId = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							g3: roleId,
							aC: _Utils_update(
								projectMenuState,
								{db: state}),
							P: A2($author$project$Views$Messages$findRole, model.aw, roleId)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateProjectValidation = F2(
	function (msg, model) {
		var projectValidations = model.aP;
		if (!msg) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aP: _Utils_update(
							projectValidations,
							{bH: true})
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aP: _Utils_update(
							projectValidations,
							{iE: true})
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateQuestions = F2(
	function (profilePage, questions) {
		return _Utils_update(
			profilePage,
			{
				bN: $author$project$MainMsg$Successs(questions)
			});
	});
var $author$project$Main$updateAnswer = F3(
	function (answer, value, questionId) {
		return _Utils_update(
			answer,
			{iL: questionId, iT: value});
	});
var $author$project$Main$updateQuestionsForm = F3(
	function (value, questionId, profilePageData) {
		var updatedQuestions = function () {
			var _v0 = profilePageData.bN;
			if (_v0.$ === 3) {
				var questions = _v0.a;
				return A2(
					$elm$core$List$map,
					function (question) {
						return _Utils_eq(question.V, questionId) ? _Utils_update(
							question,
							{
								gu: A3($author$project$Main$updateAnswer, question.gu, value, questionId)
							}) : question;
					},
					questions);
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_update(
			profilePageData,
			{
				bN: $author$project$MainMsg$Successs(updatedQuestions)
			});
	});
var $author$project$Main$updateResume = F2(
	function (userProfile, maybeResume) {
		return _Utils_update(
			userProfile,
			{iU: maybeResume});
	});
var $author$project$Main$updateRoleChangeInfo = F4(
	function (roleInfo, roleMemberId, newRoleId, userId) {
		return _Utils_update(
			roleInfo,
			{ie: newRoleId, aQ: roleMemberId, cu: userId});
	});
var $author$project$Main$updateRoleEthnicities = F2(
	function (role, options) {
		return _Utils_update(
			role,
			{ea: options});
	});
var $author$project$Main$updateRoleGenders = F2(
	function (role, options) {
		return _Utils_update(
			role,
			{hy: options});
	});
var $author$project$Main$updateRoleMulti = F3(
	function (msg, model, item) {
		var role = model.P;
		var userProfile = model.z;
		switch (msg) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									hy: A2($author$project$Main$addIfNotPresent, item, model.P.hy)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									hy: A2(
										$elm$core$List$filter,
										function (gender) {
											return !_Utils_eq(item, gender);
										},
										model.P.hy)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									ea: A2($author$project$Main$addIfNotPresent, item, model.P.ea)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{
									ea: A2($author$project$Main$addIfNotPresent, item, model.z.ea)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							P: _Utils_update(
								role,
								{
									ea: A2(
										$elm$core$List$filter,
										function (ethnicity) {
											return !_Utils_eq(item, ethnicity);
										},
										model.P.ea)
								})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							z: _Utils_update(
								userProfile,
								{
									ea: A2(
										$elm$core$List$filter,
										function (ethnicity) {
											return !_Utils_eq(item, ethnicity);
										},
										model.z.ea)
								})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateRoleValidation = F2(
	function (msg, model) {
		var roleValidations = model.T;
		switch (msg) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{bH: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{iZ: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{iV: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{hw: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{cZ: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{cX: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{ea: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{h4: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{hZ: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{eN: true})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								roleValidations,
								{eI: true})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$userPresent = F2(
	function (user, schedules) {
		return A2(
			$elm$core$List$member,
			user.cU,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.cU;
				},
				A2(
					$elm$core$List$map,
					function ($) {
						return $.f_;
					},
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.jD;
						},
						schedules))));
	});
var $author$project$Main$availableList = F3(
	function (pipeline, columnNames, schedules) {
		return A2(
			$elm$core$List$filter,
			function (user) {
				return !A2($author$project$Main$userPresent, user, schedules);
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.jR;
				},
				A2(
					$elm$core$List$filter,
					function (column) {
						return A2($elm$core$List$member, column.bH, columnNames);
					},
					pipeline)));
	});
var $author$project$Main$columnsToPullScheduledUsersFrom = function (scheduleType) {
	switch (scheduleType) {
		case 'Audition':
			return _List_fromArray(
				['Scheduled Audition']);
		case 'Callback':
			return _List_fromArray(
				['Scheduled Callbacks']);
		default:
			return _List_Nil;
	}
};
var $author$project$Main$columnsToPullUsersFrom = function (scheduleType) {
	switch (scheduleType) {
		case 'Audition':
			return _List_fromArray(
				['Selected Candidates']);
		case 'Callback':
			return _List_fromArray(
				['Scheduled Audition', 'Selected Candidates']);
		default:
			return _List_Nil;
	}
};
var $author$project$Main$findSchedule = F2(
	function (scheduleId, schedules) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptySchedule,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.V;
						},
						scheduleId),
					schedules)));
	});
var $author$project$Main$publishedStatus = function (schedules) {
	var _v0 = $elm$core$List$head(schedules);
	if (_v0.$ === 1) {
		return false;
	} else {
		var val = _v0.a;
		return val.a3;
	}
};
var $author$project$Main$pullTalentFromSchedules = function (schedules) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.f_;
		},
		A2(
			$elm$core$List$concatMap,
			function (schedule) {
				return A2(
					$elm$core$List$filter,
					function (timeSlot) {
						return !_Utils_eq(timeSlot.f_, $author$project$User$emptyPipelineUser);
					},
					schedule.jD);
			},
			schedules));
};
var $author$project$Main$scheduleList = F2(
	function (schedules, scheduleType) {
		return A2(
			$elm$core$List$filter,
			function (schedule) {
				return _Utils_eq(schedule.fy, scheduleType);
			},
			schedules);
	});
var $author$project$Main$scheduledList = F3(
	function (pipeline, columnNames, schedules) {
		return A2(
			$elm$core$List$filter,
			function (user) {
				return A2($author$project$Main$userPresent, user, schedules);
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.jR;
				},
				A2(
					$elm$core$List$filter,
					function (column) {
						return A2($elm$core$List$member, column.bH, columnNames);
					},
					pipeline)));
	});
var $author$project$Main$addOrRemoveRole = F2(
	function (item, items) {
		return A2($elm$core$List$member, item, items) ? A2(
			$elm$core$List$filter,
			function (role) {
				return !_Utils_eq(role, item);
			},
			items) : A2($elm$core$List$cons, item, items);
	});
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Main$filterRoleList = F2(
	function (searchString, roles) {
		return A2(
			$elm$core$List$filter,
			function (role) {
				return A2(
					$elm$core$String$contains,
					$elm$core$String$toUpper(searchString),
					$elm$core$String$toUpper(role));
			},
			roles);
	});
var $author$project$Views$Schedule$roleNames = function (roles) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.bH;
		},
		roles);
};
var $author$project$Main$updateScheduleForm = F3(
	function (model, schedulePageData, scheduleFormMsg) {
		var currentSchedule = schedulePageData.aX;
		switch (scheduleFormMsg.$) {
			case 0:
				var value = scheduleFormMsg.a;
				var deadlineValue = A2(
					$elm$core$Maybe$withDefault,
					$author$project$SharedProjectRoleSchedules$emptyDeadline,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$author$project$Utils$eq,
								function ($) {
									return $.bH;
								},
								value),
							schedulePageData.ae.hb)));
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{fy: value}),
						d8: deadlineValue.d8,
						fO: deadlineValue.fO
					});
			case 1:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{jk: value})
					});
			case 2:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{hi: value})
					});
			case 4:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{gF: value})
					});
			case 5:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{gE: value})
					});
			case 6:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{
								gK: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(value))
							})
					});
			case 7:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{
								fq: A2($author$project$Main$addOrRemoveRole, value, currentSchedule.fq)
							})
					});
			case 8:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{
								da: A2(
									$author$project$Main$filterRoleList,
									value,
									$author$project$Views$Schedule$roleNames(schedulePageData.ae.fq)),
								i_: value
							})
					});
			case 9:
				var open = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{ja: open});
			case 14:
				return _Utils_update(
					schedulePageData,
					{fJ: !model.bQ.fJ});
			case 10:
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{fq: _List_Nil})
					});
			case 11:
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{
								fq: $author$project$Views$Schedule$roleNames(schedulePageData.ae.fq)
							})
					});
			case 3:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						aX: _Utils_update(
							currentSchedule,
							{
								jC: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(value))
							})
					});
			case 12:
				return _Utils_update(
					schedulePageData,
					{
						gB: true,
						aX: _Utils_update(
							currentSchedule,
							{
								da: $author$project$Views$Schedule$roleNames(schedulePageData.ae.fq)
							})
					});
			default:
				return _Utils_update(
					schedulePageData,
					{gB: false});
		}
	});
var $author$project$Main$updateTimeSlotInDayOfPage = F2(
	function (schedule, updatedTimeSlot) {
		return _Utils_update(
			schedule,
			{
				jD: A2(
					$elm$core$List$map,
					function (time_slot) {
						return _Utils_eq(time_slot.V, updatedTimeSlot.V) ? updatedTimeSlot : time_slot;
					},
					schedule.jD)
			});
	});
var $author$project$Main$updateTimeSlotInSchedule = F2(
	function (schedules, updatedTimeSlot) {
		return A2(
			$elm$core$List$map,
			function (schedule) {
				return _Utils_eq(schedule.V, updatedTimeSlot.i0) ? _Utils_update(
					schedule,
					{
						jD: A2(
							$elm$core$List$map,
							function (timeSlot) {
								return _Utils_eq(timeSlot.V, updatedTimeSlot.V) ? updatedTimeSlot : timeSlot;
							},
							schedule.jD)
					}) : schedule;
			},
			schedules);
	});
var $author$project$Main$validScheduleForm = function (schedule) {
	return (schedule.jk === '') || ((schedule.hi === '') || ((!schedule.gK) || (!schedule.jC)));
};
var $author$project$Main$updateSchedulePageData = F2(
	function (model, sMsg) {
		var schedulePageData = model.bQ;
		var viewingProject = model.h;
		switch (sMsg.$) {
			case 0:
				var scheduleForm = sMsg.a;
				switch (scheduleForm) {
					case 0:
						return _Utils_update(
							schedulePageData,
							{aX: $author$project$SharedProjectRoleSchedules$emptySchedule, bP: scheduleForm});
					case 2:
						return (!$author$project$Main$validScheduleForm(schedulePageData.aX)) ? _Utils_update(
							schedulePageData,
							{fw: false, bP: scheduleForm}) : _Utils_update(
							schedulePageData,
							{fw: true});
					default:
						return _Utils_update(
							schedulePageData,
							{bP: scheduleForm});
				}
			case 14:
				var comment = sMsg.a;
				return _Utils_update(
					schedulePageData,
					{b2: comment});
			case 1:
				var schedulePage = sMsg.a;
				switch (schedulePage.$) {
					case 1:
						var scheduleType = schedulePage.a;
						return _Utils_update(
							schedulePageData,
							{fy: scheduleType});
					case 3:
						var project = schedulePage.a;
						var scheduleType = schedulePage.b;
						return _Utils_update(
							schedulePageData,
							{
								D: A3(
									$author$project$Main$availableList,
									project.v,
									$author$project$Main$columnsToPullUsersFrom(model.bQ.fy),
									A2($author$project$Main$scheduleList, project.f, model.bQ.fy)),
								ae: project,
								a3: $author$project$Main$publishedStatus(schedulePageData.f),
								aE: schedulePage,
								fy: scheduleType,
								i3: A3(
									$author$project$Main$scheduledList,
									project.v,
									$author$project$Main$columnsToPullScheduledUsersFrom(model.bQ.fy),
									A2($author$project$Main$scheduleList, project.f, model.bQ.fy)),
								f: A2($author$project$Main$scheduleList, project.f, scheduleType)
							});
					case 4:
						var updatedPipeline = schedulePage.a;
						return _Utils_update(
							schedulePageData,
							{
								D: A3(
									$author$project$Main$availableList,
									updatedPipeline,
									$author$project$Main$columnsToPullUsersFrom(model.bQ.fy),
									A2($author$project$Main$scheduleList, model.bQ.f, model.bQ.fy)),
								i3: A3(
									$author$project$Main$scheduledList,
									updatedPipeline,
									$author$project$Main$columnsToPullScheduledUsersFrom(model.bQ.fy),
									A2($author$project$Main$scheduleList, model.bQ.f, model.bQ.fy))
							});
					case 2:
						var projectId = schedulePage.a;
						var scheduleType = schedulePage.b;
						return _Utils_update(
							schedulePageData,
							{
								aX: $author$project$SharedProjectRoleSchedules$emptySchedule,
								ae: A2(
									$elm$core$Maybe$withDefault,
									$author$project$SharedProjectRoleSchedules$emptyProject,
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$author$project$Utils$eq,
												function ($) {
													return $.cU;
												},
												projectId),
											model.A))),
								aE: schedulePage,
								fy: scheduleType,
								f: _List_Nil
							});
					default:
						return _Utils_update(
							schedulePageData,
							{aE: schedulePage});
				}
			case 2:
				var scheduleFormMsg = sMsg.a;
				return A3($author$project$Main$updateScheduleForm, model, schedulePageData, scheduleFormMsg);
			case 3:
				var schedules = sMsg.a;
				var formView = sMsg.b;
				return _Utils_update(
					schedulePageData,
					{
						D: A3(
							$author$project$Main$availableList,
							model.h.v,
							$author$project$Main$columnsToPullUsersFrom(model.bQ.fy),
							A2($author$project$Main$scheduleList, schedules, model.bQ.fy)),
						a3: false,
						bP: formView,
						aE: A3($author$project$Main$determineSchedulePageView, schedules, model.bQ.fy, model.bQ.ae),
						i3: A3(
							$author$project$Main$scheduledList,
							model.h.v,
							$author$project$Main$columnsToPullScheduledUsersFrom(model.bQ.fy),
							A2($author$project$Main$scheduleList, schedules, model.bQ.fy)),
						f: A2($author$project$Main$scheduleList, schedules, model.bQ.fy)
					});
			case 8:
				var schedules = sMsg.a;
				var scheduleView = sMsg.b;
				var _v3 = function () {
					switch (scheduleView.$) {
						case 0:
							var scheduleType = scheduleView.a;
							return _Utils_Tuple2(scheduleType, '');
						case 3:
							var scheduleType = scheduleView.b;
							return _Utils_Tuple2(scheduleType, '');
						case 5:
							var projectId = scheduleView.a;
							var scheduleId = scheduleView.b;
							return _Utils_Tuple2(
								A2($author$project$Main$findSchedule, scheduleId, schedules).fy,
								scheduleId);
						default:
							return _Utils_Tuple2('', '');
					}
				}();
				var sType = _v3.a;
				var sId = _v3.b;
				return _Utils_update(
					schedulePageData,
					{
						D: A3(
							$author$project$Main$availableList,
							viewingProject.v,
							$author$project$Main$columnsToPullUsersFrom(sType),
							A2($author$project$Main$scheduleList, schedules, sType)),
						b6: A2($author$project$Main$findSchedule, sId, schedules),
						ae: A2($author$project$Main$addSchedulesToViewingProject, model.h, schedules),
						a3: $author$project$Main$publishedStatus(schedules),
						aE: scheduleView,
						i3: A3(
							$author$project$Main$scheduledList,
							viewingProject.v,
							$author$project$Main$columnsToPullScheduledUsersFrom(sType),
							A2($author$project$Main$scheduleList, schedules, sType)),
						f: A2($author$project$Main$scheduleList, schedules, sType)
					});
			case 10:
				var schedules = sMsg.a;
				var talent = sMsg.b;
				var userSwapData = sMsg.c;
				return _Utils_update(
					schedulePageData,
					{
						D: talent,
						a3: $author$project$Main$publishedStatus(schedules),
						bP: 0,
						i3: $author$project$Main$pullTalentFromSchedules(schedules),
						f: schedules,
						f2: userSwapData
					});
			case 4:
				var scheduleType = sMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						D: A3(
							$author$project$Main$availableList,
							viewingProject.v,
							$author$project$Main$columnsToPullUsersFrom(scheduleType),
							A2($author$project$Main$scheduleList, schedulePageData.ae.f, scheduleType)),
						a3: $author$project$Main$publishedStatus(schedulePageData.f),
						fy: scheduleType,
						i3: A3(
							$author$project$Main$scheduledList,
							viewingProject.v,
							$author$project$Main$columnsToPullScheduledUsersFrom(scheduleType),
							A2($author$project$Main$scheduleList, schedulePageData.ae.f, scheduleType)),
						f: A2($author$project$Main$scheduleList, schedulePageData.ae.f, scheduleType)
					});
			case 5:
				var updatedTimeSlot = sMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						b2: '',
						b6: A2($author$project$Main$updateTimeSlotInDayOfPage, schedulePageData.b6, updatedTimeSlot),
						f: A2($author$project$Main$updateTimeSlotInSchedule, schedulePageData.f, updatedTimeSlot)
					});
			case 6:
				return $author$project$SharedProjectRoleSchedules$initialSchedulePageData;
			case 7:
				return $author$project$SharedProjectRoleSchedules$initialSchedulePageData;
			case 9:
				var data = sMsg.a;
				return _Utils_update(
					schedulePageData,
					{f2: data});
			case 11:
				var schedules = sMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						a3: $author$project$Main$publishedStatus(schedules),
						aE: A2($author$project$SharedProjectRoleSchedules$ProjectSchedule, schedulePageData.ae, schedulePageData.fy),
						f: schedules
					});
			case 12:
				var project = sMsg.a;
				var schedule = sMsg.b;
				return _Utils_update(
					schedulePageData,
					{
						b6: schedule,
						aE: A2($author$project$SharedProjectRoleSchedules$ScheduleDayOfPage, project.cU, schedule.V)
					});
			default:
				return _Utils_update(
					schedulePageData,
					{dP: !schedulePageData.dP});
		}
	});
var $author$project$Main$updateSearchResultAge = F2(
	function (age, _v0) {
		var viewingTalentResult = _v0.p;
		return _Utils_update(
			viewingTalentResult,
			{gk: age});
	});
var $author$project$Main$updateSecretString = F2(
	function (profile, secretString) {
		return _Utils_update(
			profile,
			{i8: secretString});
	});
var $author$project$Main$updateTalentFilterExpand = F2(
	function (model, talentFilter) {
		var talentFilterExpands = model.I;
		switch (talentFilter) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							I: _Utils_update(
								talentFilterExpands,
								{en: !model.I.en})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							I: _Utils_update(
								talentFilterExpands,
								{ds: !model.I.ds})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							I: _Utils_update(
								talentFilterExpands,
								{eb: !model.I.eb})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							I: _Utils_update(
								talentFilterExpands,
								{ei: !model.I.ei})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							I: _Utils_update(
								talentFilterExpands,
								{er: !model.I.er})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							I: _Utils_update(
								talentFilterExpands,
								{gc: !model.I.gc})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							I: _Utils_update(
								talentFilterExpands,
								{fL: !model.I.fL})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							I: _Utils_update(
								talentFilterExpands,
								{eJ: !model.I.eJ})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateTalentFilterOffset = F2(
	function (talentFilterValues, offset) {
		return _Utils_update(
			talentFilterValues,
			{io: offset + 48});
	});
var $author$project$MainMsg$UpdatedMembership = function (a) {
	return {$: 317, a: a};
};
var $author$project$Api$Request$updateTalentMembership = F3(
	function (status, membershipId, jwt) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$emptyBody,
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdatedMembership, $author$project$Api$Decoders$talentUserDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'GET',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('agencies/talent/' + (membershipId + ('/' + status)))
			});
	});
var $author$project$User$LoadingTalentDetails = {$: 2};
var $author$project$User$OptionsModal = {$: 3};
var $author$project$Main$filterRoleOptions = F2(
	function (roles, projectId) {
		return A2(
			$elm$core$List$map,
			function (role) {
				return {V: role.cU, bH: role.bH};
			},
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.iH;
					},
					projectId),
				roles));
	});
var $author$project$Utils$reasonActionText = function (reason) {
	switch (reason) {
		case 0:
			return 'Removing from role. Please provide a reason.';
		case 1:
			return 'Requesting to be rescheduled. Please provide a reason.';
		case 2:
			return 'Declining audition schedule request. Please provide a reason.';
		case 4:
			return 'Requesting to be rescheduled. Please provide a reason.';
		case 5:
			return 'Declining callback schedule request. Please provide a reason.';
		case 3:
			return 'Declining application request. Please provide a reason.';
		case 6:
			return 'Declining booking request. Please provide a reason.';
		default:
			return '';
	}
};
var $author$project$Main$updateTalentMenuOptions = F5(
	function (tMsg, talentOptionsMenu, projectId, roleId, roles) {
		switch (tMsg.$) {
			case 0:
				var reason = tMsg.a;
				return _Utils_update(
					talentOptionsMenu,
					{iP: reason});
			case 2:
				var talent = tMsg.a;
				return _Utils_update(
					talentOptionsMenu,
					{bG: $author$project$User$OptionsModal, jr: talent});
			case 1:
				var modalView = tMsg.a;
				switch (modalView.$) {
					case 1:
						var reasonAction = modalView.a;
						return _Utils_update(
							talentOptionsMenu,
							{
								h8: $author$project$Utils$reasonActionText(reasonAction),
								bG: modalView
							});
					case 4:
						return _Utils_update(
							talentOptionsMenu,
							{
								bG: modalView,
								fq: A2($author$project$Main$filterRoleOptions, roles, projectId)
							});
					default:
						return _Utils_update(
							talentOptionsMenu,
							{bG: modalView});
				}
			case 3:
				var talentProfile = tMsg.a;
				return (!talentOptionsMenu.dk) ? $author$project$User$initialTalentMenuOptions : _Utils_update(
					talentOptionsMenu,
					{g2: projectId, g4: roleId, bG: $author$project$User$LoadingTalentDetails, jr: talentProfile, dk: 0});
			default:
				var newRole = tMsg.a;
				return _Utils_update(
					talentOptionsMenu,
					{fp: newRole});
		}
	});
var $author$project$Main$updateTalentVideo = F2(
	function (profile, updatedVideo) {
		return _Utils_update(
			profile,
			{
				jT: A2(
					$elm$core$List$map,
					function (video) {
						return _Utils_eq(video.V, updatedVideo.V) ? updatedVideo : video;
					},
					profile.jT)
			});
	});
var $author$project$Main$updateUser = F2(
	function (msg, model) {
		var userData = model.aT;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aT: _Utils_update(
								userData,
								{bm: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aT: _Utils_update(
								userData,
								{bE: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aT: _Utils_update(
								userData,
								{eW: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aT: _Utils_update(
								userData,
								{eX: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aT: _Utils_update(
								userData,
								{eR: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aT: _Utils_update(
								userData,
								{bl: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aT: _Utils_update(
								userData,
								{cE: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$MainMsg$UpdatePasswords = function (a) {
	return {$: 43, a: a};
};
var $author$project$User$UserPasswords = F3(
	function (password, oldPassword, confirmPassword) {
		return {cF: confirmPassword, eR: oldPassword, eW: password};
	});
var $author$project$Api$Decoders$updatePasswordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'oldPassword',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'confirmPassword',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'password',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$User$UserPasswords))));
var $author$project$Api$Encoders$updatePasswordEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(model.jP.eW))
			]));
};
var $author$project$Api$Request$updateUserPassword = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$updatePasswordEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdatePasswords, $author$project$Api$Decoders$updatePasswordDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'PUT',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('user/' + model.ht)
		});
};
var $author$project$Api$Encoders$agencyEncoder = function (agency) {
	var agent = A2(
		$elm$core$Maybe$withDefault,
		$author$project$User$emptyAgent,
		$elm$core$List$head(agency.gr));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(agency.V)),
				_Utils_Tuple2(
				'agency_name',
				$elm$json$Json$Encode$string(agency.cz)),
				_Utils_Tuple2(
				'agent_id',
				$elm$json$Json$Encode$string(agent.V)),
				_Utils_Tuple2(
				'agent_name',
				$elm$json$Json$Encode$string(agent.bm)),
				_Utils_Tuple2(
				'agent_email',
				$elm$json$Json$Encode$string(agent.bl)),
				_Utils_Tuple2(
				'agent_phone',
				$elm$json$Json$Encode$string(agent.eZ)),
				_Utils_Tuple2(
				'agent_address1',
				$elm$json$Json$Encode$string(agency.bv)),
				_Utils_Tuple2(
				'agent_address2',
				$elm$json$Json$Encode$string(agency.bw)),
				_Utils_Tuple2(
				'agent_city',
				$elm$json$Json$Encode$string(agency.aV)),
				_Utils_Tuple2(
				'agent_state',
				$elm$json$Json$Encode$string(agency.a7)),
				_Utils_Tuple2(
				'agent_zip',
				$elm$json$Json$Encode$string(agency.dn))
			]));
};
var $author$project$Utils$createDobFromValues = F3(
	function (month, day, year) {
		return year + ('/' + (month + ('/' + day)));
	});
var $author$project$Api$Encoders$notificationSettingsEncoder = function (settings) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'project',
				$elm$json$Json$Encode$bool(settings.ae)),
				_Utils_Tuple2(
				'talent',
				$elm$json$Json$Encode$bool(settings.jr)),
				_Utils_Tuple2(
				'audition',
				$elm$json$Json$Encode$bool(settings.gy)),
				_Utils_Tuple2(
				'messages',
				$elm$json$Json$Encode$bool(settings.h3)),
				_Utils_Tuple2(
				'profile_update',
				$elm$json$Json$Encode$bool(settings.iD))
			]));
};
var $author$project$Api$Encoders$updateProfileEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(model.z.bm)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(model.z.bE)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(model.z.bl)),
				_Utils_Tuple2(
				'phone',
				$elm$json$Json$Encode$string(model.z.eZ)),
				_Utils_Tuple2(
				'eye_color',
				$elm$json$Json$Encode$string(model.z.ho)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(model.z.aV)),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(model.z.a7)),
				_Utils_Tuple2(
				'birth_date',
				$elm$json$Json$Encode$string(
					A3($author$project$Utils$createDobFromValues, model.z.h9, model.z.ha, model.z.jZ))),
				_Utils_Tuple2(
				'gender',
				$elm$json$Json$Encode$string(model.z.hw)),
				_Utils_Tuple2(
				'ethnic_appearance',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$List$map,
						function (option) {
							return option.V;
						},
						model.z.ea))),
				_Utils_Tuple2(
				'height',
				$elm$json$Json$Encode$int(model.z.hB)),
				_Utils_Tuple2(
				'weight',
				$elm$json$Json$Encode$int(model.z.jX)),
				_Utils_Tuple2(
				'waist_size',
				$elm$json$Json$Encode$float(model.z.jV)),
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$string(model.z.cE)),
				_Utils_Tuple2(
				'min_age',
				$elm$json$Json$Encode$int(model.z.cZ)),
				_Utils_Tuple2(
				'max_age',
				$elm$json$Json$Encode$int(model.z.cX)),
				_Utils_Tuple2(
				'agency',
				$author$project$Api$Encoders$agencyEncoder(model.z.gl)),
				_Utils_Tuple2(
				'notification_settings',
				$author$project$Api$Encoders$notificationSettingsEncoder(model.z.$9))
			]));
};
var $author$project$Api$Request$updateUserProfile = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$updateProfileEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdateUserProfile, $author$project$Api$Decoders$updateProfileDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'PUT',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + model.z.cU)
		});
};
var $author$project$MainMsg$PageChangedProfileUpdated = function (a) {
	return {$: 312, a: a};
};
var $author$project$Api$Request$updateUserProfilePageChange = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$updateProfileEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$PageChangedProfileUpdated, $author$project$Api$Decoders$updateProfileDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'PUT',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + model.z.cU)
		});
};
var $author$project$Main$updateUserProfileStatus = F3(
	function (profileData, status, questionsStatus) {
		return _Utils_update(
			profileData,
			{bN: questionsStatus, z: status});
	});
var $author$project$MainMsg$UpdatedUsersRole = function (a) {
	return {$: 219, a: a};
};
var $author$project$Api$Encoders$roleChangeInfoEncoder = function (roleChangeInfo) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'role_member_id',
				$elm$json$Json$Encode$string(roleChangeInfo.aQ)),
				_Utils_Tuple2(
				'new_role_id',
				$elm$json$Json$Encode$string(roleChangeInfo.ie)),
				_Utils_Tuple2(
				'user_id',
				$elm$json$Json$Encode$string(roleChangeInfo.cu))
			]));
};
var $author$project$Api$Request$updateUsersRoleInfo = F2(
	function (jwt, roleChangeInfo) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$roleChangeInfoEncoder(roleChangeInfo)),
				eg: $elm$http$Http$expectWhatever($author$project$MainMsg$UpdatedUsersRole),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'PUT',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + 'update_users_role'
			});
	});
var $author$project$Api$Encoders$videoNameEncoder = function (filename) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'filename',
				$elm$json$Json$Encode$string(filename))
			]));
};
var $author$project$Api$Request$updateVideoInfo = F3(
	function (jwt, filename, tempId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$videoNameEncoder(filename)),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotTempfile, $author$project$Api$Decoders$videoDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'PUT',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Nothing,
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('videos/' + (tempId + '/update'))
			});
	});
var $author$project$Main$optimisticPipeline = F3(
	function (roleMemberIds, newColumnId, pipeline) {
		var pipelineWithUsersRemoved = A2(
			$elm$core$List$map,
			function (column) {
				return _Utils_update(
					column,
					{
						jR: A2(
							$elm$core$List$filter,
							function (user) {
								return !A2($elm$core$List$member, user.aQ, roleMemberIds);
							},
							column.jR)
					});
			},
			pipeline);
		var affectedUsers = A2(
			$elm$core$List$concatMap,
			function (column) {
				return A2(
					$elm$core$List$filter,
					function (user) {
						return A2($elm$core$List$member, user.aQ, roleMemberIds);
					},
					column.jR);
			},
			pipeline);
		return A2(
			$elm$core$List$map,
			function (column) {
				return _Utils_eq(column.V, newColumnId) ? (($elm$core$List$length(affectedUsers) > 1) ? _Utils_update(
					column,
					{
						jR: $elm$core$List$reverse(
							A2($elm$core$List$append, affectedUsers, column.jR))
					}) : _Utils_update(
					column,
					{
						jR: A2($elm$core$List$append, affectedUsers, column.jR)
					})) : column;
			},
			pipelineWithUsersRemoved);
	});
var $author$project$Main$updateViewingProjectPipeline = F3(
	function (viewingProject, roleMemberIds, newColumnId) {
		return _Utils_update(
			viewingProject,
			{
				v: A3($author$project$Main$optimisticPipeline, roleMemberIds, newColumnId, viewingProject.v)
			});
	});
var $author$project$Main$updateViewingProjectRoles = F2(
	function (updatedRole, project) {
		return _Utils_update(
			project,
			{
				fq: A2(
					$elm$core$List$map,
					function (role) {
						return _Utils_eq(role.cU, updatedRole.cU) ? {gg: updatedRole.gg, cU: updatedRole.cU, bH: updatedRole.bH, iV: updatedRole.iV} : role;
					},
					project.fq)
			});
	});
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Api$Request$uploadImage = F3(
	function (image, jwt, userId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'image', image)
						])),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$Uploaded, $author$project$Api$Decoders$imageDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Just('upload'),
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (userId + '/upload_image'))
			});
	});
var $author$project$MainMsg$UploadedResume = function (a) {
	return {$: 128, a: a};
};
var $author$project$User$ResumeResponse = function (url) {
	return {jM: url};
};
var $author$project$Api$Decoders$resumeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$User$ResumeResponse));
var $author$project$Api$Request$uploadResume = F3(
	function (resume, jwt, userId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'resume', resume)
						])),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UploadedResume, $author$project$Api$Decoders$resumeDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Just('upload'),
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (userId + '/resume'))
			});
	});
var $author$project$MainMsg$UploadedVideo = function (a) {
	return {$: 122, a: a};
};
var $author$project$Api$Request$uploadVideo = F4(
	function (video, tempId, jwt, roleMemberId) {
		return $elm$http$Http$request(
			{
				dG: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'video', video)
						])),
				eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$UploadedVideo, $author$project$Api$Decoders$videoDecoder),
				eq: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				eK: 'POST',
				jE: $elm$core$Maybe$Nothing,
				jH: $elm$core$Maybe$Just('uploadVideo'),
				jM: $author$project$Api$BaseUrl$talentSourceUrl + ('users/' + (roleMemberId + ('/upload_video/' + tempId)))
			});
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Main$userNotScheduled = F3(
	function (schedules, roleMemberId, scheduleType) {
		var correctSchedules = A2(
			$elm$core$List$filter,
			A2(
				$author$project$Utils$eq,
				function ($) {
					return $.fy;
				},
				scheduleType),
			schedules);
		var allTimeSlots = A2(
			$elm$core$List$concatMap,
			function (schedule) {
				return schedule.jD;
			},
			correctSchedules);
		var foundUser = A2(
			$elm_community$list_extra$List$Extra$find,
			function (timeSlot) {
				return _Utils_eq(timeSlot.f_.aQ, roleMemberId);
			},
			allTimeSlots);
		if (!foundUser.$) {
			var user = foundUser.a;
			return false;
		} else {
			return true;
		}
	});
var $author$project$Pipeline$UserPositions = F2(
	function (roleMemberId, newColumnId) {
		return {ic: newColumnId, aQ: roleMemberId};
	});
var $author$project$Main$usersToMoveList = F2(
	function (selectedTalent, columnToMoveToId) {
		return A2(
			$elm$core$List$map,
			function (talent) {
				return A2($author$project$Pipeline$UserPositions, talent.aQ, columnToMoveToId);
			},
			selectedTalent);
	});
var $author$project$Views$FormValidation$invalidFields = function (project) {
	return (project.bH === '') || (project.iE === '');
};
var $author$project$Main$touchAllProjectFields = function (model) {
	var projectValidations = model.aP;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				c8: 'Please Complete the items marked in red',
				aP: _Utils_update(
					projectValidations,
					{bH: true, iE: true})
			}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$MainMsg$NewProject = function (a) {
	return {$: 46, a: a};
};
var $author$project$Api$Request$postNewProject = function (model) {
	return $elm$http$Http$request(
		{
			dG: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$projectEncoder(model)),
			eg: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewProject, $author$project$Api$Decoders$projectDecoder),
			eq: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hR)
				]),
			eK: 'POST',
			jE: $elm$core$Maybe$Nothing,
			jH: $elm$core$Maybe$Nothing,
			jM: $author$project$Api$BaseUrl$talentSourceUrl + 'projects'
		});
};
var $author$project$Main$updateOrCreateAction = F2(
	function (form, model) {
		switch (form) {
			case 0:
				return $author$project$Api$Request$postNewProject(model);
			case 1:
				return $author$project$Api$Request$updateExistingProject(model);
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Main$validateFormAndSubmitProject = function (model) {
	return $author$project$Views$FormValidation$invalidFields(model.ae) ? $author$project$Main$touchAllProjectFields(model) : _Utils_Tuple2(
		_Utils_update(
			model,
			{v: _List_Nil, aN: 2, c8: '', aP: $author$project$Project$resetProjectValidation}),
		A2($author$project$Main$updateOrCreateAction, model.aj, model));
};
var $author$project$Main$validateWeight = function (model) {
	return ((100 < model.z.jX) && (model.z.jX < 500)) ? true : false;
};
var $author$project$Main$handleError = function (model) {
	return A3(
		$ccapndave$elm_update_extra$Update$Extra$andThen,
		$author$project$Main$update,
		$author$project$MainMsg$Logout,
		_Utils_Tuple2(
			_Utils_update(
				model,
				{
					a: $author$project$Model$Showing('Your Session has ended, Please login again!')
				}),
			$author$project$Main$dismissAlert));
};
var $author$project$Main$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 15:
					var url = msg.a;
					var _v3 = $author$project$Route$fromUrl(url);
					switch (_v3.$) {
						case 13:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										i: $author$project$Route$fromUrl(url),
										r: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									A2($author$project$Main$fetchDataForPage, $author$project$Route$Dashboard, model)));
						case 10:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										i: $author$project$Route$fromUrl(url),
										H: 0,
										w: _List_Nil,
										r: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3(
											$author$project$Main$redirectAway,
											model.z.P,
											model,
											$author$project$Route$fromUrl(url)),
											A2($author$project$Main$fetchConversations, model.z.u, model.j)
										])));
						case 2:
							var email = _v3.a;
							return A2(
								$author$project$Main$updateUser,
								$author$project$User$UserEmail(email),
								model);
						case 3:
							var email = _v3.a;
							return A2(
								$author$project$Main$updateUser,
								$author$project$User$UserEmail(email),
								model);
						case 28:
							var roleId = _v3.a;
							return A4(
								$author$project$Main$updateWith,
								$author$project$Model$AgencyTalentScheduleRouteData,
								$author$project$MainMsg$GotAgencyTalentScheduleMsg,
								model,
								A2($author$project$Pages$AgencyTalentSchedule$init, model.hR, roleId));
						case 21:
							var i = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										d_: i,
										i: $author$project$Route$fromUrl(url),
										ae: A2($author$project$Utils$findProject, model.A, i),
										Y: i,
										H: 0,
										w: _List_Nil,
										r: 'Slayt',
										h: A2($author$project$Utils$findProject, model.A, i)
									}),
								$elm$core$Platform$Cmd$batch(
									_Utils_ap(
										_List_fromArray(
											[
												A3(
												$author$project$Main$redirectAway,
												model.z.P,
												model,
												$author$project$Route$fromUrl(url))
											]),
										A2(
											$author$project$Main$fetchDataForPage,
											$author$project$Route$Project(i),
											model))));
						case 7:
							var projectId = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										d_: projectId,
										i: $author$project$Route$fromUrl(url),
										ae: A2($author$project$Utils$findProject, model.A, projectId),
										Y: projectId,
										H: 0,
										w: _List_Nil,
										r: 'Slayt',
										h: A2($author$project$Utils$findProject, model.A, projectId)
									}),
								$elm$core$Platform$Cmd$batch(
									A2(
										$author$project$Main$fetchDataForPage,
										$author$project$Route$Job(projectId),
										model)));
						case 8:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										i: $author$project$Route$fromUrl(url),
										H: 0,
										w: _List_Nil,
										r: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									A2($author$project$Main$fetchDataForPage, $author$project$Route$JobIndex, model)));
						case 20:
							return A3(
								$ccapndave$elm_update_extra$Update$Extra$andThen,
								$author$project$Main$update,
								$author$project$MainMsg$UpdateSearchingRole(model.br),
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											i: $author$project$Route$fromUrl(url),
											H: 0,
											w: _List_Nil,
											m: $author$project$InitData$initTalentFilterValues,
											r: 'Slayt'
										}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A3(
												$author$project$Main$redirectAway,
												model.z.P,
												model,
												$author$project$Route$fromUrl(url)),
												$author$project$Main$fetchAllProjects(model.hR),
												$author$project$Main$fetchRoleData(model.hR),
												A2($author$project$Api$Request$getJobPageData, model.hR, '')
											]))));
						case 23:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{d_: '', bQ: $author$project$SharedProjectRoleSchedules$initialSchedulePageData, H: 0, w: _List_Nil}),
								$elm$core$Platform$Cmd$batch(
									_Utils_ap(
										_List_fromArray(
											[
												A3(
												$author$project$Main$redirectAway,
												model.z.P,
												model,
												$author$project$Route$fromUrl(url))
											]),
										A2($author$project$Main$fetchDataForPage, $author$project$Route$ScheduleIndex, model))));
						case 24:
							var projectId = _v3.a;
							var scheduleType = _v3.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										bQ: A2(
											$author$project$Main$updateSchedulePageData,
											model,
											$author$project$Schedule$SchedulePageViewUpdate(
												A2($author$project$SharedProjectRoleSchedules$LoadingScheduleData, projectId, scheduleType)))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3(
											$author$project$Main$redirectAway,
											model.z.P,
											model,
											$author$project$Route$fromUrl(url)),
											A2($author$project$Api$Request$getProjectData, model.hR, projectId),
											A2($author$project$Api$Request$getSchedules, projectId, model.hR)
										])));
						case 25:
							var projectId = _v3.a;
							var scheduleId = _v3.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										d_: projectId,
										bQ: A2(
											$author$project$Main$updateSchedulePageData,
											model,
											$author$project$Schedule$SchedulePageViewUpdate(
												A2($author$project$SharedProjectRoleSchedules$ScheduleDayOfPage, projectId, scheduleId)))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Api$Request$getProjectData, model.hR, projectId),
											A2($author$project$Api$Request$getSchedules, projectId, model.hR),
											A2($author$project$Api$Request$getCollaboratorsOnProject, projectId, model.hR)
										])));
						case 9:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										i: $author$project$Route$fromUrl(url),
										r: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchRoleData(model.hR),
											$author$project$Main$fetchUsersJobs(model.hR),
											A2($author$project$Main$fetchConversations, model.z.u, model.j)
										])));
						case 26:
							var secretKey = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										i: $author$project$Route$fromUrl(url),
										r: 'Slayt',
										aT: A2($author$project$Main$updateSecretString, model.aT, secretKey)
									}),
								A2($author$project$Api$Request$getCollaboratorInfo, model.hR, secretKey));
						case 27:
							var secretKey = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										i: $author$project$Route$fromUrl(url),
										r: 'Slayt',
										aT: A2($author$project$Main$updateSecretString, model.aT, secretKey)
									}),
								A2($author$project$Api$Request$getAgentInfo, model.hR, secretKey));
						case 19:
							var s = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										i: $author$project$Route$fromUrl(url),
										as: $author$project$User$initialProfileValidations,
										H: 0,
										w: _List_Nil,
										r: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Api$Request$getAgencies(model.hR),
											$author$project$Api$Request$getOptions(model.hR)
										])));
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										i: $author$project$Route$fromUrl(url),
										as: $author$project$User$initialProfileValidations,
										H: 0,
										w: _List_Nil,
										r: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Main$fetchConversations, model.z.u, model.j)
										])));
					}
				case 16:
					var urlRequest = msg.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									i: $author$project$Route$fromUrl(url),
									H: 0,
									w: _List_Nil,
									r: 'Slayt'
								}),
							A2($elm$browser$Browser$Navigation$pushUrl, model.eB, url.iu));
					} else {
						var href = urlRequest.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{r: href}),
							$elm$core$Platform$Cmd$none);
					}
				case 21:
					var route = msg.a;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$RedirectRoute(route),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{i: route, bn: false, aF: false, Q: $author$project$User$initialTalentMenuOptions}),
							$elm$core$Platform$Cmd$none));
				case 22:
					var route = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								i: $author$project$Route$ProfileSubPage(route),
								e6: false
							}),
						A2(
							$author$project$Main$goTo,
							model,
							$author$project$Route$ProfileSubPage(route)));
				case 23:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bn: !model.bn}),
						$elm$core$Platform$Cmd$none);
				case 24:
					var form = msg.a;
					var _v5 = function () {
						switch (form) {
							case 0:
								return _Utils_Tuple2(0, 1);
							case 1:
								return _Utils_Tuple2(0, 1);
							case 2:
								return _Utils_Tuple2(1, 0);
							case 3:
								return _Utils_Tuple2(1, 0);
							default:
								return _Utils_Tuple2(1, 1);
						}
					}();
					var projectFormStatus = _v5.a;
					var roleFormStatus = _v5.b;
					var _v7 = function () {
						switch (form) {
							case 2:
								var _v9 = model.ea;
								if (!_v9.b) {
									return _Utils_Tuple2(
										$author$project$Api$Request$getOptions(model.hR),
										$author$project$MainMsg$NoOp);
								} else {
									return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$MainMsg$NoOp);
								}
							case 3:
								var _v10 = model.ea;
								if (!_v10.b) {
									return _Utils_Tuple2(
										$author$project$Api$Request$getOptions(model.hR),
										$author$project$MainMsg$NoOp);
								} else {
									return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$MainMsg$NoOp);
								}
							case 4:
								return _Utils_Tuple2(
									$elm$core$Platform$Cmd$none,
									$author$project$MainMsg$UpdateCurrentProjectId(model.h.cU));
							default:
								return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$MainMsg$NoOp);
						}
					}();
					var action = _v7.a;
					var closedModalAction = _v7.b;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						closedModalAction,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{aj: form, ae: $author$project$SharedProjectRoleSchedules$emptyProject, aN: projectFormStatus, c8: '', aP: $author$project$Project$resetProjectValidation, P: $author$project$SharedProjectRoleSchedules$emptyRole, ah: roleFormStatus, T: $author$project$Role$resetRoleValidations}),
							action));
				case 25:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fW: !model.fW}),
						$elm$core$Platform$Cmd$none);
				case 26:
					var user = msg.a;
					var applicant = msg.b;
					var columnId = msg.c;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$UpdateVotingComment(''),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									cB: applicant,
									cC: false,
									bh: A2(
										$elm$core$Maybe$withDefault,
										$author$project$Data$Image$emptyImage,
										$elm$core$List$head(user.hE)),
									cK: A2(
										$elm$core$Maybe$withDefault,
										$author$project$Data$Video$emptyVideo,
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (video) {
													return video.f5;
												},
												user.jT))),
									ca: 0,
									iB: columnId,
									aD: 3,
									aH: !model.aH,
									p: user
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Main$fetchConversations, model.z.u, model.j)
									]))));
				case 285:
					var action = function () {
						var _v11 = model.aD;
						switch (_v11) {
							case 4:
								return 5;
							case 5:
								return 4;
							default:
								return 3;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aD: action}),
						$elm$core$Platform$Cmd$none);
				case 240:
					var time = msg.a;
					var _v12 = model.L;
					if (_v12 === 2) {
						return _Utils_Tuple2(
							model,
							A2(
								$author$project$Api$Request$getNotifications,
								model.hR,
								$elm$core$String$fromInt(
									$elm$core$List$length(model.z.bJ))));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 4:
					var aMsg = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 241:
					var res = msg.a;
					if (!res.$) {
						var notifications = res.a;
						var latestNotification = A2(
							$elm$core$Maybe$withDefault,
							$author$project$User$emptyUserNotification,
							$elm$core$List$head(notifications));
						var newNotification = !_Utils_eq(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$User$emptyUserNotification,
								$elm$core$List$head(model.z.bJ)).V,
							latestNotification.V);
						var action = (A2(
							$elm$core$List$member,
							latestNotification.hT,
							_List_fromArray(
								[0, 3, 4, 18, 19, 6, 7, 12, 13, 14, 8])) && newNotification) ? A2($author$project$Api$Request$getProjectData, model.hR, latestNotification.iH) : ((A2(
							$elm$core$List$member,
							latestNotification.hT,
							_List_fromArray(
								[2, 22, 15, 9, 11, 5, 16, 21, 10, 17])) && newNotification) ? $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$fetchUsersJobs(model.hR),
									$author$project$Main$fetchRoleData(model.hR)
								])) : ((A2(
							$elm$core$List$member,
							latestNotification.hT,
							_List_fromArray(
								[20])) && newNotification) ? $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$fetchUsersJobs(model.hR),
									A2($author$project$Main$fetchConversations, model.z.u, model.j)
								])) : $elm$core$Platform$Cmd$none));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									z: A2($author$project$Main$updateNotificationsForUser, model.z, notifications)
								}),
							action);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 220:
					var img = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bh: img}),
						$elm$core$Platform$Cmd$none);
				case 83:
					var deleteID = msg.a;
					var name = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{al: $author$project$Utils$DeleteProject, am: deleteID, d1: name, Z: !model.Z}),
						$elm$core$Platform$Cmd$none);
				case 97:
					var projectId = msg.a;
					var confirmation = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								al: confirmation,
								bj: false,
								ae: A2(
									$elm$core$Maybe$withDefault,
									$author$project$SharedProjectRoleSchedules$emptyProject,
									A2($author$project$Main$filterProject, projectId, model.A)),
								P: A2($author$project$Views$Messages$findRole, model.aw, projectId),
								aF: !model.aF
							}),
						$elm$core$Platform$Cmd$none);
				case 29:
					var id = msg.a;
					var talent = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: ($elm$core$List$length(
									A2($author$project$Main$addOrRemoveSelectedTalent, talent, model.w)) >= 1) ? 1 : 0,
								w: A2($author$project$Main$addOrRemoveSelectedTalent, talent, model.w),
								aH: false,
								a8: $author$project$MainMsg$Successs(
									A2($author$project$Main$toggleSelectedTalent, model.a8, id))
							}),
						$elm$core$Platform$Cmd$none);
				case 27:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dx: {iW: model.g3, jj: 0, jN: model.g5},
								l: !model.l
							}),
						$elm$core$Platform$Cmd$none);
				case 28:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l: !model.l}),
						$elm$core$Platform$Cmd$none);
				case 221:
					var userJob = msg.a;
					var state = msg.b;
					var conversationId = msg.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l: !model.l,
								cT: false,
								bI: {
									dG: '',
									gY: conversationId,
									hT: state,
									aQ: userJob.aQ,
									cu: A2($author$project$Utils$findProject, model.A, userJob.P.iH).jN
								}
							}),
						$elm$core$Platform$Cmd$none);
				case 222:
					var roleMemberId = msg.a;
					var userId = msg.b;
					var state = msg.c;
					var conversationId = msg.d;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l: !model.l,
								cT: false,
								bI: {dG: '', gY: conversationId, hT: state, aQ: roleMemberId, cu: userId}
							}),
						$elm$core$Platform$Cmd$none);
				case 81:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a: $author$project$Model$Hiding}),
						$elm$core$Platform$Cmd$none);
				case 2:
					var rMsg = msg.a;
					return A2($author$project$Main$updateUser, rMsg, model);
				case 6:
					var rMsg = msg.a;
					return A2($author$project$Main$updateCompanyProfile, rMsg, model);
				case 7:
					var rMsg = msg.a;
					return A2($author$project$Main$updateBillingAddress, rMsg, model);
				case 8:
					var rMsg = msg.a;
					return A2($author$project$Main$updatePhysicalAddress, rMsg, model);
				case 1:
					var pMsg = msg.a;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$UpdateProfileHeightValue,
						A2($author$project$Main$updateProfile, pMsg, model));
				case 223:
					var nMsg = msg.a;
					return A2($author$project$Main$updateNotification, nMsg, model);
				case 82:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: $author$project$Main$updateProfileHeightValue(model)
							}),
						$elm$core$Platform$Cmd$none);
				case 9:
					var pMsg = msg.a;
					return A2($author$project$Main$updatePassword, pMsg, model);
				case 10:
					var pMsg = msg.a;
					return A2($author$project$Main$updateMessage, pMsg, model);
				case 11:
					var pMsg = msg.a;
					return A2($author$project$Main$updateProject, pMsg, model);
				case 12:
					var pMsg = msg.a;
					return A2($author$project$Main$updateProjectValidation, pMsg, model);
				case 293:
					var time = msg.a;
					var roleMemberId = msg.b;
					return (roleMemberId !== '') ? _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$refreshTalentData, roleMemberId, model.hR)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 13:
					var rMsg = msg.a;
					return A2($author$project$Main$createRole, rMsg, model);
				case 14:
					var rMsg = msg.a;
					return A2($author$project$Main$updateRoleValidation, rMsg, model);
				case 30:
					var email = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bl: email}),
						$elm$core$Platform$Cmd$none);
				case 31:
					var password = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eW: password}),
						$elm$core$Platform$Cmd$none);
				case 17:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: A3($author$project$Main$updateUserProfileStatus, model.c, $author$project$MainMsg$Loadings, $author$project$MainMsg$Loadings),
								R: $author$project$MainMsg$Loadings
							}),
						$author$project$Main$fireBaseLogin(
							_Utils_Tuple2(model.bl, model.eW)));
				case 79:
					var err = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: $author$project$Model$Showing(err),
								L: 0
							}),
						$author$project$Main$dismissAlert);
				case 39:
					var err = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: $author$project$Model$Showing(err),
								L: 0
							}),
						$author$project$Main$dismissAlert);
				case 292:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cC: !model.cC}),
						$elm$core$Platform$Cmd$none);
				case 98:
					var result = msg.a;
					if (!result.$) {
						var conversations = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dv: conversations}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = result.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 76:
					var jwt = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{L: 1, ht: jwt, hR: jwt}),
						$author$project$Api$Request$getCurrentUser(jwt));
				case 136:
					var page = msg.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Main$goTo, model, page));
				case 18:
					if (!msg.a.$) {
						var user = msg.a.a;
						var page = function () {
							var _v15 = user.P;
							switch (_v15) {
								case 1:
									return $author$project$Route$Dashboard;
								case 0:
									return $author$project$Route$Dashboard;
								case 2:
									return $author$project$Route$Dashboard;
								case 3:
									return $author$project$Route$Dashboard;
								case 4:
									return $author$project$Route$Dashboard;
								default:
									return $author$project$Route$Login;
							}
						}();
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectRoute(page),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										L: 2,
										ax: user.f$,
										bz: user.bz,
										g5: user.cU,
										W: $author$project$Main$imageUploadStatus(
											$elm$core$List$length(user.hE)),
										hE: user.hE,
										aB: user.f0,
										c: A3(
											$author$project$Main$updateUserProfileStatus,
											model.c,
											$author$project$MainMsg$Successs(user),
											$author$project$MainMsg$Loadings),
										aT: A2($author$project$Main$setUserType, model, 0),
										z: user,
										R: $author$project$MainMsg$Successs(user),
										f1: user.P
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchAllProjects(model.hR),
											A2($author$project$Main$fetchConversations, model.z.u, model.j),
											$author$project$Main$fetchRoleData(model.hR),
											$author$project$Main$twilio(
											{
												t: '',
												X: $author$project$Api$Encoders$twilioPayloadEncoder($author$project$Message$emptyToTwilioPayload),
												aa: user.u
											})
										]))));
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									L: 0,
									hW: true,
									c: A3(
										$author$project$Main$updateUserProfileStatus,
										model.c,
										$author$project$MainMsg$Failed(err),
										$author$project$MainMsg$Loadings),
									R: $author$project$MainMsg$Failed(err)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 132:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						var category = A2($author$project$Main$categoryFromIndex, model.c.dZ, user);
						var _v17 = function () {
							var _v18 = model.i;
							switch (_v18.$) {
								case 13:
									return _Utils_Tuple2($author$project$Route$Dashboard, model.g5);
								case 12:
									var string = _v18.a;
									return _Utils_Tuple2(
										$author$project$Route$Role(string),
										string);
								case 21:
									var string = _v18.a;
									return _Utils_Tuple2(
										$author$project$Route$Project(string),
										string);
								case 10:
									return _Utils_Tuple2($author$project$Route$Inbox, model.g5);
								case 22:
									var i = _v18.a;
									var code = _v18.b;
									return _Utils_Tuple2(
										A2($author$project$Route$AccountVerification, i, code),
										'');
								case 9:
									return _Utils_Tuple2($author$project$Route$MyJobs, model.g5);
								case 23:
									return _Utils_Tuple2($author$project$Route$ScheduleIndex, model.g5);
								case 24:
									var i = _v18.a;
									var scheduleType = _v18.b;
									return _Utils_Tuple2(
										A2($author$project$Route$SchedulePage, i, scheduleType),
										i);
								case 25:
									var projectId = _v18.a;
									var scheduleId = _v18.b;
									return _Utils_Tuple2(
										A2($author$project$Route$DayOfPage, projectId, scheduleId),
										scheduleId);
								case 26:
									var secretKey = _v18.a;
									return _Utils_Tuple2(
										$author$project$Route$CollaboratorsSignupPage(secretKey),
										'');
								case 27:
									var secretKey = _v18.a;
									return _Utils_Tuple2(
										$author$project$Route$AgentsSignupPage(secretKey),
										'');
								case 28:
									var roleId = _v18.a;
									return _Utils_Tuple2(
										$author$project$Route$AgencyTalentSchedulePage(roleId),
										'');
								case 7:
									var projectId = _v18.a;
									return _Utils_Tuple2(
										$author$project$Route$Job(projectId),
										'');
								case 6:
									return _Utils_Tuple2($author$project$Route$Account, category.V);
								default:
									return _Utils_Tuple2($author$project$Route$Dashboard, '');
							}
						}();
						var page = _v17.a;
						var id = _v17.b;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$SetToLoggedIn,
							A3(
								$ccapndave$elm_update_extra$Update$Extra$andThen,
								$author$project$Main$update,
								$author$project$MainMsg$RedirectRoute(page),
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											L: 1,
											ax: user.f$,
											bz: user.bz,
											d_: id,
											g3: id,
											g5: user.cU,
											W: $author$project$Main$imageUploadStatus(
												$elm$core$List$length(user.hE)),
											hE: user.hE,
											aB: user.f0,
											c: A3(
												$author$project$Main$updateUserProfileStatus,
												model.c,
												$author$project$MainMsg$Successs(user),
												$author$project$MainMsg$Loadings),
											bQ: $author$project$SharedProjectRoleSchedules$initialSchedulePageData,
											aT: A2($author$project$Main$setUserType, model, 0),
											z: user,
											R: $author$project$MainMsg$Successs(user),
											f1: user.P
										}),
									$author$project$Main$twilio(
										{
											t: '',
											X: $author$project$Api$Encoders$twilioPayloadEncoder($author$project$Message$emptyToTwilioPayload),
											aa: user.u
										}))));
					} else {
						var err = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$Logout,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('User Authentication Failed!')
									}),
								$elm$core$Platform$Cmd$none));
					}
				case 137:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{L: 2}),
						$elm$core$Platform$Cmd$none);
				case 265:
					var agentId = msg.a;
					var agencyId = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$addAgentToUser, agentId, agencyId, model.hR));
				case 263:
					var res = msg.a;
					if (!res.$) {
						var userProfile = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Successfully sent verification email to agent!'),
									z: userProfile
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 19:
					return (!_Utils_eq(model.aT.eW, model.aT.eX)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: $author$project$Model$Showing('Passwords do not match!')
							}),
						$author$project$Main$dismissAlert) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: A3($author$project$Main$updateUserProfileStatus, model.c, $author$project$MainMsg$Loadings, $author$project$MainMsg$Loadings),
								aT: A2(
									$author$project$Main$setUserType,
									model,
									$author$project$Main$setUserRegistrationType(model)),
								R: $author$project$MainMsg$Loadings
							}),
						$author$project$Main$fireBaseSignUp(
							_Utils_Tuple2(model.aT.bl, model.aT.eW)));
				case 106:
					var nMsg = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: A2($author$project$Main$updateNotificationSettings, nMsg, model.z)
							}),
						$elm$core$Platform$Cmd$none);
				case 77:
					var jwt = msg.a;
					var command = function () {
						var _v20 = model.aT.P;
						switch (_v20) {
							case 1:
								return $author$project$Api$Request$postNewCompany;
							case 3:
								return $author$project$Api$Request$postNewAgency;
							default:
								return $author$project$Api$Request$postNewUser;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{L: 1, ht: jwt, hR: jwt, aG: ''}),
						command(
							_Utils_update(
								model,
								{hR: jwt})));
				case 78:
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$postNewUser(model));
				case 80:
					var jwt = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								L: $author$project$Main$evaluateAuthStatus(jwt),
								ht: jwt,
								hR: jwt,
								c: A3($author$project$Main$updateUserProfileStatus, model.c, $author$project$MainMsg$Loadings, $author$project$MainMsg$Loadings),
								R: $author$project$MainMsg$Loadings
							}),
						$elm$core$Platform$Cmd$batch(
							A2($author$project$Main$redirectToLoginOrRefresh, jwt, model)));
				case 32:
					return _Utils_Tuple2(
						$author$project$Main$resetModel(model),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$removeUserToken(''),
									A2($author$project$Main$goTo, model, $author$project$Route$Login)
								])));
				case 35:
					var result = msg.a;
					if (!result.$) {
						var company = result.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$CreateUser,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{bz: company}),
								$elm$core$Platform$Cmd$none));
					} else {
						var err = result.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 36:
					var result = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 34:
					if (!msg.a.$) {
						var user = msg.a.a;
						var modalStatus = function () {
							var _v24 = $author$project$Main$setUserRegistrationType(model);
							if (_v24 === 1) {
								return true;
							} else {
								return false;
							}
						}();
						var currentRoute = function () {
							var _v23 = $author$project$Main$setUserRegistrationType(model);
							switch (_v23) {
								case 1:
									return $author$project$Route$DirectorRegistration;
								case 2:
									return $author$project$Route$Dashboard;
								case 3:
									return $author$project$Route$AgencyProfile;
								case 4:
									return $author$project$Route$Dashboard;
								default:
									return $author$project$Route$TalentProfile;
							}
						}();
						var cmd = function () {
							var _v22 = $author$project$Main$setUserRegistrationType(model);
							switch (_v22) {
								case 1:
									return _List_fromArray(
										[
											A2($author$project$Main$goTo, model, $author$project$Route$Dashboard)
										]);
								case 2:
									return _List_fromArray(
										[
											A2($author$project$Main$goTo, model, $author$project$Route$Dashboard)
										]);
								case 3:
									return _List_fromArray(
										[
											A2($author$project$Main$goTo, model, $author$project$Route$AgencyProfile)
										]);
								case 4:
									return _List_fromArray(
										[
											A2($author$project$Main$goTo, model, $author$project$Route$Dashboard)
										]);
								default:
									return _List_fromArray(
										[
											A2(
											$author$project$Main$goTo,
											model,
											$author$project$Route$ProfileSubPage(0))
										]);
							}
						}();
						var categoryId = A2(
							$elm$core$Maybe$withDefault,
							$author$project$User$emptyProfilePage,
							$elm$core$List$head(user.ck));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									L: 2,
									l: modalStatus,
									i: currentRoute,
									g5: user.cU,
									c: A3(
										$author$project$Main$updateUserProfileStatus,
										model.c,
										$author$project$MainMsg$Successs(user),
										$author$project$MainMsg$Loadings),
									z: user,
									R: $author$project$MainMsg$Successs(user)
								}),
							$elm$core$Platform$Cmd$batch(cmd));
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: A3(
										$author$project$Main$updateUserProfileStatus,
										model.c,
										$author$project$MainMsg$Failed(err),
										$author$project$MainMsg$Loadings),
									R: $author$project$MainMsg$Failed(err)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 20:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l: false, i: $author$project$Route$Login}),
						A2($author$project$Main$goTo, model, $author$project$Route$Login));
				case 37:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: A3(
										$author$project$Main$updateUserProfileStatus,
										model.c,
										$author$project$MainMsg$Successs(user),
										$author$project$MainMsg$Loadings),
									z: user,
									R: $author$project$MainMsg$Successs(user)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: A3(
										$author$project$Main$updateUserProfileStatus,
										model.c,
										$author$project$MainMsg$Failed(err),
										$author$project$MainMsg$Loadings),
									R: $author$project$MainMsg$Failed(err)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 41:
					var _v26 = (!model.z.P) ? A2($author$project$Main$validateProfileFields, model.z, model) : _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Api$Request$updateUserProfile(model),
									$author$project$Api$Request$updateCompany(model)
								])));
					var updatedModel = _v26.a;
					var action = _v26.b;
					return _Utils_Tuple2(updatedModel, action);
				case 38:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Your profile was updated successfully!'),
									e6: !$author$project$Main$validateWeight(model),
									c: A3(
										$author$project$Main$updateUserProfileStatus,
										model.c,
										$author$project$MainMsg$Successs(user),
										$author$project$MainMsg$Loadings),
									z: user,
									R: $author$project$MainMsg$Successs(user)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Main$goTo, model, $author$project$Route$Dashboard),
										$author$project$Main$fetchRoleData(model.hR),
										$author$project$Main$dismissAlert
									])));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error updating your profile')
								}),
							$author$project$Main$dismissAlert);
					}
				case 44:
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$updateUserPassword(model));
				case 43:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('The password was updated successfully')
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Main$goTo, model, $author$project$Route$Dashboard),
										$author$project$Main$dismissAlert
									])));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error updating the password')
								}),
							$author$project$Main$dismissAlert);
					}
				case 45:
					var res = msg.a;
					if (!res.$) {
						var projects = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{A: projects}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = res.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 47:
					return $author$project$Main$validateFormAndSubmitProject(model);
				case 46:
					var res = msg.a;
					if (!res.$) {
						var project = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing(project.bH + ' was successfully created'),
									d_: project.cU,
									aj: 2,
									aN: 1,
									ah: 0,
									h: project
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Api$Request$getOptions(model.hR),
										$author$project$Main$dismissAlert
									])));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error creating the project'),
									aN: 0
								}),
							$author$project$Main$dismissAlert);
					}
				case 49:
					return $author$project$Main$validateFormAndSubmitProject(model);
				case 156:
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$updateExistingProject(model));
				case 96:
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$PublishProject,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									bj: false,
									ae: $author$project$Main$togglePublishProject(model.ae),
									cl: true,
									aF: false
								}),
							$elm$core$Platform$Cmd$none));
				case 244:
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$PublishRole,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									cl: true,
									P: $author$project$Main$togglePublishRole(model.P),
									aF: false
								}),
							$elm$core$Platform$Cmd$none));
				case 245:
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$updateExistingRole(model));
				case 48:
					var res = msg.a;
					if (!res.$) {
						var project = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectRoute(
								$author$project$Route$Project(project.cU)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing(project.bH + ' was successfully updated!'),
										aj: 4,
										aN: 1,
										cl: false
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchAllProjects(model.hR),
											$author$project$Main$dismissAlert
										]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error updating the project'),
									aN: 0
								}),
							$author$project$Main$dismissAlert);
					}
				case 51:
					var project = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{t: 'archiveConversationsByProject'}),
						model,
						project,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 50:
					var res = msg.a;
					if (!res.$) {
						var project = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectRoute(
								$author$project$Route$Project(
									$author$project$Views$Project$firstProject(model.A).cU)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('Project was successfully deleted')
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchAllProjects(model.hR),
											$author$project$Main$dismissAlert
										]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error deleting the project')
								}),
							$author$project$Main$dismissAlert);
					}
				case 294:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						return _Utils_eq(model.p.cU, user.cU) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{p: user}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 53:
					var projectId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d_: projectId}),
						$elm$core$Platform$Cmd$none);
				case 54:
					var roleId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{g3: roleId}),
						A2(
							$author$project$Main$goTo,
							model,
							$author$project$Route$Role(roleId)));
				case 55:
					var projectId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{g3: projectId, Y: projectId}),
						A2(
							$author$project$Main$goTo,
							model,
							$author$project$Route$Job(projectId)));
				case 57:
					var roleId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l: false,
								g3: roleId,
								ap: A2($author$project$Main$toggleMultiModal, roleId, model.ap),
								bM: !model.bM
							}),
						$elm$core$Platform$Cmd$none);
				case 56:
					var roleId = msg.a;
					var projectId = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dx: {iW: roleId, jj: 0, jN: model.g5},
								l: !model.l,
								d_: projectId,
								Y: projectId
							}),
						$elm$core$Platform$Cmd$none);
				case 52:
					var res = msg.a;
					if (!res.$) {
						var roles = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aw: roles}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = res.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 60:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ah: 2}),
						$author$project$Api$Request$postNewRole(model));
				case 152:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aj: 4, P: $author$project$SharedProjectRoleSchedules$emptyRole, ah: 2, T: $author$project$Role$resetRoleValidations}),
						$author$project$Api$Request$postRoleResetForm(model));
				case 58:
					var res = msg.a;
					if (!res.$) {
						var role = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$ToggleFormOpen(4),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing(role.bH + ' was created successfully'),
										l: false,
										g3: role.cU,
										aj: 4,
										ah: 1
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchRoleData(model.hR),
											A2($author$project$Api$Request$getProjectData, model.hR, model.h.cU),
											$author$project$Main$dismissAlert
										]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error creating the role'),
									ah: 0
								}),
							$author$project$Main$dismissAlert);
					}
				case 59:
					var res = msg.a;
					if (!res.$) {
						var role = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing(role.bH + ' was created successfully'),
									aj: 2,
									ah: 0
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Main$fetchRoleData(model.hR),
										$author$project$Main$dismissAlert
									])));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error creating the role'),
									aN: 0
								}),
							$author$project$Main$dismissAlert);
					}
				case 62:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ah: 2}),
						$author$project$Api$Request$updateExistingRole(model));
				case 61:
					var res = msg.a;
					if (!res.$) {
						var role = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$UpdateProjectMenuState(
								$author$project$Project$ToggleRoleMenu($elm$core$Maybe$Nothing)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('Successfully updated ' + (role.bH + ' role')),
										aw: A2($author$project$Main$updateAllRoles, role, model.aw),
										al: $author$project$Utils$HiddenConf,
										aj: 4,
										cl: false,
										ah: 1,
										h: A2($author$project$Main$updateViewingProjectRoles, role, model.h)
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$dismissAlert,
											$author$project$Main$fetchAllProjects(model.hR)
										]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error updating the role'),
									ah: 0
								}),
							$author$project$Main$dismissAlert);
					}
				case 64:
					var role = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{t: 'archiveConversationsByRole'}),
						model,
						role,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 63:
					var res = msg.a;
					if (!res.$) {
						var role = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectRoute(
								$author$project$Route$Project(model.d_)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('Role Deleted!'),
										al: $author$project$Utils$HiddenConf
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchRoleData(model.hR),
											$author$project$Main$dismissAlert
										]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Error Deleting Role')
								}),
							$author$project$Main$dismissAlert);
					}
				case 68:
					var val = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{i5: val}),
						$elm$core$Platform$Cmd$none);
				case 69:
					var projectId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								d_: projectId,
								bj: false,
								aj: 1,
								ae: A2($author$project$Utils$findProject, model.A, projectId),
								aN: 0,
								ah: 1,
								h: A2($author$project$Utils$findProject, model.A, projectId)
							}),
						$elm$core$Platform$Cmd$none);
				case 70:
					var roleId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g3: roleId,
								aj: 2,
								P: A2(
									$elm$core$Maybe$withDefault,
									$author$project$SharedProjectRoleSchedules$emptyRole,
									A2($author$project$Main$filterRole, roleId, model.aw)),
								ah: 0
							}),
						$author$project$Api$Request$getOptions(model.hR));
				case 71:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b4: model.b4 + 1}),
						$elm$core$Platform$Cmd$none);
				case 72:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b4: model.b4 - 1}),
						$elm$core$Platform$Cmd$none);
				case 75:
					var time = msg.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							A2($author$project$Main$fetchDataForPage, model.i, model)));
				case 74:
					var tMsg = msg.a;
					return A2($author$project$Main$toggleFilters, tMsg, model);
				case 73:
					var fMsg = msg.a;
					return A2($author$project$Main$updateTalentFilterValues, fMsg, model);
				case 84:
					var subMsg = msg.a;
					var _v39 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.B.fR);
					var newDatePicker = _v39.a;
					var dateEvent = _v39.b;
					var _v40 = $author$project$Main$createDates(dateEvent);
					var newDate = _v40.a;
					var formattedDate = _v40.b;
					return A5($author$project$Main$updateDatesInModel, model, 0, newDate, formattedDate, newDatePicker);
				case 85:
					var subMsg = msg.a;
					var _v41 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.B.dD);
					var newDatePicker = _v41.a;
					var dateEvent = _v41.b;
					var _v42 = $author$project$Main$createDates(dateEvent);
					var newDate = _v42.a;
					var formattedDate = _v42.b;
					return A5($author$project$Main$updateDatesInModel, model, 1, newDate, formattedDate, newDatePicker);
				case 86:
					var subMsg = msg.a;
					var _v43 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.B.dC);
					var newDatePicker = _v43.a;
					var dateEvent = _v43.b;
					var _v44 = $author$project$Main$createDates(dateEvent);
					var newDate = _v44.a;
					var formattedDate = _v44.b;
					return A5($author$project$Main$updateDatesInModel, model, 2, newDate, formattedDate, newDatePicker);
				case 87:
					var subMsg = msg.a;
					var _v45 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.B.fd);
					var newDatePicker = _v45.a;
					var dateEvent = _v45.b;
					var _v46 = $author$project$Main$createDates(dateEvent);
					var newDate = _v46.a;
					var formattedDate = _v46.b;
					return A5($author$project$Main$updateDatesInModel, model, 3, newDate, formattedDate, newDatePicker);
				case 88:
					var subMsg = msg.a;
					var _v47 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.B.dJ);
					var newDatePicker = _v47.a;
					var dateEvent = _v47.b;
					var _v48 = $author$project$Main$createDates(dateEvent);
					var newDate = _v48.a;
					var formattedDate = _v48.b;
					return A5($author$project$Main$updateDatesInModel, model, 4, newDate, formattedDate, newDatePicker);
				case 89:
					var subMsg = msg.a;
					var _v49 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.B.dI);
					var newDatePicker = _v49.a;
					var dateEvent = _v49.b;
					var _v50 = $author$project$Main$createDates(dateEvent);
					var newDate = _v50.a;
					var formattedDate = _v50.b;
					return A5($author$project$Main$updateDatesInModel, model, 5, newDate, formattedDate, newDatePicker);
				case 90:
					var subMsg = msg.a;
					var _v51 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.B.fa);
					var newDatePicker = _v51.a;
					var dateEvent = _v51.b;
					var _v52 = $author$project$Main$createDates(dateEvent);
					var newDate = _v52.a;
					var formattedDate = _v52.b;
					return A5($author$project$Main$updateDatesInModel, model, 6, newDate, formattedDate, newDatePicker);
				case 91:
					var subMsg = msg.a;
					var _v53 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.B.ej);
					var newDatePicker = _v53.a;
					var dateEvent = _v53.b;
					var _v54 = $author$project$Main$createDates(dateEvent);
					var newDate = _v54.a;
					var formattedDate = _v54.b;
					return A5($author$project$Main$updateDatesInModel, model, 7, newDate, formattedDate, newDatePicker);
				case 92:
					var subMsg = msg.a;
					var _v55 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.B.fG);
					var newDatePicker = _v55.a;
					var dateEvent = _v55.b;
					var _v56 = $author$project$Main$createDates(dateEvent);
					var newDate = _v56.a;
					var formattedDate = _v56.b;
					return A5($author$project$Main$updateDatesInModel, model, 8, newDate, formattedDate, newDatePicker);
				case 93:
					var projectId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d_: projectId}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$author$project$Main$goTo,
									model,
									$author$project$Route$Project(projectId))
								])));
				case 94:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bM: !model.bM}),
						$elm$core$Platform$Cmd$none);
				case 95:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bj: !model.bj}),
						$elm$core$Platform$Cmd$none);
				case 100:
					var conversationId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bZ: $author$project$Message$LoadingMessages, bC: conversationId}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Main$fetchMessages, conversationId, model.hR, model.g5),
									A3($author$project$Api$Request$markConversationAsRead, model.g5, model.hR, conversationId)
								])));
				case 107:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bZ: $author$project$Message$LoadingMessages, bC: ''}),
						$elm$core$Platform$Cmd$none);
				case 101:
					var time = msg.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Main$fetchMessages, model.bC, model.hR, model.g5),
									A2($author$project$Main$fetchUnreadMessages, model.g5, model.hR)
								])));
				case 99:
					var result = msg.a;
					if (!result.$) {
						var receivedMessages = result.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectRoute($author$project$Route$Inbox),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										bZ: $author$project$Message$Messages(
											$elm$core$List$reverse(receivedMessages))
									}),
								$author$project$Main$changeWindowHeight('')));
					} else {
						var err = result.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 102:
					return $author$project$Main$updateSendMessageTwilio(model);
				case 111:
					var id = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						$author$project$Main$conversationTwilioPayload(model),
						model,
						id,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 112:
					var result = msg.a;
					if (!result.$) {
						var conversation = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{bC: conversation.V}),
							A4($author$project$Main$createMessage, conversation.V, model.y.dG, model.z.u, model.z.cU));
					} else {
						var err = result.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 113:
					if (msg.a === 2) {
						var _v59 = msg.a;
						return _Utils_Tuple2(
							model,
							A2($author$project$Api$Request$deleteResume, model.hR, model.g5));
					} else {
						var fileAction = msg.a;
						var mime_types = _List_fromArray(
							['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/pdf']);
						return _Utils_Tuple2(
							model,
							A2(
								$elm$file$File$Select$file,
								mime_types,
								function (file) {
									return A2($author$project$MainMsg$GotResume, file, fileAction);
								}));
					}
				case 114:
					var fileAction = msg.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$file$File$Select$file,
							_List_fromArray(
								['image/*']),
							function (file) {
								return A2($author$project$MainMsg$GotFile, file, fileAction);
							}));
				case 115:
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$getTempfile, model.hR, model.p.aQ));
				case 295:
					var res = msg.a;
					if (!res.$) {
						var video = res.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$file$File$Select$file,
								_List_fromArray(
									['video/*']),
								function (file) {
									return A2($author$project$MainMsg$GotVideoFile, file, video.V);
								}));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 116:
					var file = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bf: A2($elm$core$String$dropLeft, 12, file)
							}),
						$elm$core$Platform$Cmd$none);
				case 117:
					var file = msg.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$author$project$MainMsg$ChatFileToString,
							$elm$file$File$toString(file)));
				case 229:
					var stringFile = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Main$twilio(
							{
								t: 'sendFile',
								X: $author$project$Api$Encoders$twilioPayloadEncoder(
									A3($author$project$Main$fileUploadPayload, stringFile, model.j.k.V, model.p.aQ)),
								aa: model.z.u
							}));
				case 118:
					var file = msg.a;
					var fileAction = msg.b;
					var _v61 = A2($author$project$Main$replacingData, fileAction, model);
					var deletingId = _v61.a;
					var images = _v61.b;
					var replaceImageMessage = _v61.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								am: deletingId,
								W: $author$project$SharedProjectRoleSchedules$Uploading(0),
								hE: images
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Api$Request$uploadImage, file, model.hR, model.g5),
									replaceImageMessage
								])));
				case 124:
					var file = msg.a;
					var files = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$uploadImage, file, model.hR, model.g5));
				case 119:
					var file = msg.a;
					var fileAction = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$uploadResume, file, model.hR, model.g5));
				case 120:
					var file = msg.a;
					var files = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$uploadResume, file, model.hR, model.g5));
				case 125:
					var progress = msg.a;
					if (!progress.$) {
						var p = progress.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									W: $author$project$SharedProjectRoleSchedules$Uploading(
										$elm$http$Http$fractionSent(p))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 129:
					var result = msg.a;
					if (!result.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									co: $author$project$SharedProjectRoleSchedules$ResumeWaiting,
									z: A2($author$project$Main$updateResume, model.z, $elm$core$Maybe$Nothing)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 128:
					var result = msg.a;
					if (!result.$) {
						var resume = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									co: $author$project$SharedProjectRoleSchedules$ResumeWaiting,
									z: A2(
										$author$project$Main$updateResume,
										model.z,
										$elm$core$Maybe$Just(resume.jM))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 127:
					var result = msg.a;
					if (!result.$) {
						var image = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									W: $author$project$Main$imageUploadStatus(
										$elm$core$List$length(model.hE) + 1),
									hE: A2($elm$core$List$cons, image, model.hE)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 130:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{W: $author$project$SharedProjectRoleSchedules$Waiting}),
						$elm$http$Http$cancel('upload'));
				case 121:
					var file = msg.a;
					var tempId = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: $author$project$Model$Showing('Received file successfully!'),
								cv: $author$project$SharedProjectRoleSchedules$Waiting
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$dismissAlert,
									A3(
									$author$project$Api$Request$updateVideoInfo,
									model.hR,
									$elm$file$File$name(file),
									tempId),
									A4($author$project$Api$Request$uploadVideo, file, tempId, model.hR, model.p.aQ)
								])));
				case 126:
					var progress = msg.a;
					if (!progress.$) {
						var p = progress.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cv: $author$project$SharedProjectRoleSchedules$Waiting}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 122:
					var result = msg.a;
					if (!result.$) {
						var video = result.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Error uploading video'),
									cv: $author$project$SharedProjectRoleSchedules$Waiting
								}),
							$author$project$Main$dismissAlert);
					}
				case 289:
					var videoId = msg.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$toggleVideoVisibility, videoId, model.hR));
				case 290:
					var videoId = msg.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$deleteVideo, videoId, model.hR));
				case 287:
					var result = msg.a;
					if (!result.$) {
						var video = result.a;
						var message = video.f5 ? 'Video is now visible to collaborators' : 'Video is now hidden from collaborators';
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing(message),
									p: A2($author$project$Main$updateTalentVideo, model.p, video)
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 288:
					var result = msg.a;
					if (!result.$) {
						var video = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Successfully Deleted Video'),
									p: A2($author$project$Main$removeVideoFromTalent, model.p, video.V)
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 123:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: $author$project$SharedProjectRoleSchedules$Waiting}),
						$elm$http$Http$cancel('uploadVideo'));
				case 131:
					var url = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e2: A2($elm$core$List$cons, url, model.e2)
							}),
						$elm$core$Platform$Cmd$none);
				case 133:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									W: $author$project$Main$imageUploadStatus(
										$elm$core$List$length(model.hE) - 1),
									hE: A2($author$project$Main$filterImages, model.am, model.hE)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 134:
					var res = msg.a;
					if (!res.$) {
						var result = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{id: result}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 135:
					var id = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{Z: false}),
						A3($author$project$Api$Request$deleteImage, id, model.hR, model.g5));
				case 65:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l: !model.l}),
						$author$project$Api$Request$postRoleApplication(model));
				case 262:
					var projectId = msg.a;
					var roleId = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$applyToRole, projectId, roleId, model.hR));
				case 66:
					var res = msg.a;
					if (!res.$) {
						var mes = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$SearchJobs,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing(mes.h1),
										Q: A5(
											$author$project$Main$updateTalentMenuOptions,
											$author$project$User$ToggleMenuModal($author$project$User$emptySearchTalentProfile),
											model.Q,
											'',
											'',
											_List_Nil)
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchUsersJobs(model.hR),
											$author$project$Main$dismissAlert
										]))));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error applying for this job.')
								}),
							$author$project$Main$dismissAlert);
					}
				case 67:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 141:
					var res = msg.a;
					if (!res.$) {
						var applicants = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{du: applicants}),
							A2(
								$author$project$Main$goTo,
								model,
								$author$project$Route$Role(model.g3)));
					} else {
						var err = res.a;
						return $author$project$Main$handleError(model);
					}
				case 142:
					var res = msg.a;
					if (!res.$) {
						var applicants = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{du: applicants}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = res.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 138:
					var res = msg.a;
					if (!res.$) {
						var results = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a8: $author$project$MainMsg$Successs(results)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 251:
					var res = msg.a;
					if (!res.$) {
						var results = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a8: $author$project$MainMsg$Successs(
										A2($author$project$Main$addMoreUsersToList, results, model.a8))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 140:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{w: _List_Nil, a8: $author$project$MainMsg$Loadings}),
						A3($author$project$Api$Request$searchUsers, model.hR, model.m, model.Y));
				case 250:
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$loadMoreUsers, model.hR, model.m, model.br));
				case 249:
					var offset = msg.a;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$LoadMore,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									m: A2($author$project$Main$updateTalentFilterOffset, model.m, offset)
								}),
							$elm$core$Platform$Cmd$none));
				case 139:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(
							model,
							A2($author$project$Main$goTo, model, $author$project$Route$Dashboard));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 143:
					var item = msg.a;
					return A3(
						$author$project$Main$updateRoleMulti,
						0,
						model,
						A2($author$project$Views$Form$transformIdToOption, item, model.hy));
				case 286:
					var video = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cK: video}),
						$elm$core$Platform$Cmd$none);
				case 151:
					var item = msg.a;
					return A2($author$project$Main$removeMultiItems, item, model);
				case 144:
					var item = msg.a;
					return A3(
						$author$project$Main$updateRoleMulti,
						2,
						model,
						A2($author$project$Views$Form$transformIdToOption, item, model.ea));
				case 145:
					var item = msg.a;
					return A3(
						$author$project$Main$updateRoleMulti,
						3,
						model,
						A2($author$project$Views$Form$transformIdToOption, item, model.ea));
				case 146:
					var multiMsg = msg.a;
					var item = msg.b;
					switch (multiMsg) {
						case 0:
							return A3(
								$author$project$Main$updateRoleMulti,
								1,
								model,
								A2($author$project$Views$Form$transformNameToOption, item, model.hy));
						case 2:
							return A3(
								$author$project$Main$updateRoleMulti,
								4,
								model,
								A2($author$project$Views$Form$transformNameToOption, item, model.ea));
						case 3:
							return A3(
								$author$project$Main$updateRoleMulti,
								5,
								model,
								A2($author$project$Views$Form$transformNameToOption, item, model.ea));
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 147:
					var token = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{hR: token}),
						$elm$core$Platform$Cmd$none);
				case 148:
					return _Utils_Tuple2(
						model,
						$author$project$Main$fetchNewToken(''));
				case 149:
					var action = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aD: action}),
						$elm$core$Platform$Cmd$none);
				case 150:
					var size = msg.a;
					switch (size) {
						case 2:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{H: 2}),
								$elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{H: 1}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{H: 0}),
								$elm$core$Platform$Cmd$none);
					}
				case 153:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(
							model,
							A2($author$project$Main$fetchUnreadMessages, model.g5, model.hR));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 154:
					var res = msg.a;
					var page = function () {
						var _v85 = model.z.P;
						if (_v85 === 1) {
							return A2($author$project$Api$Request$getProjectData, model.hR, model.h.cU);
						} else {
							return $author$project$Main$fetchUsersJobs(model.hR);
						}
					}();
					var message = function () {
						var _v84 = model.z.P;
						switch (_v84) {
							case 1:
								return 'Successfully sent to user!';
							case 3:
								return 'Successfully updated user!';
							case 4:
								return 'Successfully updated user!';
							default:
								return 'Your response has been sent!';
						}
					}();
					var action = function () {
						var _v83 = model.z.P;
						if (!_v83) {
							return $author$project$MainMsg$SearchJobs;
						} else {
							return $author$project$MainMsg$SearchUsers;
						}
					}();
					if (!res.$) {
						var newStage = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							action,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing(message),
										l: false,
										b5: newStage.jj,
										aF: false,
										Q: $author$project$User$initialTalentMenuOptions,
										aH: false
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[page, $author$project$Main$dismissAlert]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error with your request.')
								}),
							$author$project$Main$dismissAlert);
					}
				case 155:
					var notification = msg.a;
					var roleMemberId = msg.b;
					var stage = msg.c;
					var sendingUser = msg.d;
					return _Utils_Tuple2(
						model,
						A5($author$project$Api$Request$updateUsersRoleStage, notification, model.hR, roleMemberId, stage, model.z.cU));
				case 157:
					var res = msg.a;
					if (!res.$) {
						var pipeline = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									v: pipeline,
									bQ: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										$author$project$Schedule$SchedulePageViewUpdate(
											$author$project$SharedProjectRoleSchedules$PipelineUpdate(pipeline))),
									aH: false,
									h: A2($author$project$Main$addPipelineToViewingProject, model.h, pipeline)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 158:
					var res = msg.a;
					if (!res.$) {
						var pipeline = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{v: pipeline}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 159:
					var id = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ap: A2($author$project$Main$toggleMultiModal, id, model.ap)
							}),
						$elm$core$Platform$Cmd$none);
				case 160:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('User successfully Moved!'),
									aK: '',
									aO: '',
									aD: 3,
									bO: ''
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[$author$project$Main$dismissAlert])));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 161:
					var columnId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aK: columnId}),
						$elm$core$Platform$Cmd$none);
				case 164:
					var users = msg.a;
					var projectId = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d_: projectId}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A6(
									$author$project$Main$linkToRole,
									model.aO,
									model.bO,
									A2(
										$elm$core$List$map,
										function ($) {
											return $.cU;
										},
										users),
									model.hR,
									model.aK,
									model.z)
								])));
				case 162:
					var roleMemberId = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$moveUsersInPipeline(
							{
								d_: model.d_,
								hR: model.hR,
								jS: _List_fromArray(
									[
										{ic: model.aK, aQ: roleMemberId}
									])
							}));
				case 163:
					var updatedProject = A3(
						$author$project$Main$updateViewingProjectPipeline,
						model.h,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.aQ;
							},
							model.w),
						model.aK);
					var currentColumnId = A2(
						$elm$core$Maybe$withDefault,
						$author$project$User$emptySearchTalentProfile,
						$elm$core$List$head(model.w)).g0;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								A: A2($author$project$Main$updateAllProjects, model.A, updatedProject),
								H: 0,
								w: _List_Nil,
								h: updatedProject
							}),
						$author$project$Api$Request$moveUsersInPipeline(
							{
								d_: model.d_,
								hR: model.hR,
								jS: A2($author$project$Main$usersToMoveList, model.w, model.aK)
							}));
				case 165:
					var projectId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aO: projectId}),
						$elm$core$Platform$Cmd$none);
				case 166:
					var roleId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bO: roleId}),
						$author$project$Main$loadPipelineForProject(
							{d_: model.aO, hR: model.hR}));
				case 167:
					var notification = msg.a;
					var roleMemberId = msg.b;
					return _Utils_Tuple2(
						model,
						A5($author$project$Api$Request$updateUsersRoleStage, notification, model.hR, roleMemberId, 'accepted', model.z.cU));
				case 168:
					var column = msg.a;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$ToggleColumnMenu(''),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									gQ: column,
									cP: _Utils_eq(model.cP, $author$project$Project$NotEditing) ? $author$project$Project$Edit(column.V) : $author$project$Project$NotEditing
								}),
							$elm$core$Platform$Cmd$none));
				case 169:
					var columnForm = msg.a;
					return A2($author$project$Main$updateColumn, columnForm, model);
				case 170:
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$updateColumnData(
							{gQ: model.gQ, d_: model.d_, hR: model.hR}));
				case 171:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cP: $author$project$Project$NotEditing}),
							$elm$core$Platform$Cmd$batch(
								A8(
									$author$project$Main$fetchAppropriateData,
									$author$project$Route$Project(model.d_),
									'',
									model.hR,
									model.ji,
									model.hs,
									model.z.u,
									model.j,
									model.z.P)));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 172:
					var res = msg.a;
					if (!res.$) {
						var options = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ea: options.ea, hy: options.hy}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 173:
					var res = msg.a;
					if (!res.$) {
						var response = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$SearchUsers,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing(response.h1),
										H: 0,
										w: _List_Nil
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Api$Request$getProjectData, model.hR, model.h.cU),
											$author$project$Main$dismissAlert
										]))));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 174:
					var res = msg.a;
					if (!res.$) {
						var jobs = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{eO: jobs}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 175:
					var user = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bh: A2(
									$elm$core$Maybe$withDefault,
									$author$project$Data$Image$emptyImage,
									$elm$core$List$head(user.hE)),
								aD: 1,
								aH: true,
								p: user
							}),
						A2($author$project$Main$fetchConversations, model.z.u, model.j));
				case 176:
					var user = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bh: A2(
									$elm$core$Maybe$withDefault,
									$author$project$Data$Image$emptyImage,
									$elm$core$List$head(user.hE)),
								cK: A2(
									$elm$core$Maybe$withDefault,
									$author$project$Data$Video$emptyVideo,
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (video) {
												return video.f5;
											},
											user.jT))),
								aD: 4,
								aH: true,
								p: user
							}),
						A2($author$project$Main$fetchConversations, model.z.u, model.j));
				case 177:
					var users = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ap: $author$project$Utils$Closed, H: 1, w: users}),
						$elm$core$Platform$Cmd$none);
				case 178:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: 0, w: _List_Nil}),
						$elm$core$Platform$Cmd$none);
				case 179:
					var sort = msg.a;
					var id = msg.b;
					var sortingOption = $author$project$Main$sortingMap(sort);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ap: $author$project$Utils$Closed, ji: sortingOption}),
						$author$project$Main$sortPipelineUsers(
							{d_: model.d_, V: id, hR: model.hR, ji: sortingOption}));
				case 181:
					var res = msg.a;
					if (!res.$) {
						var column = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									h: A2(
										$author$project$Main$filterOrSortViewingProjectPipeline,
										model.h,
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Pipeline$emptyColumn,
											$elm$core$List$head(column)))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 182:
					var res = msg.a;
					if (!res.$) {
						var column = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									h: A2(
										$author$project$Main$filterOrSortViewingProjectPipeline,
										model.h,
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Pipeline$emptyColumn,
											$elm$core$List$head(column)))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 180:
					var filter = msg.a;
					var id = msg.b;
					var filteringOption = $author$project$Main$filteringMap(filter);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{hs: filteringOption, ap: $author$project$Utils$Closed}),
						$author$project$Main$filterPipelineUsers(
							{d_: model.d_, hs: filteringOption, V: id, hR: model.hR}));
				case 183:
					var age = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: A2($author$project$Main$updateAgeInUserProfile, age, model),
								p: A2($author$project$Main$updateSearchResultAge, age, model)
							}),
						$elm$core$Platform$Cmd$none);
				case 184:
					var user = msg.a;
					var _v95 = function () {
						var id = user.a;
						var pcolumn = user.b;
						return _Utils_Tuple2(id, pcolumn);
					}();
					var userId = _v95.a;
					var previousColumn = _v95.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aY: A2(
									$arsduo$elm_dom_drag_drop$Dom$DragDrop$startDragging,
									model.aY,
									A2($author$project$Project$User, userId, previousColumn))
							}),
						$elm$core$Platform$Cmd$none);
				case 185:
					var dropTargetId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aY: A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$updateDropTarget, model.aY, dropTargetId)
							}),
						$elm$core$Platform$Cmd$none);
				case 186:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aY: $arsduo$elm_dom_drag_drop$Dom$DragDrop$stopDragging(model.aY)
							}),
						$elm$core$Platform$Cmd$none);
				case 187:
					var draggedUser = msg.a;
					var dropTarget = msg.b;
					var _v97 = function () {
						var roleMId = draggedUser.a;
						var pcol = draggedUser.b;
						return _Utils_Tuple2(roleMId, pcol);
					}();
					var roleMemberId = _v97.a;
					var previousColumnId = _v97.b;
					var moveData = function () {
						if (!dropTarget.$) {
							var dropTargetId = dropTarget.a;
							var _v100 = A2($author$project$Main$droppedOnSchedulingColumn, dropTargetId, model.h.v);
							var droppedOnSchedule = _v100.a;
							var scheduleType = _v100.b;
							return (droppedOnSchedule && A3($author$project$Main$userNotScheduled, model.h.f, roleMemberId, scheduleType)) ? {
								bA: true,
								al: $author$project$Utils$ForbiddenScheduleColumn(scheduleType),
								bI: $author$project$Job$emptyNotification,
								bt: previousColumnId
							} : (A2($author$project$Main$droppedOnBookingColumn, dropTargetId, model.h.v) ? {
								bA: true,
								al: $author$project$Utils$ForbiddenBookingColumn,
								bI: {dG: '', gY: '', hT: 'Booking Request', aQ: roleMemberId, cu: model.z.cU},
								bt: previousColumnId
							} : {bA: false, al: $author$project$Utils$HiddenConf, bI: $author$project$Job$emptyNotification, bt: dropTargetId});
						} else {
							return {bA: false, al: $author$project$Utils$HiddenConf, bI: $author$project$Job$emptyNotification, bt: previousColumnId};
						}
					}();
					var updatedProject = A3(
						$author$project$Main$updateViewingProjectPipeline,
						model.h,
						_List_fromArray(
							[roleMemberId]),
						moveData.bt);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								A: A2($author$project$Main$updateAllProjects, model.A, updatedProject),
								al: moveData.al,
								aY: $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState,
								bI: moveData.bI,
								aF: moveData.bA,
								h: updatedProject
							}),
						$author$project$Api$Request$moveUsersInPipeline(
							{
								d_: model.d_,
								hR: model.hR,
								jS: _List_fromArray(
									[
										{ic: moveData.bt, aQ: roleMemberId}
									])
							}));
				case 188:
					var userView = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ap: $author$project$Utils$Closed, jQ: userView}),
						$elm$core$Platform$Cmd$none);
				case 189:
					var pageView = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ap: $author$project$Utils$Closed, it: pageView, bM: false}),
						$elm$core$Platform$Cmd$none);
				case 190:
					var searchQuery = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{i7: searchQuery}),
						$elm$core$Platform$Cmd$none);
				case 191:
					var res = msg.a;
					if (!res.$) {
						var schedules = res.a;
						var page = function () {
							var _v102 = model.bQ.aE;
							if (_v102.$ === 5) {
								var projectId = _v102.a;
								var scheduleId = _v102.b;
								return A2($author$project$SharedProjectRoleSchedules$ScheduleDayOfPage, projectId, scheduleId);
							} else {
								return A3($author$project$Main$determineSchedulePageView, schedules, model.bQ.fy, model.h);
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bQ: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										A2($author$project$Schedule$ScheduleProjectUpdate, schedules, page)),
									h: A2($author$project$Main$addSchedulesToViewingProject, model.h, schedules)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 192:
					var projectId = msg.a;
					var _v103 = (projectId === '') ? _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Schedule$ResetSchedulePageData) : _Utils_Tuple2(
						A2($author$project$Api$Request$getProjectData, model.hR, projectId),
						$author$project$Schedule$ScheduleDataLoading);
					var request = _v103.a;
					var pMsg = _v103.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								d_: projectId,
								bQ: A2($author$project$Main$updateSchedulePageData, model, pMsg)
							}),
						request);
				case 312:
					var res = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 193:
					var scheduleFormView = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2($author$project$Views$Schedule$toggleScheduleForm, model.bQ, scheduleFormView)
							}),
						$elm$core$Platform$Cmd$none);
				case 194:
					var schedulingAction = model.bQ.gB ? $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Api$Request$autoSchedule(model)
							])) : $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Api$Request$createBlankSchedule(model)
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$ScheduleFormViewUpdate(3))
							}),
						schedulingAction);
				case 195:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$ScheduleFormViewUpdate(2))
							}),
						$elm$core$Platform$Cmd$none);
				case 196:
					var res = msg.a;
					if (!res.$) {
						var schedules = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bQ: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										A2($author$project$Schedule$ScheduleListUpdate, schedules, 0))
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Api$Request$getProjectData, model.hR, model.h.cU),
										A2($author$project$Api$Request$getProjectData, model.hR, model.bQ.ae.cU)
									])));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 197:
					var sMsg = msg.a;
					var action = $elm$core$Platform$Cmd$none;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2($author$project$Main$updateSchedulePageData, model, sMsg)
							}),
						action);
				case 198:
					var dragType = msg.a;
					var _v107 = function () {
						var id = dragType.a;
						var columnId = dragType.b;
						return _Utils_Tuple2(id, columnId);
					}();
					var userId = _v107.a;
					var previousColumn = _v107.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a6: A2(
									$arsduo$elm_dom_drag_drop$Dom$DragDrop$startDragging,
									model.a6,
									A2($author$project$Schedule$User, userId, previousColumn))
							}),
						$elm$core$Platform$Cmd$none);
				case 199:
					var dropTargetId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a6: A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$updateDropTarget, model.a6, dropTargetId)
							}),
						$elm$core$Platform$Cmd$none);
				case 200:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a6: $arsduo$elm_dom_drag_drop$Dom$DragDrop$stopDragging(model.a6)
							}),
						$elm$core$Platform$Cmd$none);
				case 202:
					var draggedUser = msg.a;
					var dropTarget = msg.b;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 201:
					var draggedUser = msg.a;
					var dropTarget = msg.b;
					var _v109 = $author$project$Main$columnDefinitions(model.bQ.fy);
					var pendingColumn = _v109.a;
					var scheduledColumn = _v109.b;
					var _v110 = function () {
						var userData = draggedUser.a;
						var cTimeSlot = draggedUser.b;
						return _Utils_Tuple2(userData, cTimeSlot);
					}();
					var user = _v110.a;
					var currentTimeSlotId = _v110.b;
					var _v112 = function () {
						if ($author$project$Views$Schedule$schedulePublished(model.bQ.f)) {
							switch (dropTarget.$) {
								case 0:
									var id = dropTarget.a;
									var schedId = dropTarget.b;
									return _Utils_Tuple3(id, schedId, $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
								case 1:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_eq(droppedOnUser.cU, user.cU) ? _Utils_Tuple3(timeSlotId, schedId, $author$project$SharedProjectRoleSchedules$emptyUserSwapData) : _Utils_Tuple3(
										timeSlotId,
										schedId,
										A6($author$project$SharedProjectRoleSchedules$UserSwapData, true, user, droppedOnUser, timeSlotId, currentTimeSlotId, schedId));
								case 4:
									return _Utils_Tuple3('', '', $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
								case 2:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_Tuple3(
										timeSlotId,
										schedId,
										A6($author$project$SharedProjectRoleSchedules$UserSwapData, false, user, droppedOnUser, timeSlotId, currentTimeSlotId, schedId));
								default:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_Tuple3(
										'',
										'',
										A6($author$project$SharedProjectRoleSchedules$UserSwapData, false, user, droppedOnUser, '', currentTimeSlotId, schedId));
							}
						} else {
							switch (dropTarget.$) {
								case 0:
									var id = dropTarget.a;
									var schedId = dropTarget.b;
									return _Utils_Tuple3(id, schedId, $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
								case 1:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_eq(droppedOnUser.cU, user.cU) ? _Utils_Tuple3('', '', $author$project$SharedProjectRoleSchedules$emptyUserSwapData) : _Utils_Tuple3(
										timeSlotId,
										schedId,
										A6($author$project$SharedProjectRoleSchedules$UserSwapData, true, user, droppedOnUser, timeSlotId, currentTimeSlotId, schedId));
								case 4:
									return _Utils_Tuple3('', '', $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
								case 2:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_Tuple3('', '', $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
								default:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_Tuple3('', '', $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
							}
						}
					}();
					var newTimeSlotId = _v112.a;
					var scheduleId = _v112.b;
					var userSwapData = _v112.c;
					var removingUserFromSchedule = (newTimeSlotId === '') && (scheduleId === '');
					var droppedOnATakenSlot = userSwapData.S.cU !== '';
					var droppedOnMyself = _Utils_eq(userSwapData.q.aQ, userSwapData.S.aQ);
					var userInSchedule = A2($author$project$Main$userPresent, user, model.bQ.f);
					var addingUnscheduledUserToEmpySlot = (!userInSchedule) && ((!removingUserFromSchedule) && ((!droppedOnATakenSlot) && (!$author$project$Views$Schedule$schedulePublished(model.bQ.f))));
					var removeScheduledUserFromSchedule = userInSchedule && removingUserFromSchedule;
					var usersInScheduleNotRemovingOrSwapping = userInSchedule && ((!removingUserFromSchedule) && ((!droppedOnATakenSlot) && (!$author$project$Views$Schedule$schedulePublished(model.bQ.f))));
					var _v115 = usersInScheduleNotRemovingOrSwapping ? A4($author$project$Main$changeUsersTimeSlotInSchedule, model, user, currentTimeSlotId, newTimeSlotId) : (removeScheduledUserFromSchedule ? A5($author$project$Main$removeUserFromScheduleAndUpdatePipeline, model, user, newTimeSlotId, currentTimeSlotId, pendingColumn) : (addingUnscheduledUserToEmpySlot ? A6($author$project$Main$addUserToScheduleAndUpdatePipeline, model, user, newTimeSlotId, currentTimeSlotId, pendingColumn, scheduledColumn) : _Utils_Tuple3($elm$core$Platform$Cmd$none, model.bQ.f, model.bQ.D)));
					var backendChanges = _v115.a;
					var scheduleData = _v115.b;
					var talentData = _v115.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: A2($author$project$Main$publishedModalState, model, dropTarget),
								a6: $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState,
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, userSwapData))
							}),
						backendChanges);
				case 203:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{l: !model.l}),
						$elm$core$Platform$Cmd$none);
				case 204:
					var stageType = (model.bQ.fy === 'Audition') ? 5 : 11;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								l: false,
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$SchedulePageViewUpdate(
										A2($author$project$SharedProjectRoleSchedules$LoadingScheduleData, model.bQ.ae.cU, model.bQ.fy)))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Request$publishSchedule, model, stageType),
									$author$project$Main$dismissAlert
								])));
				case 205:
					var res = msg.a;
					if (!res.$) {
						var schedules = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Your Schedule has been Published! Talent will be notified.'),
									bQ: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										$author$project$Schedule$PublishScheduleUpdate(schedules))
								}),
							A2($author$project$Api$Request$getProjectData, model.hR, model.d_));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 206:
					var res = msg.a;
					if (!res.$) {
						var project = res.a;
						var updatedModel = (_Utils_eq(model.h.cU, project.cU) || (_Utils_eq(model.d_, project.cU) || _Utils_eq(model.bQ.ae.cU, project.cU))) ? _Utils_update(
							model,
							{d_: project.cU, h: project}) : model;
						return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 207:
					var res = msg.a;
					if (!res.$) {
						var timeSlot = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bQ: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										$author$project$Schedule$UpdateTimeSlot(timeSlot))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 208:
					var project = msg.a;
					var scheduleType = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$SchedulePageViewUpdate(
										A2($author$project$SharedProjectRoleSchedules$LoadingScheduleData, project.cU, scheduleType)))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Request$getProjectData, model.hR, project.cU),
									A2(
									$author$project$Main$goTo,
									model,
									A2($author$project$Route$SchedulePage, project.cU, scheduleType))
								])));
				case 209:
					var data = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$UserSwapDataUpdate(data))
							}),
						$elm$core$Platform$Cmd$none);
				case 212:
					var data = msg.a;
					var movedFromOutsideSchedule = data.J === '';
					var _v119 = $author$project$Main$columnDefinitions(model.bQ.fy);
					var pendingColumn = _v119.a;
					var scheduledColumn = _v119.b;
					var _v120 = A2($author$project$Main$swapNotificationKind, model, movedFromOutsideSchedule);
					var notification1 = _v120.a;
					var notification2 = _v120.b;
					var notificationData = {dG: '', gY: '', hT: notification1, aQ: data.q.aQ, cu: model.g5};
					var swapNotificationData = {dG: '', gY: '', hT: notification2, aQ: data.S.aQ, cu: model.g5};
					var _v121 = function () {
						if (movedFromOutsideSchedule) {
							var _v122 = _Utils_Tuple2(
								A4($author$project$Main$updateSchedules, model.bQ.f, data.q, data.U, data.J),
								A3($author$project$Main$updateAvailiableTalent, model.bQ.D, data.q, false));
							var firstScheduleUpdate = _v122.a;
							var firstTalentUpdate = _v122.b;
							return A9($author$project$Main$removeCurrentPublishedUserAndAddMovingUser, data, model.hR, model.bQ, notificationData, swapNotificationData, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn);
						} else {
							return A5($author$project$Main$updateBothUsersPositionsInPublishedSchedule, data, model.hR, model.bQ, notificationData, swapNotificationData);
						}
					}();
					var backendChanges = _v121.a;
					var scheduleData = _v121.b;
					var talentData = _v121.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: 2,
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, $author$project$SharedProjectRoleSchedules$emptyUserSwapData))
							}),
						backendChanges);
				case 213:
					var data = msg.a;
					var movedFromOutsideSchedule = data.J === '';
					var _v123 = $author$project$Main$columnDefinitions(model.bQ.fy);
					var pendingColumn = _v123.a;
					var scheduledColumn = _v123.b;
					var _v124 = A2($author$project$Main$removeNotificationKind, model, movedFromOutsideSchedule);
					var notification1 = _v124.a;
					var notification2 = _v124.b;
					var notificationData = {dG: '', gY: '', hT: notification1, aQ: data.q.aQ, cu: model.g5};
					var swapNotificationData = {dG: '', gY: '', hT: notification2, aQ: data.S.aQ, cu: model.g5};
					var _v125 = function () {
						var _v126 = _Utils_Tuple2(
							A4($author$project$Main$updateSchedules, model.bQ.f, data.q, data.U, data.J),
							A3($author$project$Main$updateAvailiableTalent, model.bQ.D, data.q, false));
						var firstScheduleUpdate = _v126.a;
						var firstTalentUpdate = _v126.b;
						return A9($author$project$Main$removeCurrentPublishedUserAndAddMovingUser, data, model.hR, model.bQ, notificationData, swapNotificationData, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn);
					}();
					var backendChanges = _v125.a;
					var scheduleData = _v125.b;
					var talentData = _v125.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, $author$project$SharedProjectRoleSchedules$emptyUserSwapData))
							}),
						backendChanges);
				case 214:
					var data = msg.a;
					var userInSchedule = A2($author$project$Main$userPresent, data.q, model.bQ.f);
					var notificationData = {
						dG: '',
						gY: '',
						hT: A2($author$project$Main$createSingleNotificationKind, model, userInSchedule),
						aQ: data.q.aQ,
						cu: model.g5
					};
					var _v127 = $author$project$Main$columnDefinitions(model.bQ.fy);
					var pendingColumn = _v127.a;
					var scheduledColumn = _v127.b;
					var _v128 = userInSchedule ? A5($author$project$Main$changeUsersTimeSlotInPublishedSchedule, model, data.q, notificationData, data.J, data.U) : A7($author$project$Main$addUserToPublishedScheduleAndUpdatePipeline, model, data.q, notificationData, data.U, data.J, pendingColumn, scheduledColumn);
					var backendChanges = _v128.a;
					var scheduleData = _v128.b;
					var talentData = _v128.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cm: 2,
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, $author$project$SharedProjectRoleSchedules$emptyUserSwapData))
							}),
						backendChanges);
				case 210:
					var data = msg.a;
					var movedFromOutsideSchedule = data.J === '';
					var _v129 = $author$project$Main$columnDefinitions(model.bQ.fy);
					var pendingColumn = _v129.a;
					var scheduledColumn = _v129.b;
					var _v130 = function () {
						if (movedFromOutsideSchedule) {
							var _v131 = _Utils_Tuple2(
								A4($author$project$Main$updateSchedules, model.bQ.f, data.q, data.U, data.J),
								A3($author$project$Main$updateAvailiableTalent, model.bQ.D, data.q, false));
							var firstScheduleUpdate = _v131.a;
							var firstTalentUpdate = _v131.b;
							return A7($author$project$Main$removeCurrentUserAndAddMovingUser, data, model.hR, model.bQ, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn);
						} else {
							return A3($author$project$Main$updateBothUsersPositionsInSchedule, data, model.hR, model.bQ);
						}
					}();
					var backendChanges = _v130.a;
					var scheduleData = _v130.b;
					var talentData = _v130.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, $author$project$SharedProjectRoleSchedules$emptyUserSwapData))
							}),
						backendChanges);
				case 211:
					var data = msg.a;
					var _v132 = $author$project$Main$columnDefinitions(model.bQ.fy);
					var pendingColumn = _v132.a;
					var scheduledColumn = _v132.b;
					var _v133 = function () {
						var _v134 = _Utils_Tuple2(
							A4($author$project$Main$updateSchedules, model.bQ.f, data.q, data.U, data.J),
							A3($author$project$Main$updateAvailiableTalent, model.bQ.D, data.q, false));
						var firstScheduleUpdate = _v134.a;
						var firstTalentUpdate = _v134.b;
						return A7($author$project$Main$removeCurrentUserAndAddMovingUser, data, model.hR, model.bQ, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn);
					}();
					var backendChanges = _v133.a;
					var scheduleData = _v133.b;
					var talentData = _v133.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, $author$project$SharedProjectRoleSchedules$emptyUserSwapData))
							}),
						backendChanges);
				case 215:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cm: 2}),
						$elm$core$Platform$Cmd$none);
				case 216:
					var scheduleType = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$SwitchViewingSchedules(scheduleType))
							}),
						A2(
							$author$project$Main$goTo,
							model,
							A2($author$project$Route$SchedulePage, model.bQ.ae.cU, scheduleType)));
				case 217:
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$updateUsersRoleInfo, model.hR, model.a5));
				case 322:
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Api$Request$updateUsersRoleInfo,
							model.hR,
							{ie: model.Q.fp, aQ: model.Q.jr.aQ, cu: model.Q.jr.cU}));
				case 218:
					var roleMemberId = msg.a;
					var newRoleId = msg.b;
					var userId = msg.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a5: A4($author$project$Main$updateRoleChangeInfo, model.a5, roleMemberId, newRoleId, userId)
							}),
						$elm$core$Platform$Cmd$none);
				case 219:
					var res = msg.a;
					if (!res.$) {
						var action = function () {
							var _v136 = model.z.P;
							if (!_v136) {
								return $author$project$MainMsg$SearchJobs;
							} else {
								return $author$project$MainMsg$SearchUsers;
							}
						}();
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							action,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('Users Role Successfully Updated'),
										a5: A4($author$project$Main$updateRoleChangeInfo, model.a5, '', '', ''),
										Q: $author$project$User$initialTalentMenuOptions
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$dismissAlert,
											A2($author$project$Api$Request$getProjectData, model.hR, model.h.cU)
										]))));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('There was an error updating users role.')
								}),
							$author$project$Main$dismissAlert);
					}
				case 224:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{z: user}),
							$author$project$Main$twilio(
								{
									t: 'refreshTwilioToken',
									X: $author$project$Api$Encoders$twilioPayloadEncoder($author$project$Message$emptyToTwilioPayload),
									aa: user.u
								}));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 226:
					var twilioData = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						twilioData,
						model,
						'',
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 225:
					var data = msg.a;
					var _v138 = A2($elm$json$Json$Decode$decodeValue, $author$project$Message$fromTwilioDataDecoder, data);
					if (!_v138.$) {
						var twilioData = _v138.a;
						return A4(
							$author$project$Main$updateTwilioData,
							twilioData,
							model,
							'',
							_List_fromArray(
								[$author$project$User$emptyUserConvoInfo]));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 227:
					var id = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{t: 'switchChannel'}),
						model,
						id,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 228:
					var res = msg.a;
					if (!res.$) {
						var pipelineUser = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									b5: $author$project$Main$extractStage(pipelineUser),
									p: $author$project$Utils$transformToSearchResultTalentProfile(pipelineUser)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 230:
					var filterType = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b1: A2($author$project$Main$updateChatFilterValues, filterType, model)
							}),
						$elm$core$Platform$Cmd$none);
				case 231:
					var convoId = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{t: 'switchChannel'}),
						model,
						convoId,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 232:
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{t: 'closeTalentConversationContainer'}),
						model,
						'',
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 233:
					var convoId = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{t: 'archiveConversation'}),
						model,
						convoId,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 234:
					var convoId = msg.a;
					var notificationId = msg.b;
					var page = function () {
						var _v140 = model.z.P;
						switch (_v140) {
							case 0:
								return $author$project$Route$MyJobs;
							case 1:
								return $author$project$Route$Inbox;
							default:
								return $author$project$Route$Inbox;
						}
					}();
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						A2(
							$author$project$MainMsg$ViewThenMarkAsRead,
							page,
							_List_fromArray(
								[notificationId])),
						A4(
							$author$project$Main$updateTwilioData,
							_Utils_update(
								$author$project$Message$emptyFromTwilioPayload,
								{t: 'switchChannel'}),
							model,
							convoId,
							_List_fromArray(
								[$author$project$User$emptyUserConvoInfo])));
				case 235:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bp: !model.bp}),
						$elm$core$Platform$Cmd$none);
				case 236:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bn: false, bp: false}),
						$elm$core$Platform$Cmd$none);
				case 237:
					var res = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 238:
					var res = msg.a;
					if (!res.$) {
						var userConvoInfo = res.a;
						return A4(
							$author$project$Main$updateTwilioData,
							_Utils_update(
								$author$project$Message$emptyFromTwilioPayload,
								{t: 'gotUserConvoInfo'}),
							model,
							'',
							userConvoInfo);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 305:
					return (model.M.fC === '') ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								M: A2($author$project$Main$updateJobPageData, $author$project$Job$SearchingJobs, model.M)
							}),
						A2($author$project$Api$Request$searchJobs, model.hR, '-1')) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								M: A2($author$project$Main$updateJobPageData, $author$project$Job$SearchingJobs, model.M)
							}),
						A2($author$project$Api$Request$searchJobs, model.hR, model.M.fC));
				case 306:
					var res = msg.a;
					if (!res.$) {
						var jobs = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									M: A2(
										$author$project$Main$updateJobPageData,
										$author$project$Job$SearchResults(jobs),
										model.M),
									Y: A2(
										$elm$core$Maybe$withDefault,
										$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
										$elm$core$List$head(jobs)).V
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 105:
					var res = msg.a;
					if (!res.$) {
						var agents = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Success!'),
									c: $author$project$Main$closeAddAgentForm(model.c),
									z: A2($author$project$Main$updateAgentsList, model.z, agents)
								}),
							$author$project$Main$dismissAlert);
					} else {
						var error = res.a;
						if (error.$ === 3) {
							var a = error.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('Error with agent!')
									}),
								$author$project$Main$dismissAlert);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}
				case 104:
					var agentId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{Z: false}),
						A3($author$project$Api$Request$deleteAgent, agentId, model.z.gl.V, model.hR));
				case 239:
					var page = msg.a;
					var notificationIds = msg.b;
					if (page.$ === 24) {
						var projectId = page.a;
						var scheduleType = page.b;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$View(
								A2($author$project$Route$SchedulePage, projectId, scheduleType)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										bp: false,
										z: A2($author$project$Main$updateNotifications, model.z, notificationIds)
									}),
								A2($author$project$Api$Request$markNotificationsAsRead, model.hR, notificationIds)));
					} else {
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectRoute(page),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										bp: false,
										z: A2($author$project$Main$updateNotifications, model.z, notificationIds)
									}),
								A2($author$project$Api$Request$markNotificationsAsRead, model.hR, notificationIds)));
					}
				case 103:
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$addUpdateAgent, model.c.bB, model.z.gl.V, model.hR));
				case 242:
					var notifications = msg.a;
					var notificationIds = A2(
						$elm$core$List$map,
						function ($) {
							return $.V;
						},
						notifications);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: A2($author$project$Main$updateNotifications, model.z, notificationIds)
							}),
						A2($author$project$Api$Request$markNotificationsAsRead, model.hR, notificationIds));
				case 243:
					var projectMenuMsg = msg.a;
					return A2($author$project$Main$updateProjectMenuState, model, projectMenuMsg);
				case 246:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cT: true}),
						$elm$core$Platform$Cmd$none);
				case 247:
					var talentFilter = msg.a;
					return A2($author$project$Main$updateTalentFilterExpand, model, talentFilter);
				case 248:
					var allTalent = function () {
						var _v146 = model.a8;
						if (_v146.$ === 3) {
							var searchResultTalentProfileList = _v146.a;
							return searchResultTalentProfileList;
						} else {
							return _List_Nil;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{w: allTalent}),
						$elm$core$Platform$Cmd$none);
				case 252:
					var allGenders = ($elm$core$List$length(model.P.hy) > 0) ? _List_Nil : model.hy;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								P: A2($author$project$Main$updateRoleGenders, model.P, allGenders)
							}),
						$elm$core$Platform$Cmd$none);
				case 253:
					var allEthnicities = ($elm$core$List$length(model.P.ea) > 0) ? _List_Nil : model.ea;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								P: A2($author$project$Main$updateRoleEthnicities, model.P, allEthnicities)
							}),
						$elm$core$Platform$Cmd$none);
				case 254:
					var imageId = msg.a;
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Api$Request$getProxiedImage,
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Data$Image$emptyImage,
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$author$project$Utils$eq,
											function ($) {
												return $.V;
											},
											imageId),
										model.hE))),
							model.hR));
				case 304:
					var jobPageMsg = msg.a;
					var url = function () {
						if (jobPageMsg.$ === 3) {
							var projectId = jobPageMsg.a;
							return $author$project$Route$Job(projectId);
						} else {
							return model.i;
						}
					}();
					var selectedJob = function () {
						if (jobPageMsg.$ === 3) {
							var projectId = jobPageMsg.a;
							return projectId;
						} else {
							return '';
						}
					}();
					if (jobPageMsg.$ === 1) {
						var newId = model.bX + 1;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									M: A2($author$project$Main$updateJobPageData, jobPageMsg, model.M),
									Y: selectedJob,
									bX: newId
								}),
							A3(
								$andrewMacmurray$elm_delay$Delay$after,
								500,
								0,
								A2($author$project$MainMsg$Timeout, newId, 0)));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									i: url,
									M: A2($author$project$Main$updateJobPageData, jobPageMsg, model.M),
									Y: selectedJob
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 259:
					var res = msg.a;
					if (!res.$) {
						var image = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{av: true, az: image}),
							$author$project$Main$kickOffResizing(''));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 319:
					var fullImageModal = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ca: fullImageModal}),
						$elm$core$Platform$Cmd$none);
				case 255:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{av: false, az: $author$project$User$emptyProxyImage}),
						$elm$core$Platform$Cmd$none);
				case 256:
					var url = msg.a;
					var _v151 = A5($author$project$Main$removeOriginalImage, model.hR, model.g5, url, model.az, model.hE);
					var images = _v151.a;
					var deleteMessage = _v151.b;
					var uploadMessage = _v151.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{av: false, hE: images}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[deleteMessage, uploadMessage])));
				case 257:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 258:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 260:
					var id = msg.a;
					var searchType = msg.b;
					if (_Utils_eq(id, model.bX)) {
						var $temp$msg = $author$project$MainMsg$TypingEnded(searchType),
							$temp$model = model;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 264:
					var search = msg.a;
					if (search === 1) {
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$SearchUsers,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					} else {
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$SearchJobs,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				case 268:
					var res = msg.a;
					if (!res.$) {
						var collaborators = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bQ: A2(
										$author$project$Main$updateCollaborator,
										model.bQ,
										$author$project$SharedProjectRoleSchedules$UpdateCollaborators(collaborators))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 266:
					var amsg = msg.a;
					var message = function () {
						switch (amsg.$) {
							case 0:
								return (!model.bQ.by.c2) ? $author$project$Api$Request$getCollaborators(model.hR) : $elm$core$Platform$Cmd$none;
							case 10:
								var _v155 = model.bQ.aE;
								if (_v155.$ === 5) {
									var projectId = _v155.a;
									var scheduleId = _v155.b;
									return model.bQ.by.cS ? A3($author$project$Api$Request$addCollaborator, model.bQ.by, model.hR, projectId) : $elm$core$Platform$Cmd$none;
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							default:
								return $elm$core$Platform$Cmd$none;
						}
					}();
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$VerifyCollabForm($author$project$SharedProjectRoleSchedules$VerifyForm),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									bQ: A2($author$project$Main$updateCollaborator, model.bQ, amsg)
								}),
							message));
				case 267:
					var amsg = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2($author$project$Main$updateCollaborator, model.bQ, amsg)
							}),
						$elm$core$Platform$Cmd$none);
				case 269:
					var res = msg.a;
					if (!res.$) {
						var collaborators = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$UpdateCollaboratorData(
								$author$project$SharedProjectRoleSchedules$CollaboratorAdded(collaborators)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('Collaboration invitation sent to user'),
										cH: collaborators
									}),
								$author$project$Main$dismissAlert));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 109:
					var agentId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: A3($author$project$Main$toggleAgentForm, model.c, agentId, model.z)
							}),
						$elm$core$Platform$Cmd$none);
				case 110:
					var agentInfo = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: A2($author$project$Main$updateAgentInfo, model.c, agentInfo)
							}),
						$elm$core$Platform$Cmd$none);
				case 270:
					var res = msg.a;
					if (!res.$) {
						var invitation = res.a;
						var message = (invitation.b3 && (model.hR === '')) ? $elm$core$Platform$Cmd$none : ((invitation.b3 && (model.hR !== '')) ? $author$project$Main$removeUserToken('') : $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Main$goTo, model, $author$project$Route$Login),
									$author$project$Main$removeUserToken('')
								])));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									L: 0,
									bl: invitation.f_.bl,
									aT: A2($author$project$Main$updateCollaboratorProfile, model.aT, invitation.f_)
								}),
							message);
					} else {
						return _Utils_Tuple2(
							model,
							A2($author$project$Main$goTo, model, $author$project$Route$Login));
					}
				case 108:
					var res = msg.a;
					if (!res.$) {
						var invitation = res.a;
						var message = (invitation.b3 && (model.hR === '')) ? $elm$core$Platform$Cmd$none : ((invitation.b3 && (model.hR !== '')) ? $author$project$Main$removeUserToken('') : $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Main$goTo, model, $author$project$Route$Login),
									$author$project$Main$removeUserToken('')
								])));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									L: 0,
									bl: invitation.f_.bl,
									aT: A2($author$project$Main$updateCollaboratorProfile, model.aT, invitation.f_)
								}),
							message);
					} else {
						return _Utils_Tuple2(
							model,
							A2($author$project$Main$goTo, model, $author$project$Route$Login));
					}
				case 271:
					var res = msg.a;
					if (!res.$) {
						var projects = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dN: projects}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 272:
					var projectId = msg.a;
					var scheduleId = msg.b;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$View(
							A2($author$project$Route$DayOfPage, projectId, scheduleId)),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{d_: projectId}),
							$elm$core$Platform$Cmd$none));
				case 274:
					var roleMemberId = msg.a;
					var vote = msg.b;
					var timeSlotId = msg.c;
					return _Utils_Tuple2(
						model,
						A5($author$project$Api$Request$submitVote, roleMemberId, vote, model.bQ.b2, model.hR, timeSlotId));
				case 273:
					var res = msg.a;
					if (!res.$) {
						var timeSlot = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Vote Successfully Recorded!'),
									bQ: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										$author$project$Schedule$UpdateTimeSlot(timeSlot))
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 275:
					var response = msg.a;
					var invitationId = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$updateInvitation, response, invitationId, model.hR));
				case 276:
					var res = msg.a;
					if (!res.$) {
						var projects = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dN: projects}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 277:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2($author$project$Main$updateSchedulePageData, model, $author$project$Schedule$UpdateCollaboratorsModal)
							}),
						$elm$core$Platform$Cmd$none);
				case 278:
					var res = msg.a;
					if (!res.$) {
						var collaborators = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cH: collaborators}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 279:
					var invitationId = msg.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$removeCollaborator, invitationId, model.hR));
				case 280:
					var res = msg.a;
					if (!res.$) {
						var collaborators = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Collaborator Successfully Removed'),
									cH: collaborators
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 281:
					var comment = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bQ: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$UpdateMyComment(comment))
							}),
						$elm$core$Platform$Cmd$none);
				case 282:
					var time = msg.a;
					var projectId = msg.b;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Request$getProjectData, model.hR, projectId),
									A2($author$project$Api$Request$getCollaboratorsOnProject, projectId, model.hR)
								])));
				case 283:
					var timeSlotId = msg.a;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$submitVotingComment, model.bQ.b2, model.hR, timeSlotId));
				case 284:
					var res = msg.a;
					if (!res.$) {
						var timeSlot = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Comment Successfully submitted!'),
									bQ: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										$author$project$Schedule$UpdateTimeSlot(timeSlot))
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 296:
					var pageIndex = msg.a;
					var savingAction = ((_Utils_cmp(
						pageIndex + 1,
						$elm$core$List$length(model.z.ck)) > 0) || (pageIndex < 0)) ? $elm$core$Platform$Cmd$none : $author$project$Api$Request$updateUserProfilePageChange(model);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: A2($author$project$Main$updateCurrentProfilePage, model.c, pageIndex)
							}),
						savingAction);
				case 297:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$toggleProfilePageNav(model.c)
							}),
						$elm$core$Platform$Cmd$none);
				case 298:
					var res = msg.a;
					if (!res.$) {
						var questions = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: A2($author$project$Main$updateQuestions, model.c, questions)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 299:
					var value = msg.a;
					var questionId = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: A3($author$project$Main$updateQuestionsForm, value, questionId, model.c)
							}),
						$elm$core$Platform$Cmd$none);
				case 301:
					var pmsg = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 300:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Failed to update profile!')
								}),
							$author$project$Main$dismissAlert);
					}
				case 302:
					var res = msg.a;
					if (!res.$) {
						var agencies = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: A2($author$project$Main$updateAgencies, agencies, model.c)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 33:
					var res = msg.a;
					if (!res.$) {
						var userProfile = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Successfully Removed Agent'),
									z: userProfile
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 303:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$toggleAgencyFields(model.c),
								z: $author$project$Main$clearAgencyInfo(model.z)
							}),
						$elm$core$Platform$Cmd$none);
				case 42:
					var associationId = msg.a;
					var agentId = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$deleteTalentAgent, associationId, agentId, model.hR));
				case 307:
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$createAgency, model.z.cy, model.hR));
				case 308:
					var res = msg.a;
					if (!res.$) {
						var userProfile = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Successfully Added Agency!'),
									c: $author$project$Main$toggleAgencyFields(model.c),
									z: userProfile
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Main$dismissAlert,
										$author$project$Api$Request$getAgencies(model.hR)
									])));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Failed to add agency. Please fill out all fields!')
								}),
							$author$project$Main$dismissAlert);
					}
				case 309:
					return (model.bl === '') ? _Utils_Tuple2(
						_Utils_update(
							model,
							{bR: 'Please provide a valid email to send password reset to!'}),
						$author$project$Main$resetErrorMessage) : _Utils_Tuple2(
						model,
						$author$project$Main$sendPasswordResetEmail(model.bl));
				case 311:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bR: ''}),
						$elm$core$Platform$Cmd$none);
				case 310:
					var status = msg.a;
					switch (status) {
						case 'success':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('Sent Password Reset email to ' + model.bl)
									}),
								$author$project$Main$dismissAlert);
						case 'error':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('Failed to send password reset email. Please ensure that your email is correct.')
									}),
								$author$project$Main$dismissAlert);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 3:
					var aMsg = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gl: A2($author$project$Main$updateAgency, model.gl, aMsg)
							}),
						$elm$core$Platform$Cmd$none);
				case 261:
					var res = msg.a;
					if (!res.$) {
						var talent = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									Q: A5(
										$author$project$Main$updateTalentMenuOptions,
										$author$project$User$GotTalentInfo(talent),
										model.Q,
										'',
										'',
										_List_Nil),
									p: talent
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 5:
					var invalidForm = A2(
						$elm$core$List$member,
						'',
						_List_fromArray(
							[model.gl.cz, model.gl.bl, model.gl.bv, model.gl.aV, model.gl.a7, model.gl.dn, model.gl.eW, model.gl.cF]));
					var message = invalidForm ? $author$project$Model$Showing('Form is not valid') : $author$project$Model$Hiding;
					var submitAction = invalidForm ? _List_fromArray(
						[$author$project$Main$dismissAlert]) : _List_fromArray(
						[
							$author$project$Main$dismissAlert,
							$author$project$Main$fireBaseSignUp(
							_Utils_Tuple2(model.gl.bl, model.gl.eW))
						]);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: message,
								aT: $author$project$Main$setUserDataToAgency(model.aT)
							}),
						$elm$core$Platform$Cmd$batch(submitAction));
				case 313:
					var projectId = msg.a;
					var column = A2(
						$elm$core$Maybe$withDefault,
						$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$author$project$Utils$eq,
									function ($) {
										return $.V;
									},
									projectId),
								model.M.fe))).hY;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$SearchUsers,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{aK: column, aO: projectId, Y: projectId}),
							$elm$core$Platform$Cmd$none));
				case 314:
					var roleId = msg.a;
					var role = A2(
						$elm$core$Maybe$withDefault,
						$author$project$SharedProjectRoleSchedules$emptyRole,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$author$project$Utils$eq,
									function ($) {
										return $.cU;
									},
									roleId),
								model.aw)));
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$SearchUsers,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									bO: roleId,
									br: roleId,
									m: A2($author$project$Main$updateFiltersBasedOnRole, role, model.m)
								}),
							$elm$core$Platform$Cmd$none));
				case 315:
					var projectId = msg.a;
					var roleId = msg.b;
					var columnId = msg.c;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$RedirectRoute($author$project$Route$TalentSearch),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{aK: columnId, aO: projectId, bO: roleId, Y: projectId, br: roleId}),
							$elm$core$Platform$Cmd$none));
				case 316:
					var res = msg.a;
					if (!res.$) {
						var talent = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cA: talent}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 318:
					var status = msg.a;
					var membershipId = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$updateTalentMembership, status, membershipId, model.hR));
				case 317:
					var res = msg.a;
					if (!res.$) {
						var returnedTalent = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cA: A2(
										$elm$core$List$map,
										function (talent) {
											return _Utils_eq(talent.V, returnedTalent.V) ? returnedTalent : talent;
										},
										model.cA),
									Z: false
								}),
							$author$project$Api$Request$getDashboardData(model.hR));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 291:
					var res = msg.a;
					if (!res.$) {
						var schedule = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bQ: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										A2(
											$author$project$Schedule$ScheduleProjectUpdate,
											model.h.f,
											A2($author$project$SharedProjectRoleSchedules$ScheduleDayOfPage, model.h.cU, schedule.V)))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 320:
					var res = msg.a;
					if (!res.$) {
						var data = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									M: A2(
										$author$project$Main$updateJobPageData,
										$author$project$Job$LandedOnPage(data),
										model.M)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 40:
					var res = msg.a;
					if (!res.$) {
						var data = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									g7: $author$project$SharedProjectRoleSchedules$DashboardDataDone(data)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$Logout,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('Session has ended, please login again!')
									}),
								$author$project$Main$dismissAlert));
					}
				case 321:
					var tMsg = msg.a;
					var message = function () {
						if (tMsg.$ === 3) {
							var talentProfile = tMsg.a;
							return (!model.Q.dk) ? $elm$core$Platform$Cmd$none : A3($author$project$Api$Request$getDetailedTalentInfo, model.hR, model.Y, talentProfile.cU);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								Q: A5($author$project$Main$updateTalentMenuOptions, tMsg, model.Q, model.Y, model.br, model.aw)
							}),
						message);
				case 323:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{Q: $author$project$User$initialTalentMenuOptions}),
						A2($author$project$Api$Request$removeTalent, model.Q, model.hR));
				case 325:
					var subMsg = msg.a;
					return A2($author$project$Main$handleTalentProfileModalSubMsgs, model, subMsg);
				case 326:
					return A2($author$project$Main$handlePageSpecificSubMsgs, model, msg);
				case 324:
					var res = msg.a;
					var pageActions = function () {
						var _v180 = model.i;
						if (_v180.$ === 21) {
							var projectId = _v180.a;
							return _List_fromArray(
								[
									$author$project$Main$fetchPipeline(
									{d_: projectId, hR: model.hR, ji: model.ji}),
									$author$project$Main$dismissAlert
								]);
						} else {
							return _List_fromArray(
								[$author$project$Main$dismissAlert]);
						}
					}();
					var action = function () {
						var _v179 = model.z.P;
						if (!_v179) {
							return $author$project$MainMsg$SearchJobs;
						} else {
							return $author$project$MainMsg$SearchUsers;
						}
					}();
					if (!res.$) {
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							action,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: $author$project$Model$Showing('Successfully Removed Talent')
									}),
								$elm$core$Platform$Cmd$batch(pageActions)));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: $author$project$Model$Showing('Error removing talent!')
								}),
							$author$project$Main$dismissAlert);
					}
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Main$updateSendMessageTwilio = function (model) {
	return ((model.y.dG !== '') || (model.bf !== '')) ? A3(
		$ccapndave$elm_update_extra$Update$Extra$andThen,
		$author$project$Main$update,
		$author$project$MainMsg$NewMessageMsg(''),
		_Utils_Tuple2(
			_Utils_update(
				model,
				{
					bf: '',
					j: A3($author$project$Main$optimisticMessages, model.y.dG, model.z.cU, model)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Main$changeWindowHeight(''),
						A4($author$project$Main$createMessage, model.j.k.V, model.y.dG, model.z.u, model.z.cU)
					])))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Main$updateTalentFilterValues = F2(
	function (fMsg, model) {
		var talentFilterValues = model.m;
		switch (fMsg.$) {
			case 8:
				var gender = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{
										hx: A2($author$project$Main$updateFilterValues, gender, model.m.hx),
										io: 0
									})
							}),
						$elm$core$Platform$Cmd$none));
			case 1:
				var height = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{h6: height, io: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 2:
				var height = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{h$: height, io: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 0:
				var weight = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{eN: weight, io: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 3:
				var weight = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{eI: weight, io: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 4:
				var size = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{h5: size, io: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 5:
				var size = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{h_: size, io: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 6:
				var age = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{cZ: age, io: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 7:
				var age = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{cX: age, io: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 9:
				var val = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{
										hp: A2($author$project$Main$updateFilterValues, val, model.m.hp),
										io: 0
									})
							}),
						$elm$core$Platform$Cmd$none));
			case 10:
				var val = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: _Utils_update(
									talentFilterValues,
									{
										io: 0,
										iM: A2($author$project$Main$updateFilterValues, val, model.m.iM)
									})
							}),
						$elm$core$Platform$Cmd$none));
			case 11:
				var val = fMsg.a;
				var newId = model.bX + 1;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							m: _Utils_update(
								talentFilterValues,
								{io: 0, i6: val}),
							bX: newId
						}),
					A3(
						$andrewMacmurray$elm_delay$Delay$after,
						500,
						0,
						A2($author$project$MainMsg$Timeout, newId, 1)));
			case 12:
				var val = fMsg.a;
				var clearedFilters = function () {
					switch (val) {
						case 0:
							return _Utils_update(
								model,
								{
									m: _Utils_update(
										talentFilterValues,
										{hx: _List_Nil})
								});
						case 4:
							return _Utils_update(
								model,
								{
									m: _Utils_update(
										talentFilterValues,
										{cX: '', cZ: ''})
								});
						case 2:
							return _Utils_update(
								model,
								{
									m: _Utils_update(
										talentFilterValues,
										{eI: '', eN: ''})
								});
						case 1:
							return _Utils_update(
								model,
								{
									m: _Utils_update(
										talentFilterValues,
										{h$: '', h6: ''})
								});
						case 6:
							return _Utils_update(
								model,
								{
									m: _Utils_update(
										talentFilterValues,
										{iM: _List_Nil})
								});
						case 5:
							return _Utils_update(
								model,
								{
									m: _Utils_update(
										talentFilterValues,
										{hp: _List_Nil})
								});
						case 3:
							return _Utils_update(
								model,
								{
									m: _Utils_update(
										talentFilterValues,
										{h_: '', h5: ''})
								});
						case 7:
							return model;
						default:
							return model;
					}
				}();
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(clearedFilters, $elm$core$Platform$Cmd$none));
			default:
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{Y: '', br: '', m: $author$project$InitData$initTalentFilterValues}),
						$elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Main$validateProfileFields = F2(
	function (userProfile, model) {
		return ((userProfile.ha === '0') || ((userProfile.h9 === '0') || (userProfile.jZ === '0'))) ? A3(
			$ccapndave$elm_update_extra$Update$Extra$andThen,
			$author$project$Main$update,
			$author$project$MainMsg$GoToPage(1),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						a: $author$project$Model$Showing('Please enter your birthday!')
					}),
				$author$project$Main$dismissAlert)) : _Utils_Tuple2(
			_Utils_update(
				model,
				{e7: '', as: $author$project$User$initialProfileValidations}),
			$author$project$Api$Request$updateUserProfile(model));
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Main$messageBox = function (model) {
	var _v0 = model.a;
	if (_v0.$ === 1) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert')
				]),
			_List_Nil);
	} else {
		var alert = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert showing'),
					$elm$html$Html$Events$onClick($author$project$MainMsg$DismissAlert)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(alert)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('exit-alert'),
							$elm$html$Html$Events$onClick($author$project$MainMsg$DismissAlert)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('X')
						]))
				]));
	}
};
var $author$project$MainMsg$CloseAllMenus = {$: 236};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Views$Nav$nothing = $elm$html$Html$text('');
var $author$project$MainMsg$MarkAllNotificationsAsRead = function (a) {
	return {$: 242, a: a};
};
var $author$project$MainMsg$ToggleMenu = {$: 23};
var $author$project$MainMsg$ToggleNotifications = {$: 235};
var $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$bars = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('bars');
var $frandibar$elm_font_awesome_5$FontAwesome$bell = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('bell');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $frandibar$elm_font_awesome_5$FontAwesome$Solid = 0;
var $frandibar$elm_font_awesome_5$FontAwesome$animationClass = function (animation) {
	if (!animation) {
		return 'fa-spin';
	} else {
		return 'fa-pulse';
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$borderClass = 'fa-border';
var $frandibar$elm_font_awesome_5$FontAwesome$invertClass = 'fa-inverse';
var $frandibar$elm_font_awesome_5$FontAwesome$pullClass = function (p) {
	if (!p) {
		return 'fa-pull-left';
	} else {
		return 'fa-pull-right';
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$sizeClass = function (size) {
	switch (size.$) {
		case 0:
			return 'fa-xs';
		case 1:
			return 'fa-sm';
		case 2:
			return 'fa-lg';
		default:
			var n = size.a;
			return 'fa-' + ($elm$core$String$fromInt(n) + 'x');
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$widthClass = 'fa-fw';
var $frandibar$elm_font_awesome_5$FontAwesome$className = function (opt) {
	switch (opt.$) {
		case 0:
			var animation = opt.a;
			return _Utils_Tuple2(
				$frandibar$elm_font_awesome_5$FontAwesome$animationClass(animation),
				true);
		case 1:
			return _Utils_Tuple2($frandibar$elm_font_awesome_5$FontAwesome$borderClass, true);
		case 2:
			return _Utils_Tuple2($frandibar$elm_font_awesome_5$FontAwesome$widthClass, true);
		case 4:
			return _Utils_Tuple2($frandibar$elm_font_awesome_5$FontAwesome$invertClass, true);
		case 6:
			var direction = opt.a;
			return _Utils_Tuple2(
				$frandibar$elm_font_awesome_5$FontAwesome$pullClass(direction),
				true);
		case 7:
			var size = opt.a;
			return _Utils_Tuple2(
				$frandibar$elm_font_awesome_5$FontAwesome$sizeClass(size),
				true);
		default:
			return _Utils_Tuple2('', false);
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$iconClass = function (iconOrLogo) {
	var root = function () {
		if (!iconOrLogo.$) {
			var name = iconOrLogo.a;
			return name;
		} else {
			var name = iconOrLogo.a;
			return name;
		}
	}();
	return 'fa-' + root;
};
var $frandibar$elm_font_awesome_5$FontAwesome$styleClass = F2(
	function (iconOrLogo, style) {
		if (iconOrLogo.$ === 1) {
			return 'fab';
		} else {
			switch (style) {
				case 0:
					return 'fas';
				case 1:
					return 'far';
				default:
					return 'fal';
			}
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$classes = F3(
	function (iconUnstyled, style, options) {
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					A2($frandibar$elm_font_awesome_5$FontAwesome$styleClass, iconUnstyled, style),
					true),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						$frandibar$elm_font_awesome_5$FontAwesome$iconClass(iconUnstyled),
						true),
					A2($elm$core$List$map, $frandibar$elm_font_awesome_5$FontAwesome$className, options))));
	});
var $frandibar$elm_font_awesome_5$FontAwesome$Utils$onlyOne = F3(
	function (f, curr, _v0) {
		var found = _v0.a;
		var list = _v0.b;
		var _v1 = _Utils_Tuple2(
			f(curr),
			found);
		if (_v1.a) {
			if (!_v1.b) {
				return _Utils_Tuple2(
					true,
					A2($elm$core$List$cons, curr, list));
			} else {
				return _Utils_Tuple2(found, list);
			}
		} else {
			return _Utils_Tuple2(
				found,
				A2($elm$core$List$cons, curr, list));
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup = F2(
	function (f, list) {
		return A3(
			$elm$core$List$foldr,
			$frandibar$elm_font_awesome_5$FontAwesome$Utils$onlyOne(f),
			_Utils_Tuple2(false, _List_Nil),
			list).b;
	});
var $frandibar$elm_font_awesome_5$FontAwesome$isAnimation = function (option) {
	if (!option.$) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isBorder = function (option) {
	if (option.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isHtmlTag = function (option) {
	if (option.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isInvertColor = function (option) {
	if (option.$ === 4) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isMask = function (option) {
	if (option.$ === 5) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isPull = function (option) {
	if (option.$ === 6) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isSize = function (option) {
	if (option.$ === 7) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isTransform = function (option) {
	if (option.$ === 8) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isWidth = function (option) {
	if (option.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$filterAttrs = function (options) {
	return A2(
		$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
		$frandibar$elm_font_awesome_5$FontAwesome$isWidth,
		A2(
			$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
			$frandibar$elm_font_awesome_5$FontAwesome$isTransform,
			A2(
				$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
				$frandibar$elm_font_awesome_5$FontAwesome$isSize,
				A2(
					$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
					$frandibar$elm_font_awesome_5$FontAwesome$isPull,
					A2(
						$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
						$frandibar$elm_font_awesome_5$FontAwesome$isMask,
						A2(
							$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
							$frandibar$elm_font_awesome_5$FontAwesome$isInvertColor,
							A2(
								$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
								$frandibar$elm_font_awesome_5$FontAwesome$isHtmlTag,
								A2(
									$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
									$frandibar$elm_font_awesome_5$FontAwesome$isBorder,
									A2($frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup, $frandibar$elm_font_awesome_5$FontAwesome$isAnimation, options)))))))));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $frandibar$elm_font_awesome_5$FontAwesome$mask = F2(
	function (opt, opts) {
		if (opt.$ === 5) {
			var maskIcon = opt.a;
			var style = opt.b;
			var val = A2($frandibar$elm_font_awesome_5$FontAwesome$styleClass, maskIcon, style) + (' ' + $frandibar$elm_font_awesome_5$FontAwesome$iconClass(maskIcon));
			return A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'data-fa-mask', val),
				opts);
		} else {
			return opts;
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$maskAttr = function (options) {
	return A3($elm$core$List$foldr, $frandibar$elm_font_awesome_5$FontAwesome$mask, _List_Nil, options);
};
var $frandibar$elm_font_awesome_5$FontAwesome$transformVal = function (transformValue) {
	switch (transformValue.$) {
		case 0:
			var n = transformValue.a;
			return 'grow-' + $elm$core$String$fromFloat(n);
		case 1:
			var n = transformValue.a;
			return 'shrink-' + $elm$core$String$fromFloat(n);
		case 2:
			var n = transformValue.a;
			return 'down-' + $elm$core$String$fromFloat(n);
		case 3:
			var n = transformValue.a;
			return 'left-' + $elm$core$String$fromFloat(n);
		case 4:
			var n = transformValue.a;
			return 'right-' + $elm$core$String$fromFloat(n);
		case 5:
			var n = transformValue.a;
			return 'up-' + $elm$core$String$fromFloat(n);
		case 6:
			var n = transformValue.a;
			return 'rotate-' + $elm$core$String$fromFloat(n);
		case 7:
			return 'flip-h';
		default:
			return 'flip-v';
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$transform = F2(
	function (opt, opts) {
		if (opt.$ === 8) {
			var transforms = opt.a;
			var val = A2(
				$elm$core$String$join,
				' ',
				A2($elm$core$List$map, $frandibar$elm_font_awesome_5$FontAwesome$transformVal, transforms));
			return A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'data-fa-transform', val),
				opts);
		} else {
			return opts;
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$transformAttr = function (options) {
	return A3($elm$core$List$foldr, $frandibar$elm_font_awesome_5$FontAwesome$transform, _List_Nil, options);
};
var $frandibar$elm_font_awesome_5$FontAwesome$htmlAttrs = F2(
	function (options, htmlAttributes) {
		return _Utils_ap(
			$frandibar$elm_font_awesome_5$FontAwesome$transformAttr(options),
			_Utils_ap(
				$frandibar$elm_font_awesome_5$FontAwesome$maskAttr(options),
				htmlAttributes));
	});
var $frandibar$elm_font_awesome_5$FontAwesome$I = 0;
var $frandibar$elm_font_awesome_5$FontAwesome$findTag = F2(
	function (option, previousTag) {
		if (option.$ === 3) {
			var newTag = option.a;
			return newTag;
		} else {
			return previousTag;
		}
	});
var $elm$html$Html$i = _VirtualDom_node('i');
var $frandibar$elm_font_awesome_5$FontAwesome$htmlTag = function (opts) {
	var foundTag = A3($elm$core$List$foldl, $frandibar$elm_font_awesome_5$FontAwesome$findTag, 0, opts);
	if (!foundTag) {
		return $elm$html$Html$i;
	} else {
		return $elm$html$Html$span;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions = F4(
	function (iconName, style, options, htmlAttributes) {
		var opts = $frandibar$elm_font_awesome_5$FontAwesome$filterAttrs(options);
		return A3(
			$frandibar$elm_font_awesome_5$FontAwesome$htmlTag,
			opts,
			A2(
				$elm$core$List$cons,
				A3($frandibar$elm_font_awesome_5$FontAwesome$classes, iconName, style, opts),
				A2($frandibar$elm_font_awesome_5$FontAwesome$htmlAttrs, opts, htmlAttributes)),
			_List_Nil);
	});
var $frandibar$elm_font_awesome_5$FontAwesome$icon = function (iconName) {
	return A4($frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions, iconName, 0, _List_Nil, _List_Nil);
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$MainMsg$GoToConversationPage = F2(
	function (a, b) {
		return {$: 234, a: a, b: b};
	});
var $author$project$Views$Nav$notificationAction = F2(
	function (notification, userProfile) {
		var _v0 = notification.hT;
		switch (_v0) {
			case 0:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Project(notification.iH),
					_List_fromArray(
						[notification.V]));
			case 2:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.V]));
			case 3:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Project(notification.iH),
					_List_fromArray(
						[notification.V]));
			case 4:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Project(notification.iH),
					_List_fromArray(
						[notification.V]));
			case 5:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.V]));
			case 6:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iH, 'Audition'),
					_List_fromArray(
						[notification.V]));
			case 7:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iH, 'Audition'),
					_List_fromArray(
						[notification.V]));
			case 8:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iH, 'Audition'),
					_List_fromArray(
						[notification.V]));
			case 12:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iH, 'Callback'),
					_List_fromArray(
						[notification.V]));
			case 13:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iH, 'Callback'),
					_List_fromArray(
						[notification.V]));
			case 14:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iH, 'Callback'),
					_List_fromArray(
						[notification.V]));
			case 11:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.V]));
			case 9:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.V]));
			case 15:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.V]));
			case 10:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.V]));
			case 16:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.V]));
			case 18:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Project(notification.iH),
					_List_fromArray(
						[notification.V]));
			case 19:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Project(notification.iH),
					_List_fromArray(
						[notification.V]));
			case 17:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.V]));
			case 20:
				return A2($author$project$MainMsg$GoToConversationPage, notification.gY, notification.V);
			default:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Dashboard,
					_List_fromArray(
						[notification.V]));
		}
	});
var $author$project$Views$Nav$notificationText = F2(
	function (notification, userProfile) {
		var _v0 = userProfile.P;
		switch (_v0) {
			case 4:
				var _v1 = notification.hT;
				switch (_v1) {
					case 0:
						return notification.jv + (' applied to ' + (notification.iY + (' in ' + notification.iI)));
					case 2:
						return notification.jv + (' has been invited to apply to ' + (notification.iY + (' in ' + notification.iI)));
					case 3:
						return notification.jv + (' ACCEPTED application request for ' + (notification.iY + (' in ' + notification.iI)));
					case 4:
						return notification.jv + (' REJECTED application request for ' + (notification.iY + (' in ' + notification.iI)));
					case 5:
						return notification.jv + (' has a pending audition request for ' + (notification.iY + (' in ' + notification.iI)));
					case 6:
						return notification.jv + (' ACCEPTED audition schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 7:
						return notification.jv + (' REJECTED audition schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 8:
						return notification.jv + (' requested to be RESCHEDULED for the audition for ' + (notification.iY + (' in ' + notification.iI)));
					case 12:
						return notification.jv + (' ACCEPTED callback schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 13:
						return notification.jv + (' REJECTED callback schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 14:
						return notification.jv + (' has requested to be RESCHEDULED for the callback for ' + (notification.iY + (' in ' + notification.iI)));
					case 11:
						return notification.jv + (' has a new callback schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 9:
						return notification.jv + (' has been RESCHEDULED for ' + (notification.iY + (' in ' + notification.iI)));
					case 15:
						return notification.jv + ('\'s callback has been RESCHEDULED for ' + (notification.iY + (' in ' + notification.iI)));
					case 10:
						return notification.jv + ('\'s audition has been canceled for ' + (notification.iY + (' in ' + notification.iI)));
					case 16:
						return notification.jv + ('\'s callback has been canceled for ' + (notification.iY + (' in ' + notification.iI)));
					case 18:
						return notification.jv + (' ACCEPTED booking request for ' + (notification.iY + (' in ' + notification.iI)));
					case 19:
						return notification.jv + (' REJECTED booking request for ' + (notification.iY + (' in ' + notification.iI)));
					case 17:
						return notification.jv + (' has a pending booking request for ' + (notification.iY + (' in ' + notification.iI)));
					case 21:
						return notification.iY + ' has been canceled until further notice.';
					case 22:
						var _v2 = userProfile.P;
						switch (_v2) {
							case 0:
								return 'Your role in project ' + (notification.iI + (' has been switched to ' + notification.iY));
							case 1:
								return 'Talent has switched their role in ' + (notification.iI + (' to ' + notification.iY));
							default:
								return 'Role has been switch in ' + (notification.iI + (' to ' + notification.iY));
						}
					case 25:
						return 'Agent has removed ' + (notification.jv + (' from project ' + notification.iY));
					case 24:
						return notification.jv + (' has been removed by casting from ' + notification.iY);
					case 23:
						return notification.jv + (' removed themselves from role ' + notification.iY);
					case 20:
						return (notification.dU > 1) ? ('You have ' + ($elm$core$String$fromInt(notification.dU) + ' new messages')) : 'You have a new message!';
					default:
						return 'NEW NOTIFICATION!';
				}
			case 3:
				var _v3 = notification.hT;
				switch (_v3) {
					case 0:
						return notification.jv + (' applied to ' + (notification.iY + (' in ' + notification.iI)));
					case 2:
						return notification.jv + (' has been invited to apply to ' + (notification.iY + (' in ' + notification.iI)));
					case 3:
						return notification.jv + (' ACCEPTED application request for ' + (notification.iY + (' in ' + notification.iI)));
					case 4:
						return notification.jv + (' REJECTED application request for ' + (notification.iY + (' in ' + notification.iI)));
					case 5:
						return notification.jv + (' has a pending audition request for ' + (notification.iY + (' in ' + notification.iI)));
					case 6:
						return notification.jv + (' ACCEPTED audition schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 7:
						return notification.jv + (' REJECTED audition schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 8:
						return notification.jv + (' requested to be RESCHEDULED for the audition for ' + (notification.iY + (' in ' + notification.iI)));
					case 12:
						return notification.jv + (' ACCEPTED callback schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 13:
						return notification.jv + (' REJECTED callback schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 14:
						return notification.jv + (' has requested to be RESCHEDULED for the callback for ' + (notification.iY + (' in ' + notification.iI)));
					case 11:
						return notification.jv + (' has a new callback schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 9:
						return notification.jv + (' has been RESCHEDULED for ' + (notification.iY + (' in ' + notification.iI)));
					case 15:
						return notification.jv + ('\'s callback has been RESCHEDULED for ' + (notification.iY + (' in ' + notification.iI)));
					case 10:
						return notification.jv + ('\'s audition has been canceled for ' + (notification.iY + (' in ' + notification.iI)));
					case 16:
						return notification.jv + ('\'s callback has been canceled for ' + (notification.iY + (' in ' + notification.iI)));
					case 18:
						return notification.jv + (' ACCEPTED booking request for ' + (notification.iY + (' in ' + notification.iI)));
					case 19:
						return notification.jv + (' REJECTED booking request for ' + (notification.iY + (' in ' + notification.iI)));
					case 17:
						return notification.jv + (' has a pending booking request for ' + (notification.iY + (' in ' + notification.iI)));
					case 21:
						return notification.iY + ' has been canceled until further notice.';
					case 22:
						var _v4 = userProfile.P;
						switch (_v4) {
							case 0:
								return 'Your role in project ' + (notification.iI + (' has been switched to ' + notification.iY));
							case 1:
								return 'Talent has switched their role in ' + (notification.iI + (' to ' + notification.iY));
							default:
								return 'Role has been switch in ' + (notification.iI + (' to ' + notification.iY));
						}
					case 25:
						return 'Agent has removed ' + (notification.jv + (' from project ' + notification.iY));
					case 24:
						return notification.jv + (' has been removed by casting from ' + notification.iY);
					case 23:
						return notification.jv + (' removed themselves from role ' + notification.iY);
					case 20:
						return (notification.dU > 1) ? ('You have ' + ($elm$core$String$fromInt(notification.dU) + ' new messages')) : 'You have a new message!';
					default:
						return 'NEW NOTIFICATION!';
				}
			default:
				var _v5 = notification.hT;
				switch (_v5) {
					case 0:
						return notification.jv + ' applied to your role!';
					case 2:
						return 'Congratulations! You have been selected to apply for the part of  ' + (notification.iY + (' in ' + notification.iI));
					case 3:
						return notification.jv + (' ACCEPTED your application request for ' + (notification.iY + (' in ' + notification.iI)));
					case 4:
						return notification.jv + (' REJECTED your application request for ' + (notification.iY + (' in ' + notification.iI)));
					case 5:
						return 'You\'ve got a new audition request for ' + (notification.iY + (' in ' + notification.iI));
					case 6:
						return notification.jv + (' ACCEPTED your audition schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 7:
						return notification.jv + (' REJECTED your audition schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 8:
						return notification.jv + (' has requested to be RESCHEDULED for the audition for ' + (notification.iY + (' in ' + notification.iI)));
					case 12:
						return notification.jv + (' ACCEPTED your callback schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 13:
						return notification.jv + (' REJECTED your callback schedule request for ' + (notification.iY + (' in ' + notification.iI)));
					case 14:
						return notification.jv + (' has requested to be RESCHEDULED for the callback for ' + (notification.iY + (' in ' + notification.iI)));
					case 11:
						return 'You have a new callback schedule request for ' + (notification.iY + (' in ' + notification.iI));
					case 9:
						return 'Your audition has been RESCHEDULED for ' + (notification.iY + (' in ' + notification.iI));
					case 15:
						return 'Your callback has been RESCHEDULED for ' + (notification.iY + (' in ' + notification.iI));
					case 10:
						return 'Your audition has been canceled for ' + (notification.iY + (' in ' + notification.iI));
					case 16:
						return 'Your callback has been canceled for ' + (notification.iY + (' in ' + notification.iI));
					case 18:
						return notification.jv + (' ACCEPTED your booking request for ' + (notification.iY + (' in ' + notification.iI)));
					case 19:
						return notification.jv + (' REJECTED your booking request for ' + (notification.iY + (' in ' + notification.iI)));
					case 17:
						return 'Congratulations! You\'ve been selected for the part of  ' + (notification.iY + (' in ' + notification.iI));
					case 21:
						return notification.iY + ' has been canceled until further notice.';
					case 22:
						var _v6 = userProfile.P;
						switch (_v6) {
							case 0:
								return 'Your role in project ' + (notification.iI + (' has been switched to ' + notification.iY));
							case 1:
								return 'Talent has switched their role in ' + (notification.iI + (' to ' + notification.iY));
							default:
								return 'Role has been switch in ' + (notification.iI + (' to ' + notification.iY));
						}
					case 25:
						return 'Agent has removed ' + (notification.jv + (' from project ' + notification.iY));
					case 24:
						return 'You\'ve been removed by casting from ' + notification.iY;
					case 23:
						return notification.jv + ('removed themselves from role ' + notification.iY);
					case 20:
						return (notification.dU > 1) ? ('You have ' + ($elm$core$String$fromInt(notification.dU) + ' new messages')) : 'You have a new message!';
					default:
						return 'NEW NOTIFICATION!';
				}
		}
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Views$Nav$notificationItem = F2(
	function (notification, userProfile) {
		var bodyText = function () {
			var _v2 = notification.hT;
			switch (_v2) {
				case 20:
					return notification.dG;
				case 4:
					return notification.dG;
				case 7:
					return notification.dG;
				case 19:
					return notification.dG;
				case 13:
					return notification.dG;
				case 8:
					return notification.dG;
				case 14:
					return notification.dG;
				default:
					return '';
			}
		}();
		var _v0 = function () {
			var _v1 = userProfile.P;
			switch (_v1) {
				case 0:
					var jobPosterAvatar = (notification.hO === '') ? '/default_user.png' : notification.hO;
					return _Utils_Tuple2(jobPosterAvatar, notification.hQ);
				case 1:
					var talentAvatar = (notification.js === '') ? '/default_user.png' : notification.js;
					return _Utils_Tuple2(notification.js, notification.jv);
				default:
					return _Utils_Tuple2('/default_user.png', '');
			}
		}();
		var avatar = _v0.a;
		var name = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('notification-item-container', true),
							_Utils_Tuple2('notification-container-dimmed', notification.hN)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('notification-sender-info-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('avatar-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(avatar)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('notification-time-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(notification.fY)
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('new-notification-icon', true),
											_Utils_Tuple2('hide-new-icon', notification.hN)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('New!')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('notification-info-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Views$Nav$notificationText, notification, userProfile))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('notification-body-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(bodyText)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('see-more-button'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Views$Nav$notificationAction, notification, userProfile))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('SEE MORE')
						]))
				]));
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Views$Nav$notificationList = function (userProfile) {
	return (!$elm$core$List$length(userProfile.bJ)) ? A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('empty-notifications')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('No Notifications')
					]))
			])) : A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('notification-list')
			]),
		A2(
			$elm$core$List$map,
			function (notification) {
				return A2($author$project$Views$Nav$notificationItem, notification, userProfile);
			},
			userProfile.bJ));
};
var $author$project$Views$Nav$notificationsModal = F2(
	function (newNotifications, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('right')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('notifications')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('notifications'),
									$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleNotifications)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('notification-text envelope')
										]),
									_List_fromArray(
										[
											$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$bell)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('notification-text notifications')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Notifications')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('notification-count')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$elm$core$List$length(newNotifications)))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('notification-container', true),
											_Utils_Tuple2('notifications-open', model.bp)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'showing-no-new',
													!$elm$core$List$length(newNotifications)),
													_Utils_Tuple2('no-new-notifications', true)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('No New Notifications')
										])),
									$author$project$Views$Nav$notificationList(model.z),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mark-as-read-button'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$MarkAllNotificationsAsRead(newNotifications))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Mark All As Read')
										]))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
							$elm$html$Html$Attributes$class('show-menu'),
							$elm$html$Html$Attributes$id('hamburger')
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$bars)
						])),
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
							$elm$html$Html$Attributes$class('show-menu menu-text button'),
							$elm$html$Html$Attributes$id('menu-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Menu')
						]))
				]));
	});
var $author$project$Views$Nav$pageTitle = function (model) {
	var _v0 = model.i;
	switch (_v0.$) {
		case 6:
			return 'Account';
		case 13:
			return 'Dashboard';
		case 14:
			return 'Profile';
		case 10:
			return 'Inbox';
		case 20:
			return 'Talent Search';
		case 21:
			return 'Projects';
		case 19:
			var s = _v0.a;
			return 'Account';
		case 12:
			return 'Roles';
		case 11:
			return 'Roles';
		case 22:
			var id = _v0.a;
			var code = _v0.b;
			return 'Account Verification';
		case 7:
			return 'Job Listing Details';
		case 8:
			return 'Discover Jobs';
		case 9:
			return 'My Jobs';
		case 23:
			return 'Schedules';
		case 24:
			return 'Schedules';
		default:
			return '';
	}
};
var $author$project$Views$Nav$showAgencyMenu = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('menu', true),
						_Utils_Tuple2('menu-open', model.bn)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Menu')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
								$elm$html$Html$Attributes$class('close-menu')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ｘ')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Dashboard))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Dashboard')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$AgencyProfile))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$TalentSearch))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Talent Search')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$Logout)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$Views$Nav$showAgentMenu = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('menu', true),
						_Utils_Tuple2('menu-open', model.bn)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Menu')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
								$elm$html$Html$Attributes$class('close-menu')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ｘ')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Dashboard))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Dashboard')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$AgentProfile))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$TalentSearch))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Talent Search')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$Logout)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$SharedProjectRoleSchedules$firstBasicProject = function (allProjects) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
		$elm$core$List$head(allProjects));
};
var $author$project$Views$Nav$maybeFirstProjectLink = function (dashbordDataStatus) {
	var project = function () {
		if (dashbordDataStatus.$ === 2) {
			var data = dashbordDataStatus.a;
			return $author$project$SharedProjectRoleSchedules$firstBasicProject(data.fe);
		} else {
			return $author$project$SharedProjectRoleSchedules$firstBasicProject(_List_Nil);
		}
	}();
	var _v0 = project.V;
	if (_v0 === '') {
		return $elm$html$Html$text('');
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$View(
								$author$project$Route$Project(project.V)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Projects')
						]))
				]));
	}
};
var $author$project$Views$Nav$showDirectorMenu = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('menu', true),
						_Utils_Tuple2('menu-open', model.bn)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Menu')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
								$elm$html$Html$Attributes$class('close-menu')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ｘ')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Dashboard))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Dashboard')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Account))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$TalentSearch))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Talent Search')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						$author$project$Views$Nav$maybeFirstProjectLink(model.g7)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$ScheduleIndex))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Schedules')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Inbox))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Inbox')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$Logout)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$Views$Nav$showTalentMenu = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('menu', true),
						_Utils_Tuple2('menu-open', model.bn)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Menu')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
								$elm$html$Html$Attributes$class('close-menu')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ｘ')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Dashboard))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Dashboard')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Account))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View(
									$author$project$Route$Job('1')))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Discover Jobs')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$MyJobs))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('My Jobs')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$Logout)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$MainMsg$ViewProfileSubPage = function (a) {
	return {$: 22, a: a};
};
var $author$project$Views$Nav$pageSubTitle = function (page) {
	return 'Profile Info';
};
var $author$project$Views$Nav$subNavBarItem = F2(
	function (currentRoute, page) {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$ViewProfileSubPage(page)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'highlight',
							_Utils_eq(
								currentRoute,
								$author$project$Route$ProfileSubPage(page)))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Views$Nav$pageSubTitle(page))
				]));
	});
var $author$project$Views$Nav$subNavBarItems = function (currentRoute) {
	var item = $author$project$Views$Nav$subNavBarItem(currentRoute);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('account-sub-nav')
			]),
		_List_fromArray(
			[
				item(0)
			]));
};
var $author$project$Views$Nav$subNavBar = function (model) {
	var _v0 = model.i;
	if (_v0.$ === 19) {
		return $author$project$Views$Nav$subNavBarItems(model.i);
	} else {
		return $author$project$Views$Nav$nothing;
	}
};
var $author$project$Views$Nav$navBar = function (model) {
	var newNotifications = A2(
		$elm$core$List$filter,
		function (notification) {
			return !notification.hN;
		},
		model.z.bJ);
	var notifications = function () {
		var _v1 = model.z.P;
		if (_v1 === 2) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collaborator-logout'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$Logout)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('logout')
					]));
		} else {
			return A2($author$project$Views$Nav$notificationsModal, newNotifications, model);
		}
	}();
	var menu = function () {
		var _v0 = model.z.P;
		switch (_v0) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Nav$showTalentMenu(model)
						]));
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Nav$showDirectorMenu(model)
						]));
			case 3:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Nav$showAgencyMenu(model)
						]));
			case 4:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Nav$showAgentMenu(model)
						]));
			default:
				return $author$project$Views$Nav$nothing;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$nav,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-menu')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('main-nav')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('logo-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('logo-link'),
												$elm$html$Html$Attributes$href('/dashboard')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('logo')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Views$Nav$pageTitle(model))
											]))
									])),
								notifications,
								$author$project$Views$Nav$subNavBar(model)
							])),
						menu,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('clip')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('invisible-modal', true),
										_Utils_Tuple2('showing-invisible-modal', model.bp || model.bn)
									])),
								$elm$html$Html$Events$onClick($author$project$MainMsg$CloseAllMenus)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$MainMsg$DeleteImage = function (a) {
	return {$: 135, a: a};
};
var $author$project$MainMsg$ToggleDeleteConfirmation = F2(
	function (a, b) {
		return {$: 83, a: a, b: b};
	});
var $author$project$MainMsg$DeleteAgent = function (a) {
	return {$: 104, a: a};
};
var $author$project$MainMsg$ToggleAddAgentForm = function (a) {
	return {$: 109, a: a};
};
var $author$project$MainMsg$AddAgent = {$: 103};
var $author$project$User$CurrentAgentCity = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$CurrentAgentFirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$CurrentAgentLastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$UpdateAgentInfoMsg = function (a) {
	return {$: 110, a: a};
};
var $author$project$User$CurrentAgentEmail = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Views$Profile$agentEmailField = function (profilePageData) {
	return (profilePageData.bB.V === '') ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Agent Email')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgentInfoMsg, $author$project$User$CurrentAgentEmail)),
						$elm$html$Html$Attributes$value(profilePageData.bB.bl),
						$elm$html$Html$Attributes$placeholder('Agent Email')
					]),
				_List_Nil)
			])) : A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(profilePageData.bB.bl)
			]));
};
var $author$project$Views$Profile$agentSubmitText = function (agent) {
	return (agent.V !== '') ? 'Update Agent' : 'Add Agent';
};
var $author$project$Views$Profile$addAgentForm = function (profilePageData) {
	return profilePageData.bY ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('add-agent-form')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Agent First Name')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgentInfoMsg, $author$project$User$CurrentAgentFirstName)),
						$elm$html$Html$Attributes$value(profilePageData.bB.bm),
						$elm$html$Html$Attributes$placeholder('Agent First Name')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Agent Last Name')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgentInfoMsg, $author$project$User$CurrentAgentLastName)),
						$elm$html$Html$Attributes$value(profilePageData.bB.bE),
						$elm$html$Html$Attributes$placeholder('Agent Last Name')
					]),
				_List_Nil),
				$author$project$Views$Profile$agentEmailField(profilePageData),
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Agent City')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgentInfoMsg, $author$project$User$CurrentAgentCity)),
						$elm$html$Html$Attributes$value(profilePageData.bB.aV),
						$elm$html$Html$Attributes$placeholder('Agent City')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('close-agent-form'),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$ToggleAddAgentForm(''))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('submit-agent-button'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$AddAgent)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Views$Profile$agentSubmitText(profilePageData.bB))
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Profile$deleteAgentButton = function (agent) {
	var _v0 = agent.hT;
	if (_v0 === 4) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$MainMsg$ToggleDeleteConfirmation, agent.V, ''))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Delete')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Views$Profile$agentItem = function (agent) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agent-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agent-image-info-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('agent-image-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(agent.eu)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('agent-info')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(agent.bm + (' ' + agent.bE))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(agent.aV)
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agent-action-items')
					]),
				_List_fromArray(
					[
						$author$project$Views$Profile$deleteAgentButton(agent),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleAddAgentForm(agent.V))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							]))
					]))
			]));
};
var $author$project$Views$Profile$agentList = function (agents) {
	return (!$elm$core$List$length(agents)) ? A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('There are no agents assocated with this agency.'),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$ToggleAddAgentForm('123'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('ADD AGENT')
					]))
			])) : A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agent-list')
			]),
		A2($elm$core$List$map, $author$project$Views$Profile$agentItem, agents));
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Views$Confirmations$deleteConfirmation = F4(
	function (showConfirmation, deleteMessage, toggleMessage, deleteText) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal', true),
									_Utils_Tuple2('modal-open', showConfirmation)
								])),
							$elm$html$Html$Events$onClick(toggleMessage)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('delete-confirmation', true),
									_Utils_Tuple2('delete-showing', showConfirmation)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(deleteText)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button'),
									$elm$html$Html$Events$onClick(deleteMessage)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Yes')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button'),
									$elm$html$Html$Events$onClick(toggleMessage)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No')
								]))
						]))
				]));
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Views$Profile$agencyAgents = F4(
	function (agents, profilePageData, showDeleteConfirmation, deleteID) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('agents-container')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Views$Confirmations$deleteConfirmation,
					showDeleteConfirmation,
					$author$project$MainMsg$DeleteAgent(deleteID),
					A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
					'Are you sure you want to delete this agent?'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Agents')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$ToggleAddAgentForm('123'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('ADD AGENT')
						])),
					$author$project$Views$Profile$agentList(agents),
					$author$project$Views$Profile$addAgentForm(profilePageData)
				]));
	});
var $author$project$User$AuditionNotification = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$MessageNotification = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$ProfileNotification = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$ProjectNotification = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$TalentNotification = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$UpdateNotificationSettings = function (a) {
	return {$: 106, a: a};
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Views$Profile$agencyNotificationSettings = function (notificationSettings) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-profile-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Please select the notifcations you would like to receive from Slayt. Please keep in mind you can come back and change these notfications at any time.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification-selection-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(notificationSettings.ae),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateNotificationSettings, $author$project$User$ProjectNotification))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selection-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Project Emails')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('selection-sub-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You will receive an email whenever a new project is posted.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification-selection-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(notificationSettings.jr),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateNotificationSettings, $author$project$User$TalentNotification))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selection-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Talent Bookings')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('selection-sub-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You will receive an email notifiying you that any of your registered talent have booking requests.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification-selection-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(notificationSettings.gy),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateNotificationSettings, $author$project$User$AuditionNotification))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selection-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Audition Notifications')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('selection-sub-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You will receive an email when talent receives audition/callback requests.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification-selection-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(notificationSettings.iD),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateNotificationSettings, $author$project$User$ProfileNotification))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selection-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Talent Profile Updates')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('selection-sub-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Whenever a talent changes their profile, which includes images, agency representation, sizes or videos, you will receive a notification.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification-selection-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(notificationSettings.h3),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateNotificationSettings, $author$project$User$MessageNotification))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selection-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('In App Messages')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('selection-sub-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You will be cc\'d on all communication through our in app messaging service.')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$User$AgencyName = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$AgentAddress1 = function (a) {
	return {$: 5, a: a};
};
var $author$project$User$AgentAddress2 = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$AgentCity = function (a) {
	return {$: 7, a: a};
};
var $author$project$User$AgentState = function (a) {
	return {$: 8, a: a};
};
var $author$project$User$AgentZip = function (a) {
	return {$: 9, a: a};
};
var $author$project$User$ProfileAgency = function (a) {
	return {$: 16, a: a};
};
var $author$project$MainMsg$UserProfileMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$Profile$agencyProfileAttributes = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-profile-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgencyName(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gl.cz),
										$elm$html$Html$Attributes$placeholder('Agency Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Email')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(userProfile.bl)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency Address')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgentAddress1(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gl.bv),
										$elm$html$Html$Attributes$placeholder('Address')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency Address Line 2')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgentAddress2(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gl.bw),
										$elm$html$Html$Attributes$placeholder('Address Line 2')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency City')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgentCity(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gl.aV),
										$elm$html$Html$Attributes$placeholder('City')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency State')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgentState(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gl.a7),
										$elm$html$Html$Attributes$placeholder('State')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency Zipcode')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgentZip(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gl.dn),
										$elm$html$Html$Attributes$placeholder('Zip Code')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$MainMsg$OpenCropper = function (a) {
	return {$: 254, a: a};
};
var $author$project$MainMsg$ImageRequested = function (a) {
	return {$: 114, a: a};
};
var $author$project$SharedProjectRoleSchedules$ReplaceFile = 0;
var $author$project$Views$Profile$replaceImageText = F2(
	function (image, images) {
		return ($elm$core$List$length(images) > 1) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$MainMsg$ToggleDeleteConfirmation, image.V, ''))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Remove image')
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image-upload-button'),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$ImageRequested(0))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Replace image')
				]));
	});
var $author$project$Views$Profile$imageItem = F2(
	function (image, images) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(image.jM)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image-options')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$Profile$replaceImageText, image, images),
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-crop-alt crop-image'),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$OpenCropper(image.V))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$MainMsg$CloseResizingModal = {$: 255};
var $author$project$Views$Profile$imageResizeWindow = F2(
	function (resizing, image) {
		return resizing ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image-resizing-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('resizing-modal'),
							$elm$html$Html$Events$onClick($author$project$MainMsg$CloseResizingModal)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('resizing-inner-window')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image-to-resize')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('overlay')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('overlay-inner')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('resize-image'),
											$elm$html$Html$Attributes$src(image.jM)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('crop-pro-tip')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Pro Tip: Hold down shift to preserve aspect ratio')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cancel-button'),
									$elm$html$Html$Events$onClick($author$project$MainMsg$CloseResizingModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn-crop js-crop')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Crop Image')
								]))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$MainMsg$Cancel = {$: 130};
var $author$project$MainMsg$DragFileEnter = {$: 257};
var $author$project$MainMsg$DragFileLeave = {$: 258};
var $author$project$SharedProjectRoleSchedules$NewFile = 1;
var $elm$core$Basics$round = _Basics_round;
var $author$project$Utils$createPercent = function (fraction) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(100 * fraction));
};
var $author$project$MainMsg$GotFiles = F2(
	function (a, b) {
		return {$: 124, a: a, b: b};
	});
var $elm$file$File$decoder = _File_decoder;
var $elm$json$Json$Decode$oneOrMoreHelp = F2(
	function (toValue, xs) {
		if (!xs.b) {
			return $elm$json$Json$Decode$fail('a ARRAY with at least ONE element');
		} else {
			var y = xs.a;
			var ys = xs.b;
			return $elm$json$Json$Decode$succeed(
				A2(toValue, y, ys));
		}
	});
var $elm$json$Json$Decode$oneOrMore = F2(
	function (toValue, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$elm$json$Json$Decode$oneOrMoreHelp(toValue),
			$elm$json$Json$Decode$list(decoder));
	});
var $author$project$Views$Profile$dropDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files']),
	A2($elm$json$Json$Decode$oneOrMore, $author$project$MainMsg$GotFiles, $elm$file$File$decoder));
var $author$project$Views$Profile$hijack = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$Views$Profile$hijackOn = F2(
	function (event, decoder) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Views$Profile$hijack, decoder));
	});
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$progress = _VirtualDom_node('progress');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Views$Profile$uploadGallery = F2(
	function (imageUpload, images) {
		switch (imageUpload.$) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image-upload-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image-upload-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Upload Image')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('upload-drop-zone'),
									A2(
									$author$project$Views$Profile$hijackOn,
									'dragenter',
									$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileEnter)),
									A2(
									$author$project$Views$Profile$hijackOn,
									'dragover',
									$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileEnter)),
									A2(
									$author$project$Views$Profile$hijackOn,
									'dragleave',
									$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileLeave)),
									A2($author$project$Views$Profile$hijackOn, 'drop', $author$project$Views$Profile$dropDecoder)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Drag a photo here')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Or')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('image-upload-button'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$ImageRequested(1))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Select Photos')
										]))
								]))
						]));
			case 1:
				var fraction = imageUpload.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$progress,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(
									$author$project$Utils$createPercent(fraction)),
									$elm$html$Html$Attributes$max('100'),
									A2($elm$html$Html$Attributes$style, 'display', 'block')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$MainMsg$Cancel)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image-upload-button-disabled')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Upload Image')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('upload-button-message')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('(max reached)')
								]))
						]));
			default:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$ImageRequested(1))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Image Upload Failed!')
						]));
		}
	});
var $author$project$Views$Profile$agencyQuestionsSection = function (model) {
	var _v0 = model.c.dZ;
	switch (_v0) {
		case 0:
			return $author$project$Views$Profile$agencyProfileAttributes(model.z);
		case 1:
			return $author$project$Views$Profile$agencyNotificationSettings(model.z.$9);
		case 2:
			return A4($author$project$Views$Profile$agencyAgents, model.z.gl.gr, model.c, model.Z, model.am);
		case 3:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('talent-view-page')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-container')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Views$Confirmations$deleteConfirmation,
								model.Z,
								$author$project$MainMsg$DeleteImage(model.am),
								A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
								'Are you sure you want to remove this image?'),
								A2($author$project$Views$Profile$imageResizeWindow, model.av, model.az),
								A2(
								$elm$html$Html$form,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form main-form')
									]),
								_List_fromArray(
									[
										A2($author$project$Views$Profile$uploadGallery, model.W, model.hE),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-preview-gallery')
											]),
										A2(
											$elm$core$List$map,
											function (image) {
												return A2($author$project$Views$Profile$imageItem, image, model.hE);
											},
											model.hE))
									]))
							]))
					]));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$MainMsg$UpdateProfileInfo = {$: 41};
var $author$project$Views$Profile$nextButton = F2(
	function (currentPageIndex, pageCount) {
		return (_Utils_cmp(currentPageIndex + 1, pageCount) < 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$GoToPage(currentPageIndex + 1))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('next-button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Next'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-right')
								]),
							_List_Nil)
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$MainMsg$UpdateProfileInfo)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('next-button save-exit-next')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Save and Exit'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-right')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Views$Profile$agentAgencyProfileFooter = F2(
	function (currentPageIndex, pageCount) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('profile-page-footer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pro-tip-footer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A2($author$project$Views$Profile$nextButton, currentPageIndex, pageCount)
				]));
	});
var $author$project$MainMsg$ToggleProfilePageNav = {$: 297};
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Views$Profile$profilePageSelection = F3(
	function (page, activePage, pages) {
		var pageIndex = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm_community$list_extra$List$Extra$elemIndex,
				page,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.r;
					},
					pages)));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$GoToPage(pageIndex)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('profile-page-option', true),
							_Utils_Tuple2(
							'active',
							_Utils_eq(page, activePage))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(page)
				]));
	});
var $author$project$Views$Profile$talentProfileHeader = F4(
	function (pages, activePage, currentPageIndex, navOpen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('profile-header-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$GoToPage(currentPageIndex - 1))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-left')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Back')
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selected-profile-page'),
							$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleProfilePageNav)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(activePage.r),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('fas fa-chevron-down', !navOpen),
											_Utils_Tuple2('fas fa-chevron-up', navOpen)
										]))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('profile-page-selection', true),
									_Utils_Tuple2('nav-open', navOpen)
								]))
						]),
					A2(
						$elm$core$List$map,
						function (page) {
							return A3($author$project$Views$Profile$profilePageSelection, page.r, activePage.r, pages);
						},
						pages)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('profile-next-button'),
							$elm$html$Html$Events$onClick($author$project$MainMsg$UpdateProfileInfo)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('EXIT')
						]))
				]));
	});
var $author$project$Views$Profile$agencyProfileView = function (model) {
	var _v0 = model.c.z;
	switch (_v0.$) {
		case 1:
			return $elm$html$Html$text('');
		case 2:
			return $elm$html$Html$text('');
		case 0:
			return $elm$html$Html$text('');
		default:
			var profile = _v0.a;
			var pageArray = $elm$core$Array$fromList(profile.ck);
			var activePage = A2(
				$elm$core$Maybe$withDefault,
				$author$project$User$emptyProfilePage,
				A2($elm$core$Array$get, model.c.dZ, pageArray));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('profile-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('profile-container')
							]),
						_List_fromArray(
							[
								A4($author$project$Views$Profile$talentProfileHeader, profile.ck, activePage, model.c.dZ, model.c.c7),
								$author$project$Views$Profile$agencyQuestionsSection(model),
								A2(
								$author$project$Views$Profile$agentAgencyProfileFooter,
								model.c.dZ,
								$elm$core$List$length(profile.ck))
							]))
					]));
	}
};
var $author$project$MainMsg$RegisterAgency = {$: 5};
var $author$project$User$AgencyPassword = function (a) {
	return {$: 10, a: a};
};
var $author$project$User$AgencyPasswordConfirmation = function (a) {
	return {$: 11, a: a};
};
var $author$project$User$AgentEmail = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$AgentFirstName = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$AgentLastName = function (a) {
	return {$: 2, a: a};
};
var $author$project$MainMsg$UpdateAgencyMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$Auth$agencySignupForm = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgencyName)),
									$elm$html$Html$Attributes$placeholder('Agency Name')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentFirstName)),
									$elm$html$Html$Attributes$placeholder('Account owners First Name')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentLastName)),
									$elm$html$Html$Attributes$placeholder('Account owners Last Name')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentEmail)),
									$elm$html$Html$Attributes$placeholder('Account owners Email')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentAddress1)),
									$elm$html$Html$Attributes$placeholder('Address')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentAddress2)),
									$elm$html$Html$Attributes$placeholder('Address Line 2')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentCity)),
									$elm$html$Html$Attributes$placeholder('City')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentState)),
									$elm$html$Html$Attributes$placeholder('State')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentZip)),
									$elm$html$Html$Attributes$placeholder('Zip Code')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgencyPassword)),
									$elm$html$Html$Attributes$placeholder('Password'),
									$elm$html$Html$Attributes$type_('password')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgencyPasswordConfirmation)),
									$elm$html$Html$Attributes$placeholder('Confirm Password'),
									$elm$html$Html$Attributes$type_('password')
								]),
							_List_Nil)
						]))
				]))
		]));
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Views$Auth$errorMessage = function (error) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('error-message')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(error)
			]));
};
var $author$project$Views$Auth$logoImage = function (logoPath) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src(logoPath),
				$elm$html$Html$Attributes$class('logo-primary')
			]),
		_List_Nil);
};
var $author$project$Views$Auth$agencySignupView = F3(
	function (err, email, logoPath) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Agency Sign Up')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									$author$project$Views$Auth$agencySignupForm,
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$RegisterAgency),
													$elm$html$Html$Attributes$class('button full')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('NEXT')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-switch-container')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Already have an account?'),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$Login)),
											$elm$html$Html$Attributes$class('link-button signup-switch')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Login »')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sign-up-options')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$DirectorRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch casting-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Casting Director Sign-Up »')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$TalentRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch casting-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Talent Sign-Up »')
										]))
								]))
						]))
				]));
	});
var $author$project$User$ProfileFirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$ProfileLastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$ProfilePhoneNumber = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$Profile$agentProfileAttributes = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-profile-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('First Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileFirstName)),
										$elm$html$Html$Attributes$value(userProfile.bm),
										$elm$html$Html$Attributes$placeholder('First Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Last Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileLastName)),
										$elm$html$Html$Attributes$value(userProfile.bE),
										$elm$html$Html$Attributes$placeholder('Last Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Email')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(userProfile.bl)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Phone Number')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfilePhoneNumber)),
										$elm$html$Html$Attributes$value(userProfile.eZ),
										$elm$html$Html$Attributes$placeholder('Phone Number')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Views$Profile$agentQuestionsSection = function (model) {
	var _v0 = model.c.dZ;
	switch (_v0) {
		case 0:
			return $author$project$Views$Profile$agentProfileAttributes(model.z);
		case 1:
			return $author$project$Views$Profile$agencyNotificationSettings(model.z.$9);
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('talent-view-page')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-container')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Views$Confirmations$deleteConfirmation,
								model.Z,
								$author$project$MainMsg$DeleteImage(model.am),
								A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
								'Are you sure you want to remove this image?'),
								A2($author$project$Views$Profile$imageResizeWindow, model.av, model.az),
								A2(
								$elm$html$Html$form,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form main-form')
									]),
								_List_fromArray(
									[
										A2($author$project$Views$Profile$uploadGallery, model.W, model.hE),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-preview-gallery')
											]),
										A2(
											$elm$core$List$map,
											function (image) {
												return A2($author$project$Views$Profile$imageItem, image, model.hE);
											},
											model.hE))
									]))
							]))
					]));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Views$Profile$agentProfileView = function (model) {
	var _v0 = model.c.z;
	switch (_v0.$) {
		case 1:
			return $elm$html$Html$text('');
		case 2:
			return $elm$html$Html$text('');
		case 0:
			return $elm$html$Html$text('');
		default:
			var profile = _v0.a;
			var pageArray = $elm$core$Array$fromList(profile.ck);
			var activePage = A2(
				$elm$core$Maybe$withDefault,
				$author$project$User$emptyProfilePage,
				A2($elm$core$Array$get, model.c.dZ, pageArray));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('profile-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('profile-container')
							]),
						_List_fromArray(
							[
								A4($author$project$Views$Profile$talentProfileHeader, profile.ck, activePage, model.c.dZ, model.c.c7),
								$author$project$Views$Profile$agentQuestionsSection(model),
								A2(
								$author$project$Views$Profile$agentAgencyProfileFooter,
								model.c.dZ,
								$elm$core$List$length(profile.ck))
							]))
					]));
	}
};
var $author$project$MainMsg$RegisterUser = {$: 19};
var $author$project$User$Company = function (a) {
	return {$: 6, a: a};
};
var $author$project$MainMsg$UpdateUserMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$UserFirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$UserLastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$UserPassword = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$UserPasswordConfirmation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Views$Auth$agentsSignupForm = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bm),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserFirstName)),
										$elm$html$Html$Attributes$placeholder('First Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bE),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserLastName)),
										$elm$html$Html$Attributes$placeholder('Last Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bl),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserEmail)),
										$elm$html$Html$Attributes$placeholder('Email')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.cE),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$Company)),
										$elm$html$Html$Attributes$placeholder('Company Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPassword)),
										$elm$html$Html$Attributes$placeholder('Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPasswordConfirmation)),
										$elm$html$Html$Attributes$placeholder('Confirm Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$MainMsg$DirectorConfirmationRedirect = {$: 20};
var $author$project$Views$Auth$showSignUpConfirmationModal = function (isOpen) {
	if (isOpen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('director-signup-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$MainMsg$DirectorConfirmationRedirect),
							$elm$html$Html$Attributes$class('close')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('X')
						])),
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirmation-modal-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Thanks for signing up!')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirmation-modal-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(' Thanks for signing up with Talent Source! Please check your email to confirm your registration.')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$View($author$project$Route$Login))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('return to login page.')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/talent-search'),
							$elm$html$Html$Attributes$class('temp-access-link')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('** Access Director Portal **')
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Auth$agentsSignupView = F4(
	function (isOpen, userProfile, logoPath, err) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Agents Signup')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									$author$project$Views$Auth$agentsSignupForm(userProfile),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$RegisterUser),
													$elm$html$Html$Attributes$class('button full')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Create Account')
												]))
										]))
								])),
							$author$project$Views$Auth$showSignUpConfirmationModal(isOpen)
						]))
				]));
	});
var $author$project$Views$Auth$collaboratorsSignupForm = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bm),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserFirstName)),
										$elm$html$Html$Attributes$placeholder('First Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bE),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserLastName)),
										$elm$html$Html$Attributes$placeholder('Last Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bl),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserEmail)),
										$elm$html$Html$Attributes$placeholder('Email')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.cE),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$Company)),
										$elm$html$Html$Attributes$placeholder('Company Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPassword)),
										$elm$html$Html$Attributes$placeholder('Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPasswordConfirmation)),
										$elm$html$Html$Attributes$placeholder('Confirm Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Views$Auth$collaboratorsSignupView = F4(
	function (isOpen, userProfile, logoPath, err) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Collaborator Signup')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									$author$project$Views$Auth$collaboratorsSignupForm(userProfile),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$RegisterUser),
													$elm$html$Html$Attributes$class('button full')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Create Account')
												]))
										]))
								])),
							$author$project$Views$Auth$showSignUpConfirmationModal(isOpen)
						]))
				]));
	});
var $author$project$MainMsg$UpdateTalentMembership = F2(
	function (a, b) {
		return {$: 318, a: a, b: b};
	});
var $author$project$Views$Dashboard$agentImageWidget = function (profile) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agent-profile-info-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Image$emptyImage,
							$elm$core$List$head(profile.hE)).jM)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(profile.bm + (' ' + profile.bE))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(profile.gl.cz)
							]))
					]))
			]));
};
var $author$project$MainMsg$FindJob = function (a) {
	return {$: 55, a: a};
};
var $author$project$Views$Dashboard$agentProjectLi = function (project) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href('/discover-jobs/' + project.V),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$FindJob(project.V))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(project.bH)
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(project.e1)
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'(' + ($elm$core$String$fromInt(
							$elm$core$List$length(project.fq)) + ' Roles)'))
					]))
			]));
};
var $author$project$Views$Dashboard$agentProjectsWidget = function (dashboardPageData) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agent-projects-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-widget-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Open Projects')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agent-projects-list')
					]),
				A2($elm$core$List$map, $author$project$Views$Dashboard$agentProjectLi, dashboardPageData.fe))
			]));
};
var $author$project$Views$Schedule$getVoteTotal = F2(
	function (votes, vote) {
		return $elm$core$String$fromInt(
			$elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.f6;
						},
						vote),
					votes)));
	});
var $frandibar$elm_font_awesome_5$FontAwesome$calendarTimes = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('calendar-times');
var $frandibar$elm_font_awesome_5$FontAwesome$check = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('check');
var $frandibar$elm_font_awesome_5$FontAwesome$hourglassStart = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('hourglass-start');
var $author$project$Views$Schedule$statusHoverText = F2(
	function (scheduleMembers, scheduleType) {
		var scheduleMember = A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fy;
						},
						scheduleType),
					scheduleMembers)));
		var _v0 = scheduleMember.dc;
		switch (_v0) {
			case 6:
				return _Utils_Tuple2('Accepted Audition Request', '');
			case 7:
				return _Utils_Tuple2('Rejected Audition', scheduleMember.dG);
			case 8:
				return _Utils_Tuple2('Requested to be rescheduled', scheduleMember.dG);
			case 9:
				return _Utils_Tuple2('Pending response from user', '');
			case 5:
				return _Utils_Tuple2('Pending response from user', '');
			case 12:
				return _Utils_Tuple2('Accepted Callback Request', '');
			case 13:
				return _Utils_Tuple2('Rejected Callback', scheduleMember.dG);
			case 14:
				return _Utils_Tuple2('Requested to be rescheduled for callback', scheduleMember.dG);
			case 15:
				return _Utils_Tuple2('Pending response from user', '');
			case 11:
				return _Utils_Tuple2('Pending response from user', '');
			default:
				return _Utils_Tuple2('', '');
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$times = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('times');
var $author$project$Views$Schedule$timeSlotStatus = F2(
	function (user, scheduleType) {
		var scheduleMember = A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fy;
						},
						scheduleType),
					user.fx)));
		var scheduleStatus = function () {
			var _v1 = scheduleMember.dc;
			switch (_v1) {
				case 5:
					return {cw: '', eY: 'active', af: '', ag: ''};
				case 11:
					return {cw: '', eY: 'active', af: '', ag: ''};
				case 6:
					return {cw: 'active', eY: '', af: '', ag: ''};
				case 7:
					return {cw: '', eY: '', af: 'active', ag: ''};
				case 8:
					return {cw: '', eY: '', af: '', ag: 'active'};
				case 12:
					return {cw: 'active', eY: '', af: '', ag: ''};
				case 13:
					return {cw: '', eY: '', af: 'active', ag: ''};
				case 14:
					return {cw: '', eY: '', af: '', ag: 'active'};
				case 9:
					return {cw: '', eY: 'active', af: '', ag: ''};
				case 15:
					return {cw: '', eY: 'active', af: '', ag: ''};
				default:
					return {cw: '', eY: '', af: '', ag: ''};
			}
		}();
		var _v0 = A2($author$project$Views$Schedule$statusHoverText, user.fx, scheduleType);
		var statusText = _v0.a;
		var statusReason = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('day-of-status')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('accepted-schedule-icon ' + scheduleStatus.cw)
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$check)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rejected-schedule-icon ' + scheduleStatus.af)
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$times)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pending-icon ' + scheduleStatus.eY)
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$hourglassStart)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('reschedule-icon ' + scheduleStatus.ag)
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$calendarTimes)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-verbiage')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('schedule-status-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(statusText)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-body-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(statusReason)
								]))
						]))
				]));
	});
var $author$project$Views$Schedule$dashboardDayOfScheduleTimeSlot = F2(
	function (timeSlot, scheduleType) {
		var yes = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f7, 'yes');
		var no = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f7, 'no');
		var maybe = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f7, 'maybe');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('day-of-schedule-item-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Data$Image$emptyImage,
										$elm$core$List$head(timeSlot.f_.hE)).jM)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('user-name-role-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(timeSlot.f_.bm + (' ' + timeSlot.f_.bE))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('role')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(timeSlot.f_.P.bH)
										]))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(scheduleType)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(timeSlot.el)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$Schedule$timeSlotStatus, timeSlot.f_, scheduleType)
						]))
				]));
	});
var $author$project$Views$Dashboard$agentScheduleInfo = function (dashboardPageData) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard-time-slots')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agent-talent-schedules')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Schedules')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('day-of-schedule-time-slots-container')
					]),
				A2(
					$elm$core$List$map,
					function (timeSlot) {
						return A2($author$project$Views$Schedule$dashboardDayOfScheduleTimeSlot, timeSlot, timeSlot.fy);
					},
					A2(
						$elm$core$List$filter,
						function (timeSlot) {
							return timeSlot.f_.cU !== '';
						},
						dashboardPageData.jD)))
			]));
};
var $author$project$Views$Dashboard$acceptedStatusButton = function (talent) {
	var _v0 = talent.cw;
	switch (_v0) {
		case 0:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('accepted-icon')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Accepted')
					]));
		case 1:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rejected-icon')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Rejected')
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pending-icons')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('accept-membership-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$ToggleDeleteConfirmation, 'Accepted', talent.h0))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Accept')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('reject-membership-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$ToggleDeleteConfirmation, 'Rejected', talent.h0))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reject')
							]))
					]));
	}
};
var $author$project$Views$Dashboard$talentLi = function (talent) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('talent-user-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('talent-image-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(talent.iC)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(talent.bH)
							]))
					])),
				$author$project$Views$Dashboard$acceptedStatusButton(talent)
			]));
};
var $author$project$Views$Dashboard$agentTalentWidget = function (dashboardPageData) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agent-talent-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-widget-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('My Talent')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-talent-list')
					]),
				A2($elm$core$List$map, $author$project$Views$Dashboard$talentLi, dashboardPageData.jr))
			]));
};
var $author$project$Views$Dashboard$agencyWidgets = F2(
	function (dashboardPageData, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('widget')
				]),
			_List_fromArray(
				[
					$author$project$Views$Dashboard$agentImageWidget(model.z),
					$author$project$Views$Dashboard$agentProjectsWidget(dashboardPageData),
					$author$project$Views$Dashboard$agentTalentWidget(dashboardPageData),
					$author$project$Views$Dashboard$agentScheduleInfo(dashboardPageData),
					A4(
					$author$project$Views$Confirmations$deleteConfirmation,
					model.Z,
					A2($author$project$MainMsg$UpdateTalentMembership, model.am, model.d1),
					A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
					'Are you sure you want to respond with ' + (model.am + ' for this talent?'))
				]));
	});
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Project$AcceptInvitation = 0;
var $author$project$MainMsg$OpenDayOfPage = F2(
	function (a, b) {
		return {$: 272, a: a, b: b};
	});
var $author$project$Project$RejectInvitation = 1;
var $author$project$MainMsg$UpdateInvitationStatus = F2(
	function (a, b) {
		return {$: 275, a: a, b: b};
	});
var $author$project$Views$Project$collaboratingProjectLink = function (project) {
	return project.cw ? A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A2($author$project$MainMsg$OpenDayOfPage, project.V, project.fz))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(project.bH)
			])) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collab-project-link')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(project.bH)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collab-action-buttons'),
						$elm$html$Html$Events$onClick(
						A2($author$project$MainMsg$UpdateInvitationStatus, 0, project.V))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('ACCEPT INVITATION')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collab-action-buttons'),
						$elm$html$Html$Events$onClick(
						A2($author$project$MainMsg$UpdateInvitationStatus, 1, project.V))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('REJECT INVITATION')
					]))
			]));
};
var $author$project$Views$Dashboard$collaboratingProjectList = function (model) {
	return A2(
		$elm$core$List$map,
		function (project) {
			return $author$project$Views$Project$collaboratingProjectLink(project);
		},
		model.dN);
};
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Views$Dashboard$collaboratorWidgets = F2(
	function (dashboardPageData, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('widget')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header-and-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$b,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Collaborating Projects')
										]))
								])),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('collaborator-body')
								]),
							$author$project$Views$Dashboard$collaboratingProjectList(model))
						]))
				]));
	});
var $author$project$Project$CreateProjectForm = 0;
var $author$project$Views$Dashboard$directorLinks = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$ToggleFormOpen(0))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Create Project')
			]))
	]);
var $author$project$Views$ModalOverlay$modal = F2(
	function (toggleMsg, open) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('modal', true),
							_Utils_Tuple2('modal-open', open)
						])),
					$elm$html$Html$Events$onClick(toggleMsg)
				]),
			_List_Nil);
	});
var $author$project$Project$AuditionLocation = function (a) {
	return {$: 11, a: a};
};
var $author$project$Project$CallbackLocation = function (a) {
	return {$: 14, a: a};
};
var $author$project$Project$NonUnion = function (a) {
	return {$: 21, a: a};
};
var $author$project$Project$NotesAgent = function (a) {
	return {$: 17, a: a};
};
var $author$project$Project$NotesTalent = function (a) {
	return {$: 18, a: a};
};
var $author$project$Project$ProjectDescription = function (a) {
	return {$: 16, a: a};
};
var $author$project$Project$ProjectDescriptionValidation = 1;
var $author$project$Project$ProjectLocationAddress1 = function (a) {
	return {$: 6, a: a};
};
var $author$project$Project$ProjectLocationAddress2 = function (a) {
	return {$: 7, a: a};
};
var $author$project$Project$ProjectLocationCity = function (a) {
	return {$: 8, a: a};
};
var $author$project$Project$ProjectLocationState = function (a) {
	return {$: 9, a: a};
};
var $author$project$Project$ProjectLocationZip = function (a) {
	return {$: 10, a: a};
};
var $author$project$MainMsg$ProjectMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Project$ProjectName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Project$ProjectNameValidation = 0;
var $author$project$Project$ProjectRate = function (a) {
	return {$: 19, a: a};
};
var $author$project$MainMsg$ProjectValidationMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Project$Union = function (a) {
	return {$: 20, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$calendar = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('calendar');
var $author$project$Views$FormValidation$invalidField = F2(
	function (touched, field) {
		return touched && (field === '');
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $CurrySoftware$elm_datepicker$DatePicker$Blur = {$: 6};
var $CurrySoftware$elm_datepicker$DatePicker$Focus = {$: 5};
var $CurrySoftware$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $CurrySoftware$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Date$Months = 1;
var $CurrySoftware$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $CurrySoftware$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.jZ - 1)) + ($justinmimbs$date$Date$monthToNumber(date.h9) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.ha,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.bg;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$option = _VirtualDom_node('option');
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			dX: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			cI: date
		};
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $CurrySoftware$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.bg;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $CurrySoftware$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.bD(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$CurrySoftware$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $CurrySoftware$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						classList(
						_List_fromArray(
							[
								_Utils_Tuple2('day', true),
								_Utils_Tuple2('disabled', disabled),
								_Utils_Tuple2(
								'picked',
								picked(d)),
								_Utils_Tuple2(
								'today',
								isToday(d)),
								_Utils_Tuple2(
								'other-month',
								isOtherMonth(d))
							]))
					]),
				props),
			_List_fromArray(
				[
					settings.cD(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.cI;
		var today = _v0.a9;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $CurrySoftware$elm_datepicker$DatePicker$Date$Off);
};
var $CurrySoftware$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, model) {
		var focused = model.ad;
		var today = model.a9;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.b9) - 1;
		var dpClass = $CurrySoftware$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($CurrySoftware$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v0 = A2($CurrySoftware$elm_datepicker$DatePicker$prepareDates, currentDate, settings.b9);
		var currentMonth = _v0.cI;
		var currentDates = _v0.dX;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($CurrySoftware$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$CurrySoftware$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$CurrySoftware$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				A2(
					$CurrySoftware$elm_datepicker$DatePicker$Date$yearRange,
					{cI: currentMonth, a9: today},
					settings.b$)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							dpClass('picker-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('prev-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'prev',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('month-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('month')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											settings.c_(
												$justinmimbs$date$Date$month(currentMonth)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('year')
										]),
									_List_fromArray(
										[
											(!$CurrySoftware$elm_datepicker$DatePicker$yearRangeActive(settings.b$)) ? $elm$html$Html$text(
											settings.dm(
												$justinmimbs$date$Date$year(currentMonth))) : A3(
											$elm$html$Html$Keyed$node,
											'span',
											_List_Nil,
											_List_fromArray(
												[
													_Utils_Tuple2(
													$elm$core$String$fromInt(
														$justinmimbs$date$Date$year(currentMonth)),
													dropdownYear)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('next-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'next',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
								]))
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							dpClass('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									dpClass('weekdays')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (d) {
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														dpClass('dow')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.cM(d))
													]));
										},
										A2(
											$elm$core$List$take,
											7,
											A2(
												$elm$core$List$drop,
												firstDayOffset,
												$elm$core$List$concat(
													A2(
														$elm$core$List$repeat,
														2,
														_List_fromArray(
															[0, 1, 2, 3, 4, 5, 6])))))))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[
									dpClass('days')
								]),
							dayList)
						]))
				]));
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $CurrySoftware$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var datepicker = _v0;
		var model = datepicker;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.hI));
		var inputClasses = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(settings.bg + 'input', true)
				]),
			settings.hH);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.cW)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($CurrySoftware$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($CurrySoftware$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($CurrySoftware$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($CurrySoftware$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($CurrySoftware$elm_datepicker$DatePicker$Focus)
						]),
					_Utils_ap(
						settings.cV,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.c5),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.cL, pickedDate)),
						model.an))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.bg + 'container', true),
			settings.cG);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.c2 ? A3($CurrySoftware$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Views$DatePicker$datePickerInput = F6(
	function (date, settings, datePicker, datePickerMsg, dateText, _v0) {
		var touched = _v0.a;
		var field = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('date-input-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					datePickerMsg,
					A3($CurrySoftware$elm_datepicker$DatePicker$view, date, settings, datePicker)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('date-input-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(dateText)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'invalid-date-field',
									A2($author$project$Views$FormValidation$invalidField, touched, field))
								]))
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$calendar)
						]))
				]));
	});
var $author$project$Project$findDeadline = F2(
	function (deadlines, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyDeadline,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (deadline) {
						return _Utils_eq(deadline.bH, name);
					},
					deadlines)));
	});
var $author$project$Views$Project$endDateFilledOut = F2(
	function (deadlines, name) {
		return $elm$core$String$length(
			A2($author$project$Project$findDeadline, deadlines, name).d8) > 0;
	});
var $author$project$Views$DatePicker$isDisabled = F2(
	function (dateInput, beginning) {
		if (dateInput.$ === 1) {
			return $CurrySoftware$elm_datepicker$DatePicker$defaultSettings.bD;
		} else {
			var date = dateInput.a;
			return function (d) {
				return (beginning === 'start') ? ((_Utils_cmp(
					$justinmimbs$date$Date$toRataDie(d),
					$justinmimbs$date$Date$toRataDie(date)) > 0) || $CurrySoftware$elm_datepicker$DatePicker$defaultSettings.bD(d)) : ((_Utils_cmp(
					$justinmimbs$date$Date$toRataDie(d),
					$justinmimbs$date$Date$toRataDie(date)) < 0) || $CurrySoftware$elm_datepicker$DatePicker$defaultSettings.bD(d));
			};
		}
	});
var $author$project$Views$DatePicker$endSettings = function (startDate) {
	return _Utils_update(
		$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
		{
			bD: A2($author$project$Views$DatePicker$isDisabled, startDate, 'end'),
			c5: ''
		});
};
var $author$project$Utils$monthTranslation = function (num) {
	switch (num) {
		case 1:
			return 'January';
		case 2:
			return 'February';
		case 3:
			return 'March';
		case 4:
			return 'April';
		case 5:
			return 'May';
		case 6:
			return 'June';
		case 7:
			return 'July';
		case 8:
			return 'August';
		case 9:
			return 'September';
		case 10:
			return 'October';
		case 11:
			return 'November';
		case 12:
			return 'December';
		default:
			return '';
	}
};
var $author$project$Utils$formatDate = function (date) {
	return $author$project$Utils$monthTranslation(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(
				A3($elm$core$String$slice, 5, 7, date)))) + (' ' + (A3($elm$core$String$slice, 8, 10, date) + (', ' + A3($elm$core$String$slice, 0, 4, date))));
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$MainMsg$CreateProject = {$: 47};
var $author$project$MainMsg$UpdateProject = {$: 49};
var $author$project$Views$Project$updating = function (id) {
	return $elm$core$String$length(id) > 0;
};
var $author$project$Views$Project$projectSubmitButton = function (model) {
	return $author$project$Views$Project$updating(model.ae.cU) ? A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$UpdateProject),
				$elm$html$Html$Attributes$class('next-step-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('SAVE')
			])) : A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$CreateProject),
				$elm$html$Html$Attributes$class('next-step-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('NEXT STEP')
			]));
};
var $author$project$Views$Project$startDateFilledOut = F2(
	function (deadlines, name) {
		return $elm$core$String$length(
			A2($author$project$Project$findDeadline, deadlines, name).fO) > 0;
	});
var $author$project$Views$DatePicker$startSettings = function (endDate) {
	return _Utils_update(
		$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
		{
			bD: A2($author$project$Views$DatePicker$isDisabled, endDate, 'start'),
			c5: ''
		});
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Views$Project$projectForm = function (model) {
	var projectDeadline = A2($author$project$Project$findDeadline, model.ae.hb, 'Project');
	var _v0 = function () {
		var _v1 = model.aN;
		switch (_v1) {
			case 1:
				return _Utils_Tuple2('create-project-modal form-hiding', '');
			case 0:
				return _Utils_Tuple2('create-project-modal', 'Create New Project');
			case 2:
				return _Utils_Tuple2('create-project-modal collapse-form', 'Creating Project...');
			default:
				return _Utils_Tuple2('create-project-modal form-complete', 'Creating Project...');
		}
	}();
	var formClass = _v0.a;
	var headerText = _v0.b;
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(formClass),
				$elm$html$Html$Attributes$autocomplete(false),
				$elm$html$Html$Events$onSubmit($author$project$MainMsg$NoOp)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('create-project-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(headerText)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('close-button'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleFormOpen(4))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('X')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('create-project-details-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-errors')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(model.c8)
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('PROJECT DETAILS')
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Project Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'invalid-field',
												A2($author$project$Views$FormValidation$invalidField, model.aP.bH, model.ae.bH))
											])),
										$elm$html$Html$Attributes$placeholder('Drink commerical'),
										$elm$html$Html$Events$onFocus(
										$author$project$MainMsg$ProjectValidationMsg(0)),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectName)),
										$elm$html$Html$Attributes$value(model.ae.bH)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('range-inputs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Project Start')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.at.gA,
										$author$project$Views$DatePicker$startSettings(model.at.iF),
										model.B.fd,
										$author$project$MainMsg$ToProjectStartDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.ae.hb, 'Project').fO),
										_Utils_Tuple2(
											A2($author$project$Views$Project$endDateFilledOut, model.ae.hb, 'Project'),
											A2($author$project$Project$findDeadline, model.ae.hb, 'Project').fO))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Project End')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.at.iF,
										$author$project$Views$DatePicker$endSettings(model.at.iK),
										model.B.fa,
										$author$project$MainMsg$ToProjectEndDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.ae.hb, 'Project').d8),
										_Utils_Tuple2(
											A2($author$project$Views$Project$startDateFilledOut, model.ae.hb, 'Project'),
											A2($author$project$Project$findDeadline, model.ae.hb, 'Project').d8))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Project Location')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('location-fields')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$placeholder('Address Line 1'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectLocationAddress1)),
														$elm$html$Html$Attributes$value(projectDeadline.bv)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$placeholder('Address Line 2'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectLocationAddress2)),
														$elm$html$Html$Attributes$value(projectDeadline.bw)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$placeholder('City'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectLocationCity)),
														$elm$html$Html$Attributes$value(projectDeadline.aV)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$placeholder('State'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectLocationState)),
														$elm$html$Html$Attributes$value(projectDeadline.a7)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$placeholder('Zip-Code'),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectLocationZip)),
												$elm$html$Html$Attributes$value(projectDeadline.dn)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Description')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'invalid-field',
												A2($author$project$Views$FormValidation$invalidField, model.aP.iE, model.ae.iE))
											])),
										$elm$html$Html$Attributes$placeholder('Include important details about this project here...'),
										$elm$html$Html$Events$onFocus(
										$author$project$MainMsg$ProjectValidationMsg(1)),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectDescription)),
										$elm$html$Html$Attributes$value(model.ae.iE)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Project Notes To Agent')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('Include important notes to agents here...'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$NotesAgent)),
										$elm$html$Html$Attributes$value(model.ae.gm)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Project Notes To Talent')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('Include important notes to talent here...'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$NotesTalent)),
										$elm$html$Html$Attributes$value(model.ae.jw)
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('create-project-schedule-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('SCHEDULE')
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('SUBMIT BY')
									])),
								A6(
								$author$project$Views$DatePicker$datePickerInput,
								model.at.jn,
								$author$project$Views$DatePicker$dateSettings,
								model.B.fR,
								$author$project$MainMsg$ToSubDatePicker,
								$author$project$Utils$formatDate(
									A2($author$project$Project$findDeadline, model.ae.hb, 'Submission').d8),
								_Utils_Tuple2(false, ''))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('range-inputs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Audition Start Date')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.at.gA,
										$author$project$Views$DatePicker$startSettings(model.at.gz),
										model.B.dD,
										$author$project$MainMsg$ToAudStartDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.ae.hb, 'Audition').fO),
										_Utils_Tuple2(
											A2($author$project$Views$Project$endDateFilledOut, model.ae.hb, 'Audition'),
											A2($author$project$Project$findDeadline, model.ae.hb, 'Audition').fO))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Audition End Date')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.at.gz,
										$author$project$Views$DatePicker$endSettings(model.at.gA),
										model.B.dC,
										$author$project$MainMsg$ToAudEndDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.ae.hb, 'Audition').d8),
										_Utils_Tuple2(
											A2($author$project$Views$Project$startDateFilledOut, model.ae.hb, 'Audition'),
											A2($author$project$Project$findDeadline, model.ae.hb, 'Audition').d8))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Audition Location')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$placeholder('123 Main St. Los Angeles, CA'),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$AuditionLocation)),
												$elm$html$Html$Attributes$value(
												A2($author$project$Project$findDeadline, model.ae.hb, 'Audition').hV)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('range-inputs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Callback Start Date')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.at.gJ,
										$author$project$Views$DatePicker$startSettings(model.at.gI),
										model.B.dJ,
										$author$project$MainMsg$ToCallStartDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.ae.hb, 'Callback').fO),
										_Utils_Tuple2(
											A2($author$project$Views$Project$endDateFilledOut, model.ae.hb, 'Callback'),
											A2($author$project$Project$findDeadline, model.ae.hb, 'Callback').fO))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Callback End Date')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.at.gI,
										$author$project$Views$DatePicker$endSettings(model.at.gJ),
										model.B.dI,
										$author$project$MainMsg$ToCallEndDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.ae.hb, 'Callback').d8),
										_Utils_Tuple2(
											A2($author$project$Views$Project$startDateFilledOut, model.ae.hb, 'Callback'),
											A2($author$project$Project$findDeadline, model.ae.hb, 'Callback').d8))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Callback Location')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$placeholder('123 Main St. Los Angeles, CA'),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$CallbackLocation)),
												$elm$html$Html$Attributes$value(
												A2($author$project$Project$findDeadline, model.ae.hb, 'Callback').hV)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Fitting Date')
									])),
								A6(
								$author$project$Views$DatePicker$datePickerInput,
								model.at.hu,
								$author$project$Views$DatePicker$startSettings(model.at.hu),
								model.B.ej,
								$author$project$MainMsg$ToFittingDatePicker,
								$author$project$Utils$formatDate(
									A2($author$project$Project$findDeadline, model.ae.hb, 'Fitting').d8),
								_Utils_Tuple2(false, ''))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Shoot Date')
									])),
								A6(
								$author$project$Views$DatePicker$datePickerInput,
								model.at.jg,
								$author$project$Views$DatePicker$startSettings(model.at.jg),
								model.B.fG,
								$author$project$MainMsg$ToShootDatePicker,
								$author$project$Utils$formatDate(
									A2($author$project$Project$findDeadline, model.ae.hb, 'Shoot').d8),
								_Utils_Tuple2(false, ''))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('range-inputs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input rate-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Rate')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('number'),
												$elm$html$Html$Attributes$value(model.ae.iJ),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectRate))
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input union-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('radio-button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('UNION'),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$value('union'),
														$elm$html$Html$Attributes$name('union'),
														$elm$html$Html$Events$onCheck(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$Union)),
														$elm$html$Html$Attributes$checked(model.ae.jI)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('radio-button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('NON-UNION'),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$value('non-union'),
														$elm$html$Html$Attributes$name('union'),
														$elm$html$Html$Events$onCheck(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$NonUnion)),
														$elm$html$Html$Attributes$checked(!model.ae.jI)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('NON-UNION')
													]))
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('create-project-footer')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Pro tip: You can always add or edit your project once it has been created.')
							])),
						$author$project$Views$Project$projectSubmitButton(model)
					]))
			]));
};
var $author$project$Views$Project$createProjectModal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('create-project-form-modal')
			]),
		_List_fromArray(
			[
				$author$project$Views$Project$projectForm(model),
				A2(
				$author$project$Views$ModalOverlay$modal,
				$author$project$MainMsg$ToggleFormOpen(4),
				model.aN !== 1)
			]));
};
var $author$project$RoleForms$AgeMax = function (a) {
	return {$: 5, a: a};
};
var $author$project$RoleForms$AgeMin = function (a) {
	return {$: 4, a: a};
};
var $author$project$RoleForms$MaxHeight = function (a) {
	return {$: 8, a: a};
};
var $author$project$RoleForms$MinHeight = function (a) {
	return {$: 7, a: a};
};
var $author$project$RoleForms$RoleDescription = function (a) {
	return {$: 2, a: a};
};
var $author$project$RoleForms$RoleDescriptionValidation = 2;
var $author$project$MainMsg$RoleMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$RoleForms$RoleName = function (a) {
	return {$: 0, a: a};
};
var $author$project$RoleForms$RoleNameValidation = 0;
var $author$project$RoleForms$RoleRate = function (a) {
	return {$: 1, a: a};
};
var $author$project$RoleForms$RoleRateValidation = 1;
var $author$project$MainMsg$RoleValidationMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$RoleForms$WeightMax = function (a) {
	return {$: 10, a: a};
};
var $author$project$RoleForms$WeightMin = function (a) {
	return {$: 9, a: a};
};
var $author$project$InitData$heightValues = _List_fromArray(
	[
		{e: '0', b: 'ANY'},
		{e: '48', b: '4\' 0\"'},
		{e: '49', b: '4\' 1\"'},
		{e: '50', b: '4\' 2\"'},
		{e: '51', b: '4\' 3\"'},
		{e: '52', b: '4\' 4\"'},
		{e: '53', b: '4\' 5\"'},
		{e: '54', b: '4\' 6\"'},
		{e: '55', b: '4\' 7\"'},
		{e: '56', b: '4\' 8\"'},
		{e: '57', b: '4\' 9\"'},
		{e: '58', b: '4\' 10\"'},
		{e: '59', b: '4\' 11\"'},
		{e: '60', b: '5\' 0\"'},
		{e: '61', b: '5\' 1\"'},
		{e: '62', b: '5\' 2\"'},
		{e: '63', b: '5\' 3\"'},
		{e: '64', b: '5\' 4\"'},
		{e: '65', b: '5\' 5\"'},
		{e: '66', b: '5\' 6\"'},
		{e: '67', b: '5\' 7\"'},
		{e: '68', b: '5\' 8\"'},
		{e: '69', b: '5\' 9\"'},
		{e: '70', b: '5\' 10\"'},
		{e: '71', b: '5\' 11\"'},
		{e: '72', b: '6\' 0\"'},
		{e: '73', b: '6\' 1\"'},
		{e: '74', b: '6\' 2\"'},
		{e: '75', b: '6\' 3\"'},
		{e: '76', b: '6\' 4\"'},
		{e: '77', b: '6\' 5\"'},
		{e: '78', b: '6\' 6\"'},
		{e: '79', b: '6\' 7\"'},
		{e: '80', b: '6\' 8\"'},
		{e: '81', b: '6\' 9\"'},
		{e: '82', b: '6\' 10\"'},
		{e: '83', b: '6\' 11\"'},
		{e: '84', b: '7\' 0\"'},
		{e: '85', b: '7\' 1\"'},
		{e: '86', b: '7\' 2\"'},
		{e: '87', b: '7\' 3\"'},
		{e: '88', b: '7\' 4\"'},
		{e: '89', b: '7\' 5\"'},
		{e: '90', b: '7\' 6\"'}
	]);
var $author$project$MainMsg$AddAllEthnicities = {$: 253};
var $author$project$MainMsg$AddAllGenders = {$: 252};
var $author$project$MainMsg$AddEthnicityItem = function (a) {
	return {$: 144, a: a};
};
var $author$project$MainMsg$AddGenderItem = function (a) {
	return {$: 143, a: a};
};
var $author$project$MainMsg$UserAddEthnicityItem = function (a) {
	return {$: 145, a: a};
};
var $author$project$Views$Form$addAllButton = F2(
	function (selectedOptions, aMsg) {
		return (selectedOptions > 0) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('all-button'),
					$elm$html$Html$Events$onClick(aMsg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('clear all')
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('all-button'),
					$elm$html$Html$Events$onClick(aMsg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('add all')
				]));
	});
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $elm$html$Html$Lazy$lazy2 = $elm$virtual_dom$VirtualDom$lazy2;
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Views$Form$multiOptionField = F2(
	function (item, itemList) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item.V),
					$elm$html$Html$Attributes$disabled(
					A2($elm$core$List$member, item.bH, itemList))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item.bH)
				]));
	});
var $author$project$MainMsg$RemoveAllItems = function (a) {
	return {$: 151, a: a};
};
var $author$project$Views$Form$removeAllVisible = F2(
	function (values, msg) {
		return ($elm$core$List$length(values) >= 1) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$RemoveAllItems(msg)),
					$elm$html$Html$Attributes$class('remove-all-items-icon')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('x')
				])) : $elm$html$Html$text('');
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$MainMsg$RemoveItem = F2(
	function (a, b) {
		return {$: 146, a: a, b: b};
	});
var $author$project$Views$Form$valueLi = F3(
	function (value, multiMsg, options) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selected-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2($author$project$MainMsg$RemoveItem, multiMsg, value)),
							$elm$html$Html$Attributes$class('remove-item')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('X')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('option-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Views$Form$multiSelect = F4(
	function (labelText, options, values, multiMsg) {
		switch (multiMsg) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('multi-select')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							A2(
							$author$project$Views$Form$addAllButton,
							$elm$core$List$length(values),
							$author$project$MainMsg$AddAllGenders),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Events$on,
									'change',
									A2($elm$json$Json$Decode$map, $author$project$MainMsg$AddGenderItem, $elm$html$Html$Events$targetValue)),
									$elm$html$Html$Attributes$class('select-field'),
									$elm$html$Html$Attributes$value('')
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$multiOptionField, option, values);
								},
								options)),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('selected-items')
								]),
							A2(
								$elm$core$List$map,
								function (value) {
									return A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Form$valueLi, value, multiMsg, options);
								},
								values)),
							A2($author$project$Views$Form$removeAllVisible, values, 0)
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('multi-select')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							A2(
							$author$project$Views$Form$addAllButton,
							$elm$core$List$length(values),
							$author$project$MainMsg$AddAllEthnicities),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Events$on,
									'change',
									A2($elm$json$Json$Decode$map, $author$project$MainMsg$AddEthnicityItem, $elm$html$Html$Events$targetValue)),
									$elm$html$Html$Attributes$class('select-field'),
									$elm$html$Html$Attributes$value('')
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$multiOptionField, option, values);
								},
								options)),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('selected-items')
								]),
							A2(
								$elm$core$List$map,
								function (value) {
									return A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Form$valueLi, value, multiMsg, options);
								},
								values)),
							A2($author$project$Views$Form$removeAllVisible, values, 2)
						]));
			case 3:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('multi-select')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Events$on,
									'change',
									A2($elm$json$Json$Decode$map, $author$project$MainMsg$UserAddEthnicityItem, $elm$html$Html$Events$targetValue)),
									$elm$html$Html$Attributes$class('select-field'),
									$elm$html$Html$Attributes$value('')
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									return A2($author$project$Views$Form$multiOptionField, option, values);
								},
								options)),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('selected-items')
								]),
							A2(
								$elm$core$List$map,
								function (value) {
									return A3($author$project$Views$Form$valueLi, value, multiMsg, options);
								},
								values)),
							A2($author$project$Views$Form$removeAllVisible, values, 3)
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('multi-select')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('select-field'),
									$elm$html$Html$Attributes$value('-')
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$multiOptionField, option, values);
								},
								options)),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('selected-items')
								]),
							A2(
								$elm$core$List$map,
								function (value) {
									return A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Form$valueLi, value, multiMsg, options);
								},
								values))
						]));
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$Animation = function (a) {
	return {$: 0, a: a};
};
var $author$project$MainMsg$SetProjectId = function (a) {
	return {$: 69, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$Spin = 0;
var $author$project$MainMsg$UpdateRole = {$: 62};
var $author$project$MainMsg$CreateRoleAndOpenNewForm = {$: 152};
var $author$project$Views$Project$anotherRoleDisabled = function (role) {
	return ((role.bH === '') && (role.iV === '')) ? $author$project$MainMsg$NoOp : $author$project$MainMsg$CreateRoleAndOpenNewForm;
};
var $author$project$MainMsg$CreateRole = {$: 60};
var $author$project$Views$Project$createOrExitRoleForm = function (role) {
	return (role.bH !== '') ? $author$project$MainMsg$CreateRole : $author$project$MainMsg$ToggleFormOpen(4);
};
var $frandibar$elm_font_awesome_5$FontAwesome$spinner = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('spinner');
var $author$project$Views$Project$roleSubmitButton = F3(
	function (role, flow, currentId) {
		switch (flow) {
			case 0:
				return $author$project$Views$Project$updating(role.cU) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$MainMsg$UpdateRole)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update Role')
								]))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$SetProjectId(currentId))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Edit Project')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Views$Project$anotherRoleDisabled(role))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('ADD ANOTHER ROLE')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Views$Project$createOrExitRoleForm(role))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('DONE')
								]))
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A4(
											$frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions,
											$frandibar$elm_font_awesome_5$FontAwesome$spinner,
											0,
											_List_fromArray(
												[
													$frandibar$elm_font_awesome_5$FontAwesome$Animation(0)
												]),
											_List_Nil)
										]))
								]))
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$Form$heightOptionField = F2(
	function (item, selectedValue) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item.e),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item.e, selectedValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item.b)
				]));
	});
var $author$project$Views$Form$selectHeightField = F5(
	function (aMsg, bMsg, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, aMsg, bMsg)),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$heightOptionField, option, valueText);
					},
					options))
			]);
	});
var $author$project$Views$Form$convertIntOptionsToString = function (options) {
	return A2($elm$core$List$map, $elm$core$String$fromInt, options);
};
var $author$project$Views$Form$stringOptionField = F2(
	function (item, selectedValue) {
		var _default = (item === '0') ? 'Select Option' : item;
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(_default),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(_default, selectedValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(_default)
				]));
	});
var $author$project$Views$Form$selectIntField = F4(
	function (msg, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(msg),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$stringOptionField, option, valueText);
					},
					A2(
						$elm$core$List$cons,
						'ANY',
						$author$project$Views$Form$convertIntOptionsToString(options))))
			]);
	});
var $author$project$Views$Project$roleForm = function (model) {
	var _v0 = function () {
		var _v1 = model.ah;
		switch (_v1) {
			case 1:
				return _Utils_Tuple2('create-role-form-container form-hiding', '');
			case 0:
				return _Utils_Tuple2('create-role-form-container', 'Create Role');
			case 2:
				return _Utils_Tuple2('create-role-form-container collapse-form', 'Creating Role...');
			default:
				return _Utils_Tuple2('create-role-form-container form-complete', 'Creating Role...');
		}
	}();
	var formClass = _v0.a;
	var headerText = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(formClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('create-role-form')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(headerText)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('close-role'),
										$elm$html$Html$Events$onClick(
										$author$project$MainMsg$ToggleFormOpen(4))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('X')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('create-role-form-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-left')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Role Name ')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Events$onFocus(
												$author$project$MainMsg$RoleValidationMsg(0)),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'invalid-field',
														A2($author$project$Views$FormValidation$invalidField, model.T.bH, model.P.bH))
													])),
												$elm$html$Html$Attributes$placeholder('Director'),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$RoleName)),
												$elm$html$Html$Attributes$value(model.P.bH)
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Description')
													])),
												A2(
												$elm$html$Html$textarea,
												_List_fromArray(
													[
														$elm$html$Html$Events$onFocus(
														$author$project$MainMsg$RoleValidationMsg(2)),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'invalid-field',
																A2($author$project$Views$FormValidation$invalidField, model.T.iV, model.P.iV))
															])),
														$elm$html$Html$Attributes$placeholder('Write a brief description of the role.'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$RoleDescription)),
														$elm$html$Html$Attributes$value(model.P.iV)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Rate')
													])),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Events$onFocus(
														$author$project$MainMsg$RoleValidationMsg(1)),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'invalid-field',
																A2($author$project$Views$FormValidation$invalidField, model.T.iZ, model.P.iZ))
															])),
														$elm$html$Html$Attributes$placeholder('$1000 + 15% agency fee'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$RoleRate)),
														$elm$html$Html$Attributes$value(model.P.iZ)
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-right')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A4(
												$author$project$Views$Form$multiSelect,
												'Gender',
												A2(
													$elm$core$List$cons,
													{V: '', bH: ''},
													model.hy),
												A2(
													$elm$core$List$map,
													function (option) {
														return option.bH;
													},
													model.P.hy),
												0)
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A4(
												$author$project$Views$Form$multiSelect,
												'Ethnic Appearance',
												A2(
													$elm$core$List$cons,
													{V: '', bH: ''},
													model.ea),
												A2(
													$elm$core$List$map,
													function (option) {
														return option.bH;
													},
													model.P.ea),
												2)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('height-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A4(
													$author$project$Views$Form$selectIntField,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$AgeMin),
													'Minimum Age',
													A2($elm$core$List$range, 0, model.P.cX),
													$elm$core$String$fromInt(model.P.cZ))),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A4(
													$author$project$Views$Form$selectIntField,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$AgeMax),
													'Maximum Age',
													A2($elm$core$List$range, model.P.cZ, 75),
													$elm$core$String$fromInt(model.P.cX)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('height-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A5(
													$author$project$Views$Form$selectHeightField,
													$author$project$MainMsg$RoleMsg,
													$author$project$RoleForms$MinHeight,
													'Minimum Height',
													$author$project$InitData$heightValues,
													$elm$core$String$fromInt(model.P.h4))),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A5(
													$author$project$Views$Form$selectHeightField,
													$author$project$MainMsg$RoleMsg,
													$author$project$RoleForms$MaxHeight,
													'Maximum Height',
													$author$project$InitData$heightValues,
													$elm$core$String$fromInt(model.P.hZ)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('height-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A4(
													$author$project$Views$Form$selectIntField,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$WeightMin),
													'Minimum Weight',
													A2(
														$elm$core$List$range,
														60,
														$elm$core$Basics$round(model.P.eI)),
													$elm$core$String$fromFloat(model.P.eN))),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A4(
													$author$project$Views$Form$selectIntField,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$WeightMax),
													'Maximum Weight',
													A2(
														$elm$core$List$range,
														$elm$core$Basics$round(model.P.eN),
														500),
													$elm$core$String$fromFloat(model.P.eI)))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-footer')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Pro tip: You can always add or edit roles once project is created.')
									])),
								A3($author$project$Views$Project$roleSubmitButton, model.P, model.ah, model.d_)
							]))
					]))
			]));
};
var $author$project$Views$Project$createRoleModal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('role-form')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Views$ModalOverlay$modal,
				$author$project$MainMsg$ToggleFormOpen(4),
				model.ah !== 1),
				$author$project$Views$Project$roleForm(model)
			]));
};
var $author$project$Views$Project$directorModals = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Views$Project$createProjectModal(model),
				$author$project$Views$Project$createRoleModal(model)
			]));
};
var $author$project$Views$Dashboard$senderName = F3(
	function (role, jobPosterName, talentName) {
		switch (role) {
			case 0:
				return jobPosterName;
			case 1:
				return talentName;
			default:
				return talentName;
		}
	});
var $author$project$Views$Dashboard$listInbox = function (model) {
	var lastMessages = A2(
		$elm$core$List$map,
		function (channel) {
			return {gY: channel.V, hQ: channel.hQ, hU: channel.hU, jv: channel.jv, jK: channel.bW};
		},
		A2($elm$core$List$take, 3, model.j.g));
	return A2(
		$elm$core$List$map,
		function (message) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A2($author$project$MainMsg$GoToConversationPage, message.gY, '')),
						$elm$html$Html$Attributes$class('inbox-widget-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($author$project$Views$Dashboard$senderName, model.z.P, message.hQ, message.jv))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(message.hU)
							]))
					]));
		},
		lastMessages);
};
var $author$project$Views$Dashboard$listProjects = function (dashboardPageData) {
	return A2(
		$elm$core$List$map,
		function (project) {
			var roleCount = $elm$core$List$length(project.fq);
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/projects/' + project.V),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateCurrentProjectId(project.V)),
						$elm$html$Html$Attributes$class('widget-list-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('project-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(project.bH)
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('project-roles')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'(' + ($elm$core$String$fromInt(roleCount) + ' Roles)'))
									]))
							]))
					]));
		},
		dashboardPageData.fe);
};
var $author$project$Views$Dashboard$listRoles = function (dashboardPageData) {
	return A2(
		$elm$core$List$map,
		function (role) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/projects/' + role.iH),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateCurrentProjectId(role.iH)),
						$elm$html$Html$Attributes$class('widget-list-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(role.bH)
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-parent-project')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(role.iI)
									]))
							]))
					]));
		},
		dashboardPageData.fq);
};
var $author$project$Views$Dashboard$directorWidgets = F2(
	function (dashboardPageData, model) {
		var firstProject = A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
			$elm$core$List$head(dashboardPageData.fe)).V;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('widgets-list')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('widget')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-and-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$b,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Recent Projects')
												]))
										])),
									A2($elm$html$Html$hr, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('body')
										]),
									$author$project$Views$Dashboard$listProjects(dashboardPageData))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('footer')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('see-more'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View(
												$author$project$Route$Project(firstProject)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('View All Projects')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('widget')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-and-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$b,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Recent Roles')
												]))
										])),
									A2($elm$html$Html$hr, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('body')
										]),
									$author$project$Views$Dashboard$listRoles(dashboardPageData))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('footer')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('see-more'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View(
												$author$project$Route$Project(firstProject)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('View All Roles')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('widget')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-and-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$b,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Inbox')
												]))
										])),
									A2($elm$html$Html$hr, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('body')
										]),
									$author$project$Views$Dashboard$listInbox(model))
								]))
						]))
				]));
	});
var $author$project$Utils$loader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loader')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('loader__icon fas fa-cog fa-spin')
						]),
					_List_Nil)
				]))
		]));
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Views$Dashboard$talentLinks = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$View($author$project$Route$MyJobs))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Details for your upcoming casting call ')
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$View(
					$author$project$Route$ProfileSubPage(0)))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Finish Profile Setup')
			]))
	]);
var $author$project$Views$Job$itemList = function (items) {
	var _v0 = $elm$core$List$head(items);
	if (!_v0.$) {
		var item = _v0.a;
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(item + ' ')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Dashboard$listJobs = function (dashboardPageData) {
	return A2(
		$elm$core$List$map,
		function (project) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/discover-jobs/' + project.V),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$FindJob(project.V)),
						$elm$html$Html$Attributes$class('widget-list-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(project.bH)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Featured | ')
											])),
										$author$project$Views$Job$itemList(
										A2(
											$elm$core$List$map,
											function ($) {
												return $.bH;
											},
											project.fq))
									]))
							]))
					]));
		},
		dashboardPageData.fe);
};
var $author$project$Views$Dashboard$actionRequired = function (job) {
	return A2(
		$elm$core$List$member,
		job.a7,
		_List_fromArray(
			[2, 17])) || (A2(
		$elm$core$List$member,
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(job.fx)).dc,
		_List_fromArray(
			[5, 17, 11, 15, 9])) || A2(
		$elm$core$List$member,
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				$elm$core$List$reverse(job.fx))).dc,
		_List_fromArray(
			[5, 17, 11, 15, 9])));
};
var $author$project$Views$Dashboard$listMyJobs = function (dashboardPageData) {
	return A2(
		$elm$core$List$map,
		function (job) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$View($author$project$Route$MyJobs)),
						$elm$html$Html$Attributes$class('inbox-widget-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(job.P.iI + (': ' + job.P.bH))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('action-text', true),
										_Utils_Tuple2(
										'showing-action-text',
										$author$project$Views$Dashboard$actionRequired(job))
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Action Required')
							]))
					]));
		},
		A2($elm$core$List$take, 3, dashboardPageData.eO));
};
var $author$project$Views$Dashboard$talentWidgets = F2(
	function (dashboardData, model) {
		var page = function () {
			var _v0 = model.z.P;
			switch (_v0) {
				case 0:
					return $author$project$MainMsg$View($author$project$Route$MyJobs);
				case 1:
					return $author$project$MainMsg$View($author$project$Route$Inbox);
				default:
					return $author$project$MainMsg$View($author$project$Route$Inbox);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('widgets-list')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('widget')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-and-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$b,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('DISCOVER')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('see-more'),
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$View(
														$author$project$Route$Job('1')))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('SEE MORE')
												]))
										])),
									A2($elm$html$Html$hr, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('body')
										]),
									$author$project$Views$Dashboard$listJobs(dashboardData))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('widget')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-and-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$b,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('MY JOBS')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('see-more'),
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$View($author$project$Route$MyJobs))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('SEE MORE')
												]))
										])),
									A2($elm$html$Html$hr, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('body')
										]),
									$author$project$Views$Dashboard$listMyJobs(dashboardData))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('widget')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-and-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$b,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('INBOX')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('see-more'),
													$elm$html$Html$Events$onClick(page)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('SEE MORE')
												]))
										])),
									A2($elm$html$Html$hr, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('body')
										]),
									$author$project$Views$Dashboard$listInbox(model))
								]))
						]))
				]));
	});
var $author$project$Views$Dashboards$AgencyDashboard$agencyConfirmations = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$author$project$Views$Confirmations$deleteConfirmation,
				model.Z,
				A2($author$project$MainMsg$UpdateTalentMembership, model.am, model.d1),
				A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
				'Are you sure you want to respond with ' + (model.am + ' for this talent?'))
			]));
};
var $author$project$Views$Dashboards$AgencyRoleSummarySection$agencyEmptyRoleSummaryView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('card-body')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('No roles associated with your talent.')
		]));
var $author$project$Views$Dashboards$AgencyRoleSummarySection$Booked = 0;
var $author$project$Views$Dashboards$AgencyRoleSummarySection$Matched = 3;
var $author$project$Views$Dashboards$AgencyRoleSummarySection$Rejected = 1;
var $author$project$Views$Dashboards$AgencyRoleSummarySection$Scheduled = 2;
var $author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryIcon = F2(
	function (stat, item) {
		var _v0 = function () {
			switch (stat) {
				case 0:
					return _Utils_Tuple3('booked', 'far fa-calendar-check', item.gD);
				case 1:
					return _Utils_Tuple3('rejected', 'far fa-calendar-times', item.iS);
				case 2:
					return _Utils_Tuple3('scheduled', 'far fa-clock', item.i1);
				default:
					return _Utils_Tuple3('matched', 'fas fa-hourglass-start', item.hX);
			}
		}();
		var className = _v0.a;
		var icon = _v0.b;
		var count = _v0.c;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__role-icon-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__role-item-status-count')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(count))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__role-item-' + (className + (' ' + icon)))
						]),
					_List_Nil)
				]));
	});
var $author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryItemIcons = function (item) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard__role-item-icons')
			]),
		_List_fromArray(
			[
				A2($author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryIcon, 0, item),
				A2($author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryIcon, 1, item),
				A2($author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryIcon, 2, item),
				A2($author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryIcon, 3, item)
			]));
};
var $author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryItem = function (item) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard__role-item'),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$View(
					$author$project$Route$AgencyTalentSchedulePage(item.iX)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__role-item-name')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(item.iY)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__role-item-project')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(item.iI)
					])),
				$author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryItemIcons(item)
			]));
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryView = function (roles) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard__section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__section-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__section-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Talent Roles')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__section-body')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card dashboard__messages-container')
							]),
						_List_fromArray(
							[
								function () {
								var _v0 = $elm$core$List$isEmpty(roles);
								if (_v0) {
									return $author$project$Views$Dashboards$AgencyRoleSummarySection$agencyEmptyRoleSummaryView;
								} else {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										A2($elm$core$List$map, $author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryItem, roles));
								}
							}()
							]))
					]))
			]));
};
var $author$project$Views$Dashboards$AgencyTalentSection$agencyEmptyTalentView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('card')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card-body')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('You currently don\'t have any talent associated with your agency.')
				]))
		]));
var $author$project$TalentProfileModal$OpenedModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$Dashboards$AgencyTalentSection$agencyTalentItemStatus = function (talent) {
	var _v0 = talent.cw;
	switch (_v0) {
		case 0:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__talent-item-status')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('You are connected')
					]));
		case 1:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__talent-item-status')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Rejected')
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__talent-item-actions')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn__primary is-small'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$ToggleDeleteConfirmation, 'Accepted', talent.h0))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Accept')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn__default is-small'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$ToggleDeleteConfirmation, 'Rejected', talent.h0))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reject')
							]))
					]));
	}
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Views$Dashboards$AgencyTalentSection$agencyTalentItem = function (talent) {
	var imageSrc = function () {
		var _v0 = talent.iC;
		if (_v0 === '') {
			return $author$project$Data$Image$emptyImage.jM;
		} else {
			return talent.iC;
		}
	}();
	var accepted = talent.cw === 2;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard__talent-item'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('has-highlight', accepted)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('avatar')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('avatar__image is-small'),
										$elm$html$Html$Attributes$src(imageSrc)
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__talent-item-content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__talent-item-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(talent.bH),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__talent-item-icon fas fa-info-circle'),
										$elm$html$Html$Attributes$title('Click to view details and message this person'),
										$elm$html$Html$Events$onClick(
										$author$project$MainMsg$GotTalentProfileModalMsg(
											$author$project$TalentProfileModal$OpenedModal(talent.V)))
									]),
								_List_Nil)
							])),
						$author$project$Views$Dashboards$AgencyTalentSection$agencyTalentItemStatus(talent)
					]))
			]));
};
var $author$project$Views$Dashboards$AgencyTalentSection$agencyTalentSectionView = function (talent) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard__section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__section-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__section-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('My Talent')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__section-body')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = $elm$core$List$isEmpty(talent);
						if (_v0) {
							return $author$project$Views$Dashboards$AgencyTalentSection$agencyEmptyTalentView;
						} else {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card dashboard__talent-container')
									]),
								A2($elm$core$List$map, $author$project$Views$Dashboards$AgencyTalentSection$agencyTalentItem, talent));
						}
					}()
					]))
			]));
};
var $author$project$Views$Dashboards$SharedProfileSection$agencyProfileAvatar = function (user) {
	var imageSrc = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Data$Image$emptyImage,
		$elm$core$List$head(user.hE)).jM;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard__profile-avatar-section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('avatar')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('avatar__image'),
								$elm$html$Html$Attributes$src(imageSrc)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Views$Dashboards$SharedProfileSection$fullName = function (user) {
	return user.bm + (' ' + user.bE);
};
var $author$project$Views$Dashboards$SharedProfileSection$sharedProfileSection = function (user) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__section dashboard__profile')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__profile-header')
							]),
						_List_fromArray(
							[
								$author$project$Views$Dashboards$SharedProfileSection$agencyProfileAvatar(user)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__profile-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__profile-headline')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Views$Dashboards$SharedProfileSection$fullName(user))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__profile-subheadline')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(user.gl.cz)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__profile-actions')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn__primary'),
												$elm$html$Html$Events$onClick(
												$author$project$MainMsg$View($author$project$Route$AgentProfile))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View Profile')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Views$Dashboards$SharedMessages$agencyEmptyMessagesView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('card-body')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('No messages.')
		]));
var $elm$core$String$trim = _String_trim;
var $author$project$Views$Dashboards$SharedMessages$agencyMessageItem = function (channel) {
	var shortMessage = A3($elm$core$String$slice, 0, 40, channel.hU);
	var name = function () {
		var _v1 = $elm$core$String$trim(channel.jv);
		if (_v1 === '') {
			return 'Deleted user';
		} else {
			var trimmed = _v1;
			return trimmed;
		}
	}();
	var imageSrc = function () {
		var _v0 = channel.js;
		if (_v0 === '') {
			return $author$project$Data$Image$emptyImage.jM;
		} else {
			return channel.js;
		}
	}();
	var hasUnread = channel.bW > 0;
	var date = channel.g9;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard__messages-item'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('has-highlight', hasUnread)
					])),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$View($author$project$Route$Inbox))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('avatar')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('avatar__image is-small'),
										$elm$html$Html$Attributes$src(imageSrc)
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__messages-item-content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__messages-item-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__messages-item-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__messages-item-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(shortMessage)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__messages-item-date')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(date)
									]))
							]))
					]))
			]));
};
var $author$project$Views$Dashboards$SharedMessages$view = function (twilioData) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard__section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__section-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__section-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Inbox')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__section-body')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card dashboard__messages-container')
							]),
						_List_fromArray(
							[
								function () {
								var _v0 = $elm$core$List$isEmpty(twilioData.g);
								if (_v0) {
									return $author$project$Views$Dashboards$SharedMessages$agencyEmptyMessagesView;
								} else {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										A2($elm$core$List$map, $author$project$Views$Dashboards$SharedMessages$agencyMessageItem, twilioData.g));
								}
							}()
							]))
					]))
			]));
};
var $author$project$Views$Dashboards$SharedProjects$emptyProjectsView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('card')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card-body')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('There are currently no open projects. Please check back later for updates.')
				]))
		]));
var $author$project$Views$Dashboards$SharedProjects$projectClickMsg = F2(
	function (project, userProfile) {
		var _v0 = userProfile.P;
		if (_v0 === 1) {
			return $author$project$MainMsg$UpdateCurrentProjectId(project.V);
		} else {
			return $author$project$MainMsg$FindJob(project.V);
		}
	});
var $author$project$Views$Dashboards$SharedProjects$plural = F3(
	function (count, singularText, pluralText) {
		if (count === 1) {
			return singularText;
		} else {
			return pluralText;
		}
	});
var $author$project$Views$Dashboards$SharedProjects$projectItem = F2(
	function (userProfile, project) {
		var roleCount = $elm$core$List$length(project.fq);
		var roleText = A3($author$project$Views$Dashboards$SharedProjects$plural, roleCount, 'Role', 'Roles');
		var nameText = ' (' + ($elm$core$String$fromInt(roleCount) + (' ' + (roleText + ')')));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__project-item'),
					$elm$html$Html$Events$onClick(
					A2($author$project$Views$Dashboards$SharedProjects$projectClickMsg, project, userProfile))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__project-item-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dashboard__project-item-company')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(project.gS)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dashboard__project-item-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(project.bH),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('dashboard__project-item-role')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(nameText)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__project-item-date')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(project.e1)
								]))
						]))
				]));
	});
var $author$project$Views$Dashboards$SharedProjects$view = F3(
	function (title, projects, userProfile) {
		var firstProject = A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
			$elm$core$List$head(projects));
		var viewAllMsg = A2($author$project$Views$Dashboards$SharedProjects$projectClickMsg, firstProject, userProfile);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dashboard__section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__section-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dashboard__section-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dashboard__section-header-link'),
											$elm$html$Html$Events$onClick(viewAllMsg)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('View All')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dashboard__section-body')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = $elm$core$List$isEmpty(projects);
							if (_v0) {
								return $author$project$Views$Dashboards$SharedProjects$emptyProjectsView;
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card dashboard__projects-container')
										]),
									A2(
										$elm$core$List$map,
										$author$project$Views$Dashboards$SharedProjects$projectItem(userProfile),
										projects));
							}
						}()
						]))
				]));
	});
var $author$project$Views$Dashboards$AgencyDashboard$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__container-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__container-left-section')
									]),
								_List_fromArray(
									[
										$author$project$Views$Dashboards$SharedProfileSection$sharedProfileSection(model.z),
										$author$project$Views$Dashboards$AgencyTalentSection$agencyTalentSectionView(model.d$.jr)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__container-middle-section')
									]),
								_List_fromArray(
									[
										A3($author$project$Views$Dashboards$SharedProjects$view, 'Open Projects', model.d$.fe, model.z),
										$author$project$Views$Dashboards$AgencyRoleSummarySection$agencyRoleSummaryView(model.i$)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__container-right-section')
									]),
								_List_fromArray(
									[
										$author$project$Views$Dashboards$SharedMessages$view(model.j)
									]))
							])),
						$author$project$Views$Dashboards$AgencyDashboard$agencyConfirmations(model)
					]))
			]));
};
var $author$project$Views$Dashboards$CastingDashboard$viewWelcomeMessage = function (userProfile) {
	var message = 'Welcome to your Dashboard. Here you can see all your active projects, roles and messages all in one place.';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard__welcome-msg')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__welcome-msg-title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Hi,'),
						$elm$html$Html$text(' '),
						$elm$html$Html$text(userProfile.bm)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__welcome-msg-body')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__welcome-msg-links')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__welcome-msg-link'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleFormOpen(0))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create Project')
							]))
					]))
			]));
};
var $author$project$Views$Dashboards$CastingDashboard$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard__container')
					]),
				_List_fromArray(
					[
						$author$project$Views$Dashboards$CastingDashboard$viewWelcomeMessage(model.z),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dashboard__container-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__container-left-section')
									]),
								_List_fromArray(
									[
										$author$project$Views$Dashboards$SharedProfileSection$sharedProfileSection(model.z)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dashboard__container-normal-section')
									]),
								_List_fromArray(
									[
										A3($author$project$Views$Dashboards$SharedProjects$view, 'Recent Projects', model.d$.fe, model.z),
										$author$project$Views$Dashboards$SharedMessages$view(model.j)
									]))
							]))
					]))
			]));
};
var $author$project$Views$Dashboard$dashboardView = function (model) {
	var welcomeText = function () {
		var _v17 = model.z.P;
		switch (_v17) {
			case 0:
				return 'Welcome to your living resume. In this section you are able to show what skills and characteristics you possess. Filling this section out fully and accurately will enable you to be connected with the greatest number of relevant jobs.';
			case 1:
				return 'Welcome to your Dashboard. Here you can see all your active projects, roles and messages all in one place.';
			case 3:
				return '';
			case 4:
				return '';
			default:
				return 'Welcome to your Dashboard. Here you can see all your collaborated projects. Click on one to go to Day of schedule page.';
		}
	}();
	var modals = function () {
		var _v16 = model.z.P;
		switch (_v16) {
			case 0:
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			case 1:
				return $author$project$Views$Project$directorModals(model);
			default:
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	}();
	var mainSection = function () {
		var _v15 = model.z.P;
		switch (_v15) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hi ' + (model.z.bm + '.'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('body')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(welcomeText)
								])),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil)
						]));
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hi ' + (model.z.bm + '.'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('body')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(welcomeText)
								])),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil)
						]));
			default:
				return $elm$html$Html$text('');
		}
	}();
	var links = function () {
		var _v14 = model.z.P;
		switch (_v14) {
			case 0:
				return $author$project$Views$Dashboard$talentLinks;
			case 1:
				return $author$project$Views$Dashboard$directorLinks;
			default:
				return _List_fromArray(
					[
						$elm$html$Html$text('')
					]);
		}
	}();
	var dashboardData = function () {
		var _v13 = model.g7;
		if (_v13.$ === 2) {
			var data = _v13.a;
			return $elm$core$Maybe$Just(data);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var widgets = function () {
		var _v7 = _Utils_Tuple2(dashboardData, model.z.P);
		_v7$5:
		while (true) {
			if (!_v7.a.$) {
				switch (_v7.b) {
					case 0:
						var data = _v7.a.a;
						var _v8 = _v7.b;
						return A2($author$project$Views$Dashboard$talentWidgets, data, model);
					case 1:
						var data = _v7.a.a;
						var _v9 = _v7.b;
						return A2($author$project$Views$Dashboard$directorWidgets, data, model);
					case 2:
						var data = _v7.a.a;
						var _v10 = _v7.b;
						return A2($author$project$Views$Dashboard$collaboratorWidgets, data, model);
					case 3:
						var data = _v7.a.a;
						var _v11 = _v7.b;
						return A2($author$project$Views$Dashboard$agencyWidgets, data, model);
					case 4:
						var data = _v7.a.a;
						var _v12 = _v7.b;
						return A2($author$project$Views$Dashboard$agencyWidgets, data, model);
					default:
						break _v7$5;
				}
			} else {
				break _v7$5;
			}
		}
		return $elm$html$Html$text('');
	}();
	var _v0 = _Utils_Tuple2(dashboardData, model.z.P);
	_v0$4:
	while (true) {
		if (_v0.a.$ === 1) {
			switch (_v0.b) {
				case 3:
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return $author$project$Utils$loader;
				case 1:
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return $author$project$Utils$loader;
				default:
					break _v0$4;
			}
		} else {
			switch (_v0.b) {
				case 1:
					var data = _v0.a.a;
					var _v5 = _v0.b;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Views$Dashboards$CastingDashboard$view(
								{d$: data, j: model.j, z: model.z}),
								modals
							]));
				case 3:
					var data = _v0.a.a;
					var _v6 = _v0.b;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Views$Dashboards$AgencyDashboard$view(
								{d$: data, am: model.am, d1: model.d1, i$: data.jy, Z: model.Z, j: model.j, z: model.z})
							]));
				default:
					break _v0$4;
			}
		}
	}
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard')
					]),
				_List_fromArray(
					[
						mainSection,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('links')
							]),
						links),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('widgets')
							]),
						_List_fromArray(
							[widgets])),
						modals
					]))
			]));
};
var $author$project$Views$Auth$directorSignupForm = function (email) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserFirstName)),
										$elm$html$Html$Attributes$placeholder('First Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserLastName)),
										$elm$html$Html$Attributes$placeholder('Last Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(email),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserEmail)),
										$elm$html$Html$Attributes$placeholder('Email')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$Company)),
										$elm$html$Html$Attributes$placeholder('Company Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPassword)),
										$elm$html$Html$Attributes$placeholder('Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPasswordConfirmation)),
										$elm$html$Html$Attributes$placeholder('Confirm Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Views$Auth$directorSignupView = F4(
	function (isOpen, err, email, logoPath) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Casting Director Registration')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									$author$project$Views$Auth$directorSignupForm(email),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$RegisterUser),
													$elm$html$Html$Attributes$class('button full')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Create Account')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-switch-container')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Already have an account?'),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$Login)),
											$elm$html$Html$Attributes$class('link-button signup-switch')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Login »')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sign-up-options')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$TalentRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch talent-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Talent Sign-up »')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$AgencyRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch casting-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Agency Sign-Up »')
										]))
								])),
							$author$project$Views$Auth$showSignUpConfirmationModal(isOpen)
						]))
				]));
	});
var $author$project$Project$InboxPage = 5;
var $author$project$MainMsg$ToggleConfirmation = F2(
	function (a, b) {
		return {$: 97, a: a, b: b};
	});
var $author$project$MainMsg$UpdateUsersRoleStage = F4(
	function (a, b, c, d) {
		return {$: 155, a: a, b: b, c: c, d: d};
	});
var $author$project$MainMsg$ChatFileRequested = function (a) {
	return {$: 116, a: a};
};
var $author$project$MainMsg$SendMessage = {$: 102};
var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
var $frandibar$elm_font_awesome_5$FontAwesome$fileImage = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('file-image');
var $frandibar$elm_font_awesome_5$FontAwesome$paperclip = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('paperclip');
var $author$project$Views$Messages$chatInputBox = F4(
	function (body, convoId, chatFileText, channel) {
		return channel.dz ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('disabled-text')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Conversation has been disabled')
				])) : A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('chat-input-box-container', true),
							_Utils_Tuple2('chat-input-hidden', (channel.V === '') || channel.dz)
						])),
					$elm$html$Html$Events$onSubmit($author$project$MainMsg$SendMessage)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chat-input-icon')
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$paperclip)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chat-input-icon')
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$fileImage)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('file'),
							$elm$html$Html$Attributes$id('chat-file-input'),
							$elm$html$Html$Attributes$accept('image/*, application/pdf'),
							$elm$html$Html$Events$onInput($author$project$MainMsg$ChatFileRequested),
							$elm$html$Html$Attributes$disabled(channel.dz)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('chat-file-text'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'chat-file-text-hidden',
									!$elm$core$String$length(chatFileText))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(chatFileText)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$class('chat-input-field'),
							$elm$html$Html$Attributes$disabled(channel.dz),
							$elm$html$Html$Attributes$placeholder('Write Something here...'),
							$elm$html$Html$Attributes$value(body),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
							$elm$html$Html$Attributes$disabled(channel.V === '')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('chat-submit-button', true),
									_Utils_Tuple2('submit-button-diabled', channel.dz)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Send')
						]))
				]));
	});
var $author$project$MainMsg$ToggleNotificationModalFromMessages = F4(
	function (a, b, c, d) {
		return {$: 222, a: a, b: b, c: c, d: d};
	});
var $author$project$Views$Messages$findProjectId = F2(
	function (conversation, projects) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyProject,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.bH;
						},
						conversation.iI),
					projects))).cU;
	});
var $author$project$Views$Messages$scheduleForCallbackButton = F2(
	function (projects, conversation) {
		var project = A2($author$project$Utils$findProject, projects, conversation.iH);
		var deadline = A2($author$project$Project$findDeadline, project.hb, 'Callback');
		return (deadline.bH !== '') ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('quick-action-button')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Callback'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Schedule for callback')
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$Messages$chatQuickActions = F5(
	function (notificationData, stage, user, conversation, projects) {
		if (!user.P) {
			switch (stage) {
				case 2:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Accepted Application', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Accept Application')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reject-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Rejected Application', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reject Application')
									]))
							]));
				case 5:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Quick Actions')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Audition Accepted', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Accept Audition Request')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reject-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Audition Rejected', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reject Audition Request')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Audition Reschedule Requested', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Request Reschedule')
									]))
							]));
				case 11:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Quick Actions')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Callback Accepted', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Accept Callback Request')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reject-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Callback Rejected', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reject Callback Request')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Callback Reschedule Requested', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Request Reschedule')
									]))
							]));
				case 17:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Quick Actions')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Accepted', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Accept Booking Request')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reject-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Rejected', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reject Booking Request')
									]))
							]));
				default:
					return A2($elm$html$Html$span, _List_Nil, _List_Nil);
			}
		} else {
			switch (stage) {
				case 0:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: User Applied to the role.')
									]))
							]));
				case 2:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Waiting for response to application request.')
									]))
							]));
				case 3:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Accepted Application Request')
									]))
							]));
				case 4:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Rejected Application Request')
									]))
							]));
				case 5:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Waiting for response to audition scheduling request.')
									]))
							]));
				case 6:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2($author$project$Views$Messages$scheduleForCallbackButton, projects, conversation),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Accepted audition schedule. ')
									]))
							]));
				case 7:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Audition'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Rejected audition schedule.')
									]))
							]));
				case 8:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Audition'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Requested to reschedule audition.')
									]))
							]));
				case 9:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Audition'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Requested to reschedule audition.')
									]))
							]));
				case 11:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Waiting for response to callback scheduling request.')
									]))
							]));
				case 12:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Accepted callback schedule.')
									]))
							]));
				case 14:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Callback'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Requested to reschedule callback')
									]))
							]));
				case 13:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Callback'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Rejected callback schedule.')
									]))
							]));
				case 15:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Callback'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aQ, conversation.eA, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Requested to reschedule callback')
									]))
							]));
				case 17:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Waiting for response to booking request.')
									]))
							]));
				case 18:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Accepted booking request.')
									]))
							]));
				case 19:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Rejected booking request.')
									]))
							]));
				default:
					return $elm$html$Html$text('');
			}
		}
	});
var $author$project$Views$Messages$chatBoxFooter = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-box-footer-container')
			]),
		_List_fromArray(
			[
				A5($author$project$Views$Messages$chatQuickActions, model.bI, model.b5, model.z, model.k, model.A),
				A4($author$project$Views$Messages$chatInputBox, model.h2, model.k.V, model.bf, model.k)
			]));
};
var $author$project$MainMsg$CloseTalentConversationContainer = {$: 232};
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Views$Messages$chatBoxProjectInfo = function (_v0) {
	var currentChannel = _v0.k;
	var viewingTalentResult = _v0.p;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-box-project-info')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(currentChannel.iI)
					])),
				A2(
				$elm$html$Html$h5,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(currentChannel.iY)
					]))
			]));
};
var $author$project$MainMsg$ToggleTalentResultModal = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $author$project$Views$Messages$headerInfo = F3(
	function (userProfile, channel, talentProfile) {
		var _v0 = userProfile.P;
		switch (_v0) {
			case 3:
				var avatar = (channel.js === '') ? $author$project$Data$Image$emptyImage.jM : channel.js;
				return _Utils_Tuple2(avatar, channel.jv);
			case 1:
				var avatar = (channel.js === '') ? $author$project$Data$Image$emptyImage.jM : channel.js;
				return _Utils_Tuple2(avatar, channel.jv);
			case 0:
				var avatar = (channel.hO === '') ? $author$project$Data$Image$emptyImage.jM : channel.hO;
				return _Utils_Tuple2(avatar, channel.hQ);
			default:
				return _Utils_Tuple2('', '');
		}
	});
var $author$project$Views$Messages$chatBoxUserInfo = function (model) {
	var _v0 = A3($author$project$Views$Messages$headerInfo, model.z, model.k, model.p);
	var avatar = _v0.a;
	var name = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-box-user-info'),
				$elm$html$Html$Events$onClick(
				A3($author$project$MainMsg$ToggleTalentResultModal, model.p, $author$project$Job$emptyApplicant, ''))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chat-box-avatar-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(avatar)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chat-box-user-info')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							])),
						A2(
						$elm$html$Html$h5,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]))
					]))
			]));
};
var $author$project$Views$Messages$chatBoxHeader = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-box-header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$MainMsg$CloseTalentConversationContainer),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('close-conversation-button', true),
								_Utils_Tuple2('close-conversation-hidden', model.z.P === 1)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('close')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('far fa-times-circle')
							]),
						_List_Nil)
					])),
				$author$project$Views$Messages$chatBoxUserInfo(model),
				$author$project$Views$Messages$chatBoxProjectInfo(model)
			]));
};
var $author$project$Views$Messages$correctAvatar = F3(
	function (creatorId, conversation, userProfile) {
		return _Utils_eq(creatorId, userProfile.cU) ? A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Image$emptyImage,
			$elm$core$List$head(userProfile.hE)).jM : ((_Utils_eq(conversation.jt, creatorId) && (conversation.js !== '')) ? conversation.js : (((!_Utils_eq(creatorId, conversation.jt)) && (conversation.hO !== '')) ? conversation.hO : '/default_user.png'));
	});
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Views$Messages$messageContainer = F3(
	function (message, userProfile, conversation) {
		var _v0 = _Utils_eq(message.g_, userProfile.cU) ? _Utils_Tuple2(
			A3($author$project$Views$Messages$correctAvatar, message.g_, conversation, userProfile),
			'left') : _Utils_Tuple2(
			A3($author$project$Views$Messages$correctAvatar, message.g_, conversation, userProfile),
			'right');
		var messageAvatar = _v0.a;
		var side = _v0.b;
		var _v1 = message.bo;
		switch (_v1) {
			case 'media':
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('message', true),
											_Utils_Tuple2(side, true)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('message-avatar-container', true)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(messageAvatar)
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message-text-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message-text')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href(message.d2),
															$elm$html$Html$Attributes$target('blank')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(message.dG)
														]))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message-time')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(message.ct)
												]))
										]))
								]))
						]));
			case 'text':
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('message', true),
											_Utils_Tuple2(side, true)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('message-avatar-container', true)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(messageAvatar)
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message-text-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message-text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(message.dG)
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message-time')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(message.ct)
												]))
										]))
								]))
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Job$NotificationBody = function (a) {
	return {$: 0, a: a};
};
var $author$project$MainMsg$NotificationFormMsg = function (a) {
	return {$: 223, a: a};
};
var $author$project$Views$Confirmations$notificationModal = F2(
	function (notification, isOpen) {
		var textType = function () {
			var _v2 = notification.hT;
			switch (_v2) {
				case 'Audition Rejected':
					return 'Reject ';
				case 'Audition Rescheduled':
					return 'Reschedule ';
				case 'Audition Reschedule Requested':
					return 'Reschedule ';
				case 'Audition Accepted':
					return 'Accept ';
				case 'Callback Rejected':
					return 'Reject ';
				case 'Callback Rescheduled':
					return 'Reschedule ';
				case 'Callback Reschedule Requested':
					return 'Reschedule ';
				case 'Callback Accepted':
					return 'Accept ';
				case 'Booking Accepted':
					return 'Accept ';
				case 'Booking Rejected':
					return 'Reject ';
				case 'Rejected Application':
					return 'Reject ';
				case 'Accepted Application':
					return 'Accept ';
				case 'Booking Request':
					return 'send ';
				default:
					return 'Send';
			}
		}();
		var textArea = function () {
			switch (textType) {
				case 'Accept ':
					return $elm$html$Html$text('');
				case 'send ':
					return $elm$html$Html$text('');
				default:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Rejection Response:')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$NotificationFormMsg, $author$project$Job$NotificationBody)),
										$elm$html$Html$Attributes$placeholder('Please let casting know why you are unable to make this scheduled time....'),
										$elm$html$Html$Attributes$value(notification.dG)
									]),
								_List_Nil)
							]));
			}
		}();
		if (isOpen) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('confirmation-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to ' + (textType + ' this request?'))
							])),
						textArea,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('controls')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$UpdateUsersRoleStage, notification, notification.aQ, notification.hT, notification.cu))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(textType + ' Request')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, '', '', '', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									]))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$Messages$chatBoxContainer = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-box-container')
			]),
		_List_fromArray(
			[
				$author$project$Views$Messages$chatBoxHeader(model),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('messages-container')
					]),
				A2(
					$elm$core$List$map,
					function (message) {
						return A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Messages$messageContainer, message, model.z, model.k);
					},
					model.k.h3)),
				$author$project$Views$Messages$chatBoxFooter(model),
				A2($author$project$Views$Confirmations$notificationModal, model.bI, model.l)
			]));
};
var $author$project$MainMsg$ArchiveConversation = function (a) {
	return {$: 233, a: a};
};
var $author$project$MainMsg$SwitchConversation = function (a) {
	return {$: 227, a: a};
};
var $author$project$Views$Messages$archiveText = function (archived) {
	return archived ? 'Restore Conversation' : 'Archive Conversation';
};
var $author$project$Views$Messages$channelList = F4(
	function (conversation, userProfile, currentConversation, viewingTalent) {
		var selected = _Utils_eq(conversation.V, currentConversation.V);
		var _v0 = A3($author$project$Views$Messages$headerInfo, userProfile, conversation, viewingTalent);
		var avatar = _v0.a;
		var name = _v0.b;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selected-conversation', selected),
							_Utils_Tuple2('conversation-list-item', true)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$SwitchConversation(conversation.V))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('archive-conversation-button', true),
									_Utils_Tuple2('restore-button', conversation.dz)
								])),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$ArchiveConversation(conversation.V))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Views$Messages$archiveText(conversation.dz))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chat-index-image')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chat-image-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('new-message-indicator', true),
													_Utils_Tuple2('showing-indicator', conversation.bW > 0)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(conversation.bW))
										])),
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(avatar)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chat-index-name-last-message-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(conversation.hU)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chat-index-project-time-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h5,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(conversation.iI)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(conversation.g9)
								]))
						]))
				]));
	});
var $author$project$Message$ArchivedFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Message$ChatSearchTerm = function (a) {
	return {$: 4, a: a};
};
var $author$project$MainMsg$UpdateChatFilterValues = function (a) {
	return {$: 230, a: a};
};
var $author$project$Views$Messages$directorOnly = F2(
	function (user, view) {
		var _v0 = user.P;
		if (_v0 === 1) {
			return view;
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Message$ProjectFilter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Message$RoleFilter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$Messages$filterChatRoleNames = F2(
	function (projects, projectName) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.bH;
			},
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$SharedProjectRoleSchedules$emptyProject,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$author$project$Utils$eq,
							function ($) {
								return $.bH;
							},
							projectName),
						projects))).fq);
	});
var $frandibar$elm_font_awesome_5$FontAwesome$chevronDown = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('chevron-down');
var $author$project$Views$Form$selectFieldRegular = F4(
	function (aMsg, placeholderText, options, valueText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('select-field-regular')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronDown)
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput(aMsg),
							$elm$html$Html$Attributes$placeholder(placeholderText),
							$elm$html$Html$Attributes$class('select-field')
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$stringOptionField, option, valueText);
						},
						options))
				]));
	});
var $author$project$Views$Messages$projectAndRoleFilters = F2(
	function (projects, filters) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('chat-project-role-filters-container')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Views$Form$selectFieldRegular,
					A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateChatFilterValues, $author$project$Message$ProjectFilter),
					'Project',
					A2(
						$elm$core$List$cons,
						'Project',
						A2(
							$elm$core$List$map,
							function ($) {
								return $.bH;
							},
							projects)),
					filters.iG),
					A4(
					$author$project$Views$Form$selectFieldRegular,
					A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateChatFilterValues, $author$project$Message$RoleFilter),
					'Role',
					A2(
						$elm$core$List$cons,
						'Role',
						A2($author$project$Views$Messages$filterChatRoleNames, projects, filters.iG)),
					filters.fo)
				]));
	});
var $frandibar$elm_font_awesome_5$FontAwesome$search = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('search');
var $author$project$Views$Messages$chatSortsAndFilters = function (_v0) {
	var userProfile = _v0.z;
	var chatFilterValues = _v0.b1;
	var allProjects = _v0.A;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-filters-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chat-search-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$search)
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$placeholder('Search by the name of the person...'),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateChatFilterValues, $author$project$Message$ChatSearchTerm))
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Views$Messages$directorOnly,
				userProfile,
				A2($author$project$Views$Messages$projectAndRoleFilters, allProjects, chatFilterValues)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('archived-read-filter-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								A3($elm$core$Basics$composeL, $author$project$MainMsg$UpdateChatFilterValues, $author$project$Message$ArchivedFilter, !chatFilterValues.gw)),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('active-option', chatFilterValues.gw)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Archived')
							]))
					]))
			]));
};
var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var $elm$html$Html$Lazy$lazy4 = $elm$virtual_dom$VirtualDom$lazy4;
var $elm$core$String$toLower = _String_toLower;
var $author$project$Views$Messages$matchingChatsBySearchTerm = F2(
	function (term, conversations) {
		return (term !== '') ? A2(
			$elm$core$List$filter,
			function (channel) {
				var _v0 = _Utils_Tuple3(
					$elm$core$String$toLower(channel.jv),
					$elm$core$String$toLower(channel.iY),
					$elm$core$String$toLower(channel.iI));
				var talentName = _v0.a;
				var roleName = _v0.b;
				var projectName = _v0.c;
				return A2($elm$core$String$contains, term, talentName) || (A2($elm$core$String$contains, term, projectName) || A2($elm$core$String$contains, term, roleName));
			},
			conversations) : conversations;
	});
var $author$project$Views$Messages$matchingProjectChat = F2(
	function (project, conversations) {
		return (project !== 'Project') ? A2(
			$elm$core$List$filter,
			A2(
				$author$project$Utils$eq,
				function ($) {
					return $.iI;
				},
				project),
			conversations) : conversations;
	});
var $author$project$Views$Messages$matchingRoleChat = F2(
	function (role, conversations) {
		return (role !== 'Role') ? A2(
			$elm$core$List$filter,
			A2(
				$author$project$Utils$eq,
				function ($) {
					return $.iY;
				},
				role),
			conversations) : conversations;
	});
var $author$project$Views$Messages$filterChannels = F2(
	function (channels, filters) {
		return A2(
			$author$project$Views$Messages$matchingRoleChat,
			filters.fo,
			A2(
				$author$project$Views$Messages$matchingProjectChat,
				filters.iG,
				A2($author$project$Views$Messages$matchingChatsBySearchTerm, filters.fC, channels)));
	});
var $author$project$Views$Messages$showArchived = F2(
	function (channels, chatFilters) {
		return chatFilters.gw ? A2(
			$elm$core$List$filter,
			function (channel) {
				return channel.dz;
			},
			A2($author$project$Views$Messages$filterChannels, channels, chatFilters)) : A2(
			$elm$core$List$filter,
			function (channel) {
				return !channel.dz;
			},
			A2($author$project$Views$Messages$filterChannels, channels, chatFilters));
	});
var $author$project$Views$Messages$chatIndexContainer = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-index-container')
			]),
		_List_fromArray(
			[
				$author$project$Views$Messages$chatSortsAndFilters(model),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (channel) {
						return A5($elm$html$Html$Lazy$lazy4, $author$project$Views$Messages$channelList, channel, model.z, model.k, model.p);
					},
					A2($author$project$Views$Messages$showArchived, model.g, model.b1)))
			]));
};
var $frandibar$elm_font_awesome_5$FontAwesome$circleNotch = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('circle-notch');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Views$Confirmations$confirmation = F5(
	function (showConfirmation, actionMessage, toggleMessage, confirmationText, destructiveActions) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal', true),
									_Utils_Tuple2('modal-open', showConfirmation)
								])),
							$elm$html$Html$Events$onClick(toggleMessage)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('delete-confirmation', true),
									_Utils_Tuple2('delete-showing', showConfirmation)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('JUST MAKING SURE...')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(confirmationText)
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('destructive-actions')
								]),
							A2(
								$elm$core$List$map,
								function (action) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(action)
											]));
								},
								destructiveActions)),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confirmation-button'),
									$elm$html$Html$Events$onClick(actionMessage)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Yes')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confirmation-cancel-button'),
									$elm$html$Html$Events$onClick(toggleMessage)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No')
								]))
						]))
				]));
	});
var $author$project$SharedProjectRoleSchedules$ImagesShowing = 1;
var $author$project$Project$SchedulingDayOfPage = 6;
var $author$project$MainMsg$ToggleFullPageImages = function (a) {
	return {$: 319, a: a};
};
var $author$project$MainMsg$ToggleAttributes = {$: 292};
var $author$project$Views$TalentModal$attributesButton = F2(
	function (attributesShowing, modalPage) {
		if (modalPage === 6) {
			return attributesShowing ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('toggle-attributes'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleAttributes)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-chevron-left')
							]),
						_List_Nil),
						$elm$html$Html$text('Videos')
					])) : A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('toggle-attributes'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleAttributes)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Attributes'),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-chevron-right')
							]),
						_List_Nil)
					]));
		} else {
			return $elm$html$Html$text('\'');
		}
	});
var $author$project$Views$TalentModal$contactInfoSection = function (viewingTalentResult) {
	var agent = A2(
		$elm$core$Maybe$withDefault,
		$author$project$User$emptyAgent,
		$elm$core$List$head(viewingTalentResult.gl.gr));
	return (viewingTalentResult.gl.V === '') ? A2(
		$elm$html$Html$table,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Location:')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(viewingTalentResult.aV + (', ' + viewingTalentResult.a7))
							]))
					]))
			])) : A2(
		$elm$html$Html$table,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Location:')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(viewingTalentResult.gl.aV + (', ' + viewingTalentResult.gl.a7))
							]))
					])),
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Agent:')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(agent.bm)
							]))
					])),
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Phone:')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(agent.eZ)
							]))
					])),
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Email')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(agent.bl)
							]))
					]))
			]));
};
var $author$project$Utils$convertHeightToFeetInches = function (height) {
	return A2(
		$elm$core$Maybe$withDefault,
		{e: '', b: 'N/A'},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (value) {
					return _Utils_eq(
						value.e,
						$elm$core$String$fromInt(height));
				},
				$author$project$InitData$heightValues)));
};
var $author$project$Views$TalentModal$fullPageImageContainer = F3(
	function (imageView, currentImage, otherImages) {
		var modalClass = function () {
			if (!imageView) {
				return 'full-page-images-modal';
			} else {
				return 'full-page-images-modal showing-full';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(modalClass),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$ToggleFullPageImages(0))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('full-size-image-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(currentImage.jM)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Views$TalentModal$createBlanks = function (num) {
	return A2(
		$elm$core$List$repeat,
		num,
		A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('empty-image')
				]),
			_List_Nil));
};
var $author$project$MainMsg$ToggleCurrentGalleryImage = function (a) {
	return {$: 220, a: a};
};
var $author$project$Views$TalentModal$createImagePreviews = function (images) {
	return A2(
		$elm$core$List$map,
		function (image) {
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image-preview-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleCurrentGalleryImage(image)),
								$elm$html$Html$Attributes$src(image.jM)
							]),
						_List_Nil)
					]));
		},
		images);
};
var $author$project$Views$TalentModal$mergeImagesAndBlanks = F2(
	function (images, blanks) {
		return A2($elm$core$List$append, images, blanks);
	});
var $author$project$Views$TalentModal$moreImages = function (images) {
	return ($elm$core$List$length(images) < 5) ? A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('more-images')
			]),
		A2(
			$elm$core$List$map,
			function (image) {
				return image;
			},
			A2(
				$author$project$Views$TalentModal$mergeImagesAndBlanks,
				$author$project$Views$TalentModal$createImagePreviews(images),
				$author$project$Views$TalentModal$createBlanks(
					5 - $elm$core$List$length(images))))) : A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('more-images')
			]),
		A2(
			$elm$core$List$map,
			function (image) {
				return image;
			},
			$author$project$Views$TalentModal$createImagePreviews(
				A2($elm$core$List$take, 5, images))));
};
var $author$project$SharedProjectRoleSchedules$ChangeRole = 2;
var $author$project$MainMsg$ChangeUsersRole = {$: 217};
var $author$project$SharedProjectRoleSchedules$Move = 0;
var $author$project$MainMsg$MoveAllCandidates = {$: 163};
var $author$project$MainMsg$MoveExistingCandidate = function (a) {
	return {$: 162, a: a};
};
var $author$project$MainMsg$MoveNewCandidate = F2(
	function (a, b) {
		return {$: 164, a: a, b: b};
	});
var $author$project$MainMsg$RemoveAllCandidates = {$: 178};
var $author$project$MainMsg$ToggleQuickActionView = function (a) {
	return {$: 149, a: a};
};
var $author$project$MainMsg$ToggleSelectedTalent = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$MainMsg$UpdateGoToColumn = function (a) {
	return {$: 161, a: a};
};
var $author$project$MainMsg$UpdateGoToProject = function (a) {
	return {$: 165, a: a};
};
var $author$project$MainMsg$UpdateGoToRole = function (a) {
	return {$: 166, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$chevronLeft = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('chevron-left');
var $author$project$Views$TalentModal$columnNamesAndIds = F2(
	function (user, columns) {
		var _v0 = user.P;
		if (_v0 === 3) {
			return A2(
				$elm$core$List$map,
				function (column) {
					return (column.g6 !== '') ? {V: column.V, bH: column.g6} : {V: column.V, bH: column.bH};
				},
				A2(
					$elm$core$List$filter,
					function (column) {
						return (!column.hL) && (column.bH === 'Matching Candidates');
					},
					columns));
		} else {
			return A2(
				$elm$core$List$map,
				function (column) {
					return (column.g6 !== '') ? {V: column.V, bH: column.g6} : {V: column.V, bH: column.bH};
				},
				A2(
					$elm$core$List$filter,
					function (column) {
						return (!column.hL) && ((column.bH === 'Matching Candidates') || (column.bH === 'Selected Candidates'));
					},
					columns));
		}
	});
var $author$project$Views$TalentModal$enableBookingButton = function (stage) {
	return !A2(
		$elm$core$List$member,
		stage,
		_List_fromArray(
			[18, 17, 19, 4, 2]));
};
var $author$project$Views$TalentModal$enableMoveButton = function (stage) {
	return !A2(
		$elm$core$List$member,
		stage,
		_List_fromArray(
			[4, 2]));
};
var $author$project$Views$TalentModal$projectNamesAndIds = function (projects) {
	return A2(
		$elm$core$List$map,
		function (project) {
			return {V: project.cU, bH: project.bH};
		},
		A2(
			$elm$core$List$filter,
			function (p) {
				return p.hK;
			},
			projects));
};
var $author$project$Views$TalentModal$quickActionButton = F3(
	function (action, buttonName, show) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('action', true),
							_Utils_Tuple2('show-action', show)
						])),
					$elm$html$Html$Events$onClick(action)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonName)
				]));
	});
var $author$project$MainMsg$UpdateChangeRoleInfo = F3(
	function (a, b, c) {
		return {$: 218, a: a, b: b, c: c};
	});
var $author$project$Views$TalentModal$optionField = F2(
	function (item, selectedId) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item.V),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item.V, selectedId))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item.bH)
				]));
	});
var $author$project$Views$TalentModal$roleChangeSelectBox = F5(
	function (placeholderText, options, roleMemberId, userId, selectedId) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						function (selection) {
							return A3($author$project$MainMsg$UpdateChangeRoleInfo, roleMemberId, selection, userId);
						}),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A2($author$project$Views$TalentModal$optionField, option, selectedId);
					},
					options))
			]);
	});
var $author$project$Views$TalentModal$roleNamesAndIds = F2(
	function (roles, projectId) {
		return A2(
			$elm$core$List$map,
			function (role) {
				return {V: role.cU, bH: role.bH};
			},
			A2(
				$elm$core$List$filter,
				function (role) {
					return _Utils_eq(role.iH, projectId);
				},
				roles));
	});
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $author$project$Views$Form$optionField = function (item) {
	return A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(item.V)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(item.bH)
			]));
};
var $author$project$Views$Form$selectField = F3(
	function (aMsg, placeholderText, options) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(aMsg),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A2($elm$html$Html$Lazy$lazy, $author$project$Views$Form$optionField, option);
					},
					options))
			]);
	});
var $author$project$Views$TalentModal$selectedUser = F2(
	function (user, selectedTalent) {
		return A2(
			$elm$core$List$member,
			user.cU,
			A2(
				$elm$core$List$map,
				function (talent) {
					return talent.cU;
				},
				selectedTalent));
	});
var $author$project$Views$TalentModal$selectionText = F2(
	function (user, selectedUsers) {
		return A2($author$project$Views$TalentModal$selectedUser, user, selectedUsers) ? 'Unselect Candidate' : 'Select Candidate';
	});
var $author$project$MainMsg$CreateConversation = function (a) {
	return {$: 111, a: a};
};
var $author$project$Views$TalentModal$sendMessage = F3(
	function (userId, bodyText, status) {
		return ((bodyText === '') || (!status)) ? $author$project$MainMsg$NoOp : $author$project$MainMsg$CreateConversation(userId);
	});
var $author$project$Views$TalentModal$sendMessageButtonText = function (status) {
	switch (status) {
		case 0:
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A4(
						$frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions,
						$frandibar$elm_font_awesome_5$FontAwesome$spinner,
						0,
						_List_fromArray(
							[
								$frandibar$elm_font_awesome_5$FontAwesome$Animation(0)
							]),
						_List_Nil)
					]));
		case 3:
			return $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$check);
		case 2:
			return $elm$html$Html$text('Send');
		default:
			return $elm$html$Html$text('Send');
	}
};
var $author$project$MainMsg$RegisterVote = F3(
	function (a, b, c) {
		return {$: 274, a: a, b: b, c: c};
	});
var $author$project$MainMsg$SubmitComment = function (a) {
	return {$: 283, a: a};
};
var $author$project$Views$TalentModal$commentItem = F2(
	function (comment, userProfile) {
		var editButton = _Utils_eq(comment.g_, userProfile.cU) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('comment-edit-button')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('edit')
				])) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('comment-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('user-comment-photo')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(comment.dV)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('creator-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(comment.dW)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('created-date')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(comment.fY)
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('comment-body')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(comment.dG)
						]))
				]));
	});
var $author$project$SharedProjectRoleSchedules$emptyTimeSlot = {
	dR: _List_Nil,
	hj: $elm$time$Time$millisToPosix(0),
	el: '',
	V: '',
	i0: '',
	fy: '',
	f_: $author$project$User$emptyPipelineUser,
	f7: _List_Nil
};
var $author$project$SharedProjectRoleSchedules$emptyVote = {V: '', aQ: '', f6: '', f8: '', f9: ''};
var $author$project$MainMsg$ToggleCommentExpand = {$: 285};
var $author$project$Views$TalentModal$expandButton = function (action) {
	switch (action) {
		case 4:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('comments-expand'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleCommentExpand)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Expand Comments'),
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-plus')
							]),
						_List_Nil)
					]));
		case 5:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('comments-expand'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleCommentExpand)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Collapse Comments'),
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-minus')
							]),
						_List_Nil)
					]));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Views$TalentModal$widthCalculation = F2(
	function (votes, timeSlot) {
		return (timeSlot.f_.cU === '') ? '0%' : ($elm$core$String$fromFloat(
			(votes / $elm$core$List$length(timeSlot.f7)) * 100) + '%');
	});
var $author$project$Views$TalentModal$votingModal = F5(
	function (schedulePageData, viewingTalentResult, userProfile, voting, action) {
		var timeSlot = A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyTimeSlot,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (ts) {
						return _Utils_eq(ts.f_.cU, viewingTalentResult.cU);
					},
					schedulePageData.b6.jD)));
		var yesVotes = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (vote) {
					return vote.f6 === 'yes';
				},
				timeSlot.f7));
		var noVotes = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (vote) {
					return vote.f6 === 'no';
				},
				timeSlot.f7));
		var myVote = A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyVote,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (vote) {
						return _Utils_eq(vote.f8, userProfile.cU);
					},
					timeSlot.f7)));
		var maybeVotes = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (vote) {
					return vote.f6 === 'maybe';
				},
				timeSlot.f7));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(voting)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voting-details-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('yes-button', true),
											_Utils_Tuple2('yes-colored', myVote.f6 === 'yes')
										])),
									$elm$html$Html$Events$onClick(
									A3($author$project$MainMsg$RegisterVote, timeSlot.f_.aQ, 'yes', timeSlot.V))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Yes')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('maybe-button', true),
											_Utils_Tuple2('maybe-colored', myVote.f6 === 'maybe')
										])),
									$elm$html$Html$Events$onClick(
									A3($author$project$MainMsg$RegisterVote, timeSlot.f_.aQ, 'maybe', timeSlot.V))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Maybe')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('no-button', true),
											_Utils_Tuple2('no-colored', myVote.f6 === 'no')
										])),
									$elm$html$Html$Events$onClick(
									A3($author$project$MainMsg$RegisterVote, timeSlot.f_.aQ, 'no', timeSlot.V))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('voting-breakdown-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('vote-bar-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('vote-total')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(yesVotes))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('yes-bar'),
													A2(
													$elm$html$Html$Attributes$style,
													'width',
													A2($author$project$Views$TalentModal$widthCalculation, yesVotes, timeSlot))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('vote-bar-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('vote-total')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(maybeVotes))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('maybe-bar'),
													A2(
													$elm$html$Html$Attributes$style,
													'width',
													A2($author$project$Views$TalentModal$widthCalculation, maybeVotes, timeSlot))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('vote-bar-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('vote-total')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(noVotes))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('no-bar'),
													A2(
													$elm$html$Html$Attributes$style,
													'width',
													A2($author$project$Views$TalentModal$widthCalculation, noVotes, timeSlot))
												]),
											_List_Nil)
										]))
								])),
							$author$project$Views$TalentModal$expandButton(action)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('comment-section-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('comments-section')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('comments')
										]),
									A2(
										$elm$core$List$map,
										function (comment) {
											return A2($author$project$Views$TalentModal$commentItem, comment, userProfile);
										},
										timeSlot.dR)),
									A2(
									$elm$html$Html$form,
									_List_fromArray(
										[
											$elm$html$Html$Events$onSubmit(
											$author$project$MainMsg$SubmitComment(timeSlot.V)),
											$elm$html$Html$Attributes$class('comment-form-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('user-comment-photo')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src(
															A2(
																$elm$core$Maybe$withDefault,
																$author$project$Data$Image$emptyImage,
																$elm$core$List$head(userProfile.hE)).jM)
														]),
													_List_Nil)
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$value(schedulePageData.b2),
													$elm$html$Html$Attributes$placeholder('Write a comment...'),
													$elm$html$Html$Events$onInput($author$project$MainMsg$UpdateVotingComment)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('comment-submit-button'),
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$SubmitComment(timeSlot.V))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Submit')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Views$TalentModal$quickActionBar = function (action) {
	return function (viewingTalentResult) {
		return function (selectedTalent) {
			return function (applicant) {
				return function (pipeline) {
					return function (modalPage) {
						return function (projects) {
							return function (roles) {
								return function (projectId) {
									return function (currentColumnId) {
										return function (project) {
											return function (selectedRoleId) {
												return function (twilioStatus) {
													return function (userProfile) {
														return function (newMessageBody) {
															return function (creatorId) {
																return function (schedulePageData) {
																	var _v0 = function () {
																		switch (action) {
																			case 3:
																				return {aU: 'change-role action-hidden', a$: 'send-message action-hidden', a0: 'move-candidate action-hidden', a1: 'options', bq: 'request-candidate action-hidden', bc: 'vote-section action-hidden'};
																			case 1:
																				return {aU: 'change-role action-hidden', a$: 'send-message', a0: 'move-candidate action-hidden', a1: 'options action-hidden', bq: 'request-candidate action-hidden', bc: 'vote-section action-hidden'};
																			case 2:
																				return {aU: 'change-role', a$: 'send-message action-hidden', a0: 'move-candidate action-hidden', a1: 'options action-hidden', bq: 'request-candidate action-hidden', bc: 'vote-section action-hidden'};
																			case 0:
																				return {aU: 'change-role action-hidden', a$: 'send-message action-hidden', a0: 'move-candidate', a1: 'options action-hidden', bq: 'request-candidate action-hidden', bc: 'vote-section action-hidden'};
																			case 4:
																				return {aU: 'change-role action-hidden', a$: 'send-message action-hidden', a0: 'move-candidate action-hidden', a1: 'options action-hidden', bq: 'request-candidate action-hidden', bc: 'vote-section'};
																			default:
																				return {aU: 'change-role action-hidden', a$: 'send-message action-hidden', a0: 'move-candidate action-hidden', a1: 'options action-hidden', bq: 'request-candidate action-hidden', bc: 'vote-section'};
																		}
																	}();
																	var opt = _v0.a1;
																	var mes = _v0.a$;
																	var move = _v0.a0;
																	var change = _v0.aU;
																	var voting = _v0.bc;
																	switch (modalPage) {
																		case 1:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A2($author$project$MainMsg$ToggleSelectedTalent, viewingTalentResult.cU, viewingTalentResult),
																								A2($author$project$Views$TalentModal$selectionText, viewingTalentResult, selectedTalent),
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(0),
																								'Move Candidate',
																								$author$project$Views$TalentModal$enableMoveButton(viewingTalentResult.jj)),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(1),
																								'Send Message',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(2),
																								'Change Role',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A4($author$project$MainMsg$ToggleNotificationModalFromMessages, viewingTalentResult.aQ, userProfile.cU, 'Booking Request', ''),
																								'Send Booking Request',
																								$author$project$Views$TalentModal$enableBookingButton(viewingTalentResult.jj))
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(move)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_Nil,
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToColumn,
																									'Move To:',
																									A2($author$project$Views$TalentModal$columnNamesAndIds, userProfile, pipeline))),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('move-candidate-button'),
																										$elm$html$Html$Events$onClick(
																										$author$project$MainMsg$MoveExistingCandidate(viewingTalentResult.aQ))
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Move Candidate')
																									]))
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(change)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_Nil,
																								A5(
																									$author$project$Views$TalentModal$roleChangeSelectBox,
																									'Change Role To:',
																									A2(
																										$elm$core$List$cons,
																										{V: '', bH: ''},
																										A2(
																											$elm$core$List$map,
																											function (role) {
																												return {V: role.cU, bH: role.bH};
																											},
																											project.fq)),
																									viewingTalentResult.aQ,
																									viewingTalentResult.cU,
																									selectedRoleId)),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('move-candidate-button'),
																										$elm$html$Html$Events$onClick($author$project$MainMsg$ChangeUsersRole)
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Change Role')
																									]))
																							]))
																					]));
																		case 2:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3($author$project$Views$TalentModal$quickActionButton, $author$project$MainMsg$RemoveAllCandidates, 'Unselect All', true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(0),
																								'Move Candidates',
																								true),
																								A3($author$project$Views$TalentModal$quickActionButton, $author$project$MainMsg$NoOp, 'Schedule Candidates', false)
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2(move, true),
																										_Utils_Tuple2('move-to-pipe', true)
																									]))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToProject,
																									'Select Project',
																									A2(
																										$elm$core$List$cons,
																										{V: '', bH: ''},
																										$author$project$Views$TalentModal$projectNamesAndIds(projects)))),
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToRole,
																									'Select Role',
																									A2(
																										$elm$core$List$cons,
																										{V: '', bH: ''},
																										A2($author$project$Views$TalentModal$roleNamesAndIds, roles, projectId)))),
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToColumn,
																									'Select Stage',
																									A2(
																										$elm$core$List$cons,
																										{V: '', bH: ''},
																										A2($author$project$Views$TalentModal$columnNamesAndIds, userProfile, pipeline)))),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$classList(
																										_List_fromArray(
																											[
																												_Utils_Tuple2('move-candidate-button', true),
																												_Utils_Tuple2('to-pipe-button', true)
																											])),
																										$elm$html$Html$Events$onClick(
																										A2($author$project$MainMsg$MoveNewCandidate, selectedTalent, projectId))
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Move Candidates')
																									]))
																							]))
																					]));
																		case 3:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A3($author$project$Views$TalentModal$quickActionButton, $author$project$MainMsg$RemoveAllCandidates, 'Unselect All', true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(0),
																								'Move Candidates',
																								true)
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(move)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_Nil,
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToColumn,
																									'Move To:',
																									A2(
																										$author$project$Views$TalentModal$columnNamesAndIds,
																										userProfile,
																										A2($elm$core$List$cons, $author$project$Pipeline$emptyColumn, pipeline)))),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('move-candidate-button'),
																										$elm$html$Html$Events$onClick($author$project$MainMsg$MoveAllCandidates)
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Move Candidates')
																									]))
																							]))
																					]));
																		case 0:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A2($author$project$MainMsg$ToggleSelectedTalent, viewingTalentResult.cU, viewingTalentResult),
																								A2($author$project$Views$TalentModal$selectionText, viewingTalentResult, selectedTalent),
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(0),
																								'Add To Project',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A4($author$project$MainMsg$ToggleNotificationModalFromMessages, viewingTalentResult.aQ, userProfile.cU, 'Booking Request', ''),
																								'Request Candidate',
																								!applicant.jj),
																								A3($author$project$Views$TalentModal$quickActionButton, $author$project$MainMsg$NoOp, 'Schedule Candidate', false)
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2(move, true),
																										_Utils_Tuple2('move-to-pipe', true)
																									]))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToProject,
																									'Select Project',
																									A2(
																										$elm$core$List$cons,
																										{V: '', bH: ''},
																										$author$project$Views$TalentModal$projectNamesAndIds(projects)))),
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToRole,
																									'Select Role',
																									A2(
																										$elm$core$List$cons,
																										{V: '', bH: ''},
																										A2($author$project$Views$TalentModal$roleNamesAndIds, roles, projectId)))),
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToColumn,
																									'Select Stage',
																									A2(
																										$elm$core$List$cons,
																										{V: '', bH: ''},
																										A2($author$project$Views$TalentModal$columnNamesAndIds, userProfile, pipeline)))),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$classList(
																										_List_fromArray(
																											[
																												_Utils_Tuple2('move-candidate-button', true),
																												_Utils_Tuple2('to-pipe-button', true)
																											])),
																										$elm$html$Html$Events$onClick(
																										A2(
																											$author$project$MainMsg$MoveNewCandidate,
																											_List_fromArray(
																												[viewingTalentResult]),
																											projectId))
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Move Candidate')
																									]))
																							]))
																					]));
																		case 4:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(1),
																								'Send Message',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A4($author$project$MainMsg$ToggleNotificationModalFromMessages, viewingTalentResult.aQ, userProfile.cU, 'Booking Request', ''),
																								'Request Candidate',
																								!applicant.jj)
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							]))
																					]));
																		case 5:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(1),
																								'Send Message',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A4($author$project$MainMsg$ToggleNotificationModalFromMessages, viewingTalentResult.aQ, userProfile.cU, 'Booking Request', ''),
																								'Request Candidate',
																								!applicant.jj)
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							]))
																					]));
																		default:
																			return ((userProfile.P === 2) || (!_Utils_eq(userProfile.cU, creatorId))) ? A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(4),
																								'Votes',
																								true)
																							])),
																						A5($author$project$Views$TalentModal$votingModal, schedulePageData, viewingTalentResult, userProfile, voting, action)
																					])) : A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(1),
																								'Send Message',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A4($author$project$MainMsg$ToggleNotificationModalFromMessages, viewingTalentResult.aQ, userProfile.cU, 'Booking Request', ''),
																								'Request Candidate',
																								!applicant.jj),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(4),
																								'Votes',
																								true)
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.cU, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							])),
																						A5($author$project$Views$TalentModal$votingModal, schedulePageData, viewingTalentResult, userProfile, voting, action)
																					]));
																	}
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Utils$UrlHelpers$officePreviewURL = function (path) {
	var query = $elm$url$Url$Builder$toQuery(
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'src', path)
			]));
	return 'https://view.officeapps.live.com/op/embed.aspx' + query;
};
var $author$project$Utils$UrlHelpers$documentURL = function (path) {
	return A2($elm$core$String$endsWith, '.doc', path) ? $author$project$Utils$UrlHelpers$officePreviewURL(path) : (A2($elm$core$String$endsWith, '.docx', path) ? $author$project$Utils$UrlHelpers$officePreviewURL(path) : path);
};
var $author$project$Views$TalentModal$resumeSection = function (maybeResume) {
	if (maybeResume.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var resume = maybeResume.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-item-icon')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Utils$UrlHelpers$documentURL(resume)),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-file')
								]),
							_List_Nil),
							$elm$html$Html$text('View Resume')
						]))
				]));
	}
};
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$MainMsg$VideoRequested = {$: 115};
var $author$project$Views$TalentModal$uploadingButton = F2(
	function (collaborator, videoUpload) {
		if (collaborator) {
			return $elm$html$Html$text('');
		} else {
			switch (videoUpload.$) {
				case 0:
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('add-videos-button'),
								$elm$html$Html$Events$onClick($author$project$MainMsg$VideoRequested)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('upload media')
							]));
				case 1:
					var fraction = videoUpload.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('add-videos-button')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fas fa-circle-notch fa-spin')
									]),
								_List_Nil),
								$elm$html$Html$text('Processing...')
							]));
				default:
					return $elm$html$Html$text('');
			}
		}
	});
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$MainMsg$ChangeVideo = function (a) {
	return {$: 286, a: a};
};
var $author$project$MainMsg$DeleteVideo = function (a) {
	return {$: 290, a: a};
};
var $author$project$MainMsg$ToggleVideoVisibility = function (a) {
	return {$: 289, a: a};
};
var $author$project$Views$TalentModal$formatLength = function (length) {
	var total_length = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toFloat(length));
	return (total_length > 60) ? ($elm$core$String$fromInt(
		$elm$core$Basics$floor(total_length / 60.0)) + ' minutes') : (((total_length > 1) && (total_length < 2)) ? ($elm$core$String$fromInt(
		$elm$core$Basics$floor(total_length)) + ' second') : ($elm$core$String$fromInt(
		$elm$core$Basics$floor(total_length)) + ' seconds'));
};
var $author$project$Views$TalentModal$videoLi = F3(
	function (video, currentVideo, collaborator) {
		var _v0 = (video.e8 === '0%') ? _Utils_Tuple2(
			'Queued',
			$elm$html$Html$text('')) : ((video.e8 === '100%') ? _Utils_Tuple2(
			'Finalizing',
			$elm$html$Html$text('')) : _Utils_Tuple2(
			'Processing...',
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-circle-notch fa-spin')
					]),
				_List_Nil)));
		var stage = _v0.a;
		var loader = _v0.b;
		var videoDetails = (video.bH === '') ? $elm$html$Html$text('') : ((video.eY && (video.bH !== '')) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('video-li')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(video.bH)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							loader,
							$elm$html$Html$text(stage)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-loading-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('loading-status-bar'),
									A2($elm$html$Html$Attributes$style, 'width', video.e8)
								]),
							_List_Nil)
						]))
				])) : (video.d9 ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('video-li')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('delete-video fas fa-trash-alt'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$DeleteVideo(video.V))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(video.bH)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Failed to process.')
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('video-li')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('delete-video fas fa-trash-alt'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$DeleteVideo(video.V))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(video.bH)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Views$TalentModal$formatLength(video.eE))
						])),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('visible'),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(video.f5),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$ToggleVideoVisibility(video.V))
								]),
							_List_Nil)
						]))
				]))));
		return collaborator ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('video-li', true),
							_Utils_Tuple2(
							'active-video',
							_Utils_eq(video.V, currentVideo.V))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$ChangeVideo(video))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(video.bH)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Views$TalentModal$formatLength(video.eE))
						]))
				])) : A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active-video',
							_Utils_eq(video.V, currentVideo.V))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$ChangeVideo(video))
				]),
			_List_fromArray(
				[videoDetails]));
	});
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Views$TalentModal$videoSection = F6(
	function (showVideo, videos, currentVideo, userProfile, creatorId, videoUpload) {
		var collaborator = (userProfile.P === 2) || (!_Utils_eq(userProfile.cU, creatorId));
		var videoList = collaborator ? A2(
			$elm$core$List$filter,
			function (video) {
				return video.f5;
			},
			videos) : videos;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('video-container', true),
							_Utils_Tuple2('showing-video', showVideo)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$video,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$width(400),
							$elm$html$Html$Attributes$height(240),
							$elm$html$Html$Attributes$controls(true),
							$elm$html$Html$Attributes$src(currentVideo.jM)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Views$TalentModal$uploadingButton, collaborator, videoUpload),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('video-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Available Videos')
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('availiable-videos')
								]),
							A2(
								$elm$core$List$map,
								function (video) {
									return A3($author$project$Views$TalentModal$videoLi, video, currentVideo, collaborator);
								},
								videoList))
						]))
				]));
	});
var $author$project$Views$TalentModal$talentSearchResultModal = function (viewingTalentResult) {
	return function (currentGalleryImage) {
		return function (selectedTalent) {
			return function (open) {
				return function (action) {
					return function (applicantData) {
						return function (pipeline) {
							return function (modalPage) {
								return function (projects) {
									return function (roles) {
										return function (projectId) {
											return function (currentColumnId) {
												return function (project) {
													return function (selectedRoleId) {
														return function (twilioStatus) {
															return function (userProfile) {
																return function (newMessageBody) {
																	return function (creatorId) {
																		return function (schedulePageData) {
																			return function (currentVideo) {
																				return function (videoUpload) {
																					return function (attributesShowing) {
																						return function (fullImageModal) {
																							var videoShowing = (modalPage === 6) && (!attributesShowing);
																							var age = ((viewingTalentResult.gk > 0) && (viewingTalentResult.gk < 18)) ? ($elm$core$String$fromInt(viewingTalentResult.gk) + ' (underage)') : (((viewingTalentResult.gk > 0) && (viewingTalentResult.gk < 100)) ? $elm$core$String$fromInt(viewingTalentResult.gk) : 'N/A');
																							return A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$classList(
																										_List_fromArray(
																											[
																												_Utils_Tuple2('talent-search-profile__container', true),
																												_Utils_Tuple2('talent-search-profile__container--open', open)
																											]))
																									]),
																								_List_fromArray(
																									[
																										A2(
																										$author$project$Views$ModalOverlay$modal,
																										A3($author$project$MainMsg$ToggleTalentResultModal, viewingTalentResult, $author$project$Job$emptyApplicant, ''),
																										open),
																										A3($author$project$Views$TalentModal$fullPageImageContainer, fullImageModal, currentGalleryImage, viewingTalentResult.hE),
																										A2(
																										$elm$html$Html$div,
																										_List_fromArray(
																											[
																												$elm$html$Html$Attributes$classList(
																												_List_fromArray(
																													[
																														_Utils_Tuple2('talent-search-profile', true),
																														_Utils_Tuple2('talent-profile-open', open)
																													]))
																											]),
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$class('profile-header')
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$h3,
																														_List_Nil,
																														_List_fromArray(
																															[
																																$elm$html$Html$text(viewingTalentResult.bm + (' ' + viewingTalentResult.bE))
																															])),
																														A2(
																														$elm$html$Html$span,
																														_List_fromArray(
																															[
																																$elm$html$Html$Events$onClick(
																																A3($author$project$MainMsg$ToggleTalentResultModal, $author$project$User$emptySearchTalentProfile, $author$project$Job$emptyApplicant, ''))
																															]),
																														_List_fromArray(
																															[
																																$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$times)
																															]))
																													])),
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$class('profile-images')
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$img,
																														_List_fromArray(
																															[
																																$elm$html$Html$Attributes$src(currentGalleryImage.jM),
																																$elm$html$Html$Attributes$class('active-image')
																															]),
																														_List_Nil),
																														A2(
																														$elm$html$Html$span,
																														_List_fromArray(
																															[
																																$elm$html$Html$Attributes$class('fas fa-expand-arrows-alt'),
																																$elm$html$Html$Events$onClick(
																																$author$project$MainMsg$ToggleFullPageImages(1))
																															]),
																														_List_Nil),
																														$author$project$Views$TalentModal$moreImages(viewingTalentResult.hE),
																														$author$project$Views$TalentModal$resumeSection(viewingTalentResult.iU)
																													])),
																												A6($author$project$Views$TalentModal$videoSection, videoShowing, viewingTalentResult.jT, currentVideo, userProfile, creatorId, videoUpload),
																												A2($author$project$Views$TalentModal$attributesButton, attributesShowing, modalPage),
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$classList(
																														_List_fromArray(
																															[
																																_Utils_Tuple2('attributes-container', true),
																																_Utils_Tuple2('video-present', videoShowing),
																																_Utils_Tuple2('attributes-showing', attributesShowing)
																															]))
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$h3,
																														_List_Nil,
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Attributes')
																															])),
																														A2(
																														$elm$html$Html$table,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Gender:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(viewingTalentResult.hw)
																																			]))
																																	])),
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Height:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				$author$project$Utils$convertHeightToFeetInches(viewingTalentResult.hB).b)
																																			]))
																																	])),
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Weight:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				$elm$core$String$fromInt(viewingTalentResult.jX))
																																			]))
																																	])),
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Waist Size:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				$elm$core$String$fromFloat(viewingTalentResult.jV) + '\"')
																																			]))
																																	])),
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Hair/Length:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('')
																																			]))
																																	])),
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Age:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(age)
																																			]))
																																	]))
																															]))
																													])),
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$classList(
																														_List_fromArray(
																															[
																																_Utils_Tuple2('contact-container', true),
																																_Utils_Tuple2('attributes-container', true),
																																_Utils_Tuple2('video-present', videoShowing),
																																_Utils_Tuple2('attributes-showing', attributesShowing)
																															]))
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$h3,
																														_List_Nil,
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Contact')
																															])),
																														$author$project$Views$TalentModal$contactInfoSection(viewingTalentResult)
																													])),
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$classList(
																														_List_fromArray(
																															[
																																_Utils_Tuple2('profile-footer', true),
																																_Utils_Tuple2('voting-section-expanded', action === 4),
																																_Utils_Tuple2('voting-section-expanded comment-section-expanded', action === 5)
																															]))
																													]),
																												_List_fromArray(
																													[
																														$author$project$Views$TalentModal$quickActionBar(action)(viewingTalentResult)(selectedTalent)(applicantData)(pipeline)(modalPage)(projects)(roles)(projectId)(currentColumnId)(project)(selectedRoleId)(twilioStatus)(userProfile)(newMessageBody)(creatorId)(schedulePageData)
																													]))
																											]))
																									]));
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$Messages$inboxView = function (model) {
	var _v0 = model.z.P;
	var _v1 = model.au;
	switch (_v1) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[$author$project$Utils$loader]));
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inbox-view')
					]),
				_List_fromArray(
					[
						$author$project$Views$Messages$chatIndexContainer(model),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-loading-icon')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions,
										$frandibar$elm_font_awesome_5$FontAwesome$circleNotch,
										0,
										_List_fromArray(
											[
												$frandibar$elm_font_awesome_5$FontAwesome$Animation(0)
											]),
										_List_Nil)
									]))
							])),
						A5(
						$author$project$Views$Confirmations$confirmation,
						model.aF,
						A4($author$project$MainMsg$UpdateUsersRoleStage, model.bI, model.k.aQ, 'Booking Request', model.bI.cu),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Are you sure you want to send a booking request to ' + (model.k.jv + '?'),
						_List_Nil)
					]));
		case 3:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inbox-view')
					]),
				_List_fromArray(
					[
						$author$project$Views$Messages$chatIndexContainer(model),
						$author$project$Views$Messages$chatBoxContainer(model),
						A5(
						$author$project$Views$Confirmations$confirmation,
						model.aF,
						A4($author$project$MainMsg$UpdateUsersRoleStage, model.bI, model.k.aQ, 'Booking Request', model.bI.cu),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Are you sure you want to send a booking request to ' + (model.k.jv + '?'),
						_List_Nil),
						$author$project$Views$TalentModal$talentSearchResultModal(model.p)(model.bh)(model.w)(model.aH)(model.aD)(model.cB)(model.v)(5)(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyProject]))(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyRole]))(model.aO)(model.d_)($author$project$SharedProjectRoleSchedules$emptyProject)(model.a5.ie)(model.au)(model.z)(model.y.dG)('')($author$project$SharedProjectRoleSchedules$initialSchedulePageData)($author$project$Data$Video$emptyVideo)($author$project$SharedProjectRoleSchedules$Waiting)(false)(model.ca)
					]));
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inbox-view')
					]),
				_List_fromArray(
					[
						$author$project$Views$Messages$chatIndexContainer(model),
						$author$project$Views$Messages$chatBoxContainer(model),
						A5(
						$author$project$Views$Confirmations$confirmation,
						model.aF,
						A4($author$project$MainMsg$UpdateUsersRoleStage, model.bI, model.k.aQ, 'Booking Request', model.bI.cu),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Are you sure you want to send a booking request to ' + (model.k.jv + '?'),
						_List_Nil),
						$author$project$Views$TalentModal$talentSearchResultModal(model.p)(model.bh)(model.w)(model.aH)(model.aD)(model.cB)(model.v)(5)(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyProject]))(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyRole]))(model.aO)(model.d_)($author$project$SharedProjectRoleSchedules$emptyProject)(model.a5.ie)(model.au)(model.z)(model.y.dG)('')($author$project$SharedProjectRoleSchedules$initialSchedulePageData)($author$project$Data$Video$emptyVideo)($author$project$SharedProjectRoleSchedules$Waiting)(false)(model.ca)
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('ERROR FETCHING DATA!')
					]));
	}
};
var $author$project$MainMsg$ToggleApplicationConfirmationModal = {$: 27};
var $author$project$MainMsg$FindJobAndOpenDetails = function (a) {
	return {$: 57, a: a};
};
var $author$project$MainMsg$NewApplication = {$: 65};
var $author$project$Views$Job$applicationConfirmationModal = function (isOpen) {
	if (isOpen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirmation-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Are you sure you want to apply to this job?')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' (You can only apply to 1 role per project)')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('controls')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button'),
									$elm$html$Html$Events$onClick($author$project$MainMsg$NewApplication)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Yes')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button'),
									$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleApplicationConfirmationModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Go Back')
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$angleDoubleDown = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('angle-double-down');
var $frandibar$elm_font_awesome_5$FontAwesome$angleDoubleUp = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('angle-double-up');
var $author$project$Utils$chevronDirection = function (open) {
	return open ? $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$angleDoubleUp) : $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$angleDoubleDown);
};
var $author$project$MainMsg$FindJobAndOpenModal = F2(
	function (a, b) {
		return {$: 56, a: a, b: b};
	});
var $author$project$Views$Job$interestedButton = F3(
	function (id, projectId, myJobs) {
		var projectIds = A2(
			$elm$core$List$map,
			function (role) {
				return role.iH;
			},
			A2(
				$elm$core$List$map,
				function ($) {
					return $.P;
				},
				myJobs));
		return A2(
			$elm$core$List$member,
			id,
			A2(
				$elm$core$List$map,
				function (job) {
					return job.P.cU;
				},
				myJobs)) ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('/jobs')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Check Status')
						]))
				])) : (A2($elm$core$List$member, projectId, projectIds) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('')
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$elm$html$Html$Events$onClick(
					A2($author$project$MainMsg$FindJobAndOpenModal, id, projectId))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('I\'m Interested')
				])));
	});
var $author$project$Views$Job$ageRow = function (job) {
	if ((job.cZ > 0) || (job.cX > 0)) {
		var min = (job.cZ > 0) ? $elm$core$String$fromInt(job.cZ) : 'ANY';
		var max = (job.cX > 0) ? $elm$core$String$fromInt(job.cX) : 'ANY';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('head')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Age Range')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(min + (' - ' + (max + ' years')))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Utils$formatHeight = function (totalHeight) {
	var inches = $elm$core$String$fromInt(
		A2($elm$core$Basics$modBy, 12, totalHeight));
	var feet = $elm$core$String$fromInt((totalHeight / 12) | 0);
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(feet + ('\' ' + (inches + '\'\' ')))
			]));
};
var $author$project$Views$Job$heightRow = function (job) {
	if ((job.h4 > 0) || (job.hZ > 0)) {
		var min = (job.h4 > 0) ? $author$project$Utils$formatHeight(job.h4) : $elm$html$Html$text('ANY');
		var max = (job.hZ > 0) ? $author$project$Utils$formatHeight(job.hZ) : $elm$html$Html$text('ANY');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('head')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Height Range')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							min,
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('- ')
								])),
							max
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Job$jobAttributeList = function (list) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (l) {
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('detail')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(l.bH)
						]));
			},
			list));
};
var $author$project$Views$Job$projectLocation = function (location) {
	return (location === '') ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('project-location-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-map-marker-alt')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('project-location')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(location)
					]))
			]));
};
var $author$project$Views$Job$weightRow = function (job) {
	if ((job.eN > 0) || (job.eI > 0)) {
		var min = (job.eN > 0) ? $elm$core$String$fromFloat(job.eN) : 'ANY';
		var max = (job.eI > 0) ? $elm$core$String$fromFloat(job.eI) : 'ANY';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('head')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Size Range')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(min + (' - ' + (max + ' pounds')))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Job$talentJobView = function (model) {
	var jobs = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (job) {
				return _Utils_eq(job.cU, model.g3);
			},
			model.aw));
	if (!jobs.$) {
		var job = jobs.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-details-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-details-titles')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-details-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(job.iI)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('role-details-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-title')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Role: ')
														])),
													$elm$html$Html$text(job.bH)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-rate')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Rate: ')
														])),
													$elm$html$Html$text('$' + job.iZ)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-details-row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-card-dates')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('far fa-calendar-alt')
														]),
													_List_Nil),
													$elm$html$Html$text(
													$author$project$Utils$formatDate(
														A2($author$project$Project$findDeadline, job.hb, 'Project').fO) + (' - ' + $author$project$Utils$formatDate(
														A2($author$project$Project$findDeadline, job.hb, 'Project').d8)))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fas fa-map-marker-alt')
														]),
													_List_Nil),
													$elm$html$Html$text(
													A2($author$project$Project$findDeadline, job.hb, 'Project').hV)
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('job-detail')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail notes head')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('PROJECT DESCRIPTION')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail content')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(job.iE)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('job-detail')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail notes head')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('ROLE DESCRIPTION')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail content')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(job.iV)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-listing-details-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('role-details')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-user-alt')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('ROLE DETAILS')
										])),
									(!_Utils_eq(job.hy, _List_Nil)) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail job-details-list')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('head')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Gender')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content')
												]),
											_List_fromArray(
												[
													$author$project$Views$Job$jobAttributeList(job.hy)
												]))
										])) : $elm$html$Html$text(''),
									$author$project$Views$Job$ageRow(job),
									$author$project$Views$Job$heightRow(job),
									$author$project$Views$Job$weightRow(job),
									(!_Utils_eq(job.ea, _List_Nil)) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail job-details-list')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('head')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Appearance')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content')
												]),
											_List_fromArray(
												[
													$author$project$Views$Job$jobAttributeList(job.ea)
												]))
										])) : $elm$html$Html$text(''),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('head')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Rate ')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('$' + job.iZ)
												]))
										])),
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('payment-details head')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('schedule-details')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('far fa-calendar-alt')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('SCHEDULE DETAILS')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('job-detail')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('head')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('JOB DATES')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.hb, 'Project').fO) + (' - ' + $author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.hb, 'Project').d8)))
																])),
															$author$project$Views$Job$projectLocation(
															A2($author$project$Project$findDeadline, job.hb, 'Project').hV)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('job-detail')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('head')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('AUDITION')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.hb, 'Audition').fO))
																])),
															$author$project$Views$Job$projectLocation(
															A2($author$project$Project$findDeadline, job.hb, 'Audition').hV)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('job-detail')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('head')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('CALLBACK')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.hb, 'Callback').fO))
																])),
															$author$project$Views$Job$projectLocation(
															A2($author$project$Project$findDeadline, job.hb, 'Callback').hV)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('job-detail')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('head')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('FITTING')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.hb, 'Fitting').fO))
																])),
															$author$project$Views$Job$projectLocation(
															A2($author$project$Project$findDeadline, job.hb, 'Fitting').hV)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('job-detail')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('head')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SHOOT')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.hb, 'Shoot').fO))
																])),
															$author$project$Views$Job$projectLocation(
															A2($author$project$Project$findDeadline, job.hb, 'Shoot').hV)
														]))
												]))
										]))
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Job$jobDropDownDetails = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('drop-down-wrapper')
			]),
		_List_fromArray(
			[
				$author$project$Views$Job$talentJobView(model)
			]));
};
var $author$project$Views$Job$jobRow = F3(
	function (model, multiModalStatus, confirmationOpen) {
		return A2(
			$elm$core$List$map,
			function (role) {
				var showDetails = _Utils_eq(
					multiModalStatus,
					$author$project$Utils$Open(role.cU)) ? $author$project$Views$Job$jobDropDownDetails(model) : $elm$html$Html$text('');
				var iconDirection = _Utils_eq(
					multiModalStatus,
					$author$project$Utils$Open(role.cU)) ? $author$project$Utils$chevronDirection(model.bM) : $author$project$Utils$chevronDirection(false);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('apply-container')
								]),
							_List_fromArray(
								[
									A3($author$project$Views$Job$interestedButton, role.cU, role.iH, model.eO)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('details-container'),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$FindJobAndOpenDetails(role.cU))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('image-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[iconDirection]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(role.iI)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-details-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('role-title')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Role: ')
																])),
															$elm$html$Html$text(role.bH)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('role-rate')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Rate: ')
																])),
															$elm$html$Html$text('$' + role.iZ)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-details-row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('role-card-dates')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$i,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('far fa-calendar-alt')
																]),
															_List_Nil),
															$elm$html$Html$text(
															$author$project$Utils$formatDate(
																A2($author$project$Project$findDeadline, role.hb, 'Project').fO) + (' - ' + $author$project$Utils$formatDate(
																A2($author$project$Project$findDeadline, role.hb, 'Project').d8)))
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$i,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('fas fa-map-marker-alt')
																]),
															_List_Nil),
															$elm$html$Html$text(
															A2($author$project$Project$findDeadline, role.hb, 'Project').hV)
														]))
												])),
											$author$project$Views$Job$applicationConfirmationModal(confirmationOpen),
											showDetails
										]))
								]))
						]));
			},
			model.aw);
	});
var $author$project$Views$Job$jobIndexView = F3(
	function (model, multiModalStatus, confirmationOpen) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal', true),
									_Utils_Tuple2('modal-open', confirmationOpen)
								])),
							$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleApplicationConfirmationModal)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Let\'s work.')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('body')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Looking for work? Here\'s some we think you might find interesting.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-container')
						]),
					A3($author$project$Views$Job$jobRow, model, multiModalStatus, confirmationOpen))
				]));
	});
var $author$project$Job$ChangeJob = function (a) {
	return {$: 3, a: a};
};
var $author$project$MainMsg$UpdateJobPageData = function (a) {
	return {$: 304, a: a};
};
var $author$project$Views$Job$inRoleBadge = function (job) {
	return (job.jr.jj !== 27) ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('in-role-badge')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Applied')
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Job$jobLi = F2(
	function (job, model) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$UpdateJobPageData(
						$author$project$Job$ChangeJob(job.V))),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected-job',
							_Utils_eq(job.V, model.M.fD.V))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('job-name-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(job.bH)
								])),
							$author$project$Views$Job$inRoleBadge(job)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('job-stat-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('project-attribute', true),
											_Utils_Tuple2('hiding-attribute', job.iJ === '0')
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-money-check-alt job-icon')
										]),
									_List_Nil),
									$elm$html$Html$text(job.iJ)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('project-attribute', true),
											_Utils_Tuple2('hiding-attribute', job.fc === '')
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-map-marker-alt job-icon')
										]),
									_List_Nil),
									$elm$html$Html$text(job.fc)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('project-attribute', true),
											_Utils_Tuple2('hiding-attribute', job.e9 === '')
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-calendar-alt job-icon')
										]),
									_List_Nil),
									$elm$html$Html$text(job.e9)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(job.hf)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('posted-date')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Posted ' + job.e1)
						]))
				]));
	});
var $author$project$Views$Job$jobList = function (model) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('job-list-container')
			]),
		A2(
			$elm$core$List$map,
			function (job) {
				return A2($author$project$Views$Job$jobLi, job, model);
			},
			model.M.fe));
};
var $author$project$Views$Job$noJobContainer = function (model) {
	return (!$elm$core$List$length(model.M.fe)) ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('No Found Jobs...')
			])) : $elm$html$Html$text('');
};
var $author$project$Utils$roleOptions = function (roles) {
	return A2(
		$elm$core$List$map,
		function (role) {
			return {V: role.V, bH: role.bH};
		},
		roles);
};
var $author$project$Job$Search = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$Job$resetSearchButton = function (model) {
	return (model.M.fC !== '') ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fas fa-times'),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$UpdateJobPageData(
					$author$project$Job$Search('')))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('')
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Job$searchWidget = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-widget-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-input-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$placeholder('Search'),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateJobPageData, $author$project$Job$Search)),
								$elm$html$Html$Attributes$value(model.M.fC)
							]),
						_List_Nil),
						$author$project$Views$Job$resetSearchButton(model)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('fas fa-circle-notch fa-spin', !model.M.fB),
								_Utils_Tuple2('search-projects-indicator', true)
							]))
					]),
				_List_Nil)
			]));
};
var $author$project$Views$Job$searchingText = function (model) {
	return (model.M.fC !== '') ? A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('job-search-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Searching: '),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('job-search-term')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(model.M.fC)
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$MainMsg$UpdateTalentMenuOptions = function (a) {
	return {$: 321, a: a};
};
var $author$project$User$NewRoleSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$ToggleModalView = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$SwitchRole = {$: 322};
var $author$project$Views$TalentOptions$changeRoleSubmitButton = function (talentMenu) {
	return (talentMenu.fp === '') ? $elm$html$Html$text('') : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$SwitchRole)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Submit')
			]));
};
var $author$project$User$emptyRoleOption = {V: '', bH: ''};
var $author$project$Views$TalentOptions$roleOption = F2(
	function (role, usersRole) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(role.V),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(role.bH, usersRole))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(role.bH)
				]));
	});
var $author$project$Views$TalentOptions$changeRoleForm = F2(
	function (talentMenu, roles) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('change-role-form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('change-role-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select New Role')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentMenuOptions, $author$project$User$NewRoleSelected))
						]),
					A2(
						$elm$core$List$map,
						function (role) {
							return A2($author$project$Views$TalentOptions$roleOption, role, talentMenu.jr.iY);
						},
						A2(
							$elm$core$List$cons,
							$author$project$User$emptyRoleOption,
							A2(
								$elm$core$List$map,
								function (role) {
									return {V: role.V, bH: role.bH};
								},
								roles)))),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$changeRoleSubmitButton(talentMenu),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$OptionsModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]))
				]));
	});
var $author$project$User$ChangeRoleModal = {$: 4};
var $author$project$User$DeclineApplication = 3;
var $author$project$User$DeclineBooking = 6;
var $author$project$User$ReasonModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$RemoveTalent = 0;
var $author$project$MainMsg$ApplyToRole = F2(
	function (a, b) {
		return {$: 262, a: a, b: b};
	});
var $author$project$Views$TalentOptions$applyToRoleButton = F2(
	function (talentMenu, role) {
		return (role !== '') ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$MainMsg$ApplyToRole, talentMenu.g2, talentMenu.fp))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Apply To Role')
				])) : A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Select Role')
				]));
	});
var $author$project$Views$TalentOptions$createNotificationData = F2(
	function (talentMenu, kind) {
		return {dG: talentMenu.iP, gY: '', hT: kind, aQ: talentMenu.jr.aQ, cu: talentMenu.jr.cU};
	});
var $author$project$User$AuditionDeclineSchedule = 2;
var $author$project$User$AuditionRescheduleTalent = 1;
var $author$project$User$CallbackDeclineSchedule = 5;
var $author$project$User$CallbackRescheduleTalent = 4;
var $author$project$Views$TalentOptions$acceptAuditionRequest = function (talentMenu) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A4(
					$author$project$MainMsg$UpdateUsersRoleStage,
					A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Audition Accepted'),
					talentMenu.jr.aQ,
					'Audition Accepted',
					talentMenu.jr.cU))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Accept Audition Request')
			]));
};
var $author$project$Views$TalentOptions$acceptCallbackRequest = function (talentMenu) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A4(
					$author$project$MainMsg$UpdateUsersRoleStage,
					A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Callback Accepted'),
					talentMenu.jr.aQ,
					'Callback Accepted',
					talentMenu.jr.cU))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Accept Callback Request')
			]));
};
var $author$project$Views$TalentOptions$rejectionRescheduleRequest = F2(
	function (scheduleStatus, reason) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$UpdateTalentMenuOptions(
						$author$project$User$ToggleModalView(
							$author$project$User$ReasonModal(reason))))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(scheduleStatus)
				]));
	});
var $author$project$Views$TalentOptions$agencyTalentSchedulingOptions = F2(
	function (scheduleMember, talentMenu) {
		var _v0 = scheduleMember.dc;
		switch (_v0) {
			case 5:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptAuditionRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Audition Request', 1),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Audition Request', 2)
						]));
			case 6:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Audition Request', 1),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Audition Request', 2)
						]));
			case 7:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptAuditionRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Audition Request', 1)
						]));
			case 9:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptAuditionRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Audition Request', 1),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Audition Request', 2)
						]));
			case 11:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptCallbackRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Callback Request', 4),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Callback Request', 5)
						]));
			case 12:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Callback Request', 4),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Callback Request', 5)
						]));
			case 13:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptCallbackRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Callback Request', 4)
						]));
			case 15:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptCallbackRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Callback Request', 4),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Callback Request', 5)
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$TalentOptions$rescheduleTalent = F2(
	function (scheduleId, scheduleType) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$View(
						A2($author$project$Route$SchedulePage, scheduleId, scheduleType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Reschedule Talent')
				]));
	});
var $author$project$Views$TalentOptions$directorSchedulingOptions = F2(
	function (scheduleMember, talentMenu) {
		var callbackActions = _List_fromArray(
			[
				A2($author$project$Views$TalentOptions$rescheduleTalent, talentMenu.g2, 'Callback'),
				A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateTalentMenuOptions(
							$author$project$User$ToggleModalView(
								$author$project$User$ReasonModal(0))))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Remove from Role')
					]))
			]);
		var auditionActions = _List_fromArray(
			[
				A2($author$project$Views$TalentOptions$rescheduleTalent, talentMenu.g2, 'Audition'),
				A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateTalentMenuOptions(
							$author$project$User$ToggleModalView(
								$author$project$User$ReasonModal(0))))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Remove from Role')
					]))
			]);
		var _v0 = scheduleMember.dc;
		switch (_v0) {
			case 5:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					auditionActions);
			case 6:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					auditionActions);
			case 7:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					auditionActions);
			case 8:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					auditionActions);
			case 9:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					auditionActions);
			case 11:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					callbackActions);
			case 14:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					callbackActions);
			case 12:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					callbackActions);
			case 13:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					callbackActions);
			case 15:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					callbackActions);
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$TalentOptions$scheduleOption = F3(
	function (scheduleMember, userProfile, talentMenu) {
		var _v0 = userProfile.P;
		if (_v0 === 1) {
			return A2($author$project$Views$TalentOptions$directorSchedulingOptions, scheduleMember, talentMenu);
		} else {
			return A2($author$project$Views$TalentOptions$agencyTalentSchedulingOptions, scheduleMember, talentMenu);
		}
	});
var $author$project$Views$TalentOptions$schedulingOptions = F2(
	function (talentMenu, userProfile) {
		return ($elm$core$List$length(talentMenu.jr.fx) > 1) ? A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (scheduleMember) {
					return A3($author$project$Views$TalentOptions$scheduleOption, scheduleMember, userProfile, talentMenu);
				},
				talentMenu.jr.fx)) : function (scheduleMember) {
			return A3($author$project$Views$TalentOptions$scheduleOption, scheduleMember, userProfile, talentMenu);
		}(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$User$emptyScheduleMember,
				$elm$core$List$head(talentMenu.jr.fx)));
	});
var $author$project$Views$TalentOptions$agencyTalentOptions = F3(
	function (talentMenu, userProfile, roles) {
		var _v0 = talentMenu.jr.jj;
		switch (_v0) {
			case 0:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 24:
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Removed from role by casting')
						]));
			case 25:
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Removed from role by Agent')
						]));
			case 1:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 2:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A4(
										$author$project$MainMsg$UpdateUsersRoleStage,
										A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Accepted Application'),
										talentMenu.jr.aQ,
										'Accepted Application',
										talentMenu.jr.cU))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Accept Application Request')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(3))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Decline Application Request')
								]))
						]));
			case 3:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 4:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A4(
										$author$project$MainMsg$UpdateUsersRoleStage,
										A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Accepted Application'),
										talentMenu.jr.aQ,
										'Accepted Application',
										talentMenu.jr.cU))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Accept Application Request')
								]))
						]));
			case 17:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A4(
										$author$project$MainMsg$UpdateUsersRoleStage,
										A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Booking Accepted'),
										talentMenu.jr.aQ,
										'Booking Accepted',
										talentMenu.jr.cU))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Accept Booking Request')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(6))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Reject Booking Request')
								]))
						]));
			case 18:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(6))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Reject Booking Request')
								]))
						]));
			case 19:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A4(
										$author$project$MainMsg$UpdateUsersRoleStage,
										A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Booking Accepted'),
										talentMenu.jr.aQ,
										'Booking Accepted',
										talentMenu.jr.cU))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Accept Booking Request')
								]))
						]));
			case 26:
				return A2($author$project$Views$TalentOptions$schedulingOptions, talentMenu, userProfile);
			case 27:
				var _v1 = userProfile.P;
				if (!_v1) {
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-option-buttons')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$select,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentMenuOptions, $author$project$User$NewRoleSelected))
									]),
								A2(
									$elm$core$List$map,
									function (role) {
										return A2(
											$elm$html$Html$option,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$value(role.V)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(role.bH)
												]));
									},
									A2($elm$core$List$cons, $author$project$User$emptyRoleOption, roles))),
								A2($author$project$Views$TalentOptions$applyToRoleButton, talentMenu, talentMenu.fp)
							]));
				} else {
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-option-buttons')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										A2(
											$author$project$MainMsg$MoveNewCandidate,
											_List_fromArray(
												[talentMenu.jr]),
											''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Submit Talent')
									]))
							]));
				}
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$TalentOptions$directorOptions = F2(
	function (talentMenu, userProfile) {
		var _v0 = talentMenu.jr.jj;
		switch (_v0) {
			case 0:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 24:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								]))
						]));
			case 1:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 2:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 3:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 4:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 17:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 18:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 19:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 26:
				return A2($author$project$Views$TalentOptions$schedulingOptions, talentMenu, userProfile);
			case 27:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2(
										$author$project$MainMsg$MoveNewCandidate,
										_List_fromArray(
											[talentMenu.jr]),
										''))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add To Role')
								]))
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$TalentOptions$optionButtons = F3(
	function (talentMenu, userProfile, roles) {
		var _v0 = userProfile.P;
		if (_v0 === 1) {
			return A2($author$project$Views$TalentOptions$directorOptions, talentMenu, userProfile);
		} else {
			return A3($author$project$Views$TalentOptions$agencyTalentOptions, talentMenu, userProfile, roles);
		}
	});
var $author$project$User$UpdateReason = function (a) {
	return {$: 0, a: a};
};
var $author$project$MainMsg$RemoveTalentFromRole = {$: 323};
var $author$project$Views$TalentOptions$reasonSubmitButton = F2(
	function (talentMenu, reason) {
		if (talentMenu.iP !== '') {
			var action = function () {
				switch (reason) {
					case 0:
						return $author$project$MainMsg$RemoveTalentFromRole;
					case 1:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Audition Reschedule Requested'),
							talentMenu.jr.aQ,
							'Audition Reschedule Requested',
							talentMenu.jr.cU);
					case 2:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Audition Rejected'),
							talentMenu.jr.aQ,
							'Audition Rejected',
							talentMenu.jr.cU);
					case 4:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Callback Reschedule Requested'),
							talentMenu.jr.aQ,
							'Callback Reschedule Requested',
							talentMenu.jr.cU);
					case 5:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Callback Rejected'),
							talentMenu.jr.aQ,
							'Callback Rejected',
							talentMenu.jr.cU);
					case 3:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Rejected Application'),
							talentMenu.jr.aQ,
							'Rejected Application',
							talentMenu.jr.cU);
					case 6:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Booking Rejected'),
							talentMenu.jr.aQ,
							'Booking Rejected',
							talentMenu.jr.cU);
					default:
						return $author$project$MainMsg$NoOp;
				}
			}();
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(action)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Submit')
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$TalentOptions$reasonForm = F2(
	function (talentMenu, reasonAction) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-options-form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(talentMenu.h8)
						])),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Reason')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentMenuOptions, $author$project$User$UpdateReason))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Views$TalentOptions$reasonSubmitButton, talentMenu, reasonAction),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$OptionsModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]))
				]));
	});
var $author$project$Views$TalentOptions$modalContent = F3(
	function (talentMenu, userProfile, roles) {
		var _v0 = talentMenu.bG;
		switch (_v0.$) {
			case 0:
				return $elm$html$Html$text('');
			case 2:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fas fa-circle-notch fa-spin')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
			case 1:
				var reason = _v0.a;
				return A2($author$project$Views$TalentOptions$reasonForm, talentMenu, reason);
			case 3:
				return A3($author$project$Views$TalentOptions$optionButtons, talentMenu, userProfile, roles);
			default:
				return A2($author$project$Views$TalentOptions$changeRoleForm, talentMenu, roles);
		}
	});
var $author$project$Views$TalentOptions$scheduleText = function (scheduleMember) {
	var scheduleStatus = function () {
		var _v0 = scheduleMember.dc;
		switch (_v0) {
			case 5:
				return 'Pending audition for: ';
			case 6:
				return 'Accepted audition for: ';
			case 7:
				return 'Rejected audition for: ';
			case 8:
				return 'Awaiting rescheduling of audition for: ';
			case 9:
				return 'Rescheduled audition for: ';
			case 10:
				return 'Canceled audition for: ';
			case 11:
				return 'Pending callback for: ';
			case 12:
				return 'Accepted callback for: ';
			case 13:
				return 'Rejected callback for: ';
			case 14:
				return 'Awaiting rescheduling of callback for: ';
			case 15:
				return 'Rescheduled callback for: ';
			case 16:
				return 'Canceled callback for: ';
			default:
				return '';
		}
	}();
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('scheduled-time-container')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				_Utils_ap(scheduleStatus, scheduleMember.fA))
			]));
};
var $author$project$Views$TalentOptions$scheduledTime = function (talent) {
	return ($elm$core$List$length(talent.fx) > 0) ? A2(
		$elm$html$Html$ul,
		_List_Nil,
		A2($elm$core$List$map, $author$project$Views$TalentOptions$scheduleText, talent.fx)) : $elm$html$Html$text('');
};
var $author$project$Views$TalentOptions$userRoleText = F2(
	function (userProfile, talentMenu) {
		if (talentMenu.jr.iY !== '') {
			var _v0 = userProfile.P;
			if (!_v0) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You are currently in the ' + (talentMenu.jr.iY + ' role'))
						]));
			} else {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(talentMenu.jr.bm + (' is currently in ' + talentMenu.jr.iY))
						]));
			}
		} else {
			if (_Utils_eq(talentMenu.bG, $author$project$User$LoadingTalentDetails)) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Getting Role Details')
						]));
			} else {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Not currently associated to any roles in project')
						]));
			}
		}
	});
var $author$project$Views$TalentOptions$talentOptionsModal = F3(
	function (talentMenu, userProfile, roles) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('talent-options-top-container', true),
							_Utils_Tuple2('talent-options-open', !talentMenu.dk)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateTalentMenuOptions(
								$author$project$User$ToggleMenuModal($author$project$User$emptySearchTalentProfile))),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('talent-options-modal', true),
									_Utils_Tuple2('talent-options-open', !talentMenu.dk)
								]))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('talent-options-container', true),
									_Utils_Tuple2('talent-options-open', !talentMenu.dk)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Manage Role')
								])),
							A2($author$project$Views$TalentOptions$userRoleText, userProfile, talentMenu),
							$author$project$Views$TalentOptions$scheduledTime(talentMenu.jr),
							A3($author$project$Views$TalentOptions$modalContent, talentMenu, userProfile, roles)
						]))
				]));
	});
var $author$project$Job$ToggleViewingJobState = {$: 4};
var $author$project$MainMsg$GoToTalentSearch = F3(
	function (a, b, c) {
		return {$: 315, a: a, b: b, c: c};
	});
var $author$project$SharedProjectRoleSchedules$emptyBasicRoleData = {dt: '', hf: '', ea: '', hy: '', V: '', bH: '', iH: '', iI: ''};
var $author$project$Views$Job$manageButton = F2(
	function (jobPageData, userProfile) {
		var _v0 = userProfile.P;
		if (!_v0) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('manage-button'),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateTalentMenuOptions(
							$author$project$User$ToggleMenuModal(jobPageData.fD.jr)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Manage Role')
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('manage-button'),
						$elm$html$Html$Events$onClick(
						A3(
							$author$project$MainMsg$GoToTalentSearch,
							jobPageData.fD.V,
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$SharedProjectRoleSchedules$emptyBasicRoleData,
								$elm$core$List$head(jobPageData.fD.fq)).V,
							jobPageData.fD.hY))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add Talent')
					]));
		}
	});
var $author$project$Views$Job$roleLi = F2(
	function (role, project) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-detail')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(role.bH + (' / Ages: ' + (role.dt + (' / Genders: ' + (role.hy + (' / Ethnicities: ' + role.ea))))))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(role.hf)
						]))
				]));
	});
var $author$project$Views$Job$viewingJob = function (_v0) {
	var jobPageData = _v0.M;
	var userProfile = _v0.z;
	return (jobPageData.fD.V === '') ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('No found job')
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('viewing-job-container', true),
						_Utils_Tuple2('viewing-container-closed', jobPageData.f3 === 1)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('job-title-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(jobPageData.fD.bH)
									])),
								A2($author$project$Views$Job$manageButton, jobPageData, userProfile)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-times'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$UpdateJobPageData($author$project$Job$ToggleViewingJobState))
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Project Description')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(jobPageData.fD.hf)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Roles')
									]))
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (role) {
								return A2($author$project$Views$Job$roleLi, role, jobPageData.fD);
							},
							jobPageData.fD.fq))
					]))
			]));
};
var $author$project$Views$Job$jobView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Views$Job$searchWidget(model),
				$author$project$Views$Job$searchingText(model),
				$author$project$Views$Job$noJobContainer(model),
				$author$project$Views$Job$jobList(model),
				$author$project$Views$Job$viewingJob(model),
				A3(
				$author$project$Views$TalentOptions$talentOptionsModal,
				model.Q,
				model.z,
				$author$project$Utils$roleOptions(model.M.fD.fq))
			]));
};
var $author$project$Views$Job$jobViewListing = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('job-detail-listing')
			]),
		_List_fromArray(
			[
				$author$project$Views$Job$jobView(model)
			]));
};
var $author$project$Main$loadingView = $author$project$Utils$loader;
var $author$project$MainMsg$SendPasswordResetEmail = {$: 309};
var $author$project$MainMsg$SigninEmail = function (a) {
	return {$: 30, a: a};
};
var $author$project$MainMsg$SigninPassword = function (a) {
	return {$: 31, a: a};
};
var $author$project$MainMsg$Signin = {$: 17};
var $author$project$Views$Auth$loginButton = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Events$onClick($author$project$MainMsg$Signin),
			$elm$html$Html$Attributes$class('button full'),
			$elm$html$Html$Attributes$id('signin')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Login')
		]));
var $author$project$Views$Auth$loginView = F2(
	function (err, logoPath) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tagline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Transparent. Accessible. Safe.')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form login main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Events$onInput($author$project$MainMsg$SigninEmail),
													$elm$html$Html$Attributes$placeholder('Email')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Events$onInput($author$project$MainMsg$SigninPassword),
													$elm$html$Html$Attributes$type_('password'),
													$elm$html$Html$Attributes$placeholder('Password')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[$author$project$Views$Auth$loginButton])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$MainMsg$SendPasswordResetEmail),
											$elm$html$Html$Attributes$class('link-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Forgot password?')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('account-signup-container')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Don\'t have an account?'),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$View($author$project$Route$TalentRegistration)),
													$elm$html$Html$Attributes$class('link-button')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sign up »')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$MainMsg$ToggleNotificationModal = F3(
	function (a, b, c) {
		return {$: 221, a: a, b: b, c: c};
	});
var $author$project$MainMsg$ResponseInvalid = {$: 246};
var $author$project$Views$Job$validateRejectionResponse = F2(
	function (notification, userJob) {
		return A2(
			$elm$core$List$member,
			notification.hT,
			_List_fromArray(
				['Audition Rejected', 'Audition Rescheduled', 'Callback Rescheduled', 'Callback Reschedule Requested', 'Audition Reschedule Requested', 'Audition Rescheduled', 'Callback Rejected', 'Callback Rescheduled', 'Booking Rejected', 'Rejected Application'])) ? (($elm$core$String$length(notification.dG) <= 1) ? $author$project$MainMsg$ResponseInvalid : A4($author$project$MainMsg$UpdateUsersRoleStage, notification, notification.aQ, notification.hT, notification.cu)) : A4($author$project$MainMsg$UpdateUsersRoleStage, notification, notification.aQ, notification.hT, notification.cu);
	});
var $author$project$Views$Job$notificationModal = F6(
	function (notification, userJob, isOpen, userId, roleId, formInvalid) {
		var textType = function () {
			var _v2 = notification.hT;
			switch (_v2) {
				case 'Audition Rejected':
					return 'Reject ';
				case 'Audition Rescheduled':
					return 'Reschedule ';
				case 'Audition Accepted':
					return 'Accept ';
				case 'Audition Reschedule Requested':
					return 'Reschedule ';
				case 'Callback Rejected':
					return 'Reject ';
				case 'Callback Rescheduled':
					return 'Reschedule ';
				case 'Callback Accepted':
					return 'Accept ';
				case 'Callback Reschedule Requested':
					return 'Reschedule';
				case 'Booking Accepted':
					return 'Accept ';
				case 'Booking Rejected':
					return 'Reject ';
				case 'Rejected Application':
					return 'Reject ';
				case 'Accepted Application':
					return 'Accept ';
				default:
					return 'Send';
			}
		}();
		var textArea = function () {
			switch (textType) {
				case 'Accept ':
					return $elm$html$Html$text('');
				case 'Reschedule ':
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rejection-input-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('* Reschedule Response:')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('invalid-response', formInvalid)
											])),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$NotificationFormMsg, $author$project$Job$NotificationBody)),
										$elm$html$Html$Attributes$placeholder('Please let casting know what your needs are for rescheduling...'),
										$elm$html$Html$Attributes$value(notification.dG)
									]),
								_List_Nil)
							]));
				default:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rejection-input-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('* Rejection Response:')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('invalid-response', formInvalid)
											])),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$NotificationFormMsg, $author$project$Job$NotificationBody)),
										$elm$html$Html$Attributes$placeholder('Please let casting know why you are unable to make this scheduled time....'),
										$elm$html$Html$Attributes$value(notification.dG)
									]),
								_List_Nil)
							]));
			}
		}();
		if (isOpen) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('confirmation-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to ' + (textType + ' this request?'))
							])),
						textArea,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('controls')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										A2($author$project$Views$Job$validateRejectionResponse, notification, userJob))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(textType + ' Request')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										A3($author$project$MainMsg$ToggleNotificationModal, userJob, '', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									]))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$Job$candidateAction = F7(
	function (notification, job, userId, isOpen, schedulingAction, scheduleStatus, formInvalid) {
		if (schedulingAction) {
			switch (scheduleStatus) {
				case 5:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('We would love to Audition you for this role. Please accept our request below!')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button accept-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Accepted', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accept Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reject-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Rejected', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reject Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reschedule-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Reschedule Requested', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Request Reschedule')
											])),
										A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.P.cU, formInvalid)
									]))
							]));
				case 9:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Your Audition time has been changed, let casting know if you can make it!')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button accept-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Accepted', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accept Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reject-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Rejected', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reject Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reschedule-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Reschedule Requested', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Request Reschedule')
											])),
										A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.P.cU, formInvalid)
									]))
							]));
				case 6:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Congratulations You\'ve landed an Audition!')
									]))
							]));
				case 7:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You\'ve rejected this Audition Request.')
									]))
							]));
				case 8:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You\'ve requested a reschedule for this Audition time. Stay tuned!')
									]))
							]));
				case 10:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You have been removed from this Audition Schedule.')
									]))
							]));
				case 11:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('We would love to see you at our CallBack for this role. Please accept our request below!')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button accept-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Accepted', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accept Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reject-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Rejected', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reject Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reschedule-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Reschedule Requested', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Request Reschedule')
											])),
										A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.P.cU, formInvalid)
									]))
							]));
				case 15:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Your CallBack time has been changed, let casting know if you can make it!')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button accept-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Accepted', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accept Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reject-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Rejected', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reject Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reschedule-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Reschedule Requested', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Request Reschedule')
											])),
										A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.P.cU, formInvalid)
									]))
							]));
				case 12:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Congratulations You\'ve landed a Callback!')
									]))
							]));
				case 13:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You\'ve rejected this Callback Request.')
									]))
							]));
				case 14:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You\'ve requested a reschedule for this CallBack time. Stay tuned!')
									]))
							]));
				case 16:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('you have been removed from this CallBack Schedule.')
									]))
							]));
				default:
					return $elm$html$Html$text('');
			}
		} else {
			var _v1 = job.a7;
			switch (_v1) {
				case 17:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('We would love to book you for this role. Please accept our request below!')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button accept-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Booking Accepted', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accept Booking Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reject-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Booking Rejected', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reject Booking Request')
											])),
										A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.P.cU, formInvalid)
									]))
							]));
				case 18:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Congratulations You\'ve landed the spot!')
									]))
							]));
				case 19:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You\'ve rejected the booking request')
									]))
							]));
				default:
					var _v2 = job.gv;
					switch (_v2) {
						case 0:
							return A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You applied to this role. Stay tuned!')
									]));
						case 2:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-status-message')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You have been invited to this role! Please accept or reject request below')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('action-buttons')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('job-action-button accept-button'),
														$elm$html$Html$Events$onClick(
														A3($author$project$MainMsg$ToggleNotificationModal, job, 'Accepted Application', ''))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Accept Invitation')
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('job-action-button reject-button'),
														$elm$html$Html$Events$onClick(
														A3($author$project$MainMsg$ToggleNotificationModal, job, 'Rejected Application', ''))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Reject Invitation')
													])),
												A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.P.cU, formInvalid)
											]))
									]));
						case 3:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-status-message')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You Accepted the Invitation request. Stay tuned!')
											]))
									]));
						case 4:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-status-message')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You\'ve rejected this role invitation')
											]))
									]));
						default:
							return $elm$html$Html$text('');
					}
			}
		}
	});
var $author$project$MainMsg$OpenTalentConversationContainer = function (a) {
	return {$: 231, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$commentAlt = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('comment-alt');
var $author$project$Views$Job$chatMessages = F2(
	function (twilioData, job) {
		var chat = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (channel) {
					return _Utils_eq(channel.iI, job.P.iI);
				},
				twilioData.g));
		if (!chat.$) {
			var conversation = chat.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('chat-icon-container', true),
								_Utils_Tuple2('chat-icon-inactive', conversation.dz)
							])),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$OpenTalentConversationContainer(conversation.V))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-message-count')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(conversation.bW))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-message-icon')
							]),
						_List_fromArray(
							[
								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$commentAlt)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Job$emptyBasicSchedulingInfo = {hj: '', fy: ''};
var $author$project$Views$Job$scheduleTimeDisplay = F6(
	function (job, scheduleType, notification, userId, isOpen, formInvalid) {
		var scheduleStatus = A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fy;
						},
						scheduleType),
					job.fx))).dc;
		var eventTime = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Job$emptyBasicSchedulingInfo,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fy;
						},
						scheduleType),
					job.jD))).hj;
		var scheduleText = function () {
			switch (scheduleStatus) {
				case 5:
					return 'Pending Audition  Scheduled For: ' + eventTime;
				case 11:
					return 'Pending Callback Scheduled For: ' + eventTime;
				case 12:
					return 'Confirmed Callback Scheduled For: ' + eventTime;
				case 6:
					return 'Confirmed Audition Scheduled For: ' + eventTime;
				case 7:
					return 'Rejected Audition Scheduled For: ' + eventTime;
				case 13:
					return 'Rejected Callback Scheduled For: ' + eventTime;
				case 8:
					return 'Pending Audition Scheduled For: ' + eventTime;
				case 14:
					return 'Pending Callback Scheduled For: ' + eventTime;
				case 15:
					return 'Rescheduled Callback Scheduled For: ' + eventTime;
				case 9:
					return 'Rescheduled Audition Scheduled For: ' + eventTime;
				default:
					return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-action-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(scheduleText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('candidate-actions')
						]),
					_List_fromArray(
						[
							A7($author$project$Views$Job$candidateAction, notification, job, userId, isOpen, true, scheduleStatus, formInvalid)
						]))
				]));
	});
var $author$project$Views$Job$appliedJobRow = F6(
	function (notification, job, userId, twilioData, isOpen, formInvalid) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('role-card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image-container')
								]),
							_List_fromArray(
								[
									A2($elm$html$Html$span, _List_Nil, _List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$FindJob(job.P.cU))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(job.P.iI)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$FindJob(job.P.cU)),
											$elm$html$Html$Attributes$class('role-details-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-title')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Role: ')
														])),
													$elm$html$Html$text(job.P.bH)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-rate')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Rate: ')
														])),
													$elm$html$Html$text('$' + job.P.iZ)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-details-row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-card-dates')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('far fa-calendar-alt')
														]),
													_List_Nil),
													$elm$html$Html$text(
													$author$project$Utils$formatDate(
														A2($author$project$Project$findDeadline, job.P.hb, 'Project').fO) + (' - ' + $author$project$Utils$formatDate(
														A2($author$project$Project$findDeadline, job.P.hb, 'Project').d8)))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fas fa-map-marker-alt')
														]),
													_List_Nil),
													$elm$html$Html$text(
													A2($author$project$Project$findDeadline, job.P.hb, 'Project').hV)
												]))
										])),
									A6($author$project$Views$Job$scheduleTimeDisplay, job, 'Audition', notification, userId, isOpen, formInvalid),
									A6($author$project$Views$Job$scheduleTimeDisplay, job, 'Callback', notification, userId, isOpen, formInvalid),
									A7($author$project$Views$Job$candidateAction, notification, job, userId, isOpen, false, 27, formInvalid)
								]))
						])),
					A2($author$project$Views$Job$chatMessages, twilioData, job)
				]));
	});
var $author$project$Views$Job$appliedJobs = F2(
	function (model, isOpen) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (job) {
					return A6($author$project$Views$Job$appliedJobRow, model.bI, job, model.g5, model.j, isOpen, model.cT);
				},
				A2(
					$elm$core$List$filter,
					function (j) {
						return j.P.bH !== '';
					},
					model.eO)));
	});
var $author$project$Views$Job$myJobsView = F2(
	function (model, isOpen) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('job-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('modal', true),
											_Utils_Tuple2('modal-open', isOpen)
										])),
									$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleApplicationConfirmationModal)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('main-section')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Jobs')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('body')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Here\'s a List of your current jobs and status. Stay up-to-date.')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('my-jobs-count')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'YOUR JOBS (' + ($elm$core$String$fromInt(
												$elm$core$List$length(model.eO)) + ')'))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-container current-cards')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Views$Job$appliedJobs, model, isOpen)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('chat-modal-container', true),
									_Utils_Tuple2('chat-modal-container-open', model.dj)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal'),
									$elm$html$Html$Events$onClick($author$project$MainMsg$CloseTalentConversationContainer)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('talent-chat-window-container')
								]),
							_List_fromArray(
								[
									$author$project$Views$Messages$chatBoxContainer(
									{A: model.A, g: model.j.g, bf: model.bf, l: isOpen, k: model.j.k, b5: model.b5, h2: model.y.dG, h3: model.j.k.h3, bI: model.bI, z: model.z, p: model.p})
								]))
						]))
				]));
	});
var $author$project$Views$Dashboard$notFoundView = A2(
	$elm$html$Html$h1,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('PAGE NOT FOUND')
		]));
var $author$project$User$CompanyName = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$CompanyPhone = function (a) {
	return {$: 2, a: a};
};
var $author$project$MainMsg$CompanyProfileMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$CompanyType = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$CompanyWebAddress = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$Profile$companyTypes = _List_fromArray(
	['Casting Director', 'Advertisement', 'Marketing', 'Retail', 'Event Planning', 'Ecommerce', 'Individual', ' Other']);
var $author$project$Views$Form$selectStringField = F5(
	function (aMsg, bMsg, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, aMsg, bMsg)),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$stringOptionField, option, valueText);
					},
					options))
			]);
	});
var $author$project$Views$Profile$directorProfileFields = function (model) {
	var profileFormError = $elm$html$Html$text('');
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image-container')
					]),
				_List_fromArray(
					[
						A2($author$project$Views$Profile$uploadGallery, model.W, model.hE),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('image-preview-gallery')
							]),
						A2(
							$elm$core$List$map,
							function (image) {
								return A2($author$project$Views$Profile$imageItem, image, model.hE);
							},
							model.hE))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Company Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$CompanyProfileMsg, $author$project$User$CompanyName)),
								$elm$html$Html$Attributes$placeholder('Star Talent'),
								$elm$html$Html$Attributes$value(model.bz.gS)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A5($author$project$Views$Form$selectStringField, $author$project$MainMsg$CompanyProfileMsg, $author$project$User$CompanyType, 'Company Type', $author$project$Views$Profile$companyTypes, model.bz.gU)),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Company Phone')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$CompanyProfileMsg, $author$project$User$CompanyPhone)),
								$elm$html$Html$Attributes$placeholder('(555) 555-5555'),
								$elm$html$Html$Attributes$type_('tel'),
								$elm$html$Html$Attributes$value(model.bz.gT)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Company Web Address')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$CompanyProfileMsg, $author$project$User$CompanyWebAddress)),
								$elm$html$Html$Attributes$placeholder('https://www.exampleagency.com'),
								$elm$html$Html$Attributes$value(model.bz.gV)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Direct Number')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfilePhoneNumber)),
								$elm$html$Html$Attributes$placeholder('(555) 555-5555'),
								$elm$html$Html$Attributes$type_('tel'),
								$elm$html$Html$Attributes$value(model.z.eZ)
							]),
						_List_Nil)
					])),
				profileFormError
			]));
};
var $author$project$Views$FormValidation$invalidProfileFields = F2(
	function (userProfile, images) {
		return (userProfile.gC === '') || ((!$elm$core$List$length(images)) || ((!userProfile.hB) || ((!userProfile.jX) || ((userProfile.hw === '') || (userProfile.ho === '')))));
	});
var $author$project$Views$Profile$profileInfoView = function (model) {
	var profileFields = $author$project$Views$Profile$directorProfileFields(
		{bz: model.bz, W: model.W, hE: model.hE, as: model.as, z: model.z});
	var _v0 = model.R;
	switch (_v0.$) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('failed')
					]));
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('user-form')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-container')
									]),
								_List_Nil)
							]))
					]));
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('user-form')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-container')
									]),
								_List_fromArray(
									[$author$project$Utils$loader]))
							]))
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('user-form')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-container')
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Views$Confirmations$deleteConfirmation,
										model.Z,
										$author$project$MainMsg$DeleteImage(model.am),
										A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
										'Are you sure you want to remove this image?'),
										A2($author$project$Views$Profile$imageResizeWindow, model.av, model.az),
										A2(
										$elm$html$Html$form,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form main-form')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'invalid-form-container',
																A2($author$project$Views$FormValidation$invalidProfileFields, model.z, model.hE) && (!model.z.P)),
																_Utils_Tuple2('invalid-form-container-hidden', true)
															]))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Please fill out your entire profile!')
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('First Name')
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Events$onInput(
																A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileFirstName)),
																$elm$html$Html$Attributes$placeholder('John'),
																$elm$html$Html$Attributes$value(model.z.bm)
															]),
														_List_Nil)
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Last Name')
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Events$onInput(
																A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileLastName)),
																$elm$html$Html$Attributes$placeholder('Smith'),
																$elm$html$Html$Attributes$value(model.z.bE)
															]),
														_List_Nil)
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Email')
															])),
														A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(model.z.bl)
															]))
													])),
												profileFields,
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Events$onClick($author$project$MainMsg$UpdateProfileInfo),
																$elm$html$Html$Attributes$class('button full')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Update Profile')
															]))
													]))
											]))
									]))
							]))
					]));
	}
};
var $author$project$Main$profileSettingsView = F2(
	function (model, a) {
		return $author$project$Views$Profile$profileInfoView(
			{av: model.av, bz: model.bz, am: model.am, ea: model.ea, az: model.az, W: model.W, hE: model.hE, as: model.as, Z: model.Z, z: model.z, R: model.R});
	});
var $author$project$User$AgencySelected = function (a) {
	return {$: 18, a: a};
};
var $author$project$User$AgentSelected = function (a) {
	return {$: 19, a: a};
};
var $author$project$MainMsg$ToggleAgencyForm = {$: 303};
var $author$project$MainMsg$AddAgentToUser = F2(
	function (a, b) {
		return {$: 265, a: a, b: b};
	});
var $author$project$Views$Profile$addAgentButton = F2(
	function (agentId, agencyId) {
		return ((agentId === '') || (agencyId === '')) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('add-agency-button'),
					$elm$html$Html$Events$onClick(
					A2($author$project$MainMsg$AddAgentToUser, agentId, agencyId))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Agent')
				]));
	});
var $author$project$MainMsg$DeleteTalentAgent = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Views$Profile$acceptedTalentText = function (accepted) {
	switch (accepted) {
		case 0:
			return 'Agent Accepted';
		case 1:
			return 'Agent Rejected';
		default:
			return 'Pending Acceptance';
	}
};
var $author$project$Views$Profile$agentLi = function (agent) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agency-info-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verification-agent-badge')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Views$Profile$acceptedTalentText(agent.dp))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agent-info-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agency Name: ' + agent.cz)
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agent Name: ' + (agent.bm + (' ' + agent.bE)))
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A2($author$project$MainMsg$DeleteTalentAgent, agent.dA, agent.V))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Remove Agent')
					]))
			]));
};
var $author$project$Views$Profile$agencyInformation = function (agents) {
	return _Utils_eq(agents, _List_Nil) ? $elm$html$Html$text('No Agents Selected') : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('My Selected Agents')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-list')
					]),
				A2($elm$core$List$map, $author$project$Views$Profile$agentLi, agents))
			]));
};
var $author$project$Views$Form$agencyOptionField = F2(
	function (item, selectedId) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item.V),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item.V, selectedId))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item.bH)
				]));
	});
var $author$project$Views$Form$agencySelectField = F4(
	function (aMsg, placeholderText, options, valueText) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(placeholderText)
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput(aMsg),
							$elm$html$Html$Attributes$placeholder(placeholderText),
							$elm$html$Html$Attributes$class('select-field')
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$agencyOptionField, option, valueText);
						},
						options))
				]));
	});
var $author$project$User$AgentPhone = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$ProfileManualAgency = function (a) {
	return {$: 17, a: a};
};
var $author$project$MainMsg$SaveAgencyInfo = {$: 307};
var $author$project$Views$Profile$addManualAgencyButton = function (agency) {
	return ((agency.go === '') || ((agency.gp === '') || ((agency.gn === '') || (agency.cz === '')))) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$SaveAgencyInfo),
				$elm$html$Html$Attributes$class('agency-save-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Add Agent')
			]));
};
var $author$project$Views$Profile$talentAgencyFields = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleAgencyForm),
						$elm$html$Html$Attributes$class('agency-toggle-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Find Agency')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agency Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (input) {
									return $author$project$MainMsg$UserProfileMsg(
										$author$project$User$ProfileManualAgency(
											$author$project$User$AgencyName(input)));
								}),
								$elm$html$Html$Attributes$placeholder('Brown Agency'),
								$elm$html$Html$Attributes$value(userProfile.cy.cz)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agent First Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (input) {
									return $author$project$MainMsg$UserProfileMsg(
										$author$project$User$ProfileManualAgency(
											$author$project$User$AgentFirstName(input)));
								}),
								$elm$html$Html$Attributes$placeholder('Bob Smith'),
								$elm$html$Html$Attributes$value(userProfile.cy.go)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agent Last Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (input) {
									return $author$project$MainMsg$UserProfileMsg(
										$author$project$User$ProfileManualAgency(
											$author$project$User$AgentLastName(input)));
								}),
								$elm$html$Html$Attributes$placeholder('Bob Smith'),
								$elm$html$Html$Attributes$value(userProfile.cy.gp)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agent Phone Number')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (input) {
									return $author$project$MainMsg$UserProfileMsg(
										$author$project$User$ProfileManualAgency(
											$author$project$User$AgentPhone(input)));
								}),
								$elm$html$Html$Attributes$placeholder('(555) 555-5555'),
								$elm$html$Html$Attributes$type_('tel'),
								$elm$html$Html$Attributes$value(userProfile.cy.gq)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agent Email')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (input) {
									return $author$project$MainMsg$UserProfileMsg(
										$author$project$User$ProfileManualAgency(
											$author$project$User$AgentEmail(input)));
								}),
								$elm$html$Html$Attributes$placeholder('agent@email.com'),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$value(userProfile.cy.gn)
							]),
						_List_Nil)
					])),
				$author$project$Views$Profile$addManualAgencyButton(userProfile.cy)
			]));
};
var $author$project$Views$Profile$addAgencyFields = F2(
	function (userProfile, profilePageData) {
		if (profilePageData.fI) {
			return $author$project$Views$Profile$talentAgencyFields(userProfile);
		} else {
			var selectedAgent = A2(
				$elm$core$Maybe$withDefault,
				$author$project$User$emptyAgent,
				$elm$core$List$head(userProfile.gl.gr));
			var agents = _Utils_ap(
				_List_fromArray(
					[
						{V: '', bH: ''}
					]),
				A2(
					$elm$core$List$map,
					function (agent) {
						return {V: agent.V, bH: agent.bm + (' ' + agent.bE)};
					},
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$User$emptyAgency,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$author$project$Utils$eq,
									function ($) {
										return $.V;
									},
									userProfile.gl.V),
								profilePageData.cx))).gr));
			var agencies = _Utils_ap(
				_List_fromArray(
					[
						{V: '', bH: ''}
					]),
				A2(
					$elm$core$List$map,
					function (agency) {
						return {V: agency.V, bH: agency.cz};
					},
					profilePageData.cx));
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleAgencyForm),
								$elm$html$Html$Attributes$class('agency-toggle-button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Enter manually')
							])),
						A4(
						$author$project$Views$Form$agencySelectField,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$AgencySelected),
						'Select Agency',
						agencies,
						userProfile.gl.V),
						A4(
						$author$project$Views$Form$agencySelectField,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$AgentSelected),
						'Select Agent',
						agents,
						selectedAgent.V),
						A2($author$project$Views$Profile$addAgentButton, selectedAgent.V, userProfile.gl.V),
						$author$project$Views$Profile$agencyInformation(userProfile.gr)
					]));
		}
	});
var $author$project$SharedProjectRoleSchedules$DeleteFile = 2;
var $author$project$MainMsg$ResumeRequested = function (a) {
	return {$: 113, a: a};
};
var $author$project$MainMsg$DropResume = F2(
	function (a, b) {
		return {$: 120, a: a, b: b};
	});
var $author$project$Views$ProfileResumeUploader$dropDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files']),
	A2($elm$json$Json$Decode$oneOrMore, $author$project$MainMsg$DropResume, $elm$file$File$decoder));
var $author$project$Utils$Hijack$hijack = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $author$project$Utils$Hijack$hijackOn = F2(
	function (event, decoder) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Utils$Hijack$hijack, decoder));
	});
var $author$project$Views$ProfileResumeUploader$profileResumeUploaderContainer = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('file-upload-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Upload your resume')
							])),
						$elm$html$Html$text('Your resume will be availble to casting directors and any agencies that you belong to.')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[content]))
			]));
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Views$ProfileResumeUploader$profileResumeUploader = F2(
	function (status, maybeResume) {
		var _v0 = _Utils_Tuple2(status, maybeResume);
		switch (_v0.a.$) {
			case 0:
				if (_v0.b.$ === 1) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return $author$project$Views$ProfileResumeUploader$profileResumeUploaderContainer(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('resume-drop-zone'),
											A2(
											$author$project$Utils$Hijack$hijackOn,
											'dragenter',
											$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileEnter)),
											A2(
											$author$project$Utils$Hijack$hijackOn,
											'dragover',
											$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileEnter)),
											A2(
											$author$project$Utils$Hijack$hijackOn,
											'dragleave',
											$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileLeave)),
											A2($author$project$Utils$Hijack$hijackOn, 'drop', $author$project$Views$ProfileResumeUploader$dropDecoder)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Drag your resume here')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Or')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('resume-upload-button'),
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$ResumeRequested(1))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Select Resume')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('file-upload-allowed-types')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Supported file types *.doc, *.docx, *.pdf, *.txt')
										]))
								])));
				} else {
					var _v3 = _v0.a;
					var resume = _v0.b.a;
					return $author$project$Views$ProfileResumeUploader$profileResumeUploaderContainer(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('resume-view-link'),
											$elm$html$Html$Attributes$href(resume),
											$elm$html$Html$Attributes$rel('noopener noreferrer'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fa fa-file')
												]),
											_List_Nil),
											$elm$html$Html$text('Resume')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('resume-actions')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('resume-link'),
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$ResumeRequested(2))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove')
												]))
										]))
								])));
				}
			case 1:
				var file = _v0.a.a;
				return $author$project$Views$ProfileResumeUploader$profileResumeUploaderContainer(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Uploading resume...')
							])));
			default:
				var _v4 = _v0.a;
				return $author$project$Views$ProfileResumeUploader$profileResumeUploaderContainer(
					$elm$html$Html$text('Resume upload Failed!'));
		}
	});
var $author$project$User$Day = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$Month = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$ProfileBirthDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$User$ProfileEyeColor = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$ProfileGender = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$ProfileHeightInFeet = function (a) {
	return {$: 9, a: a};
};
var $author$project$User$ProfileHeightInInches = function (a) {
	return {$: 8, a: a};
};
var $author$project$User$ProfileWaistSize = function (a) {
	return {$: 11, a: a};
};
var $author$project$User$ProfileWeight = function (a) {
	return {$: 10, a: a};
};
var $author$project$User$Year = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$Project$convertHeightToFeet = function (height) {
	return $elm$core$String$fromInt((height / 12) | 0);
};
var $author$project$Utils$days = function (month) {
	switch (month) {
		case 2:
			return A2($elm$core$List$range, 0, 28);
		case 4:
			return A2($elm$core$List$range, 0, 30);
		case 6:
			return A2($elm$core$List$range, 0, 30);
		case 9:
			return A2($elm$core$List$range, 0, 30);
		case 11:
			return A2($elm$core$List$range, 0, 30);
		default:
			return A2($elm$core$List$range, 0, 31);
	}
};
var $author$project$InitData$eyeColors = _List_fromArray(
	['Blue', 'Brown', 'Gray', 'Green', 'Hazel']);
var $author$project$InitData$genders = _List_fromArray(
	['Male', 'Female', 'Other']);
var $author$project$Views$Project$getLeftOverInches = function (height) {
	return $elm$core$String$fromInt(height % 12);
};
var $author$project$Utils$months = _List_fromArray(
	[
		{V: '00', bH: 'Select Month'},
		{V: '01', bH: 'Jan'},
		{V: '02', bH: 'Feb'},
		{V: '03', bH: 'March'},
		{V: '04', bH: 'April'},
		{V: '05', bH: 'May'},
		{V: '06', bH: 'June'},
		{V: '07', bH: 'July'},
		{V: '08', bH: 'Aug'},
		{V: '09', bH: 'Sept'},
		{V: '10', bH: 'Oct'},
		{V: '11', bH: 'Nov'},
		{V: '12', bH: 'Dec'}
	]);
var $author$project$Utils$parseDay = function (day) {
	return A2(
		$elm$core$List$member,
		day,
		_List_fromArray(
			['00', '01', '02', '03', '04', '05', '06', '07', '08', '09'])) ? A2($elm$core$String$dropLeft, 1, day) : day;
};
var $author$project$Views$Form$floatOptionField = F2(
	function (item, selectedValue) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromFloat(item.ba)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item.ba, selectedValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item.b)
				]));
	});
var $author$project$Views$Form$selectFloatField = F4(
	function (inputChange, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(inputChange),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$floatOptionField, option, valueText);
					},
					options))
			]);
	});
var $author$project$Views$Form$stringOptionFieldProfile = F2(
	function (item, selectedValue) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item, selectedValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item)
				]));
	});
var $author$project$Views$Form$selectIntFieldProfile = F4(
	function (msg, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(msg),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$stringOptionFieldProfile, option, valueText);
					},
					$author$project$Views$Form$convertIntOptionsToString(options)))
			]);
	});
var $author$project$Views$Form$selectProfileIntField = F4(
	function (msg, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(msg),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$stringOptionField, option, valueText);
					},
					$author$project$Views$Form$convertIntOptionsToString(options)))
			]);
	});
var $author$project$Talent$waistSizes = _List_fromArray(
	[
		{b: 'ANY', ba: 0},
		{b: '26.5\"', ba: 26.5},
		{b: '27\"', ba: 27.0},
		{b: '27.5\"', ba: 27.5},
		{b: '28\"', ba: 28.0},
		{b: '28.5\"', ba: 28.5},
		{b: '29\"', ba: 29.0},
		{b: '29.5\"', ba: 29.5},
		{b: '30\"', ba: 30.0},
		{b: '30.5\"', ba: 30.5},
		{b: '31\"', ba: 31.0},
		{b: '31.5\"', ba: 31.5},
		{b: '32\"', ba: 32.0},
		{b: '32.5\"', ba: 32.5},
		{b: '33\"', ba: 33.0},
		{b: '33.5\"', ba: 33.5},
		{b: '34\"', ba: 34.0},
		{b: '34.5\"', ba: 34.5},
		{b: '35\"', ba: 35.0},
		{b: '35.5\"', ba: 35.5},
		{b: '36\"', ba: 36.0},
		{b: '36.5\"', ba: 36.5},
		{b: '37\"', ba: 37.0},
		{b: '37.5\"', ba: 37.5},
		{b: '38\"', ba: 38.0},
		{b: '38.5\"', ba: 38.5},
		{b: '39\"', ba: 39.0},
		{b: '39.5\"', ba: 39.5},
		{b: '40\"', ba: 40.0},
		{b: '40.5\"', ba: 40.5},
		{b: '41\"', ba: 41.0},
		{b: '41.5\"', ba: 41.5},
		{b: '42\"', ba: 42.0},
		{b: '42.5\"', ba: 42.5},
		{b: '43\"', ba: 43.0},
		{b: '43.5\"', ba: 43.5},
		{b: '44\"', ba: 44.0},
		{b: '44.5\"', ba: 44.5},
		{b: '45\"', ba: 45.0},
		{b: '45.5\"', ba: 45.5},
		{b: '46\"', ba: 46.0},
		{b: '46.5\"', ba: 46.5},
		{b: '47\"', ba: 47.0},
		{b: '47.5\"', ba: 47.5},
		{b: '48\"', ba: 48.0},
		{b: '48.5\"', ba: 48.5},
		{b: '49\"', ba: 49.0},
		{b: '49.5\"', ba: 49.5},
		{b: '50\"', ba: 50.0},
		{b: '50.5\"', ba: 50.5},
		{b: '51\"', ba: 51.0},
		{b: '51.5\"', ba: 51.5}
	]);
var $author$project$Views$Profile$talentAttributesFields = F2(
	function (userProfile, ethnicities) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A5(
						$author$project$Views$Form$selectStringField,
						$author$project$MainMsg$UserProfileMsg,
						$author$project$User$ProfileEyeColor,
						'* Eye Color',
						A2($elm$core$List$cons, '', $author$project$InitData$eyeColors),
						userProfile.ho)),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Birthday')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('birthdate-input')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									$author$project$Views$Form$agencySelectField,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileBirthDate),
										$author$project$User$Month),
									'Month',
									$author$project$Utils$months,
									userProfile.h9)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A4(
								$author$project$Views$Form$selectProfileIntField,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileBirthDate),
									$author$project$User$Day),
								'Day',
								$author$project$Utils$days(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(userProfile.h9))),
								$author$project$Utils$parseDay(userProfile.ha))),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A4(
								$author$project$Views$Form$selectProfileIntField,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileBirthDate),
									$author$project$User$Year),
								'Year',
								A2(
									$elm$core$List$cons,
									0,
									A2($elm$core$List$range, 1920, 2019)),
								userProfile.jZ))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A5(
						$author$project$Views$Form$selectStringField,
						$author$project$MainMsg$UserProfileMsg,
						$author$project$User$ProfileGender,
						'* Gender',
						A2($elm$core$List$cons, '', $author$project$InitData$genders),
						userProfile.hw)),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Views$Form$multiSelect,
							'Ethnic Appearance',
							A2(
								$elm$core$List$cons,
								{V: '', bH: ''},
								ethnicities),
							A2(
								$elm$core$List$map,
								function (option) {
									return option.bH;
								},
								userProfile.ea),
							3)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('height-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('half')
								]),
							A4(
								$author$project$Views$Form$selectIntFieldProfile,
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileHeightInFeet),
								'* Height in Feet',
								_Utils_ap(
									_List_fromArray(
										[0]),
									A2($elm$core$List$range, 3, 7)),
								$author$project$Views$Project$convertHeightToFeet(userProfile.hB))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('half')
								]),
							A4(
								$author$project$Views$Form$selectIntFieldProfile,
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileHeightInInches),
								'* Height in Inches',
								A2($elm$core$List$range, 0, 12),
								$author$project$Views$Project$getLeftOverInches(userProfile.hB)))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('* Weight')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileWeight)),
									$elm$html$Html$Attributes$placeholder('135'),
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromInt(userProfile.jX))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A4(
						$author$project$Views$Form$selectFloatField,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileWaistSize),
						'Waist Size',
						$author$project$Talent$waistSizes,
						userProfile.jV))
				]));
	});
var $author$project$User$ProfileCity = function (a) {
	return {$: 12, a: a};
};
var $author$project$User$ProfileState = function (a) {
	return {$: 13, a: a};
};
var $author$project$Views$Profile$talentContactInformationFields = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('First Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileFirstName)),
								$elm$html$Html$Attributes$placeholder('John'),
								$elm$html$Html$Attributes$value(userProfile.bm)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Last Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileLastName)),
								$elm$html$Html$Attributes$placeholder('Smith'),
								$elm$html$Html$Attributes$value(userProfile.bE)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Email')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(userProfile.bl)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('City')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileCity)),
								$elm$html$Html$Attributes$placeholder('Austin'),
								$elm$html$Html$Attributes$value(userProfile.aV)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('State')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileState)),
								$elm$html$Html$Attributes$placeholder('TX'),
								$elm$html$Html$Attributes$value(userProfile.a7)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Phone Number')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfilePhoneNumber)),
								$elm$html$Html$Attributes$placeholder('(555) 555-5555'),
								$elm$html$Html$Attributes$type_('tel'),
								$elm$html$Html$Attributes$value(userProfile.eZ)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Views$Profile$questionsSection = function (pageIndex) {
	return function (userProfile) {
		return function (ethnicities) {
			return function (images) {
				return function (profilePageData) {
					return function (imageUpload) {
						return function (resumeUpload) {
							return function (deleteID) {
								return function (showDeleteConfirmation) {
									return function (adjustingImage) {
										return function (imageToAdjust) {
											switch (pageIndex) {
												case 0:
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('talent-view-page')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-container')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$form,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('form main-form')
																			]),
																		_List_fromArray(
																			[
																				$author$project$Views$Profile$talentContactInformationFields(userProfile)
																			]))
																	]))
															]));
												case 1:
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('talent-view-page')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-container')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$form,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('form main-form')
																			]),
																		_List_fromArray(
																			[
																				A2($author$project$Views$Profile$talentAttributesFields, userProfile, ethnicities)
																			]))
																	]))
															]));
												case 2:
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('talent-view-page')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-container')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$form,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('form main-form')
																			]),
																		_List_fromArray(
																			[
																				A2($author$project$Views$Profile$addAgencyFields, userProfile, profilePageData)
																			]))
																	]))
															]));
												case 3:
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('talent-view-page')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-container')
																	]),
																_List_fromArray(
																	[
																		A4(
																		$author$project$Views$Confirmations$deleteConfirmation,
																		showDeleteConfirmation,
																		$author$project$MainMsg$DeleteImage(deleteID),
																		A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
																		'Are you sure you want to remove this image?'),
																		A2($author$project$Views$Profile$imageResizeWindow, adjustingImage, imageToAdjust),
																		A2(
																		$elm$html$Html$form,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('form main-form')
																			]),
																		_List_fromArray(
																			[
																				A2($author$project$Views$Profile$uploadGallery, imageUpload, images),
																				A2(
																				$elm$html$Html$ul,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('image-preview-gallery')
																					]),
																				A2(
																					$elm$core$List$map,
																					function (image) {
																						return A2($author$project$Views$Profile$imageItem, image, images);
																					},
																					images))
																			]))
																	]))
															]));
												case 4:
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('talent-view-page')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-container')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$form,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('form main-form')
																			]),
																		_List_fromArray(
																			[
																				A2($author$project$Views$ProfileResumeUploader$profileResumeUploader, resumeUpload, userProfile.iU)
																			]))
																	]))
															]));
												default:
													return $elm$html$Html$text('');
											}
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$Profile$talentProfileFooter = F2(
	function (currentPageIndex, pageCount) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('profile-page-footer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pro-tip-footer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Pro tip: The more information you fill out, the more jobs you will land.')
						])),
					A2($author$project$Views$Profile$nextButton, currentPageIndex, pageCount)
				]));
	});
var $author$project$Views$Profile$talentProfileView = function (profilePageData) {
	return function (userProfile) {
		return function (ethnicities) {
			return function (images) {
				return function (imageUpload) {
					return function (resumeUploadStatus) {
						return function (deleteID) {
							return function (showDeleteConfirmation) {
								return function (adjustingImage) {
									return function (imageToAdjust) {
										var _v0 = profilePageData.z;
										switch (_v0.$) {
											case 1:
												return $elm$html$Html$text('');
											case 2:
												return $elm$html$Html$text('');
											case 0:
												return $elm$html$Html$text('');
											default:
												var profile = _v0.a;
												var pageArray = $elm$core$Array$fromList(profile.ck);
												var activePage = A2(
													$elm$core$Maybe$withDefault,
													$author$project$User$emptyProfilePage,
													A2($elm$core$Array$get, profilePageData.dZ, pageArray));
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('profile-wrapper')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('profile-container')
																]),
															_List_fromArray(
																[
																	A4($author$project$Views$Profile$talentProfileHeader, profile.ck, activePage, profilePageData.dZ, profilePageData.c7),
																	$author$project$Views$Profile$questionsSection(profilePageData.dZ)(userProfile)(ethnicities)(images)(profilePageData)(imageUpload)(resumeUploadStatus)(deleteID)(showDeleteConfirmation)(adjustingImage)(imageToAdjust),
																	A2(
																	$author$project$Views$Profile$talentProfileFooter,
																	profilePageData.dZ,
																	$elm$core$List$length(profile.ck))
																]))
														]));
										}
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Main$profileSettingsViewContent = F2(
	function (model, a) {
		if (a === 'profile') {
			var _v1 = model.z.P;
			switch (_v1) {
				case 0:
					return $author$project$Views$Profile$talentProfileView(model.c)(model.z)(model.ea)(model.hE)(model.W)(model.co)(model.am)(model.Z)(model.av)(model.az);
				case 1:
					return $author$project$Views$Profile$profileInfoView(
						{av: model.av, bz: model.bz, am: model.am, ea: model.ea, az: model.az, W: model.W, hE: model.hE, as: model.as, Z: model.Z, z: model.z, R: model.R});
				default:
					return $elm$html$Html$text('');
			}
		} else {
			return $author$project$Views$Dashboard$notFoundView;
		}
	});
var $author$project$Project$BulkExisting = 3;
var $author$project$Project$Existing = 1;
var $author$project$Project$dnames = function (deadlines) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.bH;
		},
		deadlines);
};
var $author$project$Pipeline$CondensedView = 1;
var $author$project$Project$OntoElement = function (a) {
	return {$: 0, a: a};
};
var $visotype$elm_dom$Dom$Internal$Element = $elm$core$Basics$identity;
var $visotype$elm_dom$Dom$Internal$modify = F2(
	function (f, _v0) {
		var data = _v0;
		return f(data);
	});
var $visotype$elm_dom$Dom$addClass = function (s) {
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					aJ: A2(
						$elm$core$List$append,
						n.aJ,
						_List_fromArray(
							[s]))
				});
		});
};
var $visotype$elm_dom$Dom$addClassConditional = F2(
	function (s, test) {
		if (test) {
			return $visotype$elm_dom$Dom$addClass(s);
		} else {
			return function (x) {
				return x;
			};
		}
	});
var $visotype$elm_dom$Dom$addAction = function (_v0) {
	var event = _v0.a;
	var msg = _v0.b;
	var handler = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $elm$virtual_dom$VirtualDom$Normal);
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					o: A2(
						$elm$core$List$append,
						n.o,
						_List_fromArray(
							[
								_Utils_Tuple2(
								event,
								handler(msg))
							]))
				});
		});
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $visotype$elm_dom$Dom$Internal$render = function (_v0) {
	var data = _v0;
	var prependStyles = function () {
		var _v8 = data.fQ;
		if (!_v8.b) {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$append(
				A2(
					$elm$core$List$map,
					function (_v9) {
						var k = _v9.a;
						var v = _v9.b;
						return A2($elm$virtual_dom$VirtualDom$style, k, v);
					},
					data.fQ));
		}
	}();
	var prependListeners = function () {
		var _v6 = data.o;
		if (!_v6.b) {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$append(
				A2(
					$elm$core$List$map,
					function (_v7) {
						var k = _v7.a;
						var v = _v7.b;
						return A2($elm$virtual_dom$VirtualDom$on, k, v);
					},
					data.o));
		}
	}();
	var consTextKeyed = function () {
		var _v5 = data.b;
		if (_v5 === '') {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$cons(
				A2(
					$elm$core$Tuple$pair,
					'rendered-internal-text',
					$elm$virtual_dom$VirtualDom$text(data.b)));
		}
	}();
	var consText = function () {
		var _v4 = data.b;
		if (_v4 === '') {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$cons(
				$elm$virtual_dom$VirtualDom$text(data.b));
		}
	}();
	var consId = function () {
		var _v3 = data.V;
		if (_v3 === '') {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$cons(
				A2(
					$elm$virtual_dom$VirtualDom$property,
					'id',
					$elm$json$Json$Encode$string(data.V)));
		}
	}();
	var consClassName = function () {
		var _v2 = data.aJ;
		if (!_v2.b) {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$cons(
				A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(
						A2($elm$core$String$join, ' ', data.aJ))));
		}
	}();
	var allAttributes = consId(
		consClassName(
			prependStyles(
				prependListeners(data.be))));
	var _v1 = _Utils_Tuple2(data.ib, data.hS);
	if (_v1.a === '') {
		if (!_v1.b.b) {
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				data.di,
				allAttributes,
				consText(data.gO));
		} else {
			return A3(
				$elm$virtual_dom$VirtualDom$keyedNode,
				data.di,
				allAttributes,
				consTextKeyed(
					A3($elm$core$List$map2, $elm$core$Tuple$pair, data.hS, data.gO)));
		}
	} else {
		if (!_v1.b.b) {
			return A4(
				$elm$virtual_dom$VirtualDom$nodeNS,
				data.ib,
				data.di,
				allAttributes,
				consText(data.gO));
		} else {
			return A4(
				$elm$virtual_dom$VirtualDom$keyedNodeNS,
				data.ib,
				data.di,
				allAttributes,
				consTextKeyed(
					A3($elm$core$List$map2, $elm$core$Tuple$pair, data.hS, data.gO)));
		}
	}
};
var $visotype$elm_dom$Dom$appendChild = function (e) {
	var r = $visotype$elm_dom$Dom$Internal$render(e);
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					gO: A2(
						$elm$core$List$append,
						n.gO,
						_List_fromArray(
							[r]))
				});
		});
};
var $visotype$elm_dom$Dom$element = function (tag) {
	return {be: _List_Nil, gO: _List_Nil, aJ: _List_Nil, V: '', hS: _List_Nil, o: _List_Nil, ib: '', fQ: _List_Nil, di: tag, b: ''};
};
var $author$project$Views$Pipeline$addTalentButton = F3(
	function (nameOfColumn, projectPublished, projectId) {
		return ((nameOfColumn === 'Matching Candidates') && projectPublished) ? A2(
			$visotype$elm_dom$Dom$appendChild,
			A2(
				$visotype$elm_dom$Dom$addClass,
				'fas fa-plus',
				$visotype$elm_dom$Dom$element('span')),
			A2(
				$visotype$elm_dom$Dom$addAction,
				_Utils_Tuple2(
					'click',
					A3($author$project$MainMsg$GoToTalentSearch, projectId, '', '')),
				A2(
					$visotype$elm_dom$Dom$addClass,
					'add-talent-button',
					$visotype$elm_dom$Dom$element('div')))) : $visotype$elm_dom$Dom$element('span');
	});
var $visotype$elm_dom$Dom$appendChildList = function (le) {
	var lr = A2($elm$core$List$map, $visotype$elm_dom$Dom$Internal$render, le);
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					gO: A2($elm$core$List$append, n.gO, lr)
				});
		});
};
var $author$project$Pipeline$ColumnName = function (a) {
	return {$: 0, a: a};
};
var $author$project$MainMsg$SubmitUpdatedColumnName = {$: 170};
var $author$project$MainMsg$ToggleEditingColumn = function (a) {
	return {$: 168, a: a};
};
var $author$project$MainMsg$UpdateColumn = function (a) {
	return {$: 169, a: a};
};
var $visotype$elm_dom$Dom$Internal$captureStopPropagation = F2(
	function (_v0, token) {
		var field = _v0.a;
		var decoder = _v0.b;
		return $elm$virtual_dom$VirtualDom$MayStopPropagation(
			A2(
				$elm$json$Json$Decode$map,
				function (x) {
					return _Utils_Tuple2(x, true);
				},
				A2(
					$elm$json$Json$Decode$map,
					token,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['target', field]),
						decoder))));
	});
var $visotype$elm_dom$Dom$addInputHandler = function (token) {
	var handler = $visotype$elm_dom$Dom$Internal$captureStopPropagation(
		_Utils_Tuple2('value', $elm$json$Json$Decode$string));
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					o: A2(
						$elm$core$List$append,
						n.o,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'input',
								handler(token))
							]))
				});
		});
};
var $elm$core$String$append = _String_append;
var $visotype$elm_dom$Dom$appendText = function (s) {
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					b: A2($elm$core$String$append, n.b, s)
				});
		});
};
var $author$project$Views$Pipeline$columnName = function (item) {
	return (item.g6 !== '') ? item.g6 : item.bH;
};
var $author$project$Views$Pipeline$columnEditingView = F2(
	function (editing, item) {
		return A2(
			$visotype$elm_dom$Dom$appendChild,
			A2(
				$visotype$elm_dom$Dom$appendText,
				$author$project$Views$Pipeline$columnName(item),
				A2(
					$visotype$elm_dom$Dom$addInputHandler,
					A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateColumn, $author$project$Pipeline$ColumnName),
					$visotype$elm_dom$Dom$element('input'))),
			A2(
				$visotype$elm_dom$Dom$appendChild,
				A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$addAction,
							_Utils_Tuple2('click', $author$project$MainMsg$SubmitUpdatedColumnName),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'fas fa-check',
								$visotype$elm_dom$Dom$element('span'))),
							A2(
							$visotype$elm_dom$Dom$addAction,
							_Utils_Tuple2(
								'click',
								$author$project$MainMsg$ToggleEditingColumn($author$project$Pipeline$emptyColumn)),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'fas fa-times',
								$visotype$elm_dom$Dom$element('span')))
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'update-icons',
						$visotype$elm_dom$Dom$element('div'))),
				A3(
					$visotype$elm_dom$Dom$addClassConditional,
					'editing-mode',
					_Utils_eq(
						editing,
						$author$project$Project$Edit(item.V)),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'column-edit-box',
						$visotype$elm_dom$Dom$element('div')))));
	});
var $author$project$Pipeline$CondensedFullPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$FilterCandidates = F2(
	function (a, b) {
		return {$: 180, a: a, b: b};
	});
var $author$project$MainMsg$SelectAllCandidates = function (a) {
	return {$: 177, a: a};
};
var $author$project$MainMsg$SortCandidates = F2(
	function (a, b) {
		return {$: 179, a: a, b: b};
	});
var $author$project$MainMsg$TogglePageView = function (a) {
	return {$: 189, a: a};
};
var $author$project$MainMsg$UpdateUserView = function (a) {
	return {$: 188, a: a};
};
var $author$project$Views$Pipeline$menuItem = F3(
	function (title, amsg, active) {
		return A2(
			$visotype$elm_dom$Dom$appendText,
			title,
			A2(
				$visotype$elm_dom$Dom$addAction,
				_Utils_Tuple2('click', amsg),
				A3(
					$visotype$elm_dom$Dom$addClassConditional,
					'active-section',
					active,
					$visotype$elm_dom$Dom$element('li'))));
	});
var $author$project$Views$Pipeline$menuOpen = F2(
	function (id, multiModalStatus) {
		if (!multiModalStatus.$) {
			var str = multiModalStatus.a;
			return _Utils_eq(str, id);
		} else {
			return false;
		}
	});
var $author$project$Views$Pipeline$columnMenu = F3(
	function (multiModalStatus, item, userView) {
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			_List_fromArray(
				[
					A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$appendText,
							'Sort By:',
							$visotype$elm_dom$Dom$element('h6')),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Date Created (Newest - Oldest)',
							A2($author$project$MainMsg$SortCandidates, 0, item.V),
							!item.ji),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Date Created (Oldest - Newest)',
							A2($author$project$MainMsg$SortCandidates, 1, item.V),
							item.ji === 1),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Role',
							A2($author$project$MainMsg$SortCandidates, 2, item.V),
							item.ji === 2),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Status',
							A2($author$project$MainMsg$SortCandidates, 3, item.V),
							item.ji === 3)
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'column-menu-section',
						$visotype$elm_dom$Dom$element('ul'))),
					A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$appendText,
							'Filter By:',
							$visotype$elm_dom$Dom$element('h6')),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Clear Filter',
							A2($author$project$MainMsg$FilterCandidates, 3, item.V),
							item.hs === 3),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Applied',
							A2($author$project$MainMsg$FilterCandidates, 0, item.V),
							!item.hs),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Invited To Apply',
							A2($author$project$MainMsg$FilterCandidates, 1, item.V),
							item.hs === 1),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Accepted Application Invitation',
							A2($author$project$MainMsg$FilterCandidates, 2, item.V),
							item.hs === 2)
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'column-menu-section',
						$visotype$elm_dom$Dom$element('ul'))),
					A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$appendText,
							'View:',
							$visotype$elm_dom$Dom$element('h6')),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Standard List',
							$author$project$MainMsg$UpdateUserView(0),
							!userView),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Condensed List',
							$author$project$MainMsg$UpdateUserView(1),
							userView === 1),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Full Page View',
							$author$project$MainMsg$TogglePageView(
								$author$project$Pipeline$CondensedFullPage(item.V)),
							false)
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'column-menu-section',
						$visotype$elm_dom$Dom$element('ul'))),
					A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$appendText,
							'Edit:',
							$visotype$elm_dom$Dom$element('h6')),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Select All Candidates',
							$author$project$MainMsg$SelectAllCandidates(
								A2(
									$elm$core$List$map,
									function (user) {
										return $author$project$Utils$transformToSearchResultTalentProfile(user);
									},
									item.jR)),
							false),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Rename List',
							$author$project$MainMsg$ToggleEditingColumn(item),
							false)
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'column-menu-section',
						$visotype$elm_dom$Dom$element('ul')))
				]),
			A3(
				$visotype$elm_dom$Dom$addClassConditional,
				'menu-open',
				A2($author$project$Views$Pipeline$menuOpen, item.V, multiModalStatus),
				A2(
					$visotype$elm_dom$Dom$addClass,
					'column-menu',
					$visotype$elm_dom$Dom$element('ul'))));
	});
var $author$project$Views$Pipeline$columnTitle = F3(
	function (item, editing, multiModalStatus) {
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			_List_fromArray(
				[
					A2(
					$visotype$elm_dom$Dom$appendText,
					$author$project$Views$Pipeline$columnName(item) + (' (' + ($elm$core$String$fromInt(
						$elm$core$List$length(item.jR)) + ')')),
					A2(
						$visotype$elm_dom$Dom$addAction,
						_Utils_Tuple2(
							'click',
							$author$project$MainMsg$ToggleEditingColumn(item)),
						A3(
							$visotype$elm_dom$Dom$addClassConditional,
							'title-hidden',
							_Utils_eq(
								editing,
								$author$project$Project$Edit(item.V)),
							$visotype$elm_dom$Dom$element('h4')))),
					A3(
					$visotype$elm_dom$Dom$addClassConditional,
					'menu-icon-open',
					A2($author$project$Views$Pipeline$menuOpen, item.V, multiModalStatus),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'menu-icon',
						A2(
							$visotype$elm_dom$Dom$addAction,
							_Utils_Tuple2(
								'click',
								$author$project$MainMsg$ToggleColumnMenu(item.V)),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'fas fa-ellipsis-h',
								$visotype$elm_dom$Dom$element('i')))))
				]),
			A2(
				$visotype$elm_dom$Dom$addClass,
				'column-title',
				$visotype$elm_dom$Dom$element('div')));
	});
var $author$project$MainMsg$MoveCanceled = {$: 186};
var $author$project$MainMsg$MoveCompleted = F2(
	function (a, b) {
		return {$: 187, a: a, b: b};
	});
var $author$project$MainMsg$MoveStarted = function (a) {
	return {$: 184, a: a};
};
var $author$project$MainMsg$MoveTargetChanged = function (a) {
	return {$: 185, a: a};
};
var $author$project$MainMsg$dragDropMessages = {d3: $author$project$MainMsg$MoveCanceled, d4: $author$project$MainMsg$MoveStarted, d5: $author$project$MainMsg$MoveTargetChanged, d6: $author$project$MainMsg$MoveCompleted};
var $author$project$Views$ModalOverlay$invisibleModalDom = F2(
	function (toggleMsg, open) {
		return A2(
			$visotype$elm_dom$Dom$addAction,
			_Utils_Tuple2('click', toggleMsg),
			A3(
				$visotype$elm_dom$Dom$addClassConditional,
				'invisible-modal-open',
				open,
				A2(
					$visotype$elm_dom$Dom$addClass,
					'invisible-modal',
					$visotype$elm_dom$Dom$element('div'))));
	});
var $visotype$elm_dom$Dom$addAttribute = function (a) {
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					be: A2(
						$elm$core$List$append,
						n.be,
						_List_fromArray(
							[a]))
				});
		});
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$isCurrentDropTarget = F2(
	function (_v0, id) {
		var state = _v0;
		var _v1 = _Utils_Tuple2(
			state.bi,
			_Utils_eq(
				state.bi,
				$arsduo$elm_dom_drag_drop$Dom$DragDrop$State$SpecificDropTarget(id)));
		if ((_v1.a.$ === 1) && _v1.b) {
			return true;
		} else {
			return false;
		}
	});
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragHelper = F2(
	function (eventName, message) {
		return A2(
			$elm$html$Html$Events$on,
			eventName,
			$elm$json$Json$Decode$succeed(message));
	});
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragEnter = function (message) {
	return A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragHelper, 'dragenter', message);
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDroppable = F4(
	function (state, dropTargetId, messages, element) {
		var droppableElement = A2(
			$visotype$elm_dom$Dom$addAttribute,
			$arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragEnter(
				messages.d5(dropTargetId)),
			element);
		var _v0 = A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$isCurrentDropTarget, state, dropTargetId);
		if (_v0) {
			return A2($visotype$elm_dom$Dom$addClass, 'drop-target', droppableElement);
		} else {
			return droppableElement;
		}
	});
var $visotype$elm_dom$Dom$prependChildList = function (le) {
	var lr = A2($elm$core$List$map, $visotype$elm_dom$Dom$Internal$render, le);
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					gO: A2($elm$core$List$append, lr, n.gO)
				});
		});
};
var $visotype$elm_dom$Dom$render = $visotype$elm_dom$Dom$Internal$render;
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$currentlyDraggedObject = function (_v0) {
	var stateData = _v0;
	return stateData.b7;
};
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$MainMsg$OpenMessageScreen = function (a) {
	return {$: 175, a: a};
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragEnd = function (message) {
	return A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragHelper, 'dragend', message);
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragStart = function (message) {
	return A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragHelper, 'dragstart', message);
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDraggable = F4(
	function (state, draggedElementId, messages, element) {
		var _v0 = $arsduo$elm_dom_drag_drop$Dom$DragDrop$currentlyDraggedObject(state);
		if (_v0.$ === 1) {
			return A2(
				$visotype$elm_dom$Dom$addAttribute,
				$arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragStart(
					messages.d4(draggedElementId)),
				A2(
					$visotype$elm_dom$Dom$addAttribute,
					A2(
						$elm$virtual_dom$VirtualDom$property,
						'draggable',
						$elm$json$Json$Encode$bool(true)),
					element));
		} else {
			var anObject = _v0.a;
			var _v1 = state;
			var stateData = _v1;
			var draggedElement = A3(
				$visotype$elm_dom$Dom$addClassConditional,
				'being-dragged',
				_Utils_eq(
					stateData.b7,
					$elm$core$Maybe$Just(draggedElementId)),
				element);
			var _v2 = stateData.bi;
			if (_v2.$ === 1) {
				var dropTargetId = _v2.a;
				return A2(
					$visotype$elm_dom$Dom$addAttribute,
					$arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragEnd(
						A2(messages.d6, draggedElementId, dropTargetId)),
					draggedElement);
			} else {
				return A2(
					$visotype$elm_dom$Dom$addAttribute,
					$arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragEnd(messages.d3),
					draggedElement);
			}
		}
	});
var $author$project$Utils$selectedUser = F2(
	function (userId, selectedTalentIds) {
		return A2($elm$core$List$member, userId, selectedTalentIds);
	});
var $author$project$Utils$stageText = function (stage) {
	switch (stage) {
		case 0:
			return 'Talent applied';
		case 1:
			return 'Agent added';
		case 2:
			return 'Invited to apply';
		case 3:
			return 'Accepted application request';
		case 4:
			return 'Rejected application Request';
		case 5:
			return 'Audition is scheduled';
		case 6:
			return 'Audition schedule accepted';
		case 7:
			return 'Audition schedule rejected';
		case 8:
			return 'Audition schedule needs to be rescheduled';
		case 9:
			return 'Audition schedule was rescheduled';
		case 10:
			return 'Audition was canceled';
		case 11:
			return 'Callback schedule requested';
		case 12:
			return 'Callback schedule accepted';
		case 13:
			return 'Callback schedule rejected';
		case 14:
			return 'Callback schedule needs to be rescheduled';
		case 15:
			return 'Callback schedule was rescheduled';
		case 16:
			return 'Callback schedule cancelled';
		case 17:
			return 'Booking request pending';
		case 18:
			return 'Accepted Booking Request';
		case 19:
			return 'Rejected Booking Request';
		case 21:
			return 'Role was cancelled';
		case 22:
			return 'Role was changed';
		case 26:
			return 'Scheduled';
		case 25:
			return 'Removed by agent';
		case 24:
			return 'Removed by Director';
		case 23:
			return 'Removed by Talent';
		default:
			return '';
	}
};
var $author$project$Utils$userInRoleDom = F2(
	function (user, menuToggle) {
		return user.ev ? A2(
			$visotype$elm_dom$Dom$appendChildList,
			_List_fromArray(
				[
					A2(
					$visotype$elm_dom$Dom$appendText,
					$author$project$Utils$stageText(user.jj),
					$visotype$elm_dom$Dom$element('span')),
					A2(
					$visotype$elm_dom$Dom$addAction,
					_Utils_Tuple2('click', menuToggle),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'manage-talent-button fas fa-user-cog',
						$visotype$elm_dom$Dom$element('span')))
				]),
			A2(
				$visotype$elm_dom$Dom$addClass,
				'user-status-section',
				$visotype$elm_dom$Dom$element('div'))) : $visotype$elm_dom$Dom$element('span');
	});
var $author$project$Utils$talentDomCardV2 = function (user) {
	return function (dragDropState) {
		return function (matchingUser) {
			return function (showingUser) {
				return function (columnId) {
					return function (toggleTalentResultModal) {
						return function (toggleSelectedTalent) {
							return function (openMessageScreen) {
								return function (dragMessages) {
									return function (dragDropInfo) {
										return function (selectedTalent) {
											return function (menuToggle) {
												return A2(
													$visotype$elm_dom$Dom$appendChild,
													A2($author$project$Utils$userInRoleDom, user, menuToggle),
													A2(
														$visotype$elm_dom$Dom$appendChild,
														A2(
															$visotype$elm_dom$Dom$appendChildList,
															_List_fromArray(
																[
																	A2(
																	$visotype$elm_dom$Dom$appendText,
																	user.bm + (' ' + user.bE),
																	$visotype$elm_dom$Dom$element('span')),
																	A2(
																	$visotype$elm_dom$Dom$addAction,
																	_Utils_Tuple2('click', toggleTalentResultModal),
																	A2(
																		$visotype$elm_dom$Dom$addClass,
																		'fas fa-info-circle',
																		$visotype$elm_dom$Dom$element('span')))
																]),
															$visotype$elm_dom$Dom$element('p')),
														A2(
															$visotype$elm_dom$Dom$appendChildList,
															_List_fromArray(
																[
																	A2(
																	$visotype$elm_dom$Dom$appendChild,
																	A2(
																		$visotype$elm_dom$Dom$addAction,
																		_Utils_Tuple2('click', toggleSelectedTalent),
																		A2(
																			$visotype$elm_dom$Dom$addAttribute,
																			$elm$html$Html$Attributes$src(
																				A2(
																					$elm$core$Maybe$withDefault,
																					$author$project$Data$Image$emptyImage,
																					$elm$core$List$head(user.hE)).jM),
																			$visotype$elm_dom$Dom$element('img'))),
																	A2(
																		$visotype$elm_dom$Dom$addClass,
																		'talent-card-image-container',
																		$visotype$elm_dom$Dom$element('div')))
																]),
															A3(
																$visotype$elm_dom$Dom$addClassConditional,
																'selected-talent',
																A2(
																	$author$project$Utils$selectedUser,
																	user.cU,
																	A2(
																		$elm$core$List$map,
																		function ($) {
																			return $.cU;
																		},
																		selectedTalent)),
																A2(
																	$visotype$elm_dom$Dom$addClass,
																	'talent-dom-card-v2',
																	A3(
																		$visotype$elm_dom$Dom$addClassConditional,
																		'showing-user',
																		showingUser,
																		A3(
																			$visotype$elm_dom$Dom$addClassConditional,
																			'matching-user',
																			matchingUser,
																			A4(
																				$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDraggable,
																				dragDropState,
																				dragDropInfo,
																				dragMessages,
																				$visotype$elm_dom$Dom$element('div')))))))));
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$Pipeline$userDisplay = F6(
	function (user, dragDropState, columnId, userView, searchQuery, selectedTalent) {
		var showingUser = $elm$core$String$length(searchQuery) <= 0;
		var matchingUser = ($elm$core$String$length(searchQuery) > 1) && (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bm)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bE)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.P.bH)) || A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bm + (' ' + user.bE))))));
		if (!userView) {
			return $author$project$Utils$talentDomCardV2(
				$author$project$Utils$transformToSearchResultTalentProfile(user))(dragDropState)(matchingUser)(showingUser)(columnId)(
				A3(
					$author$project$MainMsg$ToggleTalentResultModal,
					$author$project$Utils$transformToSearchResultTalentProfile(user),
					$author$project$Job$emptyApplicant,
					columnId))(
				A2(
					$author$project$MainMsg$ToggleSelectedTalent,
					user.cU,
					$author$project$Utils$transformToSearchResultTalentProfile(user)))(
				$author$project$MainMsg$OpenMessageScreen(
					$author$project$Utils$transformToSearchResultTalentProfile(user)))($author$project$MainMsg$dragDropMessages)(
				A2($author$project$Project$User, user.aQ, user.g0))(selectedTalent)(
				$author$project$MainMsg$UpdateTalentMenuOptions(
					$author$project$User$ToggleMenuModal(
						$author$project$Utils$transformToSearchResultTalentProfile(user))));
		} else {
			return A2(
				$visotype$elm_dom$Dom$appendChild,
				A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$addAttribute,
							$elm$html$Html$Attributes$src(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Data$Image$emptyImage,
									$elm$core$List$head(user.hE)).jM),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'square-avatar',
								$visotype$elm_dom$Dom$element('img'))),
							A2(
							$visotype$elm_dom$Dom$appendChildList,
							_List_fromArray(
								[
									A2(
									$visotype$elm_dom$Dom$appendText,
									user.bm + (' ' + user.bE),
									$visotype$elm_dom$Dom$element('h3')),
									A2(
									$visotype$elm_dom$Dom$addClass,
									'pipeline-role-name',
									A2(
										$visotype$elm_dom$Dom$appendText,
										user.P.bH,
										$visotype$elm_dom$Dom$element('span')))
								]),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'user-name-info-container',
								$visotype$elm_dom$Dom$element('div')))
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'condensed-user-info-container',
						$visotype$elm_dom$Dom$element('div'))),
				A3(
					$visotype$elm_dom$Dom$addClassConditional,
					'showing-user',
					showingUser,
					A3(
						$visotype$elm_dom$Dom$addClassConditional,
						'matching-user',
						matchingUser,
						A2(
							$visotype$elm_dom$Dom$addClass,
							'talent-card condensed',
							A2(
								$visotype$elm_dom$Dom$addAction,
								_Utils_Tuple2(
									'click',
									A3(
										$author$project$MainMsg$ToggleTalentResultModal,
										$author$project$Utils$transformToSearchResultTalentProfile(user),
										$author$project$Job$emptyApplicant,
										columnId)),
								A4(
									$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDraggable,
									dragDropState,
									A2($author$project$Project$User, user.aQ, user.g0),
									$author$project$MainMsg$dragDropMessages,
									$visotype$elm_dom$Dom$element('div')))))));
		}
	});
var $author$project$Views$Pipeline$userIndex = F2(
	function (user, users) {
		return A2(
			$elm$core$Maybe$withDefault,
			100,
			A2(
				$elm_community$list_extra$List$Extra$elemIndex,
				user.cU,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.cU;
					},
					users)));
	});
var $author$project$Views$Pipeline$talentContents = F5(
	function (users, dragDropState, columnId, userView, searchQuery) {
		return A2(
			$elm$core$List$map,
			function (user) {
				return A6(
					$author$project$Views$Pipeline$userDisplay,
					user,
					dragDropState,
					columnId,
					userView,
					searchQuery,
					A2(
						$elm$core$List$map,
						function (u) {
							return $author$project$Utils$transformToSearchResultTalentProfile(u);
						},
						users));
			},
			A2(
				$elm$core$List$sortWith,
				F2(
					function (id1, id2) {
						return A2(
							$elm$core$Basics$compare,
							A2($author$project$Views$Pipeline$userIndex, id1, users),
							A2($author$project$Views$Pipeline$userIndex, id2, users));
					}),
				users));
	});
var $author$project$Views$Pipeline$talentList = F6(
	function (dragDropState, users, columnId, userView, searchQuery, className) {
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			function () {
				var _v0 = $arsduo$elm_dom_drag_drop$Dom$DragDrop$currentlyDraggedObject(dragDropState);
				if (_v0.$ === 1) {
					return A5($author$project$Views$Pipeline$talentContents, users, dragDropState, columnId, userView, searchQuery);
				} else {
					return A5($author$project$Views$Pipeline$talentContents, users, dragDropState, columnId, userView, searchQuery);
				}
			}(),
			A2(
				$visotype$elm_dom$Dom$addClass,
				className,
				$visotype$elm_dom$Dom$element('ul')));
	});
var $author$project$Views$Pipeline$column = function (dragDropState) {
	return function (item) {
		return function (multiModalStatus) {
			return function (editing) {
				return function (projectId) {
					return function (selectedTalent) {
						return function (sort) {
							return function (pageView) {
								return function (searchQuery) {
									return function (userView) {
										return function (deadlines) {
											return function (projectPublished) {
												if (!pageView.$) {
													return $visotype$elm_dom$Dom$render(
														A2(
															$visotype$elm_dom$Dom$appendChildList,
															_List_fromArray(
																[
																	A2(
																	$visotype$elm_dom$Dom$appendChildList,
																	A2(
																		$elm$core$List$map,
																		function (user) {
																			return A6($author$project$Views$Pipeline$userDisplay, user, dragDropState, item.V, userView, searchQuery, selectedTalent);
																		},
																		item.jR),
																	A2(
																		$visotype$elm_dom$Dom$addClass,
																		'user-container',
																		$visotype$elm_dom$Dom$element('div')))
																]),
															A2(
																$visotype$elm_dom$Dom$prependChildList,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Views$ModalOverlay$invisibleModalDom,
																		$author$project$MainMsg$ToggleColumnMenu(''),
																		A2($author$project$Views$Pipeline$menuOpen, item.V, multiModalStatus)),
																		A2(
																		$visotype$elm_dom$Dom$appendChildList,
																		_List_fromArray(
																			[
																				A2($author$project$Views$Pipeline$columnEditingView, editing, item),
																				A3($author$project$Views$Pipeline$columnTitle, item, editing, multiModalStatus),
																				A3($author$project$Views$Pipeline$columnMenu, multiModalStatus, item, userView),
																				A3($author$project$Views$Pipeline$addTalentButton, item.bH, projectPublished, projectId)
																			]),
																		A2(
																			$visotype$elm_dom$Dom$addClass,
																			'column-info',
																			$visotype$elm_dom$Dom$element('div')))
																	]),
																A4(
																	$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDroppable,
																	dragDropState,
																	$author$project$Project$OntoElement(item.V),
																	$author$project$MainMsg$dragDropMessages,
																	A3(
																		$visotype$elm_dom$Dom$addClassConditional,
																		'visible-column',
																		!item.hL,
																		A2(
																			$visotype$elm_dom$Dom$addClass,
																			'column-container',
																			$visotype$elm_dom$Dom$element('li')))))));
												} else {
													return $visotype$elm_dom$Dom$render(
														A2(
															$visotype$elm_dom$Dom$prependChildList,
															_List_fromArray(
																[
																	A6($author$project$Views$Pipeline$talentList, dragDropState, item.jR, item.V, 1, searchQuery, 'full-page-users')
																]),
															A2(
																$visotype$elm_dom$Dom$addClass,
																'full-page-column-container',
																$visotype$elm_dom$Dom$element('li'))));
												}
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$Pipeline$defaultImage = function (user) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Data$Image$emptyImage,
		$elm$core$List$head(user.hE)).jM;
};
var $author$project$Views$Pipeline$condensedUser = F3(
	function (user, searchQuery, columnId) {
		var showingUser = $elm$core$String$length(searchQuery) <= 1;
		var matchingParameters = A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bm)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bE)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.P.bH)) || A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bm + (' ' + user.bE)))));
		var matchingUser = ($elm$core$String$length(searchQuery) > 1) && matchingParameters;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('talent-card condensed', true),
							_Utils_Tuple2('matching-user', matchingUser),
							_Utils_Tuple2('showing-user', showingUser)
						])),
					$elm$html$Html$Events$onClick(
					A3(
						$author$project$MainMsg$ToggleTalentResultModal,
						$author$project$Utils$transformToSearchResultTalentProfile(user),
						$author$project$Job$emptyApplicant,
						columnId))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('condensed-info-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									$author$project$Views$Pipeline$defaultImage(user))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('user-name-info-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(user.bm + (' ' + user.bE))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pipeline-role-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(user.P.bH)
								]))
						]))
				]));
	});
var $author$project$MainMsg$SearchFullPageUsers = function (a) {
	return {$: 190, a: a};
};
var $author$project$Views$Pipeline$searchBar = function (searchQuery) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('full-page-search-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$placeholder('Search Role, or Name'),
						$elm$html$Html$Attributes$value(searchQuery),
						$elm$html$Html$Events$onInput($author$project$MainMsg$SearchFullPageUsers)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-search')
					]),
				_List_Nil)
			]));
};
var $author$project$Views$Pipeline$fullPageHeader = F4(
	function (name, userCount, columnId, searchQuery) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('full-page-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							name + (' (' + ($elm$core$String$fromInt(userCount) + ')')))
						])),
					$author$project$Views$Pipeline$searchBar(searchQuery),
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('exit-full-page-container'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$TogglePageView($author$project$Pipeline$StandardPipeline))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Exit Full Page View'),
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-times')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Views$Pipeline$pipeline = function (dragDropState) {
	return function (columns) {
		return function (multiModalStatus) {
			return function (editing) {
				return function (projectId) {
					return function (selectedTalent) {
						return function (sort) {
							return function (pageView) {
								return function (searchQuery) {
									return function (userView) {
										return function (deadlines) {
											return function (projectPublished) {
												if (!pageView.$) {
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pipeline-container')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$ul,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('pipeline')
																	]),
																A2(
																	$elm$core$List$map,
																	function (pipe) {
																		return $author$project$Views$Pipeline$column(dragDropState)(pipe)(multiModalStatus)(editing)(projectId)(selectedTalent)(sort)(pageView)(searchQuery)(userView)(deadlines)(projectPublished);
																	},
																	columns))
															]));
												} else {
													var columnId = pageView.a;
													var matchingColumn = A2(
														$elm$core$Maybe$withDefault,
														$author$project$Pipeline$emptyColumn,
														$elm$core$List$head(
															A2(
																$elm$core$List$filter,
																function (pipe) {
																	return _Utils_eq(columnId, pipe.V);
																},
																columns)));
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pipeline-container-full-page')
															]),
														_List_fromArray(
															[
																A4(
																$author$project$Views$Pipeline$fullPageHeader,
																matchingColumn.bH,
																$elm$core$List$length(matchingColumn.jR),
																columnId,
																searchQuery),
																A2(
																$elm$html$Html$ul,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('full-page-user-list')
																	]),
																A2(
																	$elm$core$List$map,
																	function (user) {
																		return A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Pipeline$condensedUser, user, searchQuery, columnId);
																	},
																	matchingColumn.jR))
															]));
												}
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$MainMsg$DeleteProject = function (a) {
	return {$: 51, a: a};
};
var $author$project$MainMsg$DeleteRole = function (a) {
	return {$: 64, a: a};
};
var $author$project$MainMsg$UpdateProjectStatus = {$: 96};
var $author$project$MainMsg$UpdateRoleStatus = {$: 244};
var $author$project$Views$Project$destructiveActions = function (active) {
	return active ? _List_fromArray(
		['Talent will be notified by email of the project cancelation', 'Schedules will be removed.', 'Talent will no longer be able to view or apply to roles.']) : _List_fromArray(
		['Talent will be matched to current roles.', 'Talent will be notified by email of the matching role.', 'Talent will be able to view and apply to roles.']);
};
var $author$project$Views$Project$parseScheduleType = function (scheduleType) {
	return (scheduleType === 'Callbacks') ? 'Callback' : scheduleType;
};
var $author$project$Views$Project$publishWarning = F2(
	function (active, warningType) {
		return active ? ('Once you unpublish this ' + (warningType + ', the following actions will take place:')) : ('Once you publish this ' + (warningType + ', the following actions will take place:'));
	});
var $author$project$Views$Project$projectConfirmations = F2(
	function (model, proj) {
		if (model.aF || model.Z) {
			var _v0 = model.al;
			switch (_v0.$) {
				case 1:
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.aF,
						$author$project$MainMsg$UpdateProjectStatus,
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						A2($author$project$Views$Project$publishWarning, proj.hK, 'project'),
						$author$project$Views$Project$destructiveActions(proj.hK));
				case 2:
					var roleData = _v0.a;
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.aF,
						$author$project$MainMsg$UpdateRoleStatus,
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						A2($author$project$Views$Project$publishWarning, roleData.gg, 'role'),
						$author$project$Views$Project$destructiveActions(roleData.gg));
				case 0:
					return $elm$html$Html$text('');
				case 4:
					var roleData = _v0.a;
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.aF,
						$author$project$MainMsg$DeleteRole(roleData.cU),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Are you sure you want to delete ' + (roleData.bH + ' role?'),
						_List_Nil);
				case 3:
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.Z,
						$author$project$MainMsg$DeleteProject(proj.cU),
						A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
						'Are you sure you want to delete the ' + (model.d1 + ' project?'),
						_List_Nil);
				case 6:
					var scheduleType = _v0.a;
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.aF,
						$author$project$MainMsg$View(
							A2(
								$author$project$Route$SchedulePage,
								proj.cU,
								$author$project$Views$Project$parseScheduleType(scheduleType))),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Oops! That user has not been scheduled yet. Would you like to schedule this candidate?',
						_List_Nil);
				case 7:
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.aF,
						A4($author$project$MainMsg$UpdateUsersRoleStage, model.bI, model.bI.aQ, model.bI.hT, model.bI.cu),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Would you like to book this candidate?',
						_List_Nil);
				default:
					return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$MainMsg$ToggleEditOptions = {$: 95};
var $author$project$MainMsg$ToggleProjectInfoContainer = {$: 94};
var $author$project$Utils$UpdateProject = {$: 1};
var $author$project$Utils$dateTextNoTitle = F2(
	function (startDate, endDate) {
		return (($elm$core$String$length(startDate) > 0) && ($elm$core$String$length(endDate) > 0)) ? ($author$project$Utils$formatDate(startDate) + (' - ' + $author$project$Utils$formatDate(endDate))) : 'N/A';
	});
var $author$project$Views$ModalOverlay$invisibleModal = F2(
	function (toggleMsg, open) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('invisible-modal', true),
							_Utils_Tuple2('invisible-modal-open', open)
						])),
					$elm$html$Html$Events$onClick(toggleMsg)
				]),
			_List_Nil);
	});
var $frandibar$elm_font_awesome_5$FontAwesome$plusCircle = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('plus-circle');
var $author$project$Views$Pipeline$projectSearchBar = function (searchQuery) {
	return $visotype$elm_dom$Dom$render(
		A2(
			$visotype$elm_dom$Dom$appendChildList,
			_List_fromArray(
				[
					A2(
					$visotype$elm_dom$Dom$addInputHandler,
					$author$project$MainMsg$SearchFullPageUsers,
					A2(
						$visotype$elm_dom$Dom$addAttribute,
						$elm$html$Html$Attributes$value(searchQuery),
						A2(
							$visotype$elm_dom$Dom$addAttribute,
							$elm$html$Html$Attributes$placeholder('Search Role, or Name'),
							$visotype$elm_dom$Dom$element('input')))),
					A2(
					$visotype$elm_dom$Dom$addClass,
					'fas fa-search',
					$visotype$elm_dom$Dom$element('i'))
				]),
			A2(
				$visotype$elm_dom$Dom$addClass,
				'full-page-search-container',
				$visotype$elm_dom$Dom$element('li'))));
};
var $author$project$Views$Project$publishText = function (isActive) {
	return isActive ? 'Unpublish' : 'Publish';
};
var $author$project$Views$Project$publishedBadge = function (isActive) {
	return isActive ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('published-badge')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('LIVE')
			])) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('draft-badge')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('DRAFT')
			]));
};
var $author$project$MainMsg$FindRole = function (a) {
	return {$: 54, a: a};
};
var $author$project$Views$Project$roleList = F2(
	function (roles, project) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, role) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-preview')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h5,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'role-preview-name-' + $elm$core$String$fromInt(index),
												true),
												_Utils_Tuple2('role-preview-name', true)
											])),
										$elm$html$Html$Events$onClick(
										$author$project$MainMsg$FindRole(role.cU))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(role.bH)
									]))
							]));
				}),
			A2(
				$elm$core$List$filter,
				function (role) {
					return _Utils_eq(role.iH, project.cU);
				},
				roles));
	});
var $author$project$MainMsg$ToggleCandidateScreen = function (a) {
	return {$: 150, a: a};
};
var $author$project$Views$TalentSearch$selectedUsersButton = F5(
	function (selectedTalent, userProfile, talent, searchingProject, searchingRole) {
		if (selectedTalent > 0) {
			var _v0 = userProfile.P;
			switch (_v0) {
				case 3:
					return ((searchingProject !== '') && (searchingRole !== '')) ? A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$MoveNewCandidate, talent, ''))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Submit ' + ($elm$core$String$fromInt(selectedTalent) + ' To Role'))
							])) : $elm$html$Html$text('');
				case 4:
					return ((searchingProject !== '') && (searchingRole !== '')) ? A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$MoveNewCandidate, talent, ''))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Submit ' + ($elm$core$String$fromInt(selectedTalent) + ' To Role'))
							])) : $elm$html$Html$text('');
				case 1:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleCandidateScreen(2))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedTalent) + ' selected users')
							]));
				default:
					return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$Project$unionText = function (union) {
	return union ? 'Union' : 'Non-Union';
};
var $author$project$Views$Project$projectHeader = F3(
	function (model, project, pageView) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('project-info-container', true),
							_Utils_Tuple2('expanded', model.bM),
							_Utils_Tuple2(
							'project-info-hidden',
							!_Utils_eq(pageView, $author$project$Pipeline$StandardPipeline))
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Views$ModalOverlay$invisibleModal, $author$project$MainMsg$ToggleEditOptions, model.bj),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleProjectInfoContainer)
												]),
											_List_fromArray(
												[
													$author$project$Utils$chevronDirection(model.bM)
												])),
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleProjectInfoContainer),
													$elm$html$Html$Attributes$class('project-name')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(project.bH),
													$author$project$Views$Project$publishedBadge(project.hK)
												])),
											A5(
											$author$project$Views$TalentSearch$selectedUsersButton,
											$elm$core$List$length(model.w),
											model.z,
											model.w,
											'',
											'')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-search-bar')
										]),
									_List_fromArray(
										[
											$author$project$Views$Pipeline$projectSearchBar(model.i7)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-details-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-details')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-edit-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('PROJECT DETAILS')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleEditOptions),
															$elm$html$Html$Attributes$class('edit-project-options')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('EDIT')
														])),
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('edit-options-container', true),
																	_Utils_Tuple2('edit-options-open', model.bj)
																]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$MainMsg$SetProjectId(project.cU))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Edit Project')
																])),
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	A2($author$project$MainMsg$ToggleConfirmation, project.cU, $author$project$Utils$UpdateProject))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Views$Project$publishText(project.hK))
																])),
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	A2($author$project$MainMsg$ToggleDeleteConfirmation, project.cU, project.bH))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Delete Project')
																]))
														]))
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(project.iE)
												])),
											A2(
											$elm$html$Html$h5,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('payment-details')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'$' + (project.iJ + (' | ' + $author$project$Views$Project$unionText(project.jI))))
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('AGENT NOTES')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(project.gm)
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('TALENT NOTES')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(project.jw)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('schedule-details')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('SCHEDULE')
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('JOB DATES'),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$author$project$Utils$dateTextNoTitle,
																		A2($author$project$Project$findDeadline, project.hb, 'Project').fO,
																		A2($author$project$Project$findDeadline, project.hb, 'Project').d8))
																]))
														]))
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('AUDITION'),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$author$project$Utils$dateTextNoTitle,
																		A2($author$project$Project$findDeadline, project.hb, 'Audition').fO,
																		A2($author$project$Project$findDeadline, project.hb, 'Audition').d8))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-location')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($author$project$Project$findDeadline, project.hb, 'Project').hV)
																]))
														]))
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('CALLBACK'),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$author$project$Utils$dateTextNoTitle,
																		A2($author$project$Project$findDeadline, project.hb, 'Callback').fO,
																		A2($author$project$Project$findDeadline, project.hb, 'Callback').d8))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-location')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($author$project$Project$findDeadline, project.hb, 'Callback').hV)
																]))
														]))
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('FITTING'),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, project.hb, 'Fitting').d8))
																]))
														]))
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('SHOOT'),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, project.hb, 'Shoot').d8))
																]))
														]))
												])),
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-role-list')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('ROLES'),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('add-role-button'),
																	$elm$html$Html$Events$onClick(
																	$author$project$MainMsg$ToggleFormOpen(2))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Role'),
																	$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$plusCircle)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													A2($author$project$Views$Project$roleList, model.aw, project))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Views$Project$projectLoader = function (loading) {
	return loading ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('project-loading-icon-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-back-drop')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A4(
						$frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions,
						$frandibar$elm_font_awesome_5$FontAwesome$circleNotch,
						0,
						_List_fromArray(
							[
								$frandibar$elm_font_awesome_5$FontAwesome$Animation(0)
							]),
						_List_Nil)
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Project$ToggleCollaboratedProjectsExpanded = {$: 2};
var $author$project$Project$ToggleProjectRolesExpanded = {$: 1};
var $author$project$Project$ToggleProjectsExpanded = {$: 0};
var $author$project$Views$Project$collaboratingProjectLi = function (project) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('collab-project-container')
			]),
		_List_fromArray(
			[
				$author$project$Views$Project$collaboratingProjectLink(project)
			]));
};
var $author$project$Project$defaultScheduleType = function (names) {
	return A2($elm$core$List$member, 'Audition', names) ? 'Audition' : 'Callback';
};
var $frandibar$elm_font_awesome_5$FontAwesome$minus = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('minus');
var $frandibar$elm_font_awesome_5$FontAwesome$plus = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('plus');
var $author$project$Views$Project$expandedIcon = function (expanded) {
	return expanded ? $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$minus) : $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$plus);
};
var $author$project$Views$Project$projectLi = function (model) {
	var name = model.bH;
	var isActive = model.hK;
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$UpdateCurrentProjectId(model.cU))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				$author$project$Views$Project$publishedBadge(isActive)
			]));
};
var $author$project$Utils$DeleteRole = function (a) {
	return {$: 4, a: a};
};
var $author$project$MainMsg$SetRoleId = function (a) {
	return {$: 70, a: a};
};
var $author$project$Utils$UpdateRole = function (a) {
	return {$: 2, a: a};
};
var $author$project$Utils$toggleSwitch = F2(
	function (active, aMsg) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('switch')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(active)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slider round'),
							$elm$html$Html$Events$onClick(aMsg)
						]),
					_List_Nil)
				]));
	});
var $author$project$Views$Project$publishRoleButton = F2(
	function (projectActive, role) {
		return projectActive ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2(
						$author$project$MainMsg$ToggleConfirmation,
						role.cU,
						$author$project$Utils$UpdateRole(role)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Views$Project$publishText(role.gg))
						])),
					A2(
					$author$project$Utils$toggleSwitch,
					role.gg,
					A2(
						$author$project$MainMsg$ToggleConfirmation,
						role.cU,
						$author$project$Utils$UpdateRole(role)))
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$Project$roleLi = F3(
	function (currentRole, roleOptions, projectPublished) {
		var open = function () {
			if (!roleOptions.$) {
				var role = roleOptions.a;
				return _Utils_eq(role.cU, currentRole.cU);
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('role-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(currentRole.bH)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-name-badge-container')
						]),
					_List_fromArray(
						[
							$author$project$Views$Project$publishedBadge(currentRole.gg),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateProjectMenuState(
										$author$project$Project$ToggleRoleMenu(
											$elm$core$Maybe$Just(currentRole)))),
									$elm$html$Html$Attributes$class('fas fa-ellipsis-h')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('role-menu', true),
									_Utils_Tuple2('role-menu-expanded', open)
								]))
						]),
					_List_fromArray(
						[
							A2($author$project$Views$Project$publishRoleButton, projectPublished, currentRole),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$SetRoleId(currentRole.cU))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Edit Role')
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2(
										$author$project$MainMsg$ToggleConfirmation,
										currentRole.cU,
										$author$project$Utils$DeleteRole(currentRole)))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Delete Role')
										]))
								]))
						])),
					A2(
					$author$project$Views$ModalOverlay$invisibleModal,
					$author$project$MainMsg$UpdateProjectMenuState(
						$author$project$Project$ToggleRoleMenu($elm$core$Maybe$Nothing)),
					open)
				]));
	});
var $author$project$Project$hasAudCallDates = function (deadlineNames) {
	return A2($elm$core$List$member, 'Audition', deadlineNames) || A2($elm$core$List$member, 'Callback', deadlineNames);
};
var $author$project$Views$Project$showSchedulesButton = F2(
	function (deadlineNames, isActive) {
		return $author$project$Project$hasAudCallDates(deadlineNames) && isActive;
	});
var $author$project$Views$Project$projectMenu = F3(
	function (model, project, deadlineNames) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-menu')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-menu-header-container'),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$ToggleFormOpen(0))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-menu-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('NEW PROJECT')
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('project-menu-header-container', true),
											_Utils_Tuple2('schedule-button', true),
											_Utils_Tuple2(
											'menu-option-showing',
											A2($author$project$Views$Project$showSchedulesButton, deadlineNames, project.hK))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-menu-header'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View(
												A2(
													$author$project$Route$SchedulePage,
													project.cU,
													$author$project$Project$defaultScheduleType(deadlineNames))))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('SCHEDULES')
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-menu-header-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('manage-projects-title'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$UpdateProjectMenuState($author$project$Project$ToggleProjectsExpanded))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('MANAGE PROJECTS')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('expand-icon')
												]),
											_List_fromArray(
												[
													$author$project$Views$Project$expandedIcon(model.aC.ee)
												]))
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('all-projects-container', true),
											_Utils_Tuple2('all-projects-expanded', model.aC.ee)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('project-menu-projects', true)
												]))
										]),
									A2($elm$core$List$map, $author$project$Views$Project$projectLi, model.A))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-menu-header-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('manage-projects-title'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$UpdateProjectMenuState($author$project$Project$ToggleProjectRolesExpanded))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('ROLES FOR THIS PROJECT')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('expand-icon')
												]),
											_List_fromArray(
												[
													$author$project$Views$Project$expandedIcon(model.aC.ef)
												]))
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('all-projects-container', true),
											_Utils_Tuple2('all-projects-expanded', model.aC.ef)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-role-button'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$ToggleFormOpen(2))
										]),
									_List_fromArray(
										[
											$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$plusCircle),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('ADD ROLE')
												]))
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('project-menu-roles', true)
												]))
										]),
									A2(
										$elm$core$List$map,
										function (role) {
											return A3($author$project$Views$Project$roleLi, role, model.aC.db, project.hK);
										},
										project.fq))
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('collaborated-project-menu-header-container', true),
									_Utils_Tuple2('collaborated-projects-expanded', model.aC.ed),
									_Utils_Tuple2(
									'showing-collaborated-projects',
									$elm$core$List$length(model.dN) > 0)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('manage-projects-title'),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateProjectMenuState($author$project$Project$ToggleCollaboratedProjectsExpanded))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h5,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('COLLABORATED PROJECTS')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('expand-icon')
										]),
									_List_fromArray(
										[
											$author$project$Views$Project$expandedIcon(model.aC.ed)
										]))
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('all-collaborated-projects-container', true),
									_Utils_Tuple2('all-projects-expanded', model.aC.ed),
									_Utils_Tuple2(
									'showing-collaborated-projects',
									$elm$core$List$length(model.dN) > 0)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('project-menu-projects', true)
										]))
								]),
							A2($elm$core$List$map, $author$project$Views$Project$collaboratingProjectLi, model.dN))
						]))
				]));
	});
var $author$project$Utils$roleDataOptions = function (roles) {
	return A2(
		$elm$core$List$map,
		function (role) {
			return {V: role.cU, bH: role.bH};
		},
		roles);
};
var $author$project$Utils$userInRole = F2(
	function (user, menuToggle) {
		return user.ev ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-status-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$stageText(user.jj))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('manage-talent-button fas fa-user-cog'),
							$elm$html$Html$Events$onClick(menuToggle)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Utils$talentCard = F5(
	function (user, selectedTalent, toggleTalentResultModal, toggleSelectedTalent, menuToggle) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('talent-card-v2', true),
							_Utils_Tuple2(
							'selected-talent',
							A2(
								$author$project$Utils$selectedUser,
								user.cU,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.cU;
									},
									selectedTalent)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-card-image-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Data$Image$emptyImage,
										$elm$core$List$head(user.hE)).jM),
									$elm$html$Html$Events$onClick(toggleSelectedTalent)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(user.bm + (' ' + user.bE)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-info-circle'),
									$elm$html$Html$Events$onClick(toggleTalentResultModal)
								]),
							_List_Nil)
						])),
					A2($author$project$Utils$userInRole, user, menuToggle)
				]));
	});
var $author$project$Views$TalentSearch$selectedTalentView = function (selections) {
	return function (view) {
		return function (action) {
			return function (projects) {
				return function (roles) {
					return function (pipeline) {
						return function (actionSet) {
							return function (projectId) {
								return function (twilioStatus) {
									return function (userProfile) {
										return function (newMessageBody) {
											switch (view) {
												case 0:
													return A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('selection-container')
																	]),
																_List_Nil)
															]));
												case 2:
													return A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('modal-open'),
																		$elm$html$Html$Events$onClick(
																		$author$project$MainMsg$ToggleCandidateScreen(1))
																	]),
																_List_Nil),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2('full-selections-container', true),
																				_Utils_Tuple2('selections-full', true)
																			]))
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$h2,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Selections')
																			])),
																		A2(
																		$elm$html$Html$ul,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('candidates-full-screen')
																			]),
																		A2(
																			$elm$core$List$map,
																			function (talent) {
																				return A5(
																					$author$project$Utils$talentCard,
																					talent,
																					selections,
																					A3($author$project$MainMsg$ToggleTalentResultModal, talent, $author$project$Job$emptyApplicant, ''),
																					A2($author$project$MainMsg$ToggleSelectedTalent, talent.cU, talent),
																					$author$project$MainMsg$UpdateTalentMenuOptions(
																						$author$project$User$ToggleMenuModal(talent)));
																			},
																			selections)),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('bulk-quick-actions-container')
																			]),
																		_List_fromArray(
																			[
																				$author$project$Views$TalentModal$quickActionBar(action)($author$project$User$emptySearchTalentProfile)(selections)($author$project$Job$emptyApplicant)(pipeline)(actionSet)(projects)(roles)(projectId)('')($author$project$SharedProjectRoleSchedules$emptyProject)('')(twilioStatus)(userProfile)(newMessageBody)('')($author$project$SharedProjectRoleSchedules$initialSchedulePageData)
																			]))
																	]))
															]));
												default:
													return $elm$html$Html$text('');
											}
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$Project$projectView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('project-details-page')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Views$Project$projectMenu,
						model,
						model.h,
						$author$project$Project$dnames(model.h.hb)),
						A3($author$project$Views$Project$projectHeader, model, model.h, model.it),
						$author$project$Views$Pipeline$pipeline(model.aY)(model.h.v)(model.ap)(model.cP)(model.d_)(model.w)(model.ji)(model.it)(model.i7)(model.jQ)(model.h.hb)(model.h.hK),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bulk-selected-talent-container')
							]),
						_List_fromArray(
							[
								$author$project$Views$TalentSearch$selectedTalentView(model.w)(model.H)(model.aD)(model.A)(model.aw)(model.h.v)(3)(model.aO)(model.au)(model.z)(model.y.dG)
							])),
						$author$project$Views$Project$directorModals(model),
						A3(
						$author$project$Views$TalentOptions$talentOptionsModal,
						model.Q,
						model.z,
						$author$project$Utils$roleDataOptions(model.h.fq)),
						$author$project$Views$TalentModal$talentSearchResultModal(model.p)(model.bh)(model.w)(model.aH)(model.aD)(model.cB)(model.h.v)(1)(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyProject]))(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyRole]))(model.aO)(model.d_)(model.h)(model.a5.ie)(model.au)(model.z)(model.y.dG)(model.bQ.b6.g_)(model.bQ)($author$project$Data$Video$emptyVideo)($author$project$SharedProjectRoleSchedules$Waiting)(false)(model.ca),
						A2($author$project$Views$Project$projectConfirmations, model, model.h),
						$author$project$Views$Project$projectLoader(model.cl),
						A2($author$project$Views$Confirmations$notificationModal, model.bI, model.l)
					]))
			]));
};
var $author$project$Utils$errorView = function (error) {
	var msg = 'We\'ve been notified and will fix this asap. You can try refreshing the page in the meantime.';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('error-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('error-title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Whoops! Something strange happened!')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('error-body')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(msg)
					]))
			]));
};
var $author$project$Pages$AgencyTalentSchedule$viewBreadcrumbs = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('breadcrumbs')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('breadcrumbs-link'),
					$elm$html$Html$Attributes$href('/dashboard')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Dashboard')
				])),
			$elm$html$Html$text(' > '),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('breadcrumbs-current')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Viewing role')
				]))
		]));
var $author$project$Pages$AgencyTalentSchedule$viewHeader = function (role) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('role-detail-header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('role-detail-header-left')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-subtitle')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Project: ' + role.ae.bH)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Role: ' + role.bH)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-detail-description')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(role.ae.im)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('role-detail-header-right')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Posted ' + role.gZ)
					]))
			]));
};
var $author$project$Pages$AgencyTalentSchedule$SelectedRole = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$AgencyTalentSchedule$viewRoleItem = F2(
	function (roleId, role) {
		var selected = _Utils_eq(roleId, role.V);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('role-detail-list-item'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-selected', selected)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$AgencyTalentSchedule$SelectedRole(role.V))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-detail-list-item-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(role.bH)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-detail-list-item-subtitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(role.ae.bH)
						]))
				]));
	});
var $author$project$Pages$AgencyTalentSchedule$viewRoles = F2(
	function (roleId, roles) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (r) {
					return A2($author$project$Pages$AgencyTalentSchedule$viewRoleItem, roleId, r);
				},
				roles));
	});
var $author$project$Pages$AgencyTalentSchedule$viewMaybeRoles = F2(
	function (roleId, data) {
		if (data.$ === 3) {
			var roles = data.a;
			return A2($author$project$Pages$AgencyTalentSchedule$viewRoles, roleId, roles);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$AgencyTalentSchedule$talentCount = function (item) {
	var count = $elm$core$String$fromInt(
		$elm$core$List$length(item.jx));
	return $elm$html$Html$text('(' + (count + ')'));
};
var $author$project$Pages$AgencyTalentSchedule$scheduledDateText = function (talent) {
	var _v0 = talent.i2;
	if (!_v0.$) {
		var date = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('role-detail-pipeline-talent-schedule')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(date)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$PipelineTalentCard$view = function (talent) {
	var imageSrc = function () {
		var _v0 = talent.iC;
		if (_v0 === '') {
			return $author$project$Data$Image$emptyImage.jM;
		} else {
			var src = _v0;
			return src;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pipeline-talent-card')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('avatar')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('avatar__image is-small'),
										$elm$html$Html$Attributes$src(imageSrc)
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pipeline-talent-card-info')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(talent.bm),
						$elm$html$Html$text(' '),
						$elm$html$Html$text(talent.bE)
					]))
			]));
};
var $author$project$Pages$AgencyTalentSchedule$viewPipelineTalentItem = function (talent) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('role-detail-pipeline-talent-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$AgencyTalentSchedule$scheduledDateText(talent)
					])),
				$author$project$Views$PipelineTalentCard$view(talent)
			]));
};
var $author$project$Pages$AgencyTalentSchedule$viewPipelineItem = function (item) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('role-detail-pipeline-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('role-detail-pipeline-item-title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(item.bH),
						$elm$html$Html$text(' '),
						$author$project$Pages$AgencyTalentSchedule$talentCount(item)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('role-detail-pipeline-item-body')
					]),
				A2(
					$elm$core$List$map,
					function (t) {
						return $author$project$Pages$AgencyTalentSchedule$viewPipelineTalentItem(t);
					},
					item.jx))
			]));
};
var $author$project$Pages$AgencyTalentSchedule$viewPipeline = function (pipeline) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card role-detail-pipeline')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card-body role-detail-pipeline-body')
					]),
				A2(
					$elm$core$List$map,
					function (item) {
						return $author$project$Pages$AgencyTalentSchedule$viewPipelineItem(item);
					},
					pipeline))
			]));
};
var $author$project$Pages$AgencyTalentSchedule$valueOrBlank = F2(
	function (str, defaultValue) {
		if (str === '') {
			return defaultValue;
		} else {
			return str;
		}
	});
var $author$project$Pages$AgencyTalentSchedule$viewAgeRange = function (role) {
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromInt(role.cZ) + (' - ' + $elm$core$String$fromInt(role.cX)))
			]));
};
var $author$project$Pages$AgencyTalentSchedule$viewEthnicities = function (items) {
	var str = A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			function (e) {
				return e.bH;
			},
			items));
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($author$project$Pages$AgencyTalentSchedule$valueOrBlank, str, ' - '))
			]));
};
var $author$project$Pages$AgencyTalentSchedule$viewGenders = function (genders) {
	var str = A2($elm$core$String$join, ', ', genders);
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($author$project$Pages$AgencyTalentSchedule$valueOrBlank, str, ' - '))
			]));
};
var $author$project$Pages$AgencyTalentSchedule$viewRoleInfo = function (role) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('role-detail-role-info')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('role-detail-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-detail-item-header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Rate: ')
							])),
						$elm$html$Html$text(
						A2($author$project$Pages$AgencyTalentSchedule$valueOrBlank, role.iN, '-'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('role-detail-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-detail-item-header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Ages: ')
							])),
						$author$project$Pages$AgencyTalentSchedule$viewAgeRange(role)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('role-detail-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-detail-item-header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Ethnicities: ')
							])),
						$author$project$Pages$AgencyTalentSchedule$viewEthnicities(role.ea),
						$author$project$Pages$AgencyTalentSchedule$viewGenders(role.hy)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('role-detail-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-detail-item-header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Genders: ')
							])),
						$author$project$Pages$AgencyTalentSchedule$viewGenders(role.hy)
					]))
			]));
};
var $author$project$Pages$AgencyTalentSchedule$viewSuccess = F2(
	function (role, maybeRoles) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('role-detail-container')
				]),
			_List_fromArray(
				[
					$author$project$Pages$AgencyTalentSchedule$viewBreadcrumbs,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-detail-inner')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('role-detail-sidebar')
								]),
							_List_fromArray(
								[
									A2($author$project$Pages$AgencyTalentSchedule$viewMaybeRoles, role.V, maybeRoles)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('role-detail-content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('card-body')
												]),
											_List_fromArray(
												[
													$author$project$Pages$AgencyTalentSchedule$viewHeader(role),
													$author$project$Pages$AgencyTalentSchedule$viewRoleInfo(role)
												]))
										])),
									$author$project$Pages$AgencyTalentSchedule$viewPipeline(role.jx)
								]))
						]))
				]));
	});
var $author$project$Pages$AgencyTalentSchedule$view = function (model) {
	var _v0 = model.cp;
	switch (_v0.$) {
		case 0:
			return $elm$html$Html$text('');
		case 1:
			return $author$project$Utils$loader;
		case 2:
			var e = _v0.a;
			return $author$project$Utils$errorView(e);
		default:
			var role = _v0.a;
			return A2($author$project$Pages$AgencyTalentSchedule$viewSuccess, role, model.cq);
	}
};
var $author$project$Main$renderPageView = function (model) {
	var _v0 = _Utils_Tuple2(model.i, model.cJ);
	if ((_v0.a.$ === 28) && (!_v0.b.$)) {
		var routeData = _v0.b.a;
		return A2(
			$elm$html$Html$map,
			$author$project$MainMsg$GotAgencyTalentScheduleMsg,
			$author$project$Pages$AgencyTalentSchedule$view(routeData));
	} else {
		return $author$project$Views$Dashboard$notFoundView;
	}
};
var $author$project$Views$Project$filteredApplicants = F2(
	function (applicants, stage) {
		return A2(
			$elm$core$List$filter,
			function (applicant) {
				return _Utils_eq(applicant.jj, stage);
			},
			applicants);
	});
var $author$project$Views$Project$talentList = F2(
	function (model, users) {
		return A2(
			$elm$core$List$map,
			function (applicant) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-card'),
							$elm$html$Html$Events$onClick(
							A3($author$project$MainMsg$ToggleTalentResultModal, applicant.f_, applicant, ''))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('talent-card-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(applicant.f_.bm + (' ' + applicant.f_.bE))
								])),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Data$Image$emptyImage,
										$elm$core$List$head(applicant.f_.hE)).jM),
									$elm$html$Html$Attributes$class('square-avatar')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chat')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('far fa-comment chat-icon')
										]),
									_List_Nil)
								]))
						]));
			},
			users);
	});
var $author$project$Views$Project$roleView = function (model) {
	var r = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (role) {
				return _Utils_eq(role.cU, model.g3);
			},
			model.aw));
	if (!r.$) {
		var role = r.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$SetRoleId(model.g3)),
											$elm$html$Html$Attributes$class('button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit Role')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											A2($author$project$MainMsg$ToggleDeleteConfirmation, model.g3, role.bH)),
											$elm$html$Html$Attributes$class('button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete Role')
										]))
								])),
							A4(
							$author$project$Views$Confirmations$deleteConfirmation,
							model.Z,
							$author$project$MainMsg$DeleteRole(model.am),
							A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
							'Are you sure you want to delete ' + (model.d1 + ' Role')),
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(role.bH)
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(role.iV)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('applied-list')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Applied')
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$author$project$Views$Project$talentList,
										model,
										A2($author$project$Views$Project$filteredApplicants, model.du, 0)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('requested-list')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Requested')
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$author$project$Views$Project$talentList,
										model,
										A2($author$project$Views$Project$filteredApplicants, model.du, 2)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('accepted-list')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Accepted')
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$author$project$Views$Project$talentList,
										model,
										A2($author$project$Views$Project$filteredApplicants, model.du, 3)))
								]))
						])),
					$author$project$Views$TalentModal$talentSearchResultModal(model.p)(model.bh)(model.w)(model.aH)(model.aD)(model.cB)(model.h.v)(1)(
					_List_fromArray(
						[$author$project$SharedProjectRoleSchedules$emptyProject]))(
					_List_fromArray(
						[$author$project$SharedProjectRoleSchedules$emptyRole]))('')(model.d_)($author$project$SharedProjectRoleSchedules$emptyProject)(model.a5.ie)(model.au)(model.z)(model.y.dG)(model.bQ.b6.g_)(model.bQ)($author$project$Data$Video$emptyVideo)($author$project$SharedProjectRoleSchedules$Waiting)(false)(model.ca),
					$author$project$Views$Project$directorModals(model)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$MainMsg$CloseUserSwapMenu = function (a) {
	return {$: 209, a: a};
};
var $author$project$MainMsg$ClosedPublishedModal = {$: 215};
var $author$project$MainMsg$ToggleScheduleForm = function (a) {
	return {$: 193, a: a};
};
var $author$project$Project$SchedulingPage = 4;
var $author$project$Views$Schedule$currentPage = function (page) {
	if (page.$ === 25) {
		return 6;
	} else {
		return 4;
	}
};
var $author$project$Views$Schedule$modal = F2(
	function (open, message) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('modal', true),
							_Utils_Tuple2('modal-open', open)
						])),
					$elm$html$Html$Events$onClick(message)
				]),
			_List_Nil);
	});
var $author$project$MainMsg$MoveSinglePublishedUser = function (a) {
	return {$: 214, a: a};
};
var $author$project$Views$Schedule$movePublishedUserModal = function (model) {
	var _v0 = model.cm;
	switch (_v0) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('published-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You are trying to make changes to a published Schedule!')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Do you want to move ' + (model.bQ.f2.q.bm + '?'))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('swap-action-button button'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$MoveSinglePublishedUser(model.bQ.f2))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Move ' + model.bQ.f2.q.bm)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('swap-action-button button'),
								$elm$html$Html$Events$onClick($author$project$MainMsg$ClosedPublishedModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							]))
					]));
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('published-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You are trying to remove someone from a published Schedule!')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to remove ' + (model.bQ.f2.q.bm + '?'))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('swap-action-button button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Move ' + model.bQ.f2.q.bm)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('swap-action-button button'),
								$elm$html$Html$Events$onClick($author$project$MainMsg$ClosedPublishedModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							]))
					]));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$MainMsg$PublishSchedule = {$: 204};
var $author$project$MainMsg$TogglePublishConfirmationModal = {$: 203};
var $author$project$Views$Schedule$destructiveActions = _List_fromArray(
	['Scheduled talent will be sent a notification that they have been scheduled for this role.', 'Talent will be able to accept, reject, or request to be rescheduled.', 'You will be able to view schedules on a daily view.']);
var $author$project$Views$Schedule$publishWarning = 'Once this schedule is published the following actions will take place: ';
var $author$project$Views$Schedule$publishConfirmationModal = function (isOpen) {
	if (isOpen) {
		return A5($author$project$Views$Confirmations$confirmation, isOpen, $author$project$MainMsg$PublishSchedule, $author$project$MainMsg$TogglePublishConfirmationModal, $author$project$Views$Schedule$publishWarning, $author$project$Views$Schedule$destructiveActions);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Schedule$savingScheduleView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('saving-schedule-container', true),
						_Utils_Tuple2('form-hiding', model.bQ.bP !== 3)
					]))
			]),
		_List_fromArray(
			[
				A2($author$project$Views$Schedule$modal, model.bQ.bP === 3, $author$project$MainMsg$NoOp),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-circle-notch fa-spin')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Creating Schedule!')
							]))
					]))
			]));
};
var $author$project$Schedule$OntoUserInSchedule = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Schedule$OutOfSchedule = {$: 4};
var $author$project$SharedProjectRoleSchedules$AddCollaborator = {$: 10};
var $author$project$SharedProjectRoleSchedules$CollabCompany = function (a) {
	return {$: 2, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollabEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollabFirstName = function (a) {
	return {$: 4, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollabLastName = function (a) {
	return {$: 5, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollabPhone = function (a) {
	return {$: 3, a: a};
};
var $author$project$SharedProjectRoleSchedules$ToggleCollabForm = {$: 0};
var $author$project$SharedProjectRoleSchedules$ToggleEmailFocus = {$: 9};
var $author$project$SharedProjectRoleSchedules$FillInValues = function (a) {
	return {$: 8, a: a};
};
var $author$project$Views$Schedule$collaboratorLi = function (collaborator) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$UpdateCollaboratorData(
					$author$project$SharedProjectRoleSchedules$FillInValues(collaborator)))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(collaborator.bl)
			]));
};
var $author$project$Views$Schedule$showingCollaborators = F2(
	function (collaborators, email) {
		var matchingCollaborators = A2(
			$elm$core$List$filter,
			function (user) {
				return A2($elm$core$String$contains, email, user.bl);
			},
			collaborators);
		return (email !== '') && ($elm$core$List$length(matchingCollaborators) >= 1);
	});
var $author$project$Views$Schedule$addCollaboratorsForm = F2(
	function (projectId, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('show-collab-form', data.c2),
							_Utils_Tuple2('collaborator-container', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('collaborator-modal'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateCollaboratorData($author$project$SharedProjectRoleSchedules$ToggleCollabForm))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('collaborator-form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('collaborator-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Collaborators')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('collaborator-form'),
									$elm$html$Html$Attributes$autocomplete(false),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateCollaboratorData($author$project$SharedProjectRoleSchedules$ToggleEmailFocus))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Email Address*'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('email'),
													$elm$html$Html$Attributes$value(data.bl),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateCollaboratorData, $author$project$SharedProjectRoleSchedules$CollabEmail))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('saved-collaborators', true),
													_Utils_Tuple2(
													'matching-collaborators',
													A2($author$project$Views$Schedule$showingCollaborators, data.dO, data.bl) && data.aZ)
												]))
										]),
									A2(
										$elm$core$List$map,
										$author$project$Views$Schedule$collaboratorLi,
										A2(
											$elm$core$List$filter,
											function (user) {
												return A2($elm$core$String$contains, data.bl, user.bl);
											},
											data.dO))),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('First Name*'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$value(data.bm),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateCollaboratorData, $author$project$SharedProjectRoleSchedules$CollabFirstName))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Last Name*'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$value(data.bE),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateCollaboratorData, $author$project$SharedProjectRoleSchedules$CollabLastName))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Company'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$value(data.cE),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateCollaboratorData, $author$project$SharedProjectRoleSchedules$CollabCompany))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Phone Number'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('tel'),
													$elm$html$Html$Attributes$value(data.iv),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateCollaboratorData, $author$project$SharedProjectRoleSchedules$CollabPhone))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('collab-form-complete', data.cS),
													_Utils_Tuple2('collab-form-add', true)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$UpdateCollaboratorData($author$project$SharedProjectRoleSchedules$AddCollaborator))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('ADD'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('fas fa-circle-notch fa-spin', true),
															_Utils_Tuple2('adding-collaborator', data.gi)
														]))
												]),
											_List_Nil)
										]))
								]))
						]))
				]));
	});
var $author$project$MainMsg$ToggleCollaboratorsModal = {$: 277};
var $author$project$MainMsg$RemoveCollaborator = function (a) {
	return {$: 279, a: a};
};
var $author$project$Views$Schedule$currentCollabLi = function (collaborator) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(collaborator.bm + (' ' + collaborator.bE)),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(collaborator.bl)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						collaborator.cw ? 'Accepted Invitation' : 'Invitation Not Accepted')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('remove-collaborator-button'),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$RemoveCollaborator(collaborator.ey))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('remove')
					]))
			]));
};
var $author$project$Views$Schedule$collaboratorsModal = function (model) {
	return (!_Utils_eq(model.z.cU, model.bQ.b6.g_)) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('collaborator-modal-container', true),
						_Utils_Tuple2('collaborator-modal-open', model.bQ.dP)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collaborator-modal'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleCollaboratorsModal)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collaborator-list-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('collaborator-header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Current Collaborators')
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('collaborators-list')
							]),
						A2($elm$core$List$map, $author$project$Views$Schedule$currentCollabLi, model.cH))
					]))
			]));
};
var $author$project$Views$Schedule$dayOfScheduleHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('day-of-schedule-header')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Name')
				])),
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Stage')
				])),
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Time')
				])),
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Status')
				])),
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Votes')
				]))
		]));
var $author$project$MainMsg$OpenVotingScreen = function (a) {
	return {$: 176, a: a};
};
var $author$project$Views$Schedule$availiableVoters = function (totalVoters) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(totalVoters)) > 0;
};
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Utils$formatTime = function (time) {
	var minute = A2($elm$time$Time$toMinute, $elm$time$Time$utc, time);
	var hour = A2($elm$time$Time$toHour, $elm$time$Time$utc, time);
	var formattedMinute = (!minute) ? ($elm$core$String$fromInt(minute) + '0') : $elm$core$String$fromInt(minute);
	var formattedHour = (hour > 12) ? $elm$core$String$fromInt(hour - 12) : ((!hour) ? '12' : $elm$core$String$fromInt(hour));
	var ending = (hour >= 12) ? 'PM' : 'AM';
	return formattedHour + (':' + (formattedMinute + (' ' + ending)));
};
var $author$project$Views$Schedule$voterLi = function (vote) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(vote.f9)
			]));
};
var $author$project$Views$Schedule$votersList = F2(
	function (votes, voting_type) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('voter-list')
				]),
			A2(
				$elm$core$List$map,
				function (vote) {
					return $author$project$Views$Schedule$voterLi(vote);
				},
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.f6;
						},
						voting_type),
					votes)));
	});
var $author$project$Views$Schedule$dayOfScheduleTimeSlot = F2(
	function (timeSlot, schedule) {
		var yes = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f7, 'yes');
		var no = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f7, 'no');
		var maybe = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f7, 'maybe');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('day-of-schedule-item-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section'),
							$elm$html$Html$Events$onClick(
							A3(
								$author$project$MainMsg$ToggleTalentResultModal,
								$author$project$Utils$transformToSearchResultTalentProfile(timeSlot.f_),
								$author$project$Job$emptyApplicant,
								''))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Data$Image$emptyImage,
										$elm$core$List$head(timeSlot.f_.hE)).jM)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('user-name-role-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(timeSlot.f_.bm + (' ' + timeSlot.f_.bE))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('role')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(timeSlot.f_.P.bH)
										]))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(schedule.fy)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatTime(timeSlot.hj))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$Schedule$timeSlotStatus, timeSlot.f_, schedule.fy)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section voting-section'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$OpenVotingScreen(
								$author$project$Utils$transformToSearchResultTalentProfile(timeSlot.f_)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'yes-colored',
											$author$project$Views$Schedule$availiableVoters(yes)),
											_Utils_Tuple2('votes', true)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(yes)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('yes-voters', true),
											_Utils_Tuple2(
											'available-voters',
											$author$project$Views$Schedule$availiableVoters(yes))
										]))
								]),
							_List_fromArray(
								[
									A2($author$project$Views$Schedule$votersList, timeSlot.f7, 'yes')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'maybe-colored',
											$author$project$Views$Schedule$availiableVoters(maybe)),
											_Utils_Tuple2('votes', true)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(maybe)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('maybe-voters', true),
											_Utils_Tuple2(
											'available-voters',
											$author$project$Views$Schedule$availiableVoters(maybe))
										]))
								]),
							_List_fromArray(
								[
									A2($author$project$Views$Schedule$votersList, timeSlot.f7, 'maybe')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'no-colored',
											$author$project$Views$Schedule$availiableVoters(no)),
											_Utils_Tuple2('votes', true)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(no)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('no-voters', true),
											_Utils_Tuple2(
											'available-voters',
											$author$project$Views$Schedule$availiableVoters(no))
										]))
								]),
							_List_fromArray(
								[
									A2($author$project$Views$Schedule$votersList, timeSlot.f7, 'no')
								]))
						]))
				]));
	});
var $author$project$Views$Schedule$dayOfSchedulePage = F3(
	function (model, projectId, scheduleId) {
		var _v0 = model.z.P;
		switch (_v0) {
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-container')
						]),
					_List_fromArray(
						[
							$author$project$Views$Schedule$dayOfScheduleHeader,
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('day-of-schedule-time-slots-container')
								]),
							A2(
								$elm$core$List$map,
								function (timeSlot) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Schedule$dayOfScheduleTimeSlot, timeSlot, model.bQ.b6);
								},
								A2(
									$elm$core$List$filter,
									function (timeSlot) {
										return timeSlot.f_.cU !== '';
									},
									model.bQ.b6.jD)))
						]));
			case 4:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-container')
						]),
					_List_fromArray(
						[
							$author$project$Views$Schedule$dayOfScheduleHeader,
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('day-of-schedule-time-slots-container')
								]),
							A2(
								$elm$core$List$map,
								function (timeSlot) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Schedule$dayOfScheduleTimeSlot, timeSlot, model.bQ.b6);
								},
								A2(
									$elm$core$List$filter,
									function (timeSlot) {
										return timeSlot.f_.cU !== '';
									},
									model.bQ.b6.jD)))
						]));
			case 3:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-container')
						]),
					_List_fromArray(
						[
							$author$project$Views$Schedule$dayOfScheduleHeader,
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('day-of-schedule-time-slots-container')
								]),
							A2(
								$elm$core$List$map,
								function (timeSlot) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Schedule$dayOfScheduleTimeSlot, timeSlot, model.bQ.b6);
								},
								A2(
									$elm$core$List$filter,
									function (timeSlot) {
										return timeSlot.f_.cU !== '';
									},
									model.bQ.b6.jD)))
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-container')
						]),
					_List_fromArray(
						[
							$author$project$Views$Schedule$dayOfScheduleHeader,
							A2($author$project$Views$Schedule$addCollaboratorsForm, projectId, model.bQ.by),
							$author$project$Views$Schedule$collaboratorsModal(model),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('day-of-schedule-time-slots-container')
								]),
							A2(
								$elm$core$List$map,
								function (timeSlot) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Schedule$dayOfScheduleTimeSlot, timeSlot, model.bQ.b6);
								},
								A2(
									$elm$core$List$filter,
									function (timeSlot) {
										return timeSlot.f_.cU !== '';
									},
									model.bQ.b6.jD)))
						]));
		}
	});
var $author$project$SharedProjectRoleSchedules$ScheduleFormOpen = 1;
var $author$project$Views$Schedule$defaultScheduleContainerOptions = function (projectId) {
	return ($elm$core$String$length(projectId) > 0) ? A2(
		$visotype$elm_dom$Dom$appendChildList,
		_List_fromArray(
			[
				A2(
				$visotype$elm_dom$Dom$appendChild,
				A2(
					$visotype$elm_dom$Dom$appendText,
					'Create a New Schedule',
					$visotype$elm_dom$Dom$element('p')),
				A2(
					$visotype$elm_dom$Dom$appendChild,
					A2(
						$visotype$elm_dom$Dom$appendChild,
						A2(
							$visotype$elm_dom$Dom$addClass,
							'fas fa-plus',
							$visotype$elm_dom$Dom$element('span')),
						A2(
							$visotype$elm_dom$Dom$addAction,
							_Utils_Tuple2(
								'click',
								$author$project$MainMsg$ToggleScheduleForm(1)),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'default-icon-container',
								$visotype$elm_dom$Dom$element('div')))),
					$visotype$elm_dom$Dom$element('li')))
			]),
		A2(
			$visotype$elm_dom$Dom$addClass,
			'default-options',
			$visotype$elm_dom$Dom$element('ul'))) : $visotype$elm_dom$Dom$element('ul');
};
var $author$project$MainMsg$ScheduleMoveCanceled = {$: 200};
var $author$project$MainMsg$ScheduleMoveCompleted = F2(
	function (a, b) {
		return {$: 201, a: a, b: b};
	});
var $author$project$MainMsg$ScheduleMoveStarted = function (a) {
	return {$: 198, a: a};
};
var $author$project$MainMsg$ScheduleMoveTargetChanged = function (a) {
	return {$: 199, a: a};
};
var $author$project$MainMsg$dragDropMessagesSchedule = {d3: $author$project$MainMsg$ScheduleMoveCanceled, d4: $author$project$MainMsg$ScheduleMoveStarted, d5: $author$project$MainMsg$ScheduleMoveTargetChanged, d6: $author$project$MainMsg$ScheduleMoveCompleted};
var $author$project$Schedule$OntoElement = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Schedule$OntoPublishedElement = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $visotype$elm_dom$Dom$appendChildConditional = F2(
	function (e, test) {
		if (test) {
			return $visotype$elm_dom$Dom$appendChild(e);
		} else {
			return function (x) {
				return x;
			};
		}
	});
var $author$project$Views$Schedule$statusIcon = F2(
	function (user, scheduleType) {
		var memberStatus = A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fy;
						},
						scheduleType),
					user.fx))).dc;
		switch (memberStatus) {
			case 5:
				return 'fas fa-hourglass-start';
			case 11:
				return 'fas fa-hourglass-start';
			case 6:
				return 'fas fa-check';
			case 7:
				return 'fas fa-times';
			case 8:
				return 'far fa-calendar-times';
			case 12:
				return 'fas fa-check';
			case 13:
				return 'fas fa-times';
			case 14:
				return 'far fa-calendar-times';
			case 9:
				return 'fas fa-hourglass-start';
			case 15:
				return 'fas fa-hourglass-start';
			default:
				return '';
		}
	});
var $author$project$Views$Schedule$userStatus = F2(
	function (user, scheduleType) {
		var userStage = A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fy;
						},
						scheduleType),
					user.fx))).dc;
		switch (scheduleType) {
			case 'Audition':
				return A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[6])) ? 'confirmed' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[7])) ? 'rejected' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[5, 9])) ? 'pending' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[8])) ? 'reschedule' : '')));
			case 'Callback':
				return A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[12])) ? 'confirmed' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[13])) ? 'rejected' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[11, 15])) ? 'pending' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[14])) ? 'reschedule' : '')));
			default:
				return '';
		}
	});
var $author$project$Views$Schedule$userDisplay = F7(
	function (schedulePageData, user, dragDropState, searchQuery, time, timeSlot, dropType) {
		var showingUser = $elm$core$String$length(searchQuery) <= 1;
		var matchingUser = ($elm$core$String$length(searchQuery) > 1) && (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bm)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bE)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.P.bH)) || A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bm + (' ' + user.bE))))));
		var _v0 = A2($author$project$Views$Schedule$statusHoverText, user.fx, schedulePageData.fy);
		var statusText = _v0.a;
		var statusReason = _v0.b;
		return A2(
			$visotype$elm_dom$Dom$appendChild,
			A2(
				$visotype$elm_dom$Dom$appendChildList,
				_List_fromArray(
					[
						A2(
						$visotype$elm_dom$Dom$appendChildList,
						_List_fromArray(
							[
								A2(
								$visotype$elm_dom$Dom$addAttribute,
								$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Data$Image$emptyImage,
										$elm$core$List$head(user.hE)).jM),
								A2(
									$visotype$elm_dom$Dom$addClass,
									'square-avatar',
									$visotype$elm_dom$Dom$element('img'))),
								A2(
								$visotype$elm_dom$Dom$appendChildList,
								_List_fromArray(
									[
										A2(
										$visotype$elm_dom$Dom$appendText,
										user.bm + (' ' + user.bE),
										$visotype$elm_dom$Dom$element('h3')),
										A2(
										$visotype$elm_dom$Dom$addClass,
										'pipeline-role-name',
										A2(
											$visotype$elm_dom$Dom$appendText,
											user.P.bH,
											$visotype$elm_dom$Dom$element('span')))
									]),
								A2(
									$visotype$elm_dom$Dom$addClass,
									'user-name-info-container',
									$visotype$elm_dom$Dom$element('div')))
							]),
						A2(
							$visotype$elm_dom$Dom$addClass,
							'time-slot-image-name-role-container',
							$visotype$elm_dom$Dom$element('div'))),
						A2(
						$visotype$elm_dom$Dom$appendChildList,
						_List_fromArray(
							[
								A2(
								$visotype$elm_dom$Dom$addClass,
								'users-time',
								A2(
									$visotype$elm_dom$Dom$appendText,
									time,
									$visotype$elm_dom$Dom$element('span'))),
								A2(
								$visotype$elm_dom$Dom$addClass,
								A2($author$project$Views$Schedule$statusIcon, user, schedulePageData.fy),
								$visotype$elm_dom$Dom$element('span')),
								A2(
								$visotype$elm_dom$Dom$appendChildList,
								_List_fromArray(
									[
										A2(
										$visotype$elm_dom$Dom$appendText,
										statusText,
										A2(
											$visotype$elm_dom$Dom$addClass,
											'schedule-status-text',
											$visotype$elm_dom$Dom$element('span'))),
										A2(
										$visotype$elm_dom$Dom$appendText,
										statusReason,
										A2(
											$visotype$elm_dom$Dom$addClass,
											'status-body-text',
											$visotype$elm_dom$Dom$element('p')))
									]),
								A2(
									$visotype$elm_dom$Dom$addClass,
									'status-verbiage',
									$visotype$elm_dom$Dom$element('div')))
							]),
						A2(
							$visotype$elm_dom$Dom$addClass,
							'user-time-status-container',
							$visotype$elm_dom$Dom$element('div')))
					]),
				A2(
					$visotype$elm_dom$Dom$addClass,
					'time-slot-user-container',
					$visotype$elm_dom$Dom$element('div'))),
			A4(
				$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDroppable,
				dragDropState,
				dropType,
				$author$project$MainMsg$dragDropMessagesSchedule,
				A4(
					$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDraggable,
					dragDropState,
					A2($author$project$Schedule$User, user, timeSlot.V),
					$author$project$MainMsg$dragDropMessagesSchedule,
					A3(
						$visotype$elm_dom$Dom$addClassConditional,
						'showing-user',
						showingUser,
						A3(
							$visotype$elm_dom$Dom$addClassConditional,
							'matching-user',
							matchingUser,
							A2(
								$visotype$elm_dom$Dom$addAction,
								_Utils_Tuple2(
									'click',
									A3(
										$author$project$MainMsg$ToggleTalentResultModal,
										$author$project$Utils$transformToSearchResultTalentProfile(user),
										$author$project$Job$emptyApplicant,
										'')),
								A2(
									$visotype$elm_dom$Dom$addClass,
									A2($author$project$Views$Schedule$userStatus, timeSlot.f_, schedulePageData.fy),
									A2(
										$visotype$elm_dom$Dom$addClass,
										'talent-card condensed',
										$visotype$elm_dom$Dom$element('div')))))))));
	});
var $author$project$Views$Schedule$slot = F3(
	function (timeSlot, dragDropState, schedulePageData) {
		var elementType = A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptySchedule,
			$elm$core$List$head(schedulePageData.f)).a3 ? A3($author$project$Schedule$OntoPublishedElement, timeSlot.V, timeSlot.f_, timeSlot.i0) : A2($author$project$Schedule$OntoElement, timeSlot.V, timeSlot.i0);
		return A3(
			$visotype$elm_dom$Dom$appendChildConditional,
			A2(
				$visotype$elm_dom$Dom$appendChildList,
				_List_fromArray(
					[
						A7(
						$author$project$Views$Schedule$userDisplay,
						schedulePageData,
						timeSlot.f_,
						dragDropState,
						'',
						$author$project$Utils$formatTime(timeSlot.hj),
						timeSlot,
						A3($author$project$Schedule$OntoUserInSchedule, timeSlot.V, timeSlot.f_, timeSlot.i0))
					]),
				A2(
					$visotype$elm_dom$Dom$addClass,
					'taken-time-slot',
					$visotype$elm_dom$Dom$element('div'))),
			timeSlot.f_.cU !== '',
			A3(
				$visotype$elm_dom$Dom$appendChildConditional,
				A2(
					$visotype$elm_dom$Dom$appendChild,
					A2(
						$visotype$elm_dom$Dom$appendText,
						$author$project$Utils$formatTime(timeSlot.hj),
						$visotype$elm_dom$Dom$element('p')),
					A4(
						$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDroppable,
						dragDropState,
						elementType,
						$author$project$MainMsg$dragDropMessagesSchedule,
						A2(
							$visotype$elm_dom$Dom$addClass,
							'empty-time-slot',
							$visotype$elm_dom$Dom$element('div')))),
				timeSlot.f_.cU === '',
				A2(
					$visotype$elm_dom$Dom$addClass,
					'time-slot',
					$visotype$elm_dom$Dom$element('li'))));
	});
var $author$project$Views$Schedule$slotsContainer = F3(
	function (timeSlots, dragDropState, schedulePageData) {
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			A2(
				$elm$core$List$map,
				function (singleSlot) {
					return A3($author$project$Views$Schedule$slot, singleSlot, dragDropState, schedulePageData);
				},
				timeSlots),
			A2(
				$visotype$elm_dom$Dom$appendChild,
				A2(
					$visotype$elm_dom$Dom$appendText,
					'',
					$visotype$elm_dom$Dom$element('p')),
				$visotype$elm_dom$Dom$element('ul')));
	});
var $author$project$Views$Schedule$buildTimeSlots = F3(
	function (brokenUpTimeSlots, dragDropState, schedulePageData) {
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			A2(
				$elm$core$List$map,
				function (timeSlots) {
					return A3($author$project$Views$Schedule$slotsContainer, timeSlots, dragDropState, schedulePageData);
				},
				brokenUpTimeSlots),
			$visotype$elm_dom$Dom$element('ul'));
	});
var $elm_community$list_extra$List$Extra$groupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var thisGroup = A2($elm$core$List$take, size, xs);
		var okayLength = _Utils_eq(
			size,
			$elm$core$List$length(thisGroup));
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayLength) ? A2(
			$elm$core$List$cons,
			thisGroup,
			A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$groupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, size, xs);
	});
var $author$project$Views$Schedule$scheduleDay = F3(
	function (schedule, dragDropState, schedulePageData) {
		var brokenUpSlots = A2($elm_community$list_extra$List$Extra$groupsOf, schedule.gK, schedule.jD);
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			_List_fromArray(
				[
					A3($author$project$Views$Schedule$buildTimeSlots, brokenUpSlots, dragDropState, schedulePageData)
				]),
			A2(
				$visotype$elm_dom$Dom$appendChild,
				A2(
					$visotype$elm_dom$Dom$appendText,
					schedule.fv,
					A2(
						$visotype$elm_dom$Dom$addClass,
						'date-header',
						$visotype$elm_dom$Dom$element('h3'))),
				A2(
					$visotype$elm_dom$Dom$addClass,
					'schedule-day-container',
					$visotype$elm_dom$Dom$element('div'))));
	});
var $author$project$Views$Schedule$talentInfoText = function (scheduleType) {
	switch (scheduleType) {
		case 'Audition':
			return 'Available Talent users for Audition schedules are pulled from \'Selected Candidates\' column in the project pipeline.';
		case 'Callback':
			return 'Available Talent users for callback schedules are pulled from \'Selected Candidates\' and \'Scheduled Audition\' columns in the project project pipeline';
		default:
			return '';
	}
};
var $author$project$Views$Schedule$scheduleContainer = function (model) {
	var _v0 = model.bQ.aE;
	switch (_v0.$) {
		case 0:
			return $visotype$elm_dom$Dom$render(
				A2(
					$visotype$elm_dom$Dom$appendChild,
					$author$project$Views$Schedule$defaultScheduleContainerOptions(model.bQ.ae.cU),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'schedule-default-page',
						$visotype$elm_dom$Dom$element('div'))));
		case 2:
			return $visotype$elm_dom$Dom$render(
				A2(
					$visotype$elm_dom$Dom$appendChild,
					A2(
						$visotype$elm_dom$Dom$addClass,
						'fas fa-circle-notch fa-spin',
						$visotype$elm_dom$Dom$element('span')),
					A2(
						$visotype$elm_dom$Dom$appendChild,
						A2(
							$visotype$elm_dom$Dom$addClass,
							'modal modal-open',
							$visotype$elm_dom$Dom$element('div')),
						A2(
							$visotype$elm_dom$Dom$addClass,
							'loading-icon',
							$visotype$elm_dom$Dom$element('div')))));
		case 3:
			return $visotype$elm_dom$Dom$render(
				A2(
					$visotype$elm_dom$Dom$appendChildList,
					A2(
						$elm$core$List$map,
						function (schedule) {
							return A3($author$project$Views$Schedule$scheduleDay, schedule, model.a6, model.bQ);
						},
						model.bQ.f),
					A2(
						$visotype$elm_dom$Dom$appendChildList,
						_List_fromArray(
							[
								A2(
								$visotype$elm_dom$Dom$appendChildList,
								A2(
									$elm$core$List$map,
									function (user) {
										return A7(
											$author$project$Views$Schedule$userDisplay,
											model.bQ,
											user,
											model.a6,
											model.i7,
											'',
											$author$project$SharedProjectRoleSchedules$emptyTimeSlot,
											A3($author$project$Schedule$OntoUserInSchedule, '', $author$project$User$emptyPipelineUser, ''));
									},
									model.bQ.D),
								A2(
									$visotype$elm_dom$Dom$appendChild,
									A2(
										$visotype$elm_dom$Dom$addClass,
										'fas fa-exchange-alt',
										$visotype$elm_dom$Dom$element('span')),
									A2(
										$visotype$elm_dom$Dom$appendChild,
										A2(
											$visotype$elm_dom$Dom$appendChildList,
											_List_fromArray(
												[
													A2(
													$visotype$elm_dom$Dom$addClass,
													'fas fa-info-circle',
													$visotype$elm_dom$Dom$element('span')),
													A2(
													$visotype$elm_dom$Dom$appendText,
													$author$project$Views$Schedule$talentInfoText(model.bQ.fy),
													A2(
														$visotype$elm_dom$Dom$addClass,
														'schedule-info-container',
														$visotype$elm_dom$Dom$element('div'))),
													A2(
													$visotype$elm_dom$Dom$addClass,
													'talent-to-schedule-title',
													A2(
														$visotype$elm_dom$Dom$appendText,
														'Talent Ready to Schedule' + (' (' + ($elm$core$String$fromInt(
															$elm$core$List$length(model.bQ.D)) + ')')),
														$visotype$elm_dom$Dom$element('span')))
												]),
											A2(
												$visotype$elm_dom$Dom$addClass,
												'talent-ready-title-container',
												$visotype$elm_dom$Dom$element('div'))),
										A4(
											$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDroppable,
											model.a6,
											$author$project$Schedule$OutOfSchedule,
											$author$project$MainMsg$dragDropMessagesSchedule,
											A2(
												$visotype$elm_dom$Dom$addClass,
												'available-talent-container',
												$visotype$elm_dom$Dom$element('div'))))))
							]),
						A2(
							$visotype$elm_dom$Dom$addClass,
							'schedules-container',
							$visotype$elm_dom$Dom$element('div')))));
		case 5:
			var projectId = _v0.a;
			var scheduleId = _v0.b;
			return A3($author$project$Views$Schedule$dayOfSchedulePage, model, projectId, scheduleId);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$SharedProjectRoleSchedules$AutoSchedule = function (a) {
	return {$: 12, a: a};
};
var $author$project$SharedProjectRoleSchedules$BreakEnd = function (a) {
	return {$: 5, a: a};
};
var $author$project$SharedProjectRoleSchedules$BreakStart = function (a) {
	return {$: 4, a: a};
};
var $author$project$SharedProjectRoleSchedules$Capacity = function (a) {
	return {$: 6, a: a};
};
var $author$project$Schedule$CurrentScheduleUpdate = function (a) {
	return {$: 2, a: a};
};
var $author$project$SharedProjectRoleSchedules$ManualSchedule = function (a) {
	return {$: 13, a: a};
};
var $author$project$SharedProjectRoleSchedules$ScheduleEndTime = function (a) {
	return {$: 2, a: a};
};
var $author$project$SharedProjectRoleSchedules$ScheduleStartTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$SharedProjectRoleSchedules$ScheduleType = function (a) {
	return {$: 0, a: a};
};
var $author$project$SharedProjectRoleSchedules$SearchRoles = function (a) {
	return {$: 8, a: a};
};
var $author$project$SharedProjectRoleSchedules$TimeIncrements = function (a) {
	return {$: 3, a: a};
};
var $author$project$SharedProjectRoleSchedules$ToggleSelectionList = function (a) {
	return {$: 9, a: a};
};
var $author$project$MainMsg$UpdateSchedulePageData = function (a) {
	return {$: 197, a: a};
};
var $author$project$SharedProjectRoleSchedules$AddAllScheduleRoles = {$: 11};
var $author$project$Views$Schedule$addAllOption = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('add-all-button'),
			$elm$html$Html$Events$onClick(
			$author$project$MainMsg$UpdateSchedulePageData(
				$author$project$Schedule$CurrentScheduleUpdate($author$project$SharedProjectRoleSchedules$AddAllScheduleRoles)))
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('ADD ALL')
		]));
var $author$project$Views$Schedule$timeOptionField = F2(
	function (time, picked) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(time.ba),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(picked, time.ba))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(time.b)
				]));
	});
var $author$project$InitData$hourValues = A2($elm$core$List$range, 0, 23);
var $author$project$InitData$minuteValues = _List_fromArray(
	[0, 10, 20, 30, 40, 50]);
var $author$project$InitData$timeValues = A2(
	$elm$core$List$concatMap,
	function (hour) {
		return A2(
			$elm$core$List$map,
			function (minute) {
				var formattedMinute = (!minute) ? '00' : $elm$core$String$fromInt(minute);
				var _v0 = (hour > 12) ? _Utils_Tuple2(
					$elm$core$String$fromInt(hour - 12),
					'PM') : ((hour === 12) ? _Utils_Tuple2(
					$elm$core$String$fromInt(hour),
					'PM') : ((!hour) ? _Utils_Tuple2('12', 'AM') : _Utils_Tuple2(
					$elm$core$String$fromInt(hour),
					'AM')));
				var formattedHour = _v0.a;
				var ending = _v0.b;
				return {
					b: formattedHour + (':' + (formattedMinute + ending)),
					ba: $elm$core$String$fromInt(hour) + ('.' + formattedMinute)
				};
			},
			$author$project$InitData$minuteValues);
	},
	$author$project$InitData$hourValues);
var $author$project$Views$Schedule$toFloat = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toFloat(value));
};
var $author$project$Views$Schedule$breakEndOptions = F3(
	function (breakStartTime, scheduleEndTime, picked) {
		if ($author$project$Views$Schedule$toFloat(breakStartTime) > 0) {
			var breakValues = A2(
				$elm$core$List$filter,
				function (time) {
					return (_Utils_cmp(
						$author$project$Views$Schedule$toFloat(time.ba),
						$author$project$Views$Schedule$toFloat(breakStartTime)) > -1) && (_Utils_cmp(
						$author$project$Views$Schedule$toFloat(time.ba),
						$author$project$Views$Schedule$toFloat(scheduleEndTime)) < 0);
				},
				$author$project$InitData$timeValues);
			return A2(
				$elm$core$List$map,
				function (time) {
					return A2($author$project$Views$Schedule$timeOptionField, time, picked);
				},
				A2(
					$elm$core$List$cons,
					{b: '', ba: ''},
					breakValues));
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(''),
							$elm$html$Html$Attributes$selected(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select Break Start Time')
						]))
				]);
		}
	});
var $author$project$Views$Schedule$breakOptions = F3(
	function (startTime, endTime, picked) {
		if (($author$project$Views$Schedule$toFloat(startTime) >= 0) && ($author$project$Views$Schedule$toFloat(endTime) >= 0)) {
			var breakValues = A2(
				$elm$core$List$filter,
				function (time) {
					return (_Utils_cmp(
						$author$project$Views$Schedule$toFloat(time.ba),
						$author$project$Views$Schedule$toFloat(startTime)) > 0) && (_Utils_cmp(
						$author$project$Views$Schedule$toFloat(time.ba),
						$author$project$Views$Schedule$toFloat(endTime)) < 0);
				},
				$author$project$InitData$timeValues);
			return A2(
				$elm$core$List$map,
				function (time) {
					return A2($author$project$Views$Schedule$timeOptionField, time, picked);
				},
				A2(
					$elm$core$List$cons,
					{b: '', ba: ''},
					breakValues));
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(''),
							$elm$html$Html$Attributes$selected(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select Schedule Start And End Times')
						]))
				]);
		}
	});
var $author$project$Views$Schedule$endTimeOptions = F2(
	function (startTime, picked) {
		if ($author$project$Views$Schedule$toFloat(startTime) >= 0) {
			var endingTimeValues = A2(
				$elm$core$List$filter,
				function (time) {
					return _Utils_cmp(
						$author$project$Views$Schedule$toFloat(time.ba),
						$author$project$Views$Schedule$toFloat(startTime)) > -1;
				},
				$author$project$InitData$timeValues);
			return A2(
				$elm$core$List$map,
				function (time) {
					return A2($author$project$Views$Schedule$timeOptionField, time, picked);
				},
				A2(
					$elm$core$List$cons,
					{b: '', ba: ''},
					endingTimeValues));
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(''),
							$elm$html$Html$Attributes$selected(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select Start Time')
						]))
				]);
		}
	});
var $author$project$SharedProjectRoleSchedules$RemoveAllScheduleRoles = {$: 10};
var $author$project$Views$Schedule$removeAllOption = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('remove-all-button'),
			$elm$html$Html$Events$onClick(
			$author$project$MainMsg$UpdateSchedulePageData(
				$author$project$Schedule$CurrentScheduleUpdate($author$project$SharedProjectRoleSchedules$RemoveAllScheduleRoles)))
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('REMOVE ALL')
		]));
var $author$project$Views$Schedule$scheduleFormHeader = function (scheduleId) {
	return $author$project$Views$Project$updating(scheduleId) ? A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Edit Current Schedule')
			])) : A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Create New Schedule')
			]));
};
var $author$project$MainMsg$VerifySchedule = {$: 195};
var $author$project$Views$Schedule$scheduleSubmitButton = function (scheduleId) {
	return $author$project$Views$Project$updating(scheduleId) ? A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$VerifySchedule),
				$elm$html$Html$Attributes$class('next-step-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('UPDATE SCHEDULE')
			])) : A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$VerifySchedule),
				$elm$html$Html$Attributes$class('next-step-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('CREATE SCHEDULE')
			]));
};
var $author$project$Views$Schedule$scheduleTypeInput = function (model) {
	return (model.fy === 'Audition') ? A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value('Audition')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Audition')
			])) : A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value('Callback')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Callback')
			]));
};
var $author$project$Views$Schedule$selectIntField = F2(
	function (num, picked) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(num)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						picked,
						$elm$core$String$fromInt(num)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(num))
				]));
	});
var $author$project$SharedProjectRoleSchedules$RoleInput = function (a) {
	return {$: 7, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$checkCircle = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('check-circle');
var $author$project$Views$Schedule$selectOption = F2(
	function (role, selectedList) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$UpdateSchedulePageData(
						$author$project$Schedule$CurrentScheduleUpdate(
							$author$project$SharedProjectRoleSchedules$RoleInput(role)))),
					$elm$html$Html$Attributes$class('role-option')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selected-icon', true),
									_Utils_Tuple2(
									'role-selected',
									A2($elm$core$List$member, role, selectedList))
								]))
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$checkCircle)
						])),
					$elm$html$Html$text(role)
				]));
	});
var $author$project$SharedProjectRoleSchedules$ToggleAllSelectedItems = {$: 14};
var $frandibar$elm_font_awesome_5$FontAwesome$timesCircle = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('times-circle');
var $author$project$Views$Schedule$selectedItem = function (item) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('selected-item'),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$UpdateSchedulePageData(
					$author$project$Schedule$CurrentScheduleUpdate(
						$author$project$SharedProjectRoleSchedules$RoleInput(item))))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(item),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$timesCircle)
					]))
			]));
};
var $author$project$Views$Schedule$selectedItems = F2(
	function (items, showingAllItems) {
		return ($elm$core$List$length(items) <= 3) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selected-items-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selected-text', true),
									_Utils_Tuple2(
									'selected-text-showing',
									$elm$core$List$length(items) > 0)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('ROLES:')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selected-item-list')
						]),
					A2($elm$core$List$map, $author$project$Views$Schedule$selectedItem, items))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selected-items-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('ROLES:')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selected-item-list')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Views$Schedule$selectedItem,
						A2($elm$core$List$take, 3, items))),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateSchedulePageData(
								$author$project$Schedule$CurrentScheduleUpdate($author$project$SharedProjectRoleSchedules$ToggleAllSelectedItems))),
							$elm$html$Html$Attributes$class('additional-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'+' + ($elm$core$String$fromInt(
								$elm$core$List$length(
									A2($elm$core$List$drop, 3, items))) + ' more'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateSchedulePageData(
								$author$project$Schedule$CurrentScheduleUpdate($author$project$SharedProjectRoleSchedules$ToggleAllSelectedItems))),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('all-options-modal', true),
									_Utils_Tuple2('all-options-modal-showing', showingAllItems)
								]))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('all-selected-item-list', true),
									_Utils_Tuple2('all-selected-items-showing', showingAllItems)
								]))
						]),
					A2($elm$core$List$map, $author$project$Views$Schedule$selectedItem, items))
				]));
	});
var $author$project$Views$Schedule$timeIncrementField = F2(
	function (increment, picked) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(increment.ba)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						picked,
						$elm$core$String$fromInt(increment.ba)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(increment.b)
				]));
	});
var $author$project$InitData$timeIncrements = _List_fromArray(
	[
		{b: '10 Minutes', ba: 10},
		{b: '20 Minutes', ba: 20},
		{b: '30 Minutes', ba: 30},
		{b: '40 Minutes', ba: 40},
		{b: '50 Minutes', ba: 50},
		{b: '1 Hour', ba: 60}
	]);
var $author$project$Views$Schedule$warningMessage = function (scheduleId) {
	return $author$project$Views$Project$updating(scheduleId) ? A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('warning-message')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('WARNING: Editing schedule will override existing schedule.')
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Schedule$scheduleFormView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Views$Schedule$modal,
				model.bQ.bP === 1,
				$author$project$MainMsg$ToggleScheduleForm(0)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('create-project-modal', true),
								_Utils_Tuple2('schedule-form', true),
								_Utils_Tuple2('form-hiding', model.bQ.bP !== 1)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('create-project-header')
							]),
						_List_fromArray(
							[
								$author$project$Views$Schedule$scheduleFormHeader(model.bQ.aX.V),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('exit-schedule-form'),
										$elm$html$Html$Events$onClick(
										$author$project$MainMsg$ToggleScheduleForm(0))
									]),
								_List_fromArray(
									[
										$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$times)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('schedule-form-errors', true),
												_Utils_Tuple2('schedule-form-errors-showing', model.bQ.fw)
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('PLEASE MAKE SURE ALL FIELDS ARE FILLED OUT')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('schedule-project-info')
							]),
						_List_fromArray(
							[
								$author$project$Views$Schedule$warningMessage(model.bQ.aX.V),
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(model.bQ.ae.bH)
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Schedule Dates: ' + ($author$project$Utils$formatDate(model.bQ.fO) + (' - ' + $author$project$Utils$formatDate(model.bQ.d8))))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-inputs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule Type')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field'),
												$elm$html$Html$Attributes$value(model.bQ.fy),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$ScheduleType))
											]),
										_List_fromArray(
											[
												$author$project$Views$Schedule$scheduleTypeInput(model.bQ)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule Start Time')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field'),
												$elm$html$Html$Attributes$value(model.bQ.aX.jk),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$ScheduleStartTime))
											]),
										A2(
											$elm$core$List$map,
											function (time) {
												return A2($author$project$Views$Schedule$timeOptionField, time, model.bQ.aX.jk);
											},
											A2(
												$elm$core$List$cons,
												{b: '', ba: ''},
												$author$project$InitData$timeValues)))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule End Time')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field'),
												$elm$html$Html$Attributes$value(model.bQ.aX.hi),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$ScheduleEndTime))
											]),
										A2($author$project$Views$Schedule$endTimeOptions, model.bQ.aX.jk, model.bQ.aX.hi))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule Break Start Time')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field half-input'),
												$elm$html$Html$Attributes$value(model.bQ.aX.gF),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$BreakStart))
											]),
										A3($author$project$Views$Schedule$breakOptions, model.bQ.aX.jk, model.bQ.aX.hi, model.bQ.aX.gF))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule Break End Time')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field half-input'),
												$elm$html$Html$Attributes$value(model.bQ.aX.gE),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$BreakEnd))
											]),
										A3($author$project$Views$Schedule$breakEndOptions, model.bQ.aX.gF, model.bQ.aX.hi, model.bQ.aX.gE))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule Increment')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field half-input'),
												$elm$html$Html$Attributes$value(
												$elm$core$String$fromInt(model.bQ.aX.jC)),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$TimeIncrements))
											]),
										A2(
											$elm$core$List$map,
											function (increment) {
												return A2(
													$author$project$Views$Schedule$timeIncrementField,
													increment,
													$elm$core$String$fromInt(model.bQ.aX.jC));
											},
											A2(
												$elm$core$List$cons,
												{b: '', ba: 0},
												$author$project$InitData$timeIncrements)))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Talent Per Time slot')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field half-input'),
												$elm$html$Html$Attributes$value(
												$elm$core$String$fromInt(model.bQ.aX.gK)),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$Capacity))
											]),
										A2(
											$elm$core$List$map,
											function (num) {
												return A2(
													$author$project$Views$Schedule$selectIntField,
													num,
													$elm$core$String$fromInt(model.bQ.aX.gK));
											},
											A2($elm$core$List$range, 1, 10)))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('radio-button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Auto Schedule'),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$value('True'),
														$elm$html$Html$Attributes$name('autoSchedule'),
														$elm$html$Html$Events$onCheck(
														A2(
															$elm$core$Basics$composeL,
															A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
															$author$project$SharedProjectRoleSchedules$AutoSchedule)),
														$elm$html$Html$Attributes$checked(model.bQ.gB)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('radio-button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manual Schedule'),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$value('False'),
														$elm$html$Html$Attributes$name('autoSchedule'),
														$elm$html$Html$Events$onCheck(
														A2(
															$elm$core$Basics$composeL,
															A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
															$author$project$SharedProjectRoleSchedules$ManualSchedule)),
														$elm$html$Html$Attributes$checked(!model.bQ.gB)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Manual Schedule')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('auto-options', true),
												_Utils_Tuple2('auto-options-showing', model.bQ.gB)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('multi-select-container')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Roles to auto schedule')
													])),
												$author$project$Views$Schedule$removeAllOption,
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Attributes$placeholder('Search Roles'),
														$elm$html$Html$Events$onInput(
														A2(
															$elm$core$Basics$composeL,
															A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
															$author$project$SharedProjectRoleSchedules$SearchRoles)),
														$elm$html$Html$Events$onFocus(
														A2(
															$elm$core$Basics$composeL,
															A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
															$author$project$SharedProjectRoleSchedules$ToggleSelectionList)(true)),
														$elm$html$Html$Attributes$value(model.bQ.aX.i_)
													]),
												_List_Nil),
												A2($author$project$Views$Schedule$selectedItems, model.bQ.aX.fq, model.bQ.fJ),
												$author$project$Views$Schedule$addAllOption,
												A2(
												$elm$html$Html$ul,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('selection-list', true),
																_Utils_Tuple2('selection-list-open', model.bQ.ja)
															]))
													]),
												A2(
													$elm$core$List$map,
													function (role) {
														return A2($author$project$Views$Schedule$selectOption, role, model.bQ.aX.fq);
													},
													model.bQ.aX.da))
											]))
									])),
								$author$project$Views$Schedule$scheduleSubmitButton(model.bQ.aX.V)
							]))
					]))
			]));
};
var $author$project$MainMsg$ChangeSchedule = function (a) {
	return {$: 216, a: a};
};
var $author$project$Views$Schedule$addCollaboratorButton = function (model) {
	return (!_Utils_eq(model.z.cU, model.bQ.b6.g_)) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('add-collab-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('add-collaborators-button', true),
								_Utils_Tuple2('showing-add-collaborator-button', model.bQ.b6.fy !== '')
							])),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateCollaboratorData($author$project$SharedProjectRoleSchedules$ToggleCollabForm))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-plus')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Add Collaborators')
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' | ')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('current-collab-button'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleCollaboratorsModal)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Current Collaborators')
					]))
			]));
};
var $author$project$Views$Schedule$scheduleToggleFields = function (model) {
	var deadlines = $author$project$Project$dnames(model.bQ.ae.hb);
	return (A2($elm$core$List$member, 'Audition', deadlines) && A2($elm$core$List$member, 'Callback', deadlines)) ? _List_fromArray(
		['Audition', 'Callback']) : (A2($elm$core$List$member, 'Audition', deadlines) ? _List_fromArray(
		['Audition']) : _List_fromArray(
		['Callback']));
};
var $author$project$Views$Schedule$selectField = F2(
	function (item, picked) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(picked, item))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item)
				]));
	});
var $author$project$Views$Schedule$scheduleHeader = function (model) {
	var _v0 = model.bQ.aE;
	if (_v0.$ === 5) {
		var projectId = _v0.a;
		var scheduleId = _v0.b;
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('schedule-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-type')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									model.bQ.b6.fy + (' (' + ($elm$core$String$fromInt(
										$elm$core$List$length(
											A2(
												$elm$core$List$filter,
												function (timeSlot) {
													return timeSlot.f_.cU !== '';
												},
												model.bQ.b6.jD))) + ')')))
								])),
							$author$project$Views$Schedule$addCollaboratorButton(model)
						]))
				]));
	} else {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('schedule-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('select-field'),
									$elm$html$Html$Attributes$value(model.bQ.fy),
									$elm$html$Html$Events$onInput($author$project$MainMsg$ChangeSchedule)
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									return A2($author$project$Views$Schedule$selectField, option, model.bQ.fy);
								},
								$author$project$Views$Schedule$scheduleToggleFields(model))),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('toggle-schedule-type-icon')
								]),
							_List_fromArray(
								[
									$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronDown)
								]))
						]))
				]));
	}
};
var $author$project$Views$Schedule$addEditScheduleButton = function (scheduleData) {
	return (!$elm$core$List$length(scheduleData.f)) ? A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('project-menu-header-container', true)
					])),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$ToggleScheduleForm(1))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h5,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('schedule-menu-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('NEW SCHEDULE')
					]))
			])) : A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('project-menu-header-container', true)
					])),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$ToggleScheduleForm(1))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h5,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('schedule-menu-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('REDO SCHEDULE')
					]))
			]));
};
var $author$project$Views$Schedule$backToSchedulesButton = F2(
	function (projId, model) {
		return (!_Utils_eq(model.bQ.b6.g_, model.z.cU)) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('schedule-menu-header', true),
							_Utils_Tuple2('back-to-project-button', true)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$View(
						A2($author$project$Route$SchedulePage, projId, model.bQ.b6.fy)))
				]),
			_List_fromArray(
				[
					$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft),
					$elm$html$Html$text(' Back to all schedules')
				]));
	});
var $author$project$Views$Schedule$newScheduleButton = function (projectId) {
	return ($elm$core$String$length(projectId) > 0) ? A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('project-menu-header-container', true)
					])),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$ToggleScheduleForm(1))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h5,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('schedule-menu-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('NEW SCHEDULE')
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Schedule$optionField = F2(
	function (project, picked) {
		return ($author$project$Project$hasAudCallDates(
			$author$project$Project$dnames(project.hb)) && project.hK) ? A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(project.cU),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(picked, project.cU))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(project.bH)
				])) : ((project.cU === '') ? A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(''),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(picked, project.cU))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('SELECT PROJECT')
				])) : $elm$html$Html$text(''));
	});
var $author$project$Project$getDefaultScheduleTypeFromProjectId = F2(
	function (projectId, projects) {
		return $author$project$Project$defaultScheduleType(
			$author$project$Project$dnames(
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.hb;
					},
					A2(
						$elm$core$List$filter,
						A2(
							$author$project$Utils$eq,
							function ($) {
								return $.cU;
							},
							projectId),
						projects))));
	});
var $author$project$Views$Schedule$pageToView = F2(
	function (selection, projects) {
		return (selection !== '') ? A2(
			$author$project$Route$SchedulePage,
			selection,
			A2($author$project$Project$getDefaultScheduleTypeFromProjectId, selection, projects)) : $author$project$Route$ScheduleIndex;
	});
var $author$project$Views$Schedule$publishScheduleButton = function (scheduleData) {
	return (!A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptySchedule,
		$elm$core$List$head(scheduleData.f)).a3) ? A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('project-menu-header-container', true)
					])),
				$elm$html$Html$Events$onClick($author$project$MainMsg$TogglePublishConfirmationModal)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h5,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('schedule-menu-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('PUBLISH SCHEDULE')
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Schedule$scheduleLi = F3(
	function (schedule, projectId, viewingScheduleId) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('schedule-item', true),
							_Utils_Tuple2(
							'current-schedule-page',
							_Utils_eq(viewingScheduleId, schedule.V))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$View(
						A2($author$project$Route$DayOfPage, projectId, schedule.V)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(schedule.fv)
				]));
	});
var $author$project$Views$Schedule$scheduleMenuList = F4(
	function (projectId, title, schedules, viewingSchedule) {
		return ($elm$core$List$length(schedules) > 0) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('schedule-list', true)
								]))
						]),
					A2(
						$elm$core$List$map,
						function (schedule) {
							return A3($author$project$Views$Schedule$scheduleLi, schedule, projectId, viewingSchedule);
						},
						schedules))
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$Schedule$scheduleLists = F3(
	function (projectId, project, viewingSchedule) {
		var callbackSchedules = A2(
			$elm$core$List$filter,
			function (schedule) {
				return (schedule.fy === 'Callback') && schedule.a3;
			},
			project.f);
		var auditionSchedules = A2(
			$elm$core$List$filter,
			function (schedule) {
				return (schedule.fy === 'Audition') && schedule.a3;
			},
			project.f);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-schedules')
				]),
			_List_fromArray(
				[
					A4($author$project$Views$Schedule$scheduleMenuList, projectId, 'Live Audition Schedules', auditionSchedules, viewingSchedule),
					A4($author$project$Views$Schedule$scheduleMenuList, projectId, 'Live Callback Schedules', callbackSchedules, viewingSchedule)
				]));
	});
var $author$project$Views$Schedule$scheduleMenu = F2(
	function (model, projectId) {
		var _v0 = model.bQ.aE;
		switch (_v0.$) {
			case 0:
				return A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-select')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$select,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('select-field'),
													$elm$html$Html$Attributes$value(projectId),
													$elm$html$Html$Events$onInput(
													function (selection) {
														return $author$project$MainMsg$View(
															A2($author$project$Views$Schedule$pageToView, selection, model.A));
													})
												]),
											A2(
												$elm$core$List$map,
												function (project) {
													return A2($author$project$Views$Schedule$optionField, project, projectId);
												},
												A2($elm$core$List$cons, $author$project$SharedProjectRoleSchedules$emptyProject, model.A))),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-drop-down-icon')
												]),
											_List_fromArray(
												[
													$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronDown)
												]))
										])),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('schedule-menu-header', true),
													_Utils_Tuple2('back-to-project-button', true)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$UpdateCurrentProjectId(projectId))
										]),
									_List_fromArray(
										[
											$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft),
											$elm$html$Html$text(' Back To Project')
										])),
									$author$project$Views$Schedule$newScheduleButton(model.bQ.ae.cU)
								]))
						]));
			case 3:
				var projectData = _v0.a;
				var scheduleType = _v0.b;
				return A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-select')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$select,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('select-field'),
													$elm$html$Html$Attributes$value(projectId),
													$elm$html$Html$Events$onInput(
													function (selection) {
														return $author$project$MainMsg$View(
															A2($author$project$Views$Schedule$pageToView, selection, model.A));
													})
												]),
											A2(
												$elm$core$List$map,
												function (project) {
													return A2($author$project$Views$Schedule$optionField, project, projectId);
												},
												A2($elm$core$List$cons, $author$project$SharedProjectRoleSchedules$emptyProject, model.A))),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-drop-down-icon')
												]),
											_List_fromArray(
												[
													$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronDown)
												]))
										])),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('schedule-menu-header', true),
													_Utils_Tuple2('back-to-project-button', true)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$UpdateCurrentProjectId(projectData.cU))
										]),
									_List_fromArray(
										[
											$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft),
											$elm$html$Html$text(' Back To Project')
										])),
									$author$project$Views$Schedule$addEditScheduleButton(model.bQ),
									$author$project$Views$Schedule$publishScheduleButton(model.bQ),
									A3($author$project$Views$Schedule$scheduleLists, projectId, model.bQ.ae, model.bQ.b6.V)
								]))
						]));
			case 5:
				var projId = _v0.a;
				var scheduleId = _v0.b;
				return A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-select')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('day-of-schedule-project-name')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(model.bQ.ae.bH)
												]))
										])),
									A2($author$project$Views$Schedule$backToSchedulesButton, projId, model),
									A3($author$project$Views$Schedule$scheduleLists, projId, model.bQ.ae, model.bQ.b6.V)
								]))
						]));
			default:
				return A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-select')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$select,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('select-field'),
													$elm$html$Html$Attributes$value(model.bQ.ae.cU),
													$elm$html$Html$Events$onInput(
													function (selection) {
														return $author$project$MainMsg$View(
															A2($author$project$Route$SchedulePage, selection, 'Audition'));
													})
												]),
											A2(
												$elm$core$List$map,
												function (project) {
													return A2($author$project$Views$Schedule$optionField, project, model.bQ.ae.cU);
												},
												A2($elm$core$List$cons, $author$project$SharedProjectRoleSchedules$emptyProject, model.A))),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-drop-down-icon')
												]),
											_List_fromArray(
												[
													$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronDown)
												]))
										])),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('project-menu-header-container', true)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$ToggleScheduleForm(1))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h5,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('schedule-menu-button')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('NEW SCHEDULE')
												]))
										])),
									A2($elm$html$Html$li, _List_Nil, _List_Nil)
								]))
						]));
		}
	});
var $author$project$MainMsg$RemoveAddPublishedUser = function (a) {
	return {$: 213, a: a};
};
var $author$project$MainMsg$RemoveAddUser = function (a) {
	return {$: 211, a: a};
};
var $author$project$MainMsg$SwapPublishedUsers = function (a) {
	return {$: 212, a: a};
};
var $author$project$MainMsg$SwapUsers = function (a) {
	return {$: 210, a: a};
};
var $author$project$Views$Schedule$userSwapMenu = function (model) {
	var _v0 = function () {
		var _v1 = $author$project$Views$Schedule$schedulePublished(model.bQ.f);
		if (_v1) {
			return _Utils_Tuple3('You are trying to make changes to a published Schedule!', $author$project$MainMsg$SwapPublishedUsers, $author$project$MainMsg$RemoveAddPublishedUser);
		} else {
			return _Utils_Tuple3('Looks like that time slot is taken!', $author$project$MainMsg$SwapUsers, $author$project$MainMsg$RemoveAddUser);
		}
	}();
	var modalText = _v0.a;
	var swapAction = _v0.b;
	var removeAction = _v0.c;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('user-swap-menu', true),
						_Utils_Tuple2('showing-swap-menu', model.bQ.f2.bn)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(modalText)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('What do you want to do?')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('swap-action-button'),
						$elm$html$Html$Events$onClick(
						swapAction(model.bQ.f2))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Swap Users')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('swap-action-button'),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$CloseUserSwapMenu($author$project$SharedProjectRoleSchedules$emptyUserSwapData))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					]))
			]));
};
var $author$project$MainMsg$CreateSchedule = {$: 194};
var $author$project$Views$Schedule$autoScheduleRoles = F2(
	function (roles, autoSchedule) {
		return autoSchedule ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The following Roles will be allowed to be scheduled: ')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('auto-schedule-roles')
						]),
					A2(
						$elm$core$List$map,
						function (role) {
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(role)
									]));
						},
						roles))
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$Schedule$findTime = function (modelTime) {
	return A2(
		$elm$core$Maybe$withDefault,
		{b: 'No Time Specified', ba: ''},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (time) {
					return _Utils_eq(time.ba, modelTime);
				},
				$author$project$InitData$timeValues))).b;
};
var $author$project$Views$Schedule$verifyScheduleView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('verify-schedule-container', true),
						_Utils_Tuple2('form-hiding', model.bQ.bP !== 2)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verify-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'PLEASE VERIFY ' + ($elm$core$String$toUpper(model.bQ.fy) + ' SCHEDULE'))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Schedule Dates: ' + ($author$project$Utils$formatDate(model.bQ.fO) + (' - ' + $author$project$Utils$formatDate(model.bQ.d8))))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Your Schedules will start at: ' + $author$project$Views$Schedule$findTime(model.bQ.aX.jk))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Your Schedules will End at: ' + $author$project$Views$Schedule$findTime(model.bQ.aX.hi))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'You have a break starting at: ' + $author$project$Views$Schedule$findTime(model.bQ.aX.gF))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Your break will end at: ' + $author$project$Views$Schedule$findTime(model.bQ.aX.gE))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'The times will be broken up by ' + ($elm$core$String$fromInt(model.bQ.aX.jC) + ' minute increments'))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'You can schedule a maximum of ' + ($elm$core$String$fromInt(model.bQ.aX.gK) + ' talent per time slot'))
					])),
				A2($author$project$Views$Schedule$autoScheduleRoles, model.bQ.aX.fq, model.bQ.gB),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verify-schedule-container-buttons')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleScheduleForm(1))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit Schedule')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$CreateSchedule)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create Schedule')
							]))
					]))
			]));
};
var $author$project$Views$Schedule$scheduleIndexView = F4(
	function (model, projectId, scheduleType, confirmationOpen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-details-page')
				]),
			_List_fromArray(
				[
					A2($author$project$Views$Schedule$scheduleMenu, model, projectId),
					$author$project$Views$Schedule$scheduleFormView(model),
					$author$project$Views$Schedule$verifyScheduleView(model),
					A2(
					$author$project$Views$Schedule$modal,
					model.bQ.bP === 2,
					$author$project$MainMsg$ToggleScheduleForm(0)),
					$author$project$Views$Schedule$savingScheduleView(model),
					$author$project$Views$Schedule$scheduleHeader(model),
					$author$project$Views$Schedule$scheduleContainer(model),
					$author$project$Views$Schedule$userSwapMenu(model),
					$author$project$Views$Schedule$movePublishedUserModal(model),
					A2($author$project$Views$Schedule$modal, (!model.cm) || (model.cm === 1), $author$project$MainMsg$ClosedPublishedModal),
					A2(
					$author$project$Views$Schedule$modal,
					model.bQ.f2.bn,
					$author$project$MainMsg$CloseUserSwapMenu($author$project$SharedProjectRoleSchedules$emptyUserSwapData)),
					$author$project$Views$Schedule$publishConfirmationModal(confirmationOpen),
					$author$project$Views$TalentModal$talentSearchResultModal(model.p)(model.bh)(model.w)(model.aH)(model.aD)(model.cB)(model.v)(
					$author$project$Views$Schedule$currentPage(model.i))(
					_List_fromArray(
						[$author$project$SharedProjectRoleSchedules$emptyProject]))(
					_List_fromArray(
						[$author$project$SharedProjectRoleSchedules$emptyRole]))(model.aO)(model.d_)(model.bQ.ae)(model.a5.ie)(model.au)(model.z)(model.y.dG)(model.bQ.b6.g_)(model.bQ)(model.cK)(model.cv)(model.cC)(model.ca)
				]));
	});
var $author$project$Views$Auth$talentSignupForm = function (email) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserFirstName)),
								$elm$html$Html$Attributes$placeholder('First Name')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserLastName)),
								$elm$html$Html$Attributes$placeholder('Last Name')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(email),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserEmail)),
								$elm$html$Html$Attributes$placeholder('Email')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPassword)),
								$elm$html$Html$Attributes$placeholder('Password'),
								$elm$html$Html$Attributes$type_('password')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPasswordConfirmation)),
								$elm$html$Html$Attributes$placeholder('Confirm Password'),
								$elm$html$Html$Attributes$type_('password')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Views$Auth$talentSignupView = F3(
	function (err, email, logoPath) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Talent Registration Sign Up')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									$author$project$Views$Auth$talentSignupForm(email),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$RegisterUser),
													$elm$html$Html$Attributes$class('button full')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('NEXT')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-switch-container')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Already have an account?'),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$Login)),
											$elm$html$Html$Attributes$class('link-button signup-switch')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Login »')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sign-up-options')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$DirectorRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch casting-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Casting Director Sign-Up »')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$AgencyRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch casting-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Agency Sign-Up »')
										]))
								]))
						]))
				]));
	});
var $author$project$Project$BulkNew = 2;
var $author$project$Project$New = 0;
var $author$project$MainMsg$UpdateTalentFilterExpand = function (a) {
	return {$: 247, a: a};
};
var $author$project$Views$UpdatedTalentSearch$expandMenuButton = function (menuExpanded) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('expand-menu-button', true),
						_Utils_Tuple2('showing-expand-button', !menuExpanded)
					])),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$UpdateTalentFilterExpand(7))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-chevron-right')
					]),
				_List_Nil)
			]));
};
var $author$project$Views$UpdatedTalentSearch$selectedTalentView = function (selections) {
	return function (view) {
		return function (action) {
			return function (projects) {
				return function (roles) {
					return function (pipeline) {
						return function (actionSet) {
							return function (projectId) {
								return function (twilioStatus) {
									return function (userProfile) {
										return function (newMessageBody) {
											switch (view) {
												case 0:
													return A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('selection-container')
																	]),
																_List_Nil)
															]));
												case 2:
													return A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('modal-open'),
																		$elm$html$Html$Events$onClick(
																		$author$project$MainMsg$ToggleCandidateScreen(1))
																	]),
																_List_Nil),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2('full-selections-container', true),
																				_Utils_Tuple2('selections-full', true)
																			]))
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$h2,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Selections')
																			])),
																		A2(
																		$elm$html$Html$ul,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('candidates-full-screen')
																			]),
																		A2(
																			$elm$core$List$map,
																			function (talent) {
																				return A5(
																					$author$project$Utils$talentCard,
																					talent,
																					selections,
																					A3($author$project$MainMsg$ToggleTalentResultModal, talent, $author$project$Job$emptyApplicant, ''),
																					A2($author$project$MainMsg$ToggleSelectedTalent, talent.cU, talent),
																					$author$project$MainMsg$UpdateTalentMenuOptions(
																						$author$project$User$ToggleMenuModal(talent)));
																			},
																			selections)),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('bulk-quick-actions-container')
																			]),
																		_List_fromArray(
																			[
																				$author$project$Views$TalentModal$quickActionBar(action)($author$project$User$emptySearchTalentProfile)(selections)($author$project$Job$emptyApplicant)(pipeline)(actionSet)(projects)(roles)(projectId)('')($author$project$SharedProjectRoleSchedules$emptyProject)('')(twilioStatus)(userProfile)(newMessageBody)('')($author$project$SharedProjectRoleSchedules$initialSchedulePageData)
																			]))
																	]))
															]));
												default:
													return $elm$html$Html$text('');
											}
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Filter$UpdateEyeColorFilters = function (a) {
	return {$: 9, a: a};
};
var $author$project$Filter$UpdateGenderFilters = function (a) {
	return {$: 8, a: a};
};
var $author$project$Filter$UpdateMaxAge = function (a) {
	return {$: 7, a: a};
};
var $author$project$Filter$UpdateMaxHeight = function (a) {
	return {$: 2, a: a};
};
var $author$project$Filter$UpdateMaxWaistSize = function (a) {
	return {$: 5, a: a};
};
var $author$project$Filter$UpdateMaxWeight = function (a) {
	return {$: 3, a: a};
};
var $author$project$Filter$UpdateMinAge = function (a) {
	return {$: 6, a: a};
};
var $author$project$Filter$UpdateMinHeight = function (a) {
	return {$: 1, a: a};
};
var $author$project$Filter$UpdateMinWaistSize = function (a) {
	return {$: 4, a: a};
};
var $author$project$Filter$UpdateMinWeight = function (a) {
	return {$: 0, a: a};
};
var $author$project$Filter$UpdateRaceFilters = function (a) {
	return {$: 10, a: a};
};
var $author$project$InitData$ethnicity = _List_fromArray(
	['African American', 'Asian', 'Caucasian', 'East Indian', 'Latinx', 'Middle Eastern', 'Ethnically Ambiguous', 'Native American', 'Pacific Islander']);
var $author$project$Views$UpdatedTalentSearch$menuOpen = function (expanded) {
	return expanded ? $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$minus) : $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$plus);
};
var $author$project$MainMsg$UpdateSearchingProject = function (a) {
	return {$: 313, a: a};
};
var $author$project$Views$UpdatedTalentSearch$projectSelection = function (model) {
	var roleOptions = A2(
		$elm$core$List$map,
		function (role) {
			return {V: role.cU, bH: role.bH};
		},
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.gg;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.iH;
					},
					model.Y),
				model.aw)));
	var projectOptions = A2(
		$elm$core$List$map,
		function (project) {
			return {V: project.cU, bH: project.bH};
		},
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.hK;
			},
			model.A));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('project-search-selection')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Views$Form$agencySelectField,
				$author$project$MainMsg$UpdateSearchingProject,
				'Project',
				A2(
					$elm$core$List$cons,
					{V: '', bH: 'Select Project'},
					projectOptions),
				model.Y),
				A4(
				$author$project$Views$Form$agencySelectField,
				$author$project$MainMsg$UpdateSearchingRole,
				'Role',
				A2(
					$elm$core$List$cons,
					{V: '', bH: 'Select Role'},
					roleOptions),
				model.br)
			]));
};
var $author$project$MainMsg$UpdateTalentFilterValues = function (a) {
	return {$: 73, a: a};
};
var $author$project$Views$UpdatedTalentSearch$filterCheckboxOption = F3(
	function (option, filterType, selectedOptions) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filter-option-container'),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$UpdateTalentFilterValues(
						filterType(option)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'option-selected',
									A2($elm$core$List$member, option, selectedOptions)),
									_Utils_Tuple2('check-icon', true)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('far fa-check-circle')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(option)
						]))
				]));
	});
var $author$project$Views$UpdatedTalentSearch$talentCheckboxFilterOption = F6(
	function (filterName, options, filterMsg, selectedOptions, expanded, filterExpandMsg) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-filter-option')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-filter-header'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateTalentFilterExpand(filterExpandMsg))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('filter-title-reset-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h5,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(filterName)
										]))
								])),
							$author$project$Views$UpdatedTalentSearch$menuOpen(expanded)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('filter-options', true),
									_Utils_Tuple2('filter-options-expanded', expanded)
								]))
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A3($author$project$Views$UpdatedTalentSearch$filterCheckboxOption, option, filterMsg, selectedOptions);
						},
						options))
				]));
	});
var $author$project$Views$UpdatedTalentSearch$floatOptionsHigherThanMin = F2(
	function (lowValue, values) {
		return (!lowValue) ? values : A2(
			$elm$core$List$filter,
			function (option) {
				return _Utils_cmp(option.ba, lowValue) > 0;
			},
			values);
	});
var $author$project$Views$UpdatedTalentSearch$floatOptionsLowerThanMax = F2(
	function (highValue, values) {
		return (!highValue) ? values : A2(
			$elm$core$List$filter,
			function (option) {
				return _Utils_cmp(option.ba, highValue) < 0;
			},
			values);
	});
var $author$project$Views$UpdatedTalentSearch$talentFloatRangeFilterOption = F7(
	function (lowFilterTitle, highFilterTitle, options, lowFilterMsg, highFilterMsg, lowValue, highValue) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('range-option')
						]),
					A4(
						$author$project$Views$Form$selectFloatField,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentFilterValues, lowFilterMsg),
						lowFilterTitle,
						A2($author$project$Views$UpdatedTalentSearch$floatOptionsLowerThanMax, highValue, options),
						lowValue)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('range-option')
						]),
					A4(
						$author$project$Views$Form$selectFloatField,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentFilterValues, highFilterMsg),
						highFilterTitle,
						A2($author$project$Views$UpdatedTalentSearch$floatOptionsHigherThanMin, lowValue, options),
						highValue))
				]));
	});
var $author$project$Views$UpdatedTalentSearch$optionsHigherThanMin = F2(
	function (lowValue, values) {
		return (!lowValue) ? values : A2(
			$elm$core$List$filter,
			function (value) {
				return _Utils_cmp(value, lowValue) > 0;
			},
			values);
	});
var $author$project$Views$UpdatedTalentSearch$optionsLowerThanMax = F2(
	function (highValue, values) {
		return (!highValue) ? values : A2(
			$elm$core$List$filter,
			function (value) {
				return _Utils_cmp(value, highValue) < 0;
			},
			values);
	});
var $author$project$Views$UpdatedTalentSearch$talentRangeFilterOption = function (filterName) {
	return function (lowFilterTitle) {
		return function (highFilterTitle) {
			return function (options) {
				return function (lowFilterMsg) {
					return function (highFilterMsg) {
						return function (lowValue) {
							return function (highValue) {
								return function (expanded) {
									return function (filterExpandMsg) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('filter-range-option-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('talent-filter-header'),
															$elm$html$Html$Events$onClick(
															$author$project$MainMsg$UpdateTalentFilterExpand(filterExpandMsg))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('filter-title-reset-container')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h5,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(filterName)
																		]))
																])),
															$author$project$Views$UpdatedTalentSearch$menuOpen(expanded)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('range-options-container', true),
																	_Utils_Tuple2('range-expanded', expanded)
																]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('range-option')
																]),
															A4(
																$author$project$Views$Form$selectIntField,
																A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentFilterValues, lowFilterMsg),
																lowFilterTitle,
																A2(
																	$author$project$Views$UpdatedTalentSearch$optionsLowerThanMax,
																	A2(
																		$elm$core$Maybe$withDefault,
																		0,
																		$elm$core$String$toInt(highValue)),
																	options),
																lowValue)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('range-option')
																]),
															A4(
																$author$project$Views$Form$selectIntField,
																A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentFilterValues, highFilterMsg),
																highFilterTitle,
																A2(
																	$author$project$Views$UpdatedTalentSearch$optionsHigherThanMin,
																	A2(
																		$elm$core$Maybe$withDefault,
																		0,
																		$elm$core$String$toInt(lowValue)),
																	options),
																highValue))
														]))
												]));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$UpdatedTalentSearch$heightOptionsHigherThanMin = F2(
	function (lowValue, values) {
		return (!lowValue) ? A2(
			$elm$core$List$map,
			function (value) {
				return {
					e: $elm$core$String$fromInt(value.e),
					b: value.b
				};
			},
			values) : A2(
			$elm$core$List$map,
			function (opt) {
				return {
					e: $elm$core$String$fromInt(opt.e),
					b: opt.b
				};
			},
			A2(
				$elm$core$List$filter,
				function (value) {
					return _Utils_cmp(value.e, lowValue) > 0;
				},
				values));
	});
var $author$project$Views$UpdatedTalentSearch$heightOptionsLowerThanMax = F2(
	function (highValue, values) {
		return (!highValue) ? A2(
			$elm$core$List$map,
			function (value) {
				return {
					e: $elm$core$String$fromInt(value.e),
					b: value.b
				};
			},
			values) : A2(
			$elm$core$List$map,
			function (opt) {
				return {
					e: $elm$core$String$fromInt(opt.e),
					b: opt.b
				};
			},
			A2(
				$elm$core$List$filter,
				function (value) {
					return _Utils_cmp(value.e, highValue) < 0;
				},
				values));
	});
var $author$project$Views$UpdatedTalentSearch$talentRangeHeightFilterOption = function (filterName) {
	return function (lowFilterTitle) {
		return function (highFilterTitle) {
			return function (options) {
				return function (lowFilterMsg) {
					return function (highFilterMsg) {
						return function (lowValue) {
							return function (highValue) {
								return function (expanded) {
									return function (filterExpandMsg) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('filter-range-option-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('talent-filter-header'),
															$elm$html$Html$Events$onClick(
															$author$project$MainMsg$UpdateTalentFilterExpand(filterExpandMsg))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('filter-title-reset-container')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h5,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(filterName)
																		]))
																])),
															$author$project$Views$UpdatedTalentSearch$menuOpen(expanded)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('range-options-container', true),
																	_Utils_Tuple2('range-expanded', expanded)
																]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('range-option')
																]),
															A5(
																$author$project$Views$Form$selectHeightField,
																$author$project$MainMsg$UpdateTalentFilterValues,
																lowFilterMsg,
																lowFilterTitle,
																A2(
																	$author$project$Views$UpdatedTalentSearch$heightOptionsLowerThanMax,
																	A2(
																		$elm$core$Maybe$withDefault,
																		0,
																		$elm$core$String$toInt(highValue)),
																	A2(
																		$elm$core$List$map,
																		function (option) {
																			return {
																				e: A2(
																					$elm$core$Maybe$withDefault,
																					0,
																					$elm$core$String$toInt(option.e)),
																				b: option.b
																			};
																		},
																		options)),
																lowValue)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('range-option')
																]),
															A5(
																$author$project$Views$Form$selectHeightField,
																$author$project$MainMsg$UpdateTalentFilterValues,
																highFilterMsg,
																highFilterTitle,
																A2(
																	$author$project$Views$UpdatedTalentSearch$heightOptionsHigherThanMin,
																	A2(
																		$elm$core$Maybe$withDefault,
																		0,
																		$elm$core$String$toInt(lowValue)),
																	A2(
																		$elm$core$List$map,
																		function (option) {
																			return {
																				e: A2(
																					$elm$core$Maybe$withDefault,
																					0,
																					$elm$core$String$toInt(option.e)),
																				b: option.b
																			};
																		},
																		options)),
																highValue))
														]))
												]));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Filter$ClearAllFilters = {$: 13};
var $author$project$Views$UpdatedTalentSearch$backButton = F2(
	function (projectId, userRole) {
		switch (userRole) {
			case 3:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('back-to-project-button', true),
									_Utils_Tuple2('showing-project-button', projectId !== '')
								])),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$RedirectRoute(
								$author$project$Route$Job(projectId)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Back To Jobs'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-right')
								]),
							_List_Nil)
						]));
			case 4:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('back-to-project-button', true),
									_Utils_Tuple2('showing-project-button', projectId !== '')
								])),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$RedirectRoute(
								$author$project$Route$Job(projectId)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Back To Jobs'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-right')
								]),
							_List_Nil)
						]));
			case 1:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('back-to-project-button', true),
									_Utils_Tuple2('showing-project-button', projectId !== '')
								])),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateCurrentProjectId(projectId))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('View Project'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-right')
								]),
							_List_Nil)
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$UpdatedTalentSearch$talentSearchMenuHeader = F2(
	function (projectId, userRole) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-search-menu-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filter-collapse-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-left'),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentFilterExpand(7))
								]),
							_List_Nil),
							A2($author$project$Views$UpdatedTalentSearch$backButton, projectId, userRole)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('reset-button'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateTalentFilterValues($author$project$Filter$ClearAllFilters))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Reset all filters')
						]))
				]));
	});
var $author$project$Views$UpdatedTalentSearch$talentSearchMenu = function (model) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('talent-search-menu', true),
						_Utils_Tuple2('search-open', model.I.eJ)
					]))
			]),
		_List_fromArray(
			[
				A2($author$project$Views$UpdatedTalentSearch$talentSearchMenuHeader, model.Y, model.z.P),
				$author$project$Views$UpdatedTalentSearch$projectSelection(model),
				A6($author$project$Views$UpdatedTalentSearch$talentCheckboxFilterOption, 'Gender', $author$project$InitData$genders, $author$project$Filter$UpdateGenderFilters, model.m.hx, model.I.en, 0),
				$author$project$Views$UpdatedTalentSearch$talentRangeFilterOption('Age')('Minimum Age')('Maximum Age')(
				A2($elm$core$List$range, 1, 100))($author$project$Filter$UpdateMinAge)($author$project$Filter$UpdateMaxAge)(model.m.cZ)(model.m.cX)(model.I.ds)(4),
				A6($author$project$Views$UpdatedTalentSearch$talentCheckboxFilterOption, 'Eye Color', $author$project$InitData$eyeColors, $author$project$Filter$UpdateEyeColorFilters, model.m.hp, model.I.ei, 5),
				A6($author$project$Views$UpdatedTalentSearch$talentCheckboxFilterOption, 'Ethnic Appearance', $author$project$InitData$ethnicity, $author$project$Filter$UpdateRaceFilters, model.m.iM, model.I.eb, 6),
				$author$project$Views$UpdatedTalentSearch$talentRangeHeightFilterOption('Height')('Minimum Height')('Maximum Height')($author$project$InitData$heightValues)($author$project$Filter$UpdateMinHeight)($author$project$Filter$UpdateMaxHeight)(model.m.h6)(model.m.h$)(model.I.er)(1),
				$author$project$Views$UpdatedTalentSearch$talentRangeFilterOption('Weight')('Minimum Weight')('Maximum Weight')(
				A2($elm$core$List$range, 1, 500))($author$project$Filter$UpdateMinWeight)($author$project$Filter$UpdateMaxWeight)(model.m.eN)(model.m.eI)(model.I.gc)(2),
				A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('filter-range-option-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-filter-header'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$UpdateTalentFilterExpand(3))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('filter-title-reset-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h5,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Body Sizes')
											]))
									])),
								$author$project$Views$UpdatedTalentSearch$menuOpen(model.I.fL)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('range-options-container', true),
								_Utils_Tuple2('range-expanded', model.I.fL)
							]))
					]),
				_List_fromArray(
					[
						A7(
						$author$project$Views$UpdatedTalentSearch$talentFloatRangeFilterOption,
						'Minimum Waist Size',
						'Maximum Waist Size',
						$author$project$Talent$waistSizes,
						$author$project$Filter$UpdateMinWaistSize,
						$author$project$Filter$UpdateMaxWaistSize,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toFloat(model.m.h5)),
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toFloat(model.m.h_)))
					]))
			]));
};
var $author$project$MainMsg$LoadMoreTalent = function (a) {
	return {$: 249, a: a};
};
var $author$project$Views$UpdatedTalentSearch$loadMoreButton = function (talent) {
	return talent.dK ? A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('load-more-button'),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$LoadMoreTalent(talent.dY))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('LOAD MORE')
			])) : $elm$html$Html$text('');
};
var $author$project$Filter$UpdateSearchName = function (a) {
	return {$: 11, a: a};
};
var $author$project$Views$UpdatedTalentSearch$searchField = function (searchName) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('talent-search-field-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-search search-icon')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$class('talent-search-field'),
						$elm$html$Html$Attributes$placeholder('Search by name'),
						$elm$html$Html$Attributes$value(searchName),
						$elm$html$Html$Events$onInput(
						function (val) {
							return $author$project$MainMsg$UpdateTalentFilterValues(
								$author$project$Filter$UpdateSearchName(val));
						})
					]),
				_List_Nil)
			]));
};
var $author$project$MainMsg$SelectAllTalent = {$: 248};
var $author$project$Views$UpdatedTalentSearch$selectAllButton = function (selectedTalent) {
	return (selectedTalent > 0) ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$RemoveAllCandidates)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('UNSELECT ALL')
			])) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$SelectAllTalent)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('SELECT ALL')
			]));
};
var $author$project$Views$UpdatedTalentSearch$selectedUsersButton = F3(
	function (selectedTalent, userProfile, talent) {
		if (selectedTalent > 0) {
			var _v0 = userProfile.P;
			switch (_v0) {
				case 3:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$MoveNewCandidate, talent, ''))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Submit ' + ($elm$core$String$fromInt(selectedTalent) + ' To Role'))
							]));
				case 4:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$MoveNewCandidate, talent, ''))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Submit ' + ($elm$core$String$fromInt(selectedTalent) + ' To Role'))
							]));
				case 1:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleCandidateScreen(2))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedTalent) + ' selected users')
							]));
				default:
					return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$UpdatedTalentSearch$searchHeader = F3(
	function (searchName, selectedTalent, userProfile) {
		var talentLength = $elm$core$List$length(selectedTalent);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-search-header-container')
				]),
			_List_fromArray(
				[
					A3($author$project$Views$UpdatedTalentSearch$selectedUsersButton, talentLength, userProfile, selectedTalent),
					$author$project$Views$UpdatedTalentSearch$searchField(searchName),
					$author$project$Views$UpdatedTalentSearch$selectAllButton(talentLength)
				]));
	});
var $author$project$Views$UpdatedTalentSearch$talentSearchResults = function (model) {
	var _v0 = model.a8;
	switch (_v0.$) {
		case 1:
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		case 2:
			return $author$project$Utils$loader;
		case 3:
			var res = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('talent-search-container')
					]),
				_List_fromArray(
					[
						A3($author$project$Views$UpdatedTalentSearch$searchHeader, model.m.i6, model.w, model.z),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-search-results-container')
							]),
						A2(
							$elm$core$List$map,
							function (talent) {
								return A5(
									$author$project$Utils$talentCard,
									talent,
									model.w,
									A3($author$project$MainMsg$ToggleTalentResultModal, talent, $author$project$Job$emptyApplicant, ''),
									A2($author$project$MainMsg$ToggleSelectedTalent, talent.cU, talent),
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleMenuModal(talent)));
							},
							res)),
						$author$project$Views$UpdatedTalentSearch$loadMoreButton(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$User$emptySearchTalentProfile,
							$elm$core$List$head(
								$elm$core$List$reverse(res))))
					]));
		default:
			var err = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('error!')
					]));
	}
};
var $author$project$Views$UpdatedTalentSearch$updatedTalentSearchView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('talent-search-page-container')
			]),
		_List_fromArray(
			[
				$author$project$Views$UpdatedTalentSearch$talentSearchMenu(model),
				$author$project$Views$UpdatedTalentSearch$expandMenuButton(model.I.eJ),
				$author$project$Views$UpdatedTalentSearch$talentSearchResults(model),
				$author$project$Views$TalentModal$talentSearchResultModal(model.p)(model.bh)(model.w)(model.aH)(model.aD)($author$project$Job$emptyApplicant)(model.v)(0)(model.A)(model.aw)(model.aO)('')($author$project$SharedProjectRoleSchedules$emptyProject)(model.a5.ie)(model.au)(model.z)(model.y.dG)('')($author$project$SharedProjectRoleSchedules$initialSchedulePageData)($author$project$Data$Video$emptyVideo)($author$project$SharedProjectRoleSchedules$Waiting)(false)(model.ca),
				$author$project$Views$UpdatedTalentSearch$selectedTalentView(model.w)(model.H)(model.aD)(model.A)(model.aw)(model.v)(2)(model.aO)(model.au)(model.z)(model.y.dG),
				A3(
				$author$project$Views$TalentOptions$talentOptionsModal,
				model.Q,
				model.z,
				$author$project$Utils$roleDataOptions(
					A2(
						$elm$core$List$filter,
						function (role) {
							return _Utils_eq(role.iH, model.Y);
						},
						model.aw)))
			]));
};
var $author$project$Views$Verification$verificationView = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('You\'re Verified!')
		]));
var $author$project$Main$showView = function (model) {
	if (model.L === 2) {
		var _v0 = model.i;
		switch (_v0.$) {
			case 6:
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			case 10:
				return $author$project$Views$Messages$inboxView(
					{A: model.A, cB: model.cB, g: model.j.g, bf: model.bf, b1: model.b1, l: model.l, k: model.j.k, bh: model.bh, d_: model.d_, b5: model.b5, ca: model.ca, h2: model.y.dG, h3: model.j.h3, y: model.y, bI: model.bI, v: model.v, aO: model.aO, aD: model.aD, a5: model.a5, w: model.w, aF: model.aF, aH: model.aH, au: model.au, z: model.z, p: model.p});
			case 13:
				return $author$project$Views$Dashboard$dashboardView(model);
			case 14:
				return $author$project$Views$Profile$talentProfileView(model.c)(model.z)(model.ea)(model.hE)(model.W)(model.co)(model.am)(model.Z)(model.av)(model.az);
			case 15:
				return $author$project$Views$Profile$agencyProfileView(model);
			case 16:
				return $author$project$Views$Profile$agentProfileView(model);
			case 28:
				return $author$project$Main$renderPageView(model);
			case 18:
				var a = _v0.a;
				return A2($author$project$Main$profileSettingsView, model, a);
			case 20:
				return $author$project$Views$UpdatedTalentSearch$updatedTalentSearchView(model);
			case 21:
				var i = _v0.a;
				return $author$project$Views$Project$projectView(model);
			case 19:
				var s = _v0.a;
				return A2($author$project$Main$profileSettingsViewContent, model, s);
			case 11:
				return $author$project$Views$Project$roleView(model);
			case 12:
				return $author$project$Views$Project$roleView(model);
			case 22:
				var id = _v0.a;
				var code = _v0.b;
				return $author$project$Views$Verification$verificationView;
			case 8:
				return A3($author$project$Views$Job$jobIndexView, model, model.ap, model.l);
			case 7:
				return $author$project$Views$Job$jobViewListing(model);
			case 9:
				return A2($author$project$Views$Job$myJobsView, model, model.l);
			case 23:
				return A4($author$project$Views$Schedule$scheduleIndexView, model, model.d_, '', model.l);
			case 24:
				var i = _v0.a;
				var scheduleType = _v0.b;
				return A4($author$project$Views$Schedule$scheduleIndexView, model, i, scheduleType, model.l);
			case 25:
				var projectId = _v0.a;
				var scheduleId = _v0.b;
				return A4($author$project$Views$Schedule$scheduleIndexView, model, scheduleId, '', model.l);
			default:
				return $author$project$Views$Dashboard$dashboardView(model);
		}
	} else {
		if (model.L === 1) {
			var _v1 = model.i;
			if (_v1.$ === 22) {
				return $author$project$Views$Verification$verificationView;
			} else {
				return $author$project$Main$loadingView;
			}
		} else {
			var _v2 = model.i;
			switch (_v2.$) {
				case 0:
					return A2($author$project$Views$Auth$loginView, model.bR, model.ay.ao);
				case 1:
					return A3($author$project$Views$Auth$talentSignupView, model.aG, model.aT.bl, model.ay.ao);
				case 5:
					return A3($author$project$Views$Auth$agencySignupView, model.aG, model.aT.bl, model.ay.ao);
				case 2:
					var email = _v2.a;
					return A3($author$project$Views$Auth$talentSignupView, model.aG, model.aT.bl, model.ay.ao);
				case 3:
					var email = _v2.a;
					return A4($author$project$Views$Auth$directorSignupView, model.l, model.aG, model.aT.bl, model.ay.ao);
				case 4:
					return A4($author$project$Views$Auth$directorSignupView, model.l, model.aG, model.aT.bl, model.ay.ao);
				case 26:
					var secretKey = _v2.a;
					return A4($author$project$Views$Auth$collaboratorsSignupView, model.l, model.aT, model.ay.ao, model.aG);
				case 27:
					var secretKey = _v2.a;
					return A4($author$project$Views$Auth$agentsSignupView, model.l, model.aT, model.ay.ao, model.aG);
				case 17:
					return $author$project$Views$Dashboard$notFoundView;
				case 22:
					return $author$project$Views$Verification$verificationView;
				default:
					return A2($author$project$Views$Auth$loginView, model.bR, model.ay.ao);
			}
		}
	}
};
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$TalentProfileModal$ClosedModal = {$: 1};
var $author$project$TalentProfileModal$viewError = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('talent-modal__error-view')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Whoops! An error occurred!')
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Our team has been notified and we\'ll fix this asap.')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-modal__error-view-buttons')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn__primary'),
							$elm$html$Html$Events$onClick($author$project$TalentProfileModal$ClosedModal)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Close')
						]))
				]))
		]));
var $author$project$TalentProfileModal$viewLoading = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[$author$project$Utils$loader]));
var $author$project$TalentProfileModal$withBlankStr = function (str) {
	switch (str) {
		case '':
			return ' - ';
		case '0':
			return ' - ';
		default:
			return str;
	}
};
var $author$project$TalentProfileModal$attributeRow = F2(
	function (title, value) {
		var safeValue = $author$project$TalentProfileModal$withBlankStr(value);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-modal__attribute-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-modal__attribute-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title + ':')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-modal__attribute-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(safeValue)
						]))
				]));
	});
var $author$project$Utils$StringHelpers$joinStrings = F3(
	function (str1, str2, delim) {
		var _v0 = _Utils_Tuple2(str1, str2);
		if (_v0.a === '') {
			if (_v0.b === '') {
				return '';
			} else {
				return str2;
			}
		} else {
			if (_v0.b === '') {
				return str1;
			} else {
				return _Utils_ap(
					str1,
					_Utils_ap(delim, str2));
			}
		}
	});
var $author$project$TalentProfileModal$withBlank = function (maybeNum) {
	if (!maybeNum.$) {
		var num = maybeNum.a;
		return $author$project$TalentProfileModal$withBlankStr(
			$elm$core$String$fromInt(num));
	} else {
		return $author$project$TalentProfileModal$withBlankStr('');
	}
};
var $author$project$TalentProfileModal$attributesView = function (talent) {
	var location = A3($author$project$Utils$StringHelpers$joinStrings, talent.aV, talent.a7, ', ');
	var height = function () {
		var _v0 = $author$project$Utils$convertHeightToFeetInches(talent.hB).b;
		if (_v0 === 'ANY') {
			return ' - ';
		} else {
			var x = _v0;
			return x;
		}
	}();
	var hairInfo = A3($author$project$Utils$StringHelpers$joinStrings, talent.hA, talent.hz, ' ');
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('talent-modal__attributes')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('talent-modal__attributes-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-modal__attributes-section-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Attributes')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-modal__attribute-items')
							]),
						_List_fromArray(
							[
								A2($author$project$TalentProfileModal$attributeRow, 'Gender', talent.hw),
								A2(
								$author$project$TalentProfileModal$attributeRow,
								'Age',
								$author$project$TalentProfileModal$withBlank(talent.gk)),
								A2($author$project$TalentProfileModal$attributeRow, 'Height', height),
								A2(
								$author$project$TalentProfileModal$attributeRow,
								'Weight',
								$elm$core$String$fromInt(talent.jX)),
								A2(
								$author$project$TalentProfileModal$attributeRow,
								'Waist Size',
								$elm$core$String$fromInt(talent.jX)),
								A2($author$project$TalentProfileModal$attributeRow, 'Hair/Length', hairInfo)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('talent-modal__contact-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-modal__attributes-section-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Contact')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-modal__attribute-items')
							]),
						_List_fromArray(
							[
								A2($author$project$TalentProfileModal$attributeRow, 'Location', location),
								A2($author$project$TalentProfileModal$attributeRow, 'Phone', talent.eZ),
								A2($author$project$TalentProfileModal$attributeRow, 'Email', talent.bl)
							]))
					]))
			]));
};
var $author$project$TalentProfileModal$ToggledFullImage = function (a) {
	return {$: 3, a: a};
};
var $author$project$TalentProfileModal$fullPageImage = function (maybeImage) {
	if (!maybeImage.$) {
		var image = maybeImage.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-modal__full-screen'),
					$elm$html$Html$Events$onClick(
					$author$project$TalentProfileModal$ToggledFullImage($elm$core$Maybe$Nothing))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-modal__full-screen-image'),
							$elm$html$Html$Attributes$src(image.jM)
						]),
					_List_Nil)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$TalentProfileModal$getSelectedOrDefaultImage = F2(
	function (talent, model) {
		var imageArray = $elm$core$Array$fromList(talent.hE);
		var maybeImage = A2($elm$core$Array$get, model.dd, imageArray);
		if (!maybeImage.$) {
			var image = maybeImage.a;
			return image;
		} else {
			return $author$project$Data$Image$emptyImage;
		}
	});
var $author$project$TalentProfileModal$createBlanks = function (num) {
	return A2(
		$elm$core$List$repeat,
		num,
		A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('empty-image')
				]),
			_List_Nil));
};
var $author$project$TalentProfileModal$createImagePreviews = function (images) {
	return A2(
		$elm$core$List$map,
		function (image) {
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image-preview-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$TalentProfileModal$ToggledFullImage(
									$elm$core$Maybe$Just(image))),
								$elm$html$Html$Attributes$src(image.jM)
							]),
						_List_Nil)
					]));
		},
		images);
};
var $author$project$TalentProfileModal$mergeImagesAndBlanks = F2(
	function (images, blanks) {
		return A2($elm$core$List$append, images, blanks);
	});
var $author$project$TalentProfileModal$moreImagesView = function (images) {
	return ($elm$core$List$length(images) < 5) ? A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('more-images')
			]),
		A2(
			$elm$core$List$map,
			function (image) {
				return image;
			},
			A2(
				$author$project$TalentProfileModal$mergeImagesAndBlanks,
				$author$project$TalentProfileModal$createImagePreviews(images),
				$author$project$TalentProfileModal$createBlanks(
					5 - $elm$core$List$length(images))))) : A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('more-images')
			]),
		A2(
			$elm$core$List$map,
			function (image) {
				return image;
			},
			$author$project$TalentProfileModal$createImagePreviews(
				A2($elm$core$List$take, 5, images))));
};
var $author$project$TalentProfileModal$resumeSection = function (maybeResume) {
	if (maybeResume.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var resume = maybeResume.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-item-icon')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Utils$UrlHelpers$documentURL(resume)),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-file')
								]),
							_List_Nil),
							$elm$html$Html$text('View Resume')
						]))
				]));
	}
};
var $author$project$TalentProfileModal$imagesView = F2(
	function (talent, model) {
		var selectedImage = A2($author$project$TalentProfileModal$getSelectedOrDefaultImage, talent, model);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-modal__images')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(selectedImage.jM),
									$elm$html$Html$Attributes$class('active-image')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-expand-arrows-alt'),
									$elm$html$Html$Events$onClick(
									$author$project$TalentProfileModal$ToggledFullImage(
										$elm$core$Maybe$Just(selectedImage)))
								]),
							_List_Nil),
							$author$project$TalentProfileModal$moreImagesView(talent.hE),
							$author$project$TalentProfileModal$resumeSection(talent.iU)
						])),
					$author$project$TalentProfileModal$fullPageImage(model.cb)
				]));
	});
var $author$project$TalentProfileModal$ChangedMessage = function (a) {
	return {$: 4, a: a};
};
var $author$project$TalentProfileModal$SentMessage = {$: 5};
var $author$project$TalentProfileModal$placeholderText = function (firstName) {
	return 'Send ' + (firstName + ' a message...');
};
var $author$project$TalentProfileModal$sendMessageButtonText = function (status) {
	switch (status) {
		case 0:
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A4(
						$frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions,
						$frandibar$elm_font_awesome_5$FontAwesome$spinner,
						0,
						_List_fromArray(
							[
								$frandibar$elm_font_awesome_5$FontAwesome$Animation(0)
							]),
						_List_Nil)
					]));
		case 2:
			return $elm$html$Html$text('Send');
		default:
			return $elm$html$Html$text('Send');
	}
};
var $author$project$TalentProfileModal$messageForm = F3(
	function (talent, model, twilioStatus) {
		var isSending = !twilioStatus;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-modal__form'),
							$elm$html$Html$Events$onSubmit($author$project$TalentProfileModal$SentMessage)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$placeholder(
									$author$project$TalentProfileModal$placeholderText(talent.bm)),
									$elm$html$Html$Attributes$disabled(isSending),
									$elm$html$Html$Attributes$class('talent-modal__message-input'),
									$elm$html$Html$Events$onInput($author$project$TalentProfileModal$ChangedMessage),
									$elm$html$Html$Attributes$value(model.h1)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('talent-modal__message-actions')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('submit'),
											$elm$html$Html$Attributes$disabled(isSending),
											$elm$html$Html$Attributes$class('send-message-button button')
										]),
									_List_fromArray(
										[
											$author$project$TalentProfileModal$sendMessageButtonText(twilioStatus)
										]))
								]))
						]))
				]));
	});
var $author$project$TalentProfileModal$viewSuccess = F3(
	function (profile, model, twilioStatus) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-modal__header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(profile.bm + (' ' + profile.bE)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('talent-modal__close-icon fa fa-times'),
									$elm$html$Html$Events$onClick($author$project$TalentProfileModal$ClosedModal)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-modal__body')
						]),
					_List_fromArray(
						[
							A2($author$project$TalentProfileModal$imagesView, profile, model),
							$author$project$TalentProfileModal$attributesView(profile)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-modal__footer')
						]),
					_List_fromArray(
						[
							A3($author$project$TalentProfileModal$messageForm, profile, model, twilioStatus)
						]))
				]));
	});
var $author$project$TalentProfileModal$viewEntered = F2(
	function (model, twilioStatus) {
		var content = function () {
			var _v0 = model.jr;
			switch (_v0.$) {
				case 0:
					return $author$project$TalentProfileModal$viewLoading;
				case 1:
					return $author$project$TalentProfileModal$viewLoading;
				case 2:
					var e = _v0.a;
					return $author$project$TalentProfileModal$viewError;
				default:
					var item = _v0.a;
					return A3($author$project$TalentProfileModal$viewSuccess, item, model, twilioStatus);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-modal__outer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-modal__overlay')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('talent-modal__container')
								]),
							_List_fromArray(
								[content]))
						]))
				]));
	});
var $author$project$TalentProfileModal$view = F2(
	function (model, twilioStatus) {
		var _v0 = model.cc;
		if (_v0) {
			return A2($author$project$TalentProfileModal$viewEntered, model, twilioStatus);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Main$standardWidgets = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$MainMsg$GotTalentProfileModalMsg,
				A2($author$project$TalentProfileModal$view, model.aR, model.au))
			]));
};
var $author$project$Main$version = 'V0.0.36';
var $author$project$Main$view = function (model) {
	var _v0 = model.i;
	switch (_v0.$) {
		case 0:
			return {
				dG: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				r: model.r
			};
		case 1:
			return {
				dG: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				r: model.r
			};
		case 5:
			return {
				dG: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				r: model.r
			};
		case 2:
			var email = _v0.a;
			return {
				dG: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				r: model.r
			};
		case 3:
			var email = _v0.a;
			return {
				dG: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				r: model.r
			};
		case 4:
			return {
				dG: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				r: model.r
			};
		default:
			return {
				dG: _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('app-wrapper')
							]),
						_List_fromArray(
							[
								$author$project$Main$messageBox(model),
								$author$project$Views$Nav$navBar(model),
								$author$project$Main$showView(model),
								A2(
								$elm$html$Html$small,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('version')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Main$version)
									])),
								$author$project$Main$standardWidgets(model)
							]))
					]),
				r: model.r
			};
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		hG: F3(
			function (flags, url, key) {
				return A3($author$project$Main$init, key, url, flags);
			}),
		iq: $author$project$MainMsg$ChangedUrl,
		ir: $author$project$MainMsg$ClickedLink,
		jo: $author$project$Main$subscriptions,
		jL: $author$project$Main$update,
		jU: $author$project$Main$view
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (slayt_square) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (logoPath) {
					return $elm$json$Json$Decode$succeed(
						{ao: logoPath, jh: slayt_square});
				},
				A2($elm$json$Json$Decode$field, 'logoPath', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'slayt_square', $elm$json$Json$Decode$string)))(0)}});}(this));